import React, { useEffect, useMemo, useState } from "react";
import html2pdf, { f } from "html2pdf.js";
import DocViewer from "@cyntler/react-doc-viewer";
import { Close } from "@mui/icons-material";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

//img
import plusIcon from "../../../assets/images/svg/plusIcon.png";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import deletePopupImg from "../../../assets/images/png/Group 2@2x.png";
import bidSelectedImg from "../../../assets/images/png/like@2x.png";
import bidUnSelectedImg from "../../../assets/images/png/dislike@2x.png";
import comparingImg from "../../../assets/images/png/Group 93@2x.png";
import somthingWrongImg from "../../../assets/images/png/warning.png";
import brLogo from "../../../assets/images/png/Logo@2x.png";
// import fileAttachmentlogo from "../../../assets/images/fileattachmenticon.png";
//components
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import DateBar from "../../../components/common/DateBar/DateBar";
import NotificationBell from "../../../components/common/NotificationBell/NotificationBell";
import ProfileCard from "../../../components/common/ProfileCard/ProfileCard";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import PaginantionComponent from "../../../components/common/Pagination/PaginationComponent";
import DButton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import DataTable from "../../../components/common/DataTable/DataTableSorting";
import Attachment from "../../../components/common/Attachment/Attachment";
import AttachmentList from "../../../components/common/AttachmentList/AttachmentList";
import FilterBar from "../../../components/common/FilterBar/FilterBar";

import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Modal,
  ThemeProvider,
  TextField,
  createTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  IconButton,
  Typography,
  Stack,
  Tooltip,
} from "@mui/material";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { useTheme } from "@mui/material/styles";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import DSelectInput from "../../../components/Dashboard/DashboardInputs/DSelectInput";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import DetailsTab from "../../../components/Dashboard/DetailsTab/DetailsTab";
import DTextArea from "../../../components/Dashboard/DashboardInputs/DTextArea";
import DRadioInput from "../../../components/Dashboard/DashboardInputs/DRadioInput";
import DefaultLabel from "../../../components/Dashboard/DefaultLabel/DefaultLabel";
import BrandLogo from "../../../components/common/BrandLogo/BrandLogo";
//api and redux
import { API_ENDPOINT } from "../../../services/api/resources";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
//offline
import {
  useOfflineRFQs,
  rfqRepository,
  shouldMakeAPICall,
  offlineQueue,
  masterDataRepository,
} from "../../../offline";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import DFileUpload from "../../../components/Dashboard/DashboardInputs/DFileUpload";
import DDateInput from "../../../components/Dashboard/DashboardInputs/DDateInput";
import { nextPageClick, previouPageClick } from "../../../utils/pagination";
import { normalizeVendorsForMessageSelection } from "../../../utils/normalizeVendors";
import { setBuyerRFQData } from "../../../features/BuyerRFQDataSlice";
import {
  MoreHoriz,
  AttachmentOutlined,
  PictureAsPdf,
  InfoOutlined,
  LockOutlined,
  EventOutlined,
  AccessTimeOutlined,
  VerifiedUserOutlined,
  ForumOutlined,
  ArrowForwardIosOutlined,
  LocationOnOutlined,
  LocalShippingOutlined,
  GavelOutlined,
} from "@mui/icons-material";
import MailOutline from "@mui/icons-material/MailOutline";
import {
  emptyCheck,
  validateEmail,
  validateFile,
  validateSelect,
} from "../../../utils/validations";
import DPhoneNumberInput from "../../../components/Dashboard/DashboardInputs/DPhoneNumberInput";
import dayjs from "dayjs";
import DownloadFileButton from "../../../components/Dashboard/DownloadFileButton/DownloadFileButton";
import DaysReminder from "../../../components/Dashboard/DaysReminder/DaysReminder";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";
import TextArea from "../../../components/common/TextArea/TextArea";
//css
import classes from "./RFQTab.module.css";
import vendorClasses from "../VendorsTab/VendorsTab.module.css";
import tableStyles from "../../../components/common/DataTable/DataTable.module.css";
import styles from "../../../components/Dashboard/DashboardInputs/DashboardInput.module.css";

import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

//custom hooks
import fetchPagedData from "../../../hooks/useFetchData";
import { getUniqueData } from "../../../utils/getUniqueData";
import DropdownBtnOutlined from "../../../components/Dashboard/DropdownButtons/DropdownBtnOutlined/DropdownBtnOutlined";
import { downloadFile } from "../../../utils/downloadFile";
import DropdownBtn from "../../../components/Dashboard/DropdownButtons/DropdownBtn/DropdownBtn";
import PDFView from "../../../components/Dashboard/PDFView/PDFView";
import PDFViewAllFileType from "../../../components/Dashboard/PDFView/PdfViewer";
import { flattenNestedObjects } from "../../../utils/compareObjectFormater";

//sample files
import RFQSampleItemsFile from "../../../assets/files/RFQSampleItemsList.csv";
import DFreeSoloInput from "../../../components/Dashboard/DashboardInputs/DFreeSoloInput";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import DSearchInputDropdown from "../../../components/Dashboard/DashboardInputs/DSearchInputDropdown";
import ComparedTable from "../../../components/common/Comparison/ComparedTable";
import { Form, useNavigate } from "react-router-dom";
import QuickRFQ from "./QuickRFQ";
import { useLocation } from "react-router-dom";
import { useRef } from "react";
import { wrap } from "lodash";
import { openNegotiationBotInChat } from "../../../components/Chatbot/NegotiationBot/negotiationBotEvents";

const theme = createTheme({
  typography: {
    // fontSize: "1.4rem"
    htmlFontSize: 9.8,
  },
});
const filter = createFilterOptions();

const BuyerRFQTab = () => {
  //dispatcher
  const dispatch = useDispatch();
  // const location = useLocation();
  // const chatRFQTriggeredRef = useRef(false);

  //get data from use selector
  const data = useSelector((state) => state.loginData.value);
  const RFQData = useSelector((state) => state.buyerRFQData.value);
  const AdminData = useSelector((state) => state.adminData.value);

  //pages
  const [RFQMain, setRFQMain] = useState(true);
  const [sendMessage, setSendMessage] = useState(false);
  const [textAreaSendMessage, setTextAreaSendMessage] = useState(false);

  const [viewRFQ, setViewRFQ] = useState(false);
  const [requestRequote, setRequestQuote] = useState(false);
  const [enableSelect, setEnableSelect] = useState(false);
  const [newRFQForm, setNewRFQForm] = useState(false);
  const [viewTimeLine, setViewTimeLine] = useState(false);
  const [viewTimeLineData, setViewTimeLineData] = useState([]);
  const [openForm, setOpenForm] = useState({
    open: false,
    loading: false,
    errorMessage: "",
  });
  const [viewRFQComparedTable, setViewRFQComparedTable] = useState();
  // date filters

  const [startDateSearchQuery, setStartDateSearchQuery] = useState({
    value: "",
    isValid: true,
  });

  const [endDateSearchQuery, setEndDateSearchQuery] = useState({
    value: "",
    isValid: true,
  });
  const [rfqToken, setRFQToken] = useState();
  const [tableProps, setTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });
  const sanitizeErrorMessage = (msg) => {
    const value = String(msg || "").trim();
    if (!value) return "";
    // Backend sometimes returns this as an "error" for empty states; UI handles empty states separately.
    if (/no bids found/i.test(value)) return "";
    // View RFQ: Vendor messages empty-state should be rendered with RFQTab styling (not DataTable grey overlay).
    if (/no rfq vendors found/i.test(value)) return "";
    // useFetchData can generate this when search query is empty.
    if (/^""\s*not found!?$/i.test(value)) return "";
    return value;
  };
  const resolveRfqItemMappedToken = (item) =>
    String(
      item?.itemMappedToken ??
        item?.item_mapped_token ??
        item?.item_rfq_map_token ??
        item?.itemRfqMapToken ??
        item?.item_rfq_map?.token ??
        item?.itemRfqMap?.token ??
        item?.item_token ??
        item?.itemToken ??
        "",
    ).trim();

  const normalizeRfqItems = (items = []) =>
    (Array.isArray(items) ? items : []).map((item) => {
      const resolvedMappedToken = resolveRfqItemMappedToken(item);
      const resolvedItemToken = String(
        item?.itemToken ?? item?.item_token ?? item?.token ?? "",
      ).trim();

      return {
        ...item,
        itemMappedToken: resolvedMappedToken,
        item_mapped_token: item?.item_mapped_token ?? resolvedMappedToken,
        itemToken: resolvedItemToken || resolvedMappedToken,
        item_token:
          item?.item_token ?? resolvedItemToken ?? resolvedMappedToken,
      };
    });
  const [loading, setLoading] = useState(false);
  const [openComparisonTable, setOpenComparisonTable] = useState(false);
  const [popupText, setPopupTexts] = useState({
    popupHeroText: "",
    popupDescription: "",
  });
  const [btnError, setBtnError] = useState({
    isError: false,
    errorMsg: "",
  });

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowForComparison, setSelectedRowForComparison] = useState([]);
  const [sendErrorMsg, setSendErrorMsg] = useState(false);

  // user address state
  const [shippingAddress, setShippingAddress] = useState([]);

  //pagination data
  const [paginationData, setPaginationData] = useState();
  const [itemList, setItemList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });
  const [itemNameList, setItemNameList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });

  const [vendorsList, setVendorsList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });
  const [allVendorsList, setAllVendorsList] = useState({
    values: {
      tokens: [],
      visibleOption: [],
    },
  });
  const vendorFilterActiveRef = useRef(false);

  const [quantity, setQuantity] = useState([]);
  const [vendorId, setVendorID] = useState([]);
  const [btnPrimaryLabel, setBtnPrimaryLabel] = useState("");
  const [loadingState, setLoadingState] = useState(false);
  const [loadingStateDwnload, setLoadingStateDwnload] = useState(false);
  const masterFetchRef = useRef({
    itemsPromise: null,
    vendorsPromise: null,
  });
  //rfq form states
  const [editRFQForm, setEditRFQForm] = useState(false);
  //credentials
  const [auth_token, setAuthToken] = useState(data?.auth_token);
  const [organization_token] = useState(data?.organization_token);
  const [user_token, setUserToken] = useState(data?.user?.user_token);
  const [buyer_token, setBuyerToken] = useState(data?.user?.token);
  const [org_token, setOrgToken] = useState(data?.user?.token);
  const [bidsData, setBidsData] = useState();
  const [itemsListDataViewRFQ, setItemsListDataViewRFQ] = useState();
  const [rfqItemsPreviewDialog, setRfqItemsPreviewDialog] = useState({
    open: false,
    rfqCode: "",
    items: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  // Client-side pagination state (like PR)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [bulkBidsData, setBulkBidsData] = useState();
  const [bidsLoadedFromRfqBids, setBidsLoadedFromRfqBids] = useState(false); // Flag to track if bids were loaded from rfq_bids

  // Helper function to map bid data for table display (defined early to ensure availability)
  const mapBidForTable = (bid, vendorList = rfqVendorList) => {
    if (!bid || typeof bid !== "object") {
      console.warn("⚠️ mapBidForTable: Invalid bid data", bid);
      return null;
    }

    // Skip mapping if already mapped (check for mapped indicator), but allow "upgrade"
    // when older cached rows are missing newer fields (e.g., `first_name`).
    if (
      bid._mapped &&
      bid.vendor !== undefined &&
      bid.vendor_code !== undefined &&
      bid.first_name !== undefined
    ) {
      return bid;
    }

    // Extract vendor_code from company_vendor_code if needed (format: "VendorB(VEN-004)" or "VendorA(VEN-003)")
    let vendorCode = bid.vendor_code;

    // Check if vendor_code is missing or invalid
    if (
      !vendorCode ||
      vendorCode === "-" ||
      vendorCode === null ||
      vendorCode === undefined ||
      vendorCode === ""
    ) {
      if (bid.company_vendor_code) {
        // Try to extract from format "VendorB(VEN-004)" or "VendorA(VEN-003)"
        const match = String(bid.company_vendor_code).match(/\(([^)]+)\)/);
        if (match && match[1]) {
          vendorCode = match[1].trim();
        }
      }
    }

    const normalizeTextValue = (value) => {
      const s = String(value ?? "").trim();
      return s && s !== "-" ? s : "";
    };

    // buyer_rfq_full_view: rfq_bids.vendor is often the contact/person name, while rfq_vendor_list has the company name.
    // Prefer the company name from rfq_vendor_list when we can match by vendor_token.
    const vendorToken =
      normalizeTextValue(bid.vendor_token) ||
      normalizeTextValue(bid.vendorToken) ||
      normalizeTextValue(bid.vendor_id) ||
      normalizeTextValue(bid.vendorId) ||
      "";

    const companyFromVendorList = (() => {
      if (!vendorToken) return "";
      if (!Array.isArray(vendorList) || vendorList.length === 0) return "";
      const match = vendorList.find(
        (v) =>
          String(v?.vendor_token || v?.token || "").trim() ===
          String(vendorToken).trim(),
      );
      return (
        normalizeTextValue(match?.vendor_name) ||
        normalizeTextValue(match?.company_name) ||
        normalizeTextValue(match?.companyName) ||
        ""
      );
    })();

    // Vendor "company" vs "contact/name" varies by endpoint/org.
    // UI expects:
    // - `vendor`      → Vendor Company Name
    // - `first_name`  → Supplier Name
    const companyName =
      companyFromVendorList ||
      normalizeTextValue(bid.company_name) ||
      normalizeTextValue(bid.vendor_company_name) ||
      normalizeTextValue(bid.vendor_company) ||
      normalizeTextValue(bid.company) ||
      "";

    const contactName =
      normalizeTextValue(bid.first_name) ||
      normalizeTextValue(bid.vendor_name) ||
      normalizeTextValue(bid.vendor_contact_name) ||
      normalizeTextValue(bid.vendorContactName) ||
      "";

    const supplierName =
      normalizeTextValue(bid.vendor_name) ||
      normalizeTextValue(bid.vendor) ||
      normalizeTextValue(bid.vendor_contact_name) ||
      normalizeTextValue(bid.vendorContactName) ||
      vendorField ||
      "-";

    const supplierEmail =
      normalizeTextValue(bid.vendor_email) ||
      normalizeTextValue(bid.company_official_email) ||
      normalizeTextValue(bid.email) ||
      "-";

    // Many responses put company in `company_name` and contact in `vendor`.
    // When company is present, treat `vendor` as the contact name (if any).
    const vendorField = normalizeTextValue(bid.vendor);
    const resolvedContactName = companyFromVendorList
      ? vendorField || contactName
      : contactName || (companyName ? vendorField : "");

    const resolvedCompanyName =
      companyName ||
      vendorField ||
      normalizeTextValue(bid.company_vendor_code) ||
      "-";

    // Create mapped bid object
    const mappedBid = {
      ...bid,
      // Ensure vendor company + vendor name exist for table display
      supplier_name: supplierName,
      supplier_email: supplierEmail,
      vendor: resolvedCompanyName || "-",
      first_name: resolvedContactName || "-",
      // Ensure vendor_code exists - extract from company_vendor_code if needed
      vendor_code: vendorCode ? String(vendorCode) : "-",
      // Ensure quantity, unit_price, total_price are properly set
      quantity:
        bid.quantity !== undefined && bid.quantity !== null
          ? bid.quantity
          : null,
      unit_price:
        bid.unit_price !== undefined && bid.unit_price !== null
          ? bid.unit_price
          : null,
      total_price:
        bid.total_price !== undefined && bid.total_price !== null
          ? bid.total_price
          : bid.currency_value || 0,
      // Ensure converted_currency exists (Total Price in Local Currency) - support multiple API key names
      converted_currency:
        bid.converted_currency !== undefined && bid.converted_currency !== null
          ? bid.converted_currency
          : (bid.total_price_in_local_currency ??
            bid.total_price_local ??
            bid.total_price ??
            bid.currency_value ??
            0),
      // Ensure bid_version exists for Quote Iteration
      bid_version: bid.bid_version || bid.bid_version_int || "0",
      // Ensure created_date exists
      created_date: bid.created_date || bid.createdDate || "-",
      // Ensure document exists for File column
      document: bid.document || bid.document_url || null,
      // Mark as mapped to prevent double-mapping
      _mapped: true,
    };

    // Debug log for first bid to verify mapping
    if (!window._bidMappingLogged) {
      console.log("🔍 mapBidForTable - First bid mapping:", {
        input: {
          vendor: bid.vendor,
          vendor_code: bid.vendor_code,
          company_vendor_code: bid.company_vendor_code,
          company_name: bid.company_name,
        },
        output: {
          vendor: mappedBid.vendor,
          vendor_code: mappedBid.vendor_code,
        },
      });
      window._bidMappingLogged = true;
    }

    return mappedBid;
  };

  const [popupMessage, setPopupMessage] = useState("");
  const [btnErrorState, setBtnErrorState] = useState({
    error: false,
    errorMsg: "",
  });
  const [iterationNumber, setIterationNumber] = useState();
  const [bidToken, setBidToken] = useState("");
  const [fileName, setFileName] = useState();
  const [uploadItemDocument, setUploadItemDocument] = useState({
    uploadFile: true,
    inputs: false,
  });
  const [deletedItemsToken, setDeletedItemsToken] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentLoading, setDepartmentLoading] = useState(false);
  const [budgetConfigs, setBudgetConfigs] = useState([]);
  const [budgetConfigLoading, setBudgetConfigLoading] = useState(false);
  const [departmentError, setDepartmentError] = useState("");
  const [itemsInput, setItemsInput] = useState([
    {
      itemToken: "",
      itemTokenisValid: false,

      itemMappedToken: "",

      itemCode: "",
      itemCodeisValid: false,

      itemName: "",
      itemNameisValid: false,

      expenseType: "",

      itemQuantity: "",
      itemQuantityisValid: false,

      itemUnit: "",
      itemUnitisValid: false,

      itemDescription: "",
      itemDescriptionisValid: false,

      itemPartNumber: "",

      itemDuplicate: false,
    },
  ]);
  const [showAlternativeSuppliers, setShowAlternativeSuppliers] = useState(false);
  const [alternativeSuppliers, setAlternativeSuppliers] = useState([]);
  const [alternativeSupplierOptions, setAlternativeSupplierOptions] = useState([]);
  const [alternativeSupplierLoading, setAlternativeSupplierLoading] = useState(false);
  const [alternativeSupplierError, setAlternativeSupplierError] = useState("");
  const initialAlternativeEmailsRef = useRef([]);
  const hydrateAlternativeSuppliers = (raw) => {
    let emails = raw;
    if (typeof emails === "string") {
      try { emails = JSON.parse(emails); } catch { emails = emails.split(","); }
    }
    const normalized = [...new Set((Array.isArray(emails) ? emails : []).map((email) => String(email || "").trim()).filter(Boolean))];
    initialAlternativeEmailsRef.current = normalized.map((email) => email.toLowerCase());
    setAlternativeSupplierOptions(normalized.map((email) => ({ email, label: email, token: `alt:${email.toLowerCase()}` })));
  };
  const alternativeItemKey = JSON.stringify(
    (itemsInput || []).filter((item) => item?.itemCode || item?.itemName)
      .map((item) => ({ code: String(item.itemCode || "").trim(), name: String(item.itemName || "").trim(), token: item.itemToken }))
  );

  useEffect(() => {
    if ((!newRFQForm && !editRFQForm) || !showAlternativeSuppliers || !organization_token) return;
    const selectedItems = JSON.parse(alternativeItemKey);
    if (!selectedItems.length) {
      setAlternativeSuppliers([]);
      return;
    }
    let cancelled = false;
    setAlternativeSupplierLoading(true);
    setAlternativeSupplierError("");
    const timer = setTimeout(() => {
      Promise.all(selectedItems.map(async (item) => {
        const { data: response } = await axios.post(
          API_ENDPOINT.imported_item_vendors_vendors,
          { org_token: organization_token, item_name: item.name },
          { headers: { Authorization: `Bearer ${auth_token}` } }
        );
        return (response?.vendors || []).map((supplier) => ({ ...supplier, itemToken: item.token, itemCode: item.code }));
      })).then((results) => {
        if (cancelled) return;
        const uniqueSuppliers = new Map();
        results.flat().filter((supplier) => supplier.email).forEach((supplier) => {
          const key = `${String(supplier.email).trim().toLowerCase()}|${String(supplier.vendor_name || "").trim().toLowerCase()}`;
          const existing = uniqueSuppliers.get(key);
          uniqueSuppliers.set(key, {
            ...supplier,
            itemTokens: [...new Set([...(existing?.itemTokens || []), supplier.itemToken].filter(Boolean))],
          });
        });
        setAlternativeSuppliers([...uniqueSuppliers.values()]);
        setAlternativeSupplierOptions((current) => current.map((option) => {
          const match = uniqueSuppliers.get(`${option.email.toLowerCase()}|${String(option.vendor_name || "").toLowerCase()}`)
            || [...uniqueSuppliers.values()].find((supplier) => supplier.email.toLowerCase() === option.email.toLowerCase());
          return match ? { ...option, vendor_name: match.vendor_name, label: `${match.email} (${match.vendor_name})` } : option;
        }));
      }).catch(() => {
        if (!cancelled) setAlternativeSupplierError("Could not load alternative suppliers.");
      }).finally(() => {
        if (!cancelled) setAlternativeSupplierLoading(false);
      });
    }, 300);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [alternativeItemKey, showAlternativeSuppliers, newRFQForm, editRFQForm, organization_token, auth_token]);

  useEffect(() => {
    if (newRFQForm || editRFQForm) return;
    setShowAlternativeSuppliers(false);
    setAlternativeSuppliers([]);
    setAlternativeSupplierOptions([]);
    initialAlternativeEmailsRef.current = [];
    setAlternativeSupplierError("");
  }, [newRFQForm, editRFQForm]);
  const [itemCSV, setItemCSV] = useState({
    value: "",
    hasFile: false,
    isValid: true,
  });

  const [uploadDocument, setUploadDocument] = useState({
    uploadFile: true,
    uploadDescripton: false,
  });

  const [proposalDocument, setProposalDocument] = useState({
    value: "",
    isValid: true,
    hasFile: true,
  });
  const [proposalDescription, setProposalDescription] = useState({
    value: "",
    isValid: true,
  });

  const [requestNumber, setRequestNumber] = useState({
    value: "",
    isChanged: false,
    isValid: true,
  });

  const [RFQCategory, setRFQCategory] = useState({
    value: "",
    id: "",
    categoryList: [],
    isValid: true,
  });

  const [bidType, setBidType] = useState({
    value: true,
    isValid: true,
  });

  const [sealedBid, setSealedBid] = useState(false);

  const [bidStatus, setBidStatus] = useState({
    isValid: true,
    isChanged: false,
    value: "",
  });

  const [fromDate, setFromDate] = useState({
    value: "",
    isValid: true,
  });

  const [toDate, setToDate] = useState({
    value: "",
    isValid: true,
  });

  const [time, setTime] = useState({
    value: null,
    isChanged: false,
    isValid: true,
  });

  const [vendor, setVendor] = useState({
    value: [],
    id: [],
    isValid: true,
  });
  const [allowedVendorTokensByItemToken, setAllowedVendorTokensByItemToken] =
    useState({});
  const [itemVendorErrors, setItemVendorErrors] = useState({});
  const [
    uploadedItemTokensForVendorFilter,
    setUploadedItemTokensForVendorFilter,
  ] = useState([]);
  const [existingVendorList, setExistingVendorList] = useState([]);
  const quotationCategoryRef = useRef(null);
  const [CompanyName, setCompanyName] = useState({
    value: "",
    errorMsg: "",
    isValid: true,
  });
  const [companyList, setCompanyList] = useState([]);
  const [VendorRegisteredEmail, setVendorRegisteredEmail] = useState({
    value: "",
    errorMsg: "",
    isValid: true,
  });

  const [primaryBtnError, setPrimaryBtnError] = useState({
    error: false,
    errorMsg: "",
  });
  const [address1, setAddress1] = useState({
    value: "",
    isValid: true,
  });

  const [address2, setAddress2] = useState({
    value: "",
    isValid: true,
  });

  const [city, setCity] = useState({
    value: "",
    cityList: [],
    isValid: true,
  });

  const [stateName, setStateName] = useState({
    value: "",
    stateList: [],
    isValid: true,
  });

  const [country, setCountry] = useState({
    value: "",
    countryList: [],
    isValid: true,
  });

  const [countryToken, setCountryToken] = useState(0);
  const [stateToken, setstateToken] = useState(0);

  const [pincode, setPincode] = useState({
    value: "",
    isValid: true,
  });

  const [mobileNumber, setMobileNumber] = useState({
    value: "",
    format: "",
    isValid: true,
  });

  const budgetFinancialYear = `${new Date().getFullYear()}-${String(
    new Date().getFullYear() + 1,
  ).slice(-2)}`;

  const getAllDepartments = async () => {
    if (departmentList.length) return departmentList;
    setDepartmentLoading(true);
    try {
      const response = await axios.post(
        API_ENDPOINT.get_Department,
        { user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } },
      );
      const departments = Array.isArray(response?.data?.data)
        ? response.data.data
        : [];
      setDepartmentList(departments);
      return departments;
    } catch (error) {
      console.error("Unable to load departments:", error);
      return [];
    } finally {
      setDepartmentLoading(false);
    }
  };

  const fetchBudgetConfig = async (departmentName) => {
    if (!departmentName) return;
    setBudgetConfigLoading(true);
    try {
      const response = await axios.post(
        API_ENDPOINT.get_budget_config,
        { department_name: departmentName, financial_year: budgetFinancialYear },
        { headers: { Authorization: `Bearer ${auth_token}` } },
      );
      setBudgetConfigs(
        Array.isArray(response?.data?.results) ? response.data.results : [],
      );
    } catch (error) {
      setBudgetConfigs([]);
    } finally {
      setBudgetConfigLoading(false);
    }
  };

  const formatBudgetAmount = (amount, currency) => {
    if (amount === null || amount === undefined || amount === "") return "-";
    const value = Number(String(amount).replace(/,/g, ""));
    const symbol = { INR: "₹", USD: "$", EUR: "€", GBP: "£" }[currency] || `${currency || ""} `;
    return Number.isFinite(value)
      ? `${symbol}${value.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      : `${symbol}${amount}`;
  };

  const getBudgetNumber = (amount) => {
    const value = Number(String(amount ?? "").replace(/,/g, ""));
    return Number.isFinite(value) ? value : 0;
  };

  const hydrateRfqBudget = async (rfq) => {
    const departmentName = String(
      rfq?.dept_name ?? rfq?.department_name ?? rfq?.department ?? "",
    ).trim();
    const departmentId = rfq?.department_id ?? rfq?.dept_id ?? null;
    if (!departmentName && !departmentId) return;

    const departments = departmentList.length
      ? departmentList
      : await getAllDepartments();
    const selected =
      departments.find(
        (department) =>
          String(department?.id) === String(departmentId) ||
          String(department?.name || "").toLowerCase() === departmentName.toLowerCase(),
      ) || { id: departmentId, name: departmentName };
    setSelectedDepartment(selected);
    if (selected?.name) void fetchBudgetConfig(selected.name);
  };

  //comparision module state
  const [latestStatus, setLatestStatus] = useState("");
  const [intervalIds, setIntervalIds] = useState([]);
  const [timeOutIds, setTimeOutIds] = useState([]);
  const [compairedData, setCompairedData] = useState([]);
  const [fileJsonHistory, setFileJsonHistory] = useState([]);
  const [comparedNameDate, setComparedNameDate] = useState({});
  const [compareHistoryToken, setCompareHistoryToken] = useState("");
  const [isComparePending, setIsComparePending] = useState(false);
  const [comparisonPreviousPurchases, setComparisonPreviousPurchases] = useState([]);
  // const [chatGptToken, setchatGptToken] = useState('')

  const [openBidConfirmation, setOpenBidConfirmation] = useState({
    selectBid: false,
    unSelectBid: false,
  });

  const [openViewQuotesPopup, setOpenViewQuotesPopup] = useState(false);
  const [openComparisonPopup, setOpenComparisonPopup] = useState(false);
  const [negotiationBotState, setNegotiationBotState] = useState({
    open: false,
    loading: false,
    submitting: false,
    itemPicker: false,
    selectMode: false,
    data: null,
    botItems: [],
    selectedItem: null,
    selectedHistoryId: "",
    selectedVendorBidItemTokens: [],
    result: null,
    error: "",
  });
  const [
    negotiationExpandedDescriptions,
    setNegotiationExpandedDescriptions,
  ] = useState({});
  const [openExploreUnregisteredQuotes, setOpenExploreUnregisteredQuotes] =
    useState(false);
  const [exploreSelectedItems, setExploreSelectedItems] = useState([]);
  const [exploreMatches, setExploreMatches] = useState([]);
  const [exploreLoading, setExploreLoading] = useState(false);
  const [exploreError, setExploreError] = useState("");
  const [exploreSearch, setExploreSearch] = useState("");
  const [exploreExpandedDescriptions, setExploreExpandedDescriptions] =
    useState({});
  const [mailSendingToken, setMailSendingToken] = useState("");

  const [textAreaVlaue, setTextAreaVlaue] = useState({
    send_message: "",
  });

  const [msg_file, setMsg_file] = useState([]);
  const [charsLeft, setCharsLeft] = useState(0);
  const [errorMessages, setErrorMessages] = useState(false);
  const [organizationDetailspdfUI, setOrganizationDetailspdfUI] =
    useState(false);

  // modal states
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [supplierAddedPopupOpen, setSupplierAddedPopupOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  //delete
  const [openDltConfirmation, setOpenDltConfirmation] = useState(false);
  const [openDlt, setOpenDlt] = useState(false);
  const lastRfqFetchRef = useRef({ key: "", ts: 0 });
  const rfqFetchInFlightRef = useRef(false);
  const rfqFullSyncRef = useRef({ key: "", ts: 0, inFlight: false });

  const [bidSelection, setBidSelection] = useState({
    select: false,
    unselect: false,
  });

  // new rfq tabs
  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);

  //popuptext
  const [popupHeroText, setPopupHeroText] = useState("");
  //search filtered data
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [searchQuery3, setSearchQuery3] = useState("");
  const [sortingColumnName, setSortingColumnName] = useState(null);
  const [sortingOrder, setSortingOrder] = useState(null);
  const [forceClientPaging, setForceClientPaging] = useState(false);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchQuery]);
  //unique user
  const [uniqueData, setUniqueData] = useState();
  //pagenumber
  const [pageNumber, setPageNumber] = useState(1);

  // Server-side pagination (online only). Offline uses client-side over IndexedDB.
  const [serverPage, setServerPage] = useState(1);
  const [serverPagination, setServerPagination] = useState({
    totalRFQs: 0,
    pageCount: 1,
    pageSize: 10,
  });

  // chat dialog state
  const [timeLineVendorData, setTimeLineVendorData] = useState({});
  const [chatConfirmationDialog, setChatConfirmationDialog] = useState({
    open: false,
    isClosedChat: true,
  });
  // bidcheckbox  enable
  const [selectedbids, setSelectedbids] = useState(false);
  // open modal quantity
  const [openvendor, setOpenvendor] = useState(false); // added ?
  const [totaldata, settotaldata] = useState([]);

  const [openVendorPopup, setOpenVendorPopup] = useState(false);

  // const clearTotalData = () => {
  //   settotaldata([]);
  // };

  // send message state
  const [rfqVendorList, setRfqVendorList] = useState([]);
  const [chatHistory, setChatHistory] = useState([]);
  const [messagePageNumber, setMessagePageNumber] = useState(1);
  const [messageSearchQuery, setMessageSearchQuery] = useState("");
  const [messagePaginationData, setMessagePaginationData] = useState();
  const [messageTableProps, setMessageTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });
  const [userTableProps, setUserTableProps] = useState({
    isLoading: false,
    errorMessage: "",
  });

  const [itemToken, setItemToken] = useState([]);

  console.log(itemToken, "itemTOken");

  // vendor item mapping

  const normalizeItemTokenList = (tokens) => {
    if (!tokens) return [];
    if (Array.isArray(tokens))
      return tokens.map((t) => String(t || "").trim()).filter(Boolean);
    const single = String(tokens || "").trim();
    return single ? [single] : [];
  };

  const normalizeLooseCell = (value) =>
    String(value ?? "")
      .replace(/\s+/g, " ")
      .trim();

  const extractItemTokensFromItemUploadFile = async (file) => {
    try {
      if (!file) return [];

      const buffer =
        typeof file.arrayBuffer === "function"
          ? await file.arrayBuffer()
          : await new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result);
              reader.onerror = () =>
                reject(reader.error || new Error("Failed to read file"));
              reader.readAsArrayBuffer(file);
            });

      const workbook = XLSX.read(buffer, { type: "array" });
      const sheetName = workbook.SheetNames?.[0];
      if (!sheetName) return [];
      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const itemCodes = rows
        .map((r) =>
          normalizeLooseCell(
            r?.item_code ?? r?.itemCode ?? r?.["Item Code"] ?? r?.["ITEM CODE"],
          ),
        )
        .filter(Boolean);

      const itemNames = rows
        .map((r) =>
          normalizeLooseCell(
            r?.item_name ?? r?.itemName ?? r?.["Item Name"] ?? r?.["ITEM NAME"],
          ),
        )
        .filter(Boolean);

      let codeOptions = Array.isArray(itemList?.values?.visibleOption)
        ? itemList.values.visibleOption
        : [];
      let codeTokens = Array.isArray(itemList?.values?.tokens)
        ? itemList.values.tokens
        : [];
      let nameOptions = Array.isArray(itemNameList?.values?.visibleOption)
        ? itemNameList.values.visibleOption
        : [];
      let nameTokens = Array.isArray(itemNameList?.values?.tokens)
        ? itemNameList.values.tokens
        : [];

      // Fallback: use cached master items if state options are not ready yet.
      if (codeOptions.length === 0 || nameOptions.length === 0) {
        const cachedItems = await masterDataRepository.getItemsFromCache();
        if (Array.isArray(cachedItems) && cachedItems.length > 0) {
          if (codeOptions.length === 0) {
            codeOptions = cachedItems.map((it) => it?.item_code);
            codeTokens = cachedItems.map((it) => it?.token);
          }
          if (nameOptions.length === 0) {
            nameOptions = cachedItems.map((it) => it?.item_name);
            nameTokens = cachedItems.map((it) => it?.token);
          }
        }
      }

      const codeToToken = new Map();
      codeOptions.forEach((c, idx) => {
        const key = normalizeLooseCell(c);
        const token = codeTokens[idx];
        if (key && token) codeToToken.set(key.toLowerCase(), token);
      });
      const nameToToken = new Map();
      nameOptions.forEach((n, idx) => {
        const key = normalizeLooseCell(n);
        const token = nameTokens[idx];
        if (key && token) nameToToken.set(key.toLowerCase(), token);
      });

      const resolved = [];
      itemCodes.forEach((c) => {
        const token = codeToToken.get(c.toLowerCase());
        if (token) resolved.push(token);
      });
      itemNames.forEach((n) => {
        const token = nameToToken.get(n.toLowerCase());
        if (token) resolved.push(token);
      });

      return [
        ...new Set(resolved.map((t) => String(t).trim()).filter(Boolean)),
      ];
    } catch (e) {
      console.warn("Failed to parse item upload file for vendor filtering:", e);
      return [];
    }
  };

  const [vendorContactsByVendorToken, setVendorContactsByVendorToken] =
    useState({});
  const [vendorContactTokenSet, setVendorContactTokenSet] = useState(new Set());

  // vendor item mapping (filter vendors based on selected item(s))
  const collectSelectedItemTokens = (
    overrideIndex = null,
    overrideToken = null,
  ) => {
    const list = Array.isArray(itemsInput) ? itemsInput : [];
    const tokens = list
      .map((it, idx) => (idx === overrideIndex ? overrideToken : it?.itemToken))
      .filter(Boolean)
      .map((t) => String(t || "").trim())
      .filter(Boolean);
    return [...new Set(tokens)];
  };

  const getVendorsByCategory = async (itemTokens = []) => {
    const normalizedTokens = normalizeItemTokenList(itemTokens);
    if (normalizedTokens.length === 0) return;
    vendorFilterActiveRef.current = true;

    try {
      const fetchForToken = async (token) => {
        const res = await axios.post(
          API_ENDPOINT.vendors_by_category,
          {
            organization_token,
            item_token: token,
          },
          {
            headers: {
              Authorization: `Bearer ${auth_token}`,
            },
          },
        );
        const vendors = Array.isArray(res?.data?.vendors)
          ? res.data.vendors
          : [];
        const vendorContacts = Array.isArray(res?.data?.vendor_contacts)
          ? res.data.vendor_contacts
          : [];
        return { itemToken: token, vendors, vendorContacts };
      };

      const results =
        normalizedTokens.length === 1
          ? [await fetchForToken(normalizedTokens[0])]
          : await Promise.all(normalizedTokens.map((t) => fetchForToken(t)));

      const vendors = results.flatMap((r) => r.vendors || []);
      const vendorContacts = results.flatMap((r) => r.vendorContacts || []);

      // Map each selected item → allowed vendor/contact tokens (used for submit validation).
      const nextAllowedByItem = {};
      results.forEach((r) => {
        const token = String(r?.itemToken || "").trim();
        if (!token) return;

        const contacts = Array.isArray(r?.vendorContacts)
          ? r.vendorContacts
          : [];
        const vend = Array.isArray(r?.vendors) ? r.vendors : [];

        const fromContacts = contacts
          .map((v) =>
            String(
              v?.vendor_contact_token || v?.vendor_token || v?.token || "",
            ).trim(),
          )
          .filter(Boolean);
        const fromVendors = vend
          .map((v) =>
            String(v?.vendor_token || v?.token || v?.user_token || "").trim(),
          )
          .filter(Boolean);

        const allowed = fromContacts.length > 0 ? fromContacts : fromVendors;
        nextAllowedByItem[token] = [...new Set(allowed)];
      });
      setAllowedVendorTokensByItemToken(nextAllowedByItem);

      // Index vendor contacts by vendor token/name for payload mapping.
      if (vendorContacts.length > 0) {
        const tokenSet = new Set();
        const nextIndex = {};
        vendorContacts.forEach((vc) => {
          const vendorToken = String(
            vc?.vendor_token || vc?.vendor || vc?.vendor_id || "",
          ).trim();
          const vendorName = String(
            vc?.vendor_name ||
              vc?.vendor_contact_name ||
              vc?.company_name ||
              vc?.name ||
              "",
          ).trim();
          const groupKey = vendorToken || vendorName;
          const contactToken = String(
            vc?.vendor_contact_token || vc?.vendor_contact || vc?.token || "",
          ).trim();
          if (!groupKey || !contactToken) return;
          tokenSet.add(contactToken);
          if (!nextIndex[groupKey]) nextIndex[groupKey] = [];
          nextIndex[groupKey].push(contactToken);
        });
        // De-dupe arrays
        Object.keys(nextIndex).forEach((k) => {
          nextIndex[k] = [...new Set(nextIndex[k])];
        });
        setVendorContactsByVendorToken(nextIndex);
        setVendorContactTokenSet(tokenSet);
      } else {
        setVendorContactsByVendorToken({});
        setVendorContactTokenSet(new Set());
      }

      const shortToken = (token) => {
        const t = String(token || "").trim();
        return t ? t.slice(0, 6) : "";
      };

      // Prefer vendor_contacts list for edit vendor mapping (backend expects vendor_contact_token).
      const optionsFromContacts =
        vendorContacts.length > 0
          ? {
              ...(() => {
                const map = new Map();
                vendorContacts.forEach((v) => {
                  const token = (
                    v?.vendor_contact_token ||
                    v?.vendor_token ||
                    v?.token ||
                    ""
                  )
                    .toString()
                    .trim();
                  if (!token) return;
                  const name = String(
                    v?.vendor_name ||
                      v?.vendor_contact_name ||
                      v?.company_name ||
                      v?.name ||
                      "",
                  ).trim();
                  const email = String(
                    v?.vendor_email ||
                      v?.company_official_email ||
                      v?.email ||
                      "",
                  ).trim();
                  const label = email
                    ? `${name} (${email})`
                    : `${name} (${shortToken(token)})`;
                  if (!label) return;
                  if (!map.has(token)) map.set(token, label);
                });
                return {
                  tokens: Array.from(map.keys()),
                  visibleOption: Array.from(map.values()),
                };
              })(),
            }
          : null;

      // Fallback to vendors if vendor_contacts is not returned.
      const optionsFromVendors =
        !optionsFromContacts && vendors.length > 0
          ? {
              ...(() => {
                const map = new Map();
                vendors.forEach((v) => {
                  const token = (
                    v?.vendor_token ||
                    v?.token ||
                    v?.user_token ||
                    ""
                  )
                    .toString()
                    .trim();
                  if (!token) return;
                  const name = String(
                    v?.vendor_name || v?.company_name || v?.name || "",
                  ).trim();
                  const email = String(
                    v?.vendor_email ||
                      v?.company_official_email ||
                      v?.email ||
                      "",
                  ).trim();
                  const label = email
                    ? `${name} (${email})`
                    : `${name} (${shortToken(token)})`;
                  if (!label) return;
                  if (!map.has(token)) map.set(token, label);
                });
                return {
                  tokens: Array.from(map.keys()),
                  visibleOption: Array.from(map.values()),
                };
              })(),
            }
          : null;

      setVendorsList({
        values: optionsFromVendors ||
          optionsFromContacts || { tokens: [], visibleOption: [] },
      });
      reconcileSelectedVendorsWithOptions(
        optionsFromVendors ||
          optionsFromContacts || { tokens: [], visibleOption: [] },
      );
    } catch (err) {
      console.error("Vendor filter failed", err);
      vendorFilterActiveRef.current = true;
      setVendorsList({
        values: { tokens: [], visibleOption: [] },
      });
    }
  };

  const normalizeBidTypeValue = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (normalized === "open" || normalized === "true") return true;
      if (normalized === "closed" || normalized === "false") return false;
    }
    return false;
  };

  const normalizeBooleanValue = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1" || normalized === "yes";
    }
    return false;
  };

  const mergeSealedBidMeta = (rfqData = {}, ...sources) => {
    const getNestedResultValue = (source, key) => {
      const nestedResults = [
        source?.results,
        source?.result,
        source?.response,
      ].flatMap((value) => (Array.isArray(value) ? value : value ? [value] : []));
      return nestedResults.find(
        (result) => result?.[key] !== undefined && result?.[key] !== null,
      )?.[key];
    };
    const findValue = (key) => {
      const sourcesToSearch = [rfqData, ...sources];
      const directValue = sourcesToSearch.find(
        (source) => source?.[key] !== undefined && source?.[key] !== null,
      )?.[key];
      if (directValue !== undefined && directValue !== null) return directValue;

      return sourcesToSearch
        .map((source) => getNestedResultValue(source, key))
        .find((value) => value !== undefined && value !== null);
    };
    const sealedBidValues = [rfqData, ...sources].flatMap((source) => [
      source?.sealed_bid,
      source?.sealedBid,
      getNestedResultValue(source, "sealed_bid"),
      getNestedResultValue(source, "sealedBid"),
    ]);
    const sealedBidValue = sealedBidValues.find((value) =>
      normalizeBooleanValue(value),
    );

    return {
      ...rfqData,
      // The list and detail endpoints can disagree temporarily after an RFQ update.
      // Do not remove an active sealed-bid lock when either endpoint confirms it.
      sealed_bid: sealedBidValue ?? findValue("sealed_bid"),
      locked_bid_count: findValue("locked_bid_count"),
      next_unlock_at: findValue("next_unlock_at"),
    };
  };

  const getSelectedVendorTokens = () => {
    const alternativeTokens = alternativeSupplierOptions.map((option) => option.token).filter(Boolean);
    const tokensFromId = Array.isArray(vendorId)
      ? vendorId.filter(Boolean)
      : [];
    if (tokensFromId.length > 0) return [...new Set([...tokensFromId, ...alternativeTokens])];

    const values = Array.isArray(vendor.value)
      ? vendor.value.filter(Boolean)
      : [];
    if (values.length === 0) return alternativeTokens;

    const mappedFromOptions = values
      .map((selectedValue) => {
        const idx = vendorsList?.values?.visibleOption?.indexOf(selectedValue);
        return idx >= 0 ? vendorsList?.values?.tokens?.[idx] : null;
      })
      .filter(Boolean);

    if (mappedFromOptions.length > 0) return [...new Set([...mappedFromOptions, ...alternativeTokens])];

    // Existing edit values can already be vendor tokens.
    return [...new Set([...values.map((v) => String(v).trim()).filter(Boolean), ...alternativeTokens])];
  };

  const getSelectedVendorContactTokensForPayload = () => {
    const selectedVendorTokens = getSelectedVendorTokens();
    if (!selectedVendorTokens.length) return [];

    // If the user selected vendor_contact_token(s) directly (options are based on vendor_contacts),
    // send them as-is.
    if (vendorContactTokenSet && vendorContactTokenSet.size > 0) {
      const directContacts = selectedVendorTokens.filter((t) =>
        vendorContactTokenSet.has(String(t).trim()),
      );
      if (directContacts.length === selectedVendorTokens.length) return [...new Set(directContacts)];
    }

    const index = vendorContactsByVendorToken || {};
    const contactTokens = selectedVendorTokens.flatMap((t) => {
      // Direct match by vendor token (preferred)
      if (index[t]) return index[t];

      // Fallback: match by selected label text (when vendor_contacts lacks vendor_token in response)
      const labelIdx = vendorsList?.values?.tokens?.indexOf(t);
      const selectedLabel =
        labelIdx >= 0
          ? String(vendorsList?.values?.visibleOption?.[labelIdx] || "").trim()
          : "";
      if (selectedLabel && index[selectedLabel]) return index[selectedLabel];

      return [];
    });
    return contactTokens.length > 0
      ? [...new Set([...selectedVendorTokens.filter((t) => vendorContactTokenSet.has(String(t).trim())), ...contactTokens])]
      : selectedVendorTokens;
  };

  const reconcileSelectedVendorsWithOptions = (nextOptions) => {
    const optionLabels = Array.isArray(nextOptions?.visibleOption)
      ? nextOptions.visibleOption
      : [];
    const optionTokens = Array.isArray(nextOptions?.tokens)
      ? nextOptions.tokens
      : [];

    const selectedRaw = Array.isArray(vendor.value) ? vendor.value : [];
    if (selectedRaw.length === 0) return;

    // If selection contains tokens (vendor/vendor_contact tokens), convert to labels so UI shows names/emails.
    const tokenToLabel = new Map();
    optionTokens.forEach((t, idx) => {
      const label = optionLabels[idx];
      const token = String(t || "").trim();
      if (token && label) tokenToLabel.set(token, label);
    });

    const looksLikeToken = (v) =>
      /^[a-f0-9]{24,}$/i.test(String(v || "").trim());
    const selectedAreTokens =
      selectedRaw.some((v) => looksLikeToken(v)) &&
      selectedRaw.every((v) => looksLikeToken(v));

    if (selectedAreTokens) {
      const mappedLabels = selectedRaw
        .map((t) => tokenToLabel.get(String(t).trim()))
        .filter(Boolean);

      if (mappedLabels.length > 0) {
        setVendor((prev) => ({
          ...prev,
          value: mappedLabels,
          isValid: mappedLabels.length > 0,
        }));
      }
      return;
    }

    // Otherwise, selection is label-based; attempt a best-effort remap when option labels are "Name (email)" or "Name (tokenPrefix)".
    const remapped = selectedRaw
      .map((label) => {
        const raw = String(label || "").trim();
        if (!raw) return null;
        if (optionLabels.includes(raw)) return raw;

        const candidates = optionLabels.filter((opt) =>
          String(opt || "")
            .trim()
            .toLowerCase()
            .startsWith(raw.toLowerCase() + " ("),
        );
        if (candidates.length === 1) return candidates[0];
        // Ambiguous legacy label (multiple contacts for same vendor name): force user to pick a specific contact.
        return null;
      })
      .filter(Boolean);

    // Trim only values that are completely empty; keep ambiguous legacy labels intact.
    if (remapped.join("|") !== selectedRaw.join("|")) {
      setVendor((prev) => ({
        ...prev,
        value: remapped,
        isValid: remapped.length > 0,
      }));
      setVendorID([]);
    }
  };

  const GetAllMessageData = async () => {
    // Try cache first when offline
    if (!shouldMakeAPICall(auth_token, buyer_token)) {
      console.log("📴 Offline - loading messages from cache");
      try {
        const cachedMessages =
          await rfqRepository.getMessagesFromCache(rfqToken);
        if (cachedMessages && cachedMessages.length > 0) {
          console.log(`📦 Loaded ${cachedMessages.length} messages from cache`);
          setChatHistory(cachedMessages);
          // Set pagination data for cached messages
          setMessagePaginationData({
            total_items: cachedMessages.length,
            page_count: Math.ceil(cachedMessages.length / 10),
            current_page: messagePageNumber,
            current_page_count: cachedMessages.length,
          });
          setMessageTableProps({
            ...messageTableProps,
            isLoading: false,
            errorMessage: "", // No error when using cache
          });
          return;
        } else {
          console.log("⚠️ No cached messages found");
          setChatHistory([]);
          setMessagePaginationData({});
          setMessageTableProps({
            ...messageTableProps,
            isLoading: false,
            errorMessage: "", // No error - just empty data
          });
          return;
        }
      } catch (error) {
        console.error("Error loading messages from cache:", error);
        setChatHistory([]);
        setMessagePaginationData({});
        setMessageTableProps({
          ...messageTableProps,
          isLoading: false,
          errorMessage: "", // No error - just empty data
        });
        return;
      }
    }

    // Online: use fetchPagedData (which will also cache the data)
    fetchPagedData({
      pageNumber: messagePageNumber,
      endpoint: `${API_ENDPOINT.list_of_msg}`,
      idName: "rfq_token",
      idValue: rfqToken,
      searchQuery: messageSearchQuery,
      auth_token: auth_token,
      ...(sortingColumnName && { sortingColumnName: sortingColumnName }),
      ...(sortingOrder && { sortingOrder: sortingOrder }),
      setData: async (data) => {
        // fetchPagedData passes results array, but list_of_msg might return response array
        // Handle both cases
        let messages = data;
        if (!Array.isArray(data) && data?.response) {
          messages = data.response;
        } else if (!Array.isArray(data) && data?.results) {
          messages = data.results;
        }

        if (Array.isArray(messages)) {
          setChatHistory(messages);
          // Also save to cache
          if (messages.length > 0) {
            await rfqRepository.saveMessagesToCache(rfqToken, messages);
            console.log(`✅ Cached ${messages.length} messages from API`);
          }
        } else {
          setChatHistory([]);
        }
      },
      setPaginationData: setMessagePaginationData,
      tableProps: messageTableProps,
      setTableProps: (props) => {
        // Don't show network errors when offline - use cache silently
        if (
          props.errorMessage &&
          props.errorMessage.includes("Network error")
        ) {
          // Try to load from cache on network error
          rfqRepository
            .getMessagesFromCache(rfqToken)
            .then((cachedMessages) => {
              if (cachedMessages && cachedMessages.length > 0) {
                console.log("📦 Using cached messages due to network error");
                setChatHistory(cachedMessages);
                setMessagePaginationData({
                  total_items: cachedMessages.length,
                  page_count: Math.ceil(cachedMessages.length / 10),
                  current_page: messagePageNumber,
                  current_page_count: cachedMessages.length,
                });
                setMessageTableProps({
                  ...messageTableProps,
                  isLoading: false,
                  errorMessage: "", // Clear error - using cache
                });
              } else {
                setMessageTableProps({
                  ...props,
                  errorMessage: "", // Clear error even if no cache
                });
              }
            });
        } else {
          setMessageTableProps({
            ...props,
            errorMessage: sanitizeErrorMessage(props?.errorMessage),
          });
        }
      },
    });
  };

  useEffect(() => {
    if (viewRFQ && rfqToken) {
      const loadRFQVendorList = async () => {
        // Try cache first
        const cachedVendorList =
          await rfqRepository.getRFQVendorListFromCache(rfqToken);
        if (cachedVendorList && cachedVendorList.length > 0) {
          console.log(
            `📦 Loaded ${cachedVendorList.length} RFQ vendors from cache`,
          );
          setRfqVendorList(cachedVendorList);
        }

        // Sync from API if online
        if (shouldMakeAPICall(auth_token, buyer_token)) {
          try {
            const response = await axios({
              method: "POST",
              url: `${API_ENDPOINT.enable_vendor_list}`,
              data: { rfq_token: rfqToken },
              headers: {
                Authorization: `Bearer ${auth_token}`,
              },
            });
            const vendorList = response.data.vendor_detail || [];
            // Save to cache
            await rfqRepository.saveRFQVendorListToCache(rfqToken, vendorList);
            setRfqVendorList(vendorList);
            console.log(
              `✅ Synced---------- ${vendorList.length} RFQ vendors from API`,
            );
          } catch (err) {
            console.error("Error loading RFQ vendor list:", err);
            // If API fails and we have cached data, keep using it
            if (!cachedVendorList || cachedVendorList.length === 0) {
              console.warn("⚠️ No cached RFQ vendor list available");
              setRfqVendorList([]);
            } else {
              console.log(
                "📴 Using cached RFQ vendor list due to network error",
              );
            }
          }
        } else {
          // Offline: use cached data
          if (!cachedVendorList || cachedVendorList.length === 0) {
            console.warn("⚠️ No cached RFQ vendor list available offline");
            setRfqVendorList([]);
          } else {
            console.log("📴 Offline - using cached RFQ vendor list");
          }
        }
      };

      loadRFQVendorList();
    }

    // axios({
    //   method: "POST",
    //   url: `${API_ENDPOINT.list_of_msg}`,
    //   data: { rfq_token: rfqToken },
    //   headers: {
    //     Authorization: `Bearer ${auth_token}`,
    //   },
    // })
    //   .then((response) => {
    //     const vendorList = response.data.vendor_detail;
    //     setChatHistory(vendorList);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }, [viewRFQ, rfqToken, auth_token, buyer_token]);

  const [isempty, setisempty] = useState(false);

  const handleSeletedRowsList = (rowList, row) => {
    const uniqueList = [...new Set(row?.map((e, i) => e?.vendor_token))];
    setSelectedRows(uniqueList);
    setSelectedRowForComparison(row || []);
  };

  const handleSeletedRowsListMessage = (rowList, row) => {
    const tokensFromRowList = Array.isArray(rowList)
      ? rowList.filter(Boolean)
      : [];
    const tokensFromRows = Array.isArray(row)
      ? [
          ...new Set(
            row.map((e) => e?.token ?? e?.vendor_token).filter(Boolean),
          ),
        ]
      : [];
    const uniqueList = tokensFromRowList.length
      ? tokensFromRowList
      : tokensFromRows;
    setSelectedRows(uniqueList);
    setSelectedRowForComparison(row || []);
  };
  const storedValue = localStorage.getItem("rfq_page_number");
  // Convert the string to a number using parseInt or parseFloat
  const pageNumbers = parseInt(storedValue); // or parseFloat(storedValue) for floating point numbers

  const openRFQMain = () => {
    setRFQMain(true);
    setRequestQuote(false);
    setEnableSelect(false);
    setOpenForm({
      loading: false,
      errorMessage: "",
    });
    setViewRFQ(false);
    resetForm();
    setUniqueData();
    handleClose();
    tab1Click();
    setBtnErrorState({
      error: false,
      errorMsg: "",
    });

    setPageNumber(pageNumbers);
    setBidsData();
    setBidsLoadedFromRfqBids(false); // Reset flag when clearing bids
    setPaginationData();
    setNewRFQForm(false);
    setEditRFQForm(false);
    setSortingColumnName(null);
    setSortingOrder(null);
    setViewTimeLine(false);
    setViewUserTimeLine(false);
    setSearchQuery2("");
    SetQuickRFQ(false);
    vendorFilterActiveRef.current = false;
    setVendorsList({
      values: { tokens: [], visibleOption: [] },
    });
  };

  const selectedVendors = Array.isArray(bulkBidsData)
    ? bulkBidsData.filter((item) => item.status === "selected")
    : [];
  const vendor_data = bidsData;
  const hasSelectedStatus = selectedVendors.length > 0;

  const openRFQMainTimeLine = () => {
    setRFQMain(false);
    setViewRFQ(true);
    setViewTimeLine(false);
    setViewUserTimeLine(false);
  };
  const openViewIndividualRFQ = () => {
    setRFQMain(false);
    setViewRFQ(false);
    setViewTimeLine(false);
    setViewRFQComparedTable(true);
  };
  const backViewIndividualRFQ = () => {
    setCompairedData([]);
    setFileJsonHistory([]);
    setComparedNameDate({});
    setCompareHistoryToken("");
    setIsComparePending(false);
    setComparisonPreviousPurchases([]);
    setRFQMain(false);
    setViewRFQ(true);
    setViewTimeLine(false);
    setViewRFQComparedTable(false);
  };
  const openRFQMainCancel = () => {
    setRFQMain(true);
    setRequestQuote(false);
    setEnableSelect(false);
    setOpenForm({
      loading: false,
      errorMessage: "",
    });
    setViewRFQ(false);
    resetForm();
    setUniqueData();
    handleClose();
    tab1Click();
    setBtnErrorState({
      error: false,
      errorMsg: "",
    });

    setPageNumber(pageNumbers);
    setBidsData();
    setBidsLoadedFromRfqBids(false); // Reset flag when clearing bids
    setPaginationData();
    setNewRFQForm(false);
    setEditRFQForm(false);
    setSortingColumnName(null);
    setSortingOrder(null);
    setViewTimeLine(false);
    setSelectedRows([]);
    setSearchQuery2("");
  };

  const sendMessageReset = () => {
    setSendMessage(false);
    setTextAreaSendMessage(false);
    setErrorMessages(false);
    setOpen2(false);
  };

  const openNewRFQ = () => {
    // Ensure no stale form state leaks into a fresh RFQ
    resetForm();
    setFromDate({
      value: dayjs().startOf("day").format("YYYY-MM-DD HH:mm:ss.SSSSSS"),
      isValid: true,
    });
    setOpenForm({
      open: true,
      loading: false,
      errorMessage: "",
    });
    // New RFQ: show Select Quotation Category (not edit-only)
    setCategoryOnEdit(false);
    setEditRFQForm(false);
    setViewRFQ(false);
    setRFQMain(false);
    if (!itemList?.values?.tokens?.length) {
      viewAllItem(org_token);
    } else if (!vendorsList?.values?.tokens?.length) {
      getAllVendorsData({ showLoader: false });
    }
    setPageNumber(1);
    setNewRFQForm(true);
    setViewTimeLine(false);
    void getAllDepartments();
    getshippingAddress();
    getCategoryList();
  };

  const [categoryonEdit, setCategoryOnEdit] = useState(false);

  const openViewRFQ = async (unique_id, rowData) => {
    // Reset flag
    setBidsLoadedFromRfqBids(false);
    // Clear previous RFQ view state to avoid stale rows/buttons (e.g. selected vendors from last RFQ)
    setBulkBidsData([]);
    setBidsData([]);
    setPaginationData({});
    setTableProps((prev) => ({ ...prev, isLoading: false, errorMessage: "" }));
    setUniqueData(undefined);
    setItemsListDataViewRFQ([]);
    setRfqVendorList([]);
    setChatHistory([]);
    setMessagePaginationData({});
    setMessageTableProps({ isLoading: false, errorMessage: "" });
    setUserTableProps({ isLoading: false, errorMessage: "" });
    setSelectedRows([]);
    setSelectedRowForComparison([]);
    // Move to view immediately to avoid blocking UI while data loads
    setSortingColumnName(null);
    setSortingOrder(null);
    setRFQToken(unique_id);
    setViewRFQ(true);
    setRFQMain(false);
    setPageNumber(1);
    setNewRFQForm(false);
    setEditRFQForm(false);
    setViewTimeLine(false);
    setViewUserTimeLine(false);

    const selectedRfqFromList =
      (Array.isArray(RFQData)
        ? RFQData.find(
            (rfq) =>
              String(rfq?.token || rfq?.rfq_token || "") ===
              String(unique_id || ""),
          )
        : null) || rowData;

    if (selectedRfqFromList?.department) {
      void hydrateRfqBudget({
        department:
          selectedRfqFromList.department?.name ||
          selectedRfqFromList.department,
        department_id:
          selectedRfqFromList.department_id ||
          selectedRfqFromList.department?.id,
      });
    }

    // Load RFQ details in the background (also loads bids/vendor list if available)
    const detailsLoad = await getIndividualData(unique_id);
    if (rowData) {
      setUniqueData((prev) => mergeSealedBidMeta(prev || {}, rowData));
    }

    setOpenForm({
      open: false,
      loading: false,
      errorMessage: "",
    });

    // Only call separate bid APIs if we don't have bids from the RFQ details API
    // Offline: bind bids from IndexedDB only; do not call API
    if (!detailsLoad?.bidsLoadedFromRfqBids) {
      const cachedBids = await rfqRepository.getBidsFromIndexedDB(unique_id);
      if (!cachedBids || cachedBids.length === 0) {
        if (shouldMakeAPICall(auth_token, buyer_token)) {
          console.log("📡 Loading bids from separate API (not in rfq_bids)");
          void getEveryBidsData(unique_id);
          void GetAllBidsData(1, unique_id);
        }
      } else {
        console.log(
          `📦 Using ${cachedBids.length} bids from IndexedDB for RFQ view`,
        );
        const mappedCachedBids = cachedBids.map((bid) => mapBidForTable(bid));
        setBulkBidsData(mappedCachedBids);
        setBidsData(mappedCachedBids);
        void GetAllBidsData(1, unique_id);
      }
    } else {
      console.log(
        "✅ Bids already loaded from rfq_bids, skipping separate API calls",
      );
    }
  };

  // useEffect(() => {
  //   const storedCode = localStorage.getItem("selected_rfq_code");
  //   if (storedCode) {
  //     openViewRFQ(storedCode);
  //     localStorage.removeItem("selected_rfq_code");
  //   }

  //   const handleOpenRFQ = (e) => {
  //     const rfqCode = e.detail;
  //     if (rfqCode) {
  //       openViewRFQ(rfqCode);
  //     }
  //   };

  //   window.addEventListener("openRFQ", handleOpenRFQ);
  //   return () => window.removeEventListener("openRFQ", handleOpenRFQ);
  // }, []);

  const openEditRFQ = () => {
    // Clear any previous form state to avoid stale values (especially quotation category)
    resetForm();
    setOpenForm({
      open: true,
      loading: false,
      errorMessage: "",
    });

    setEditRFQForm(true);
    setViewRFQ(false);
    setRFQMain(false);
    // getAllVendorsData();
    setNewRFQForm(false);
    // viewAllItem(org_token);
    setSortingColumnName(null);
    setSortingOrder(null);

    getCategoryList();
    void getAllDepartments();

    // Keep quotation category visible in edit mode for all RFQs.
    setCategoryOnEdit(false);
  };

  const tab1Click = () => {
    setTab1(true);
    setTab2(false);
  };

  const tab2Click = () => {
    setTab1(false);
    setTab2(true);

    // Ensure states and cities are loaded when address tab opens
    // This ensures cache is populated before filtering
    getStatesList(null);
    getCityList(null);

    //gets states list when the shipping address tab opens (if country is already selected)
    let filterCountry = country.countryList?.filter(
      (el) => el.name === country.value,
    );

    let country_token = filterCountry && filterCountry[0]?.token;

    filterCountry && setCountryToken(country_token);

    if (filterCountry && filterCountry[0]) {
      let country_id = filterCountry[0]?.id;
      let country_token = filterCountry[0]?.token;
      // Small delay to ensure initial load completes, then filter
      setTimeout(() => {
        getStatesList(country_id, country_token);
      }, 100);
    }
  };

  const onLocaleStoreg = (data) => {
    localStorage.setItem(
      "rfq_page_number",
      `${data === "prev" ? parseInt(pageNumber) - 1 : parseInt(pageNumber) + 1}`,
    );
  };

  useEffect(() => {
    // Clear the local storage value when the page is reloaded
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("rfq_page_number", 1);
    });
  }, []);

  // Offline RFQ hook - must be declared before filteredRFQs (which may use offlineRFQs when filters are applied)
  const {
    rfqs: offlineRFQs,
    loading: offlineLoading,
    refetch: refetchRFQs,
  } = useOfflineRFQs(
    auth_token,
    buyer_token,
    null,
    debouncedSearchQuery,
    startDateSearchQuery.value,
    endDateSearchQuery.value,
    sortingColumnName,
    sortingOrder,
    true, // skipSyncWhenOnline: server-side pagination + background sync handled by GetAllData
  );

  const rfqListOffline = !shouldMakeAPICall(auth_token, buyer_token);
  const hasClientFilters = !!(
    debouncedSearchQuery ||
    startDateSearchQuery.value ||
    endDateSearchQuery.value
  );
  // Online: always use server-side pagination (even for search).
  // Offline: use client-side pagination.
  const useClientSidePaging =
    rfqListOffline || forceClientPaging || !!statusFilter;

  // Client-side filtering (offline OR when filters are applied online; uses cache as source when available).
  const filteredRFQs = useMemo(() => {
    // When status filter is active, prefer full cached list (offlineRFQs) so filter applies across all pages.
    const source =
      statusFilter && Array.isArray(offlineRFQs) && offlineRFQs.length > 0
        ? offlineRFQs
        : RFQData;

    if (!Array.isArray(source) || source.length === 0) return [];

    return source.filter((rfq) => {
      const matchesSearch =
        debouncedSearchQuery === "" ||
        rfq.rfq_code
          ?.toLowerCase()
          .includes(debouncedSearchQuery.toLowerCase()) ||
        String(rfq.purchase_request_number || "")
          .toLowerCase()
          .includes(debouncedSearchQuery.toLowerCase()) ||
        (rfq.item_name || "")
          .toLowerCase()
          .includes(debouncedSearchQuery.toLowerCase()) ||
        (rfq.item_code || "")
          .toLowerCase()
          .includes(debouncedSearchQuery.toLowerCase()) ||
        rfq.buyer_details?.name
          ?.toLowerCase()
          .includes(debouncedSearchQuery.toLowerCase());

      const normalizedStatus = String(rfq.bid_status || "")
        .trim()
        .toLowerCase();
      const normalizedFilter = String(statusFilter || "")
        .trim()
        .toLowerCase();
      const matchesStatus =
        normalizedFilter === "" || normalizedStatus === normalizedFilter;
      let matchesDate = true;
      if (startDateSearchQuery.value && endDateSearchQuery.value) {
        const rfqDate = new Date(rfq.bid_from_date || rfq.created_on || "");
        matchesDate =
          rfqDate >= new Date(startDateSearchQuery.value) &&
          rfqDate <= new Date(endDateSearchQuery.value);
      } else if (startDateSearchQuery.value) {
        matchesDate =
          new Date(rfq.bid_from_date || rfq.created_on || "") >=
          new Date(startDateSearchQuery.value);
      } else if (endDateSearchQuery.value) {
        matchesDate =
          new Date(rfq.bid_from_date || rfq.created_on || "") <=
          new Date(endDateSearchQuery.value);
      }
      return matchesSearch && matchesDate && matchesStatus;
    });
  }, [
    RFQData,
    offlineRFQs,
    debouncedSearchQuery,
    statusFilter,
    startDateSearchQuery.value,
    endDateSearchQuery.value,
    rfqListOffline,
    hasClientFilters,
  ]);

  // Client-side pagination (offline or when filters applied online). Otherwise: server-side.
  const paginatedRFQs = useMemo(() => {
    if (filteredRFQs.length === 0) return [];
    if (!useClientSidePaging) return filteredRFQs;
    if (!rowsPerPage || rowsPerPage < 0) return filteredRFQs;
    const start = page * rowsPerPage;
    return filteredRFQs.slice(start, start + rowsPerPage);
  }, [filteredRFQs, page, rowsPerPage, useClientSidePaging]);

  const clientSideCount = filteredRFQs.length || RFQData?.length || 0;
  const paginationCount = useClientSidePaging
    ? clientSideCount
    : serverPagination.totalRFQs || 0;
  const paginationPage = useClientSidePaging
    ? page
    : Math.max(0, (serverPage || 1) - 1);
  const paginationRowsPerPage = useClientSidePaging
    ? rowsPerPage
    : serverPagination.pageSize || 10;

  // Ensure table rows and pagination use the same source.
  const displayRFQs = useClientSidePaging
    ? paginatedRFQs
    : statusFilter
      ? filteredRFQs
      : RFQData;

  useEffect(() => {
    if (useClientSidePaging) setPage(0);
    else setServerPage(1);
  }, [
    debouncedSearchQuery,
    statusFilter,
    startDateSearchQuery.value,
    endDateSearchQuery.value,
    sortingColumnName,
    sortingOrder,
    useClientSidePaging,
  ]);

  useEffect(() => {
    if (!useClientSidePaging || !rowsPerPage || rowsPerPage < 0) return;
    const totalItems = filteredRFQs.length;
    const maxPage = Math.max(0, Math.ceil(totalItems / rowsPerPage) - 1);
    if (page > maxPage) setPage(maxPage);
  }, [filteredRFQs, rowsPerPage, page, useClientSidePaging]);

  const handleChangePage = (event, newPage) => {
    if (useClientSidePaging) {
      setPage(newPage);
    } else {
      setServerPage(newPage + 1);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newRows = parseInt(event.target.value, 10);
    setRowsPerPage(Number.isNaN(newRows) ? rowsPerPage : newRows);
    setPage(0);
    if (!useClientSidePaging) setServerPage(1);
  };

  // PaginationActions component (like PR)
  function PaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
      onPageChange(event, lastPage);
    };

    const isBackDisabled = page === 0;
    const isNextDisabled = page >= Math.ceil(count / rowsPerPage) - 1;

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={isBackDisabled}
          aria-label="first page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <LastPageIcon sx={{ fontSize: 24 }} />
          ) : (
            <FirstPageIcon sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={isBackDisabled}
          aria-label="previous page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight sx={{ fontSize: 24 }} />
          ) : (
            <KeyboardArrowLeft sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={isNextDisabled}
          aria-label="next page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft sx={{ fontSize: 24 }} />
          ) : (
            <KeyboardArrowRight sx={{ fontSize: 24 }} />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={isNextDisabled}
          aria-label="last page"
          size="medium"
          sx={{ p: 1.25 }}
        >
          {theme.direction === "rtl" ? (
            <FirstPageIcon sx={{ fontSize: 24 }} />
          ) : (
            <LastPageIcon sx={{ fontSize: 24 }} />
          )}
        </IconButton>
      </Box>
    );
  }

  // Legacy pagination logics (kept for backward compatibility with other views)
  // NOTE: PaginationComponent displays `itemsPerPage` as "Total count" in UI.
  // When there is no data and paginationData is an empty object, avoid showing the default "10".
  const pageSize = paginationData?.page_size || 10;
  const totalItems =
    paginationData?.total_items ||
    paginationData?.total_count ||
    (paginationData?.page_count
      ? paginationData.page_count * (paginationData?.page_size || 10)
      : bidsData?.length || 0);
  const totalPages =
    paginationData?.page_count ||
    (totalItems > 0 && pageSize > 0 ? Math.ceil(totalItems / pageSize) : 0);
  // Note: currentPage is already declared as state variable at line 222, use that instead

  // Map rfq_vendor_list (API: vendor_token, vendor_name, vendor_email, chat) to Sent Message table shape (first_name, vendor_code, company_official_email, company_phone_number, token). Preserve chat for offline timeline.
  const rfqVendorListMappedForMessages = useMemo(() => {
    if (!Array.isArray(rfqVendorList) || rfqVendorList.length === 0) return [];
    return rfqVendorList.map((v) => ({
      first_name: v.first_name ?? v.vendor_name ?? v.company_name ?? "-",
      vendor_code:
        v.vendor_code ??
        (v.vendor_id != null ? String(v.vendor_id) : null) ??
        "-",
      company_official_email:
        v.company_official_email ?? v.vendor_email ?? v.company_email ?? "-",
      company_phone_number: v.company_phone_number ?? v.vendor_phone ?? "-",
      token: v.token ?? v.vendor_token,
      vendor_token: v.vendor_token ?? v.token,
      chat: v.chat,
      vendor_name: v.vendor_name ?? v.first_name,
      vendor_email: v.vendor_email ?? v.company_official_email,
    }));
  }, [rfqVendorList]);

  // Vendor selection for "Message Vendor" popup expects `token` (used by DataTableSorting selection)
  // and `company_name` (used by headingMessage). Normalize API/cache shapes here.
  const rfqVendorListForMessageSelection = useMemo(
    () => normalizeVendorsForMessageSelection(rfqVendorList),
    [rfqVendorList],
  );

  // Messages / Sent Message table: prefer chatHistory (list_of_msg), else mapped vendor list. Offline: chatHistory from db.rfqMessages, rfqVendorList from cache (rfq_vendor_list) mapped to table shape.
  const messagesTableData = useMemo(() => {
    if (!Array.isArray(chatHistory) || chatHistory.length === 0) {
      return rfqVendorListMappedForMessages;
    }

    const normalizeMessageValue = (value) =>
      String(value ?? "")
        .trim()
        .toLowerCase();

    return chatHistory.map((message) => {
      const messageVendorToken = normalizeMessageValue(
        message?.vendor_token ||
          message?.vendor_details?.vendor_token ||
          message?.vendor_id ||
          message?.vendor_details?.vendor_id ||
          message?.token,
      );
      const messageVendorEmail = normalizeMessageValue(
        message?.company_official_email ||
          message?.vendor_email ||
          message?.vendor_details?.vendor_email ||
          message?.email,
      );

      const matchedVendor = (
        Array.isArray(rfqVendorList) ? rfqVendorList : []
      ).find((vendor) => {
        const vendorToken = normalizeMessageValue(
          vendor?.vendor_token || vendor?.token || vendor?.vendor_id,
        );
        const vendorEmail = normalizeMessageValue(
          vendor?.vendor_email ||
            vendor?.company_official_email ||
            vendor?.email,
        );

        return Boolean(
          (messageVendorToken && vendorToken === messageVendorToken) ||
          (messageVendorEmail && vendorEmail === messageVendorEmail),
        );
      });

      return {
        ...message,
        vendor_name:
          matchedVendor?.vendor_name ||
          matchedVendor?.company_name ||
          message?.vendor_name ||
          message?.company_name ||
          "-",
      };
    });
  }, [chatHistory, rfqVendorList, rfqVendorListMappedForMessages]);
  const messagePageSize = messagePaginationData?.page_size || 10;
  const messageTotalItems =
    messagePaginationData?.total_items ||
    messagePaginationData?.total_count ||
    (messagePaginationData?.page_count
      ? messagePaginationData.page_count *
        (messagePaginationData?.page_size || 10)
      : messagesTableData?.length || 0);
  const messageCurrentPage =
    messagePaginationData?.current_page || messagePageNumber || 1;
  const messageTotalPages =
    messagePaginationData?.page_count ||
    (messageTotalItems > 0 && messagePageSize > 0
      ? Math.ceil(messageTotalItems / messagePageSize)
      : messagesTableData?.length > 0
        ? 1
        : 0);

  //if selected bid logic
  const checkIsBidSelected = bulkBidsData && bulkBidsData?.map((e) => e.status);
  const hasSelectedBid =
    checkIsBidSelected &&
    checkIsBidSelected?.map((e) => e === "selected")?.filter((e) => e === true)
      ?.length !== 0;

  const isAnyApproved =
    Array.isArray(bulkBidsData) &&
    bulkBidsData.some((bid) => bid.approval_status === "Approved");
  const isAnyAppStatusOne =
    Array.isArray(bulkBidsData) &&
    bulkBidsData.some((bid) => bid.app_status === 1);
  const sendapproval =
    Array.isArray(bulkBidsData) &&
    bulkBidsData.some((bid) => bid.org_approval === "True");

  //bid iteration logics
  const bidsIteration = bulkBidsData?.map((e) => e?.bid_version_int);
  const uniqueBitIterationArr = [...new Set(bidsIteration)];
  // let maxBidIterationCount = Math.max(...uniqueBitIterationArr);
  let maxBidIterationCount = 0;

  // Load cached data into Redux when OFFLINE only (client-side pagination over IndexedDB).
  // Online: GetAllData fetches current page and dispatches; no use of offlineRFQs for list.
  useEffect(() => {
    if (!RFQMain || offlineLoading) return;
    const isOffline = !shouldMakeAPICall(auth_token, buyer_token);
    if (!isOffline) return;
    (async () => {
      const cachedAll = await rfqRepository.getRFQsFromIndexedDB(
        buyer_token,
        null,
        "",
        "",
        "",
        "",
        "",
      );
      const sorted =
        (cachedAll || []).length > 0
          ? [...cachedAll].sort((a, b) => {
              if (a._pendingSync && !b._pendingSync) return -1;
              if (!a._pendingSync && b._pendingSync) return 1;
              return getRFQCreatedMs(b) - getRFQCreatedMs(a);
            })
          : [];
      console.log(
        `📦 Offline: loading ${sorted.length} cached RFQs into Redux`,
      );
      dispatch(setBuyerRFQData(sorted));
      setTableProps({ isLoading: false, errorMessage: "" });
    })();
  }, [offlineLoading, RFQMain, dispatch, auth_token, buyer_token]);

  const filters = {
    search: debouncedSearchQuery,
    start: startDateSearchQuery.value || "",
    end: endDateSearchQuery.value || "",
    sortCol: sortingColumnName || "",
    sortOrder: sortingOrder || "",
  };

  const GetAllData = async (forcePage) => {
    const isOffline = !shouldMakeAPICall(auth_token, buyer_token);
    const pageToFetch = forcePage != null ? forcePage : serverPage;
    if (forcePage != null) setServerPage(forcePage);
    const fetchKey = JSON.stringify({
      isOffline,
      pageToFetch,
      search: filters.search,
      start: filters.start,
      end: filters.end,
      sortCol: filters.sortCol,
      sortOrder: filters.sortOrder,
    });
    const now = Date.now();
    if (rfqFetchInFlightRef.current && lastRfqFetchRef.current.key === fetchKey)
      return;
    if (
      lastRfqFetchRef.current.key === fetchKey &&
      now - lastRfqFetchRef.current.ts < 1500
    )
      return;
    rfqFetchInFlightRef.current = true;
    lastRfqFetchRef.current = { key: fetchKey, ts: now };

    const noFilters =
      !filters.search &&
      !filters.start &&
      !filters.end &&
      !filters.sortCol &&
      !filters.sortOrder;

    if (isOffline) {
      // OFFLINE: Client-side pagination over IndexedDB only
      console.log(
        "📴 Offline: loading ALL RFQs from IndexedDB for client-side pagination",
      );
      setTableProps((p) => ({ ...p, isLoading: true, errorMessage: "" }));
      const cachedRFQs = await rfqRepository.getRFQsFromIndexedDB(
        buyer_token,
        null,
        "",
        "",
        "",
        "",
        "",
      );
      const sorted =
        (cachedRFQs || []).length > 0
          ? [...cachedRFQs].sort((a, b) => {
              if (a._pendingSync && !b._pendingSync) return -1;
              if (!a._pendingSync && b._pendingSync) return 1;
              return getRFQCreatedMs(b) - getRFQCreatedMs(a);
            })
          : [];
      dispatch(setBuyerRFQData(sorted));
      setTableProps({ isLoading: false, errorMessage: "" });
      rfqFetchInFlightRef.current = false;
      return;
    }

    // ONLINE: always fetch from API; cache is only for offline use.
    // This keeps RFQ data current after every navigation or reload.

    // ONLINE: Server-side pagination — fetch current page only, then background sync rest for offline
    console.log(
      `🌐 Online: fetching page ${pageToFetch} (server-side), then background sync remaining for offline`,
    );
    setTableProps((p) => ({ ...p, isLoading: true, errorMessage: "" }));
    try {
      const { rfqs, totalRFQs, pageCount, pageSize } =
        await rfqRepository.fetchPageFromAPI(
          auth_token,
          buyer_token,
          pageToFetch,
          filters.search,
          filters.start,
          filters.end,
          filters.sortCol,
          filters.sortOrder,
        );
      const sorted =
        (rfqs || []).length > 0
          ? [...rfqs].sort((a, b) => getRFQCreatedMs(b) - getRFQCreatedMs(a))
          : [];
      dispatch(setBuyerRFQData(sorted));
      setServerPagination({ totalRFQs, pageCount, pageSize });
      setTableProps({ isLoading: false, errorMessage: "" });

      if (pageCount > 1) {
        if (noFilters && totalRFQs) {
          const cachedCount =
            await rfqRepository.getRFQCountFromCache(buyer_token);
          const lastTotalCount =
            await rfqRepository.getLastTotalCount(buyer_token);
          const cachedPages =
            await rfqRepository.getCachedPageCount(buyer_token);
          const cacheComplete =
            await rfqRepository.getCacheComplete(buyer_token);
          const cacheNowComplete =
            cachedCount >= totalRFQs && cachedPages >= pageCount;
          const cacheCountComplete = cachedCount >= totalRFQs;
          if (cacheComplete && cachedCount < totalRFQs) {
            await rfqRepository.setCacheComplete(buyer_token, false);
          }
          if (cacheCountComplete && !cacheComplete) {
            await rfqRepository.setCacheComplete(buyer_token, true);
            await rfqRepository.setLastTotalPages(buyer_token, pageCount);
            await rfqRepository.setLastSyncedPage(buyer_token, pageCount);
            if (!lastTotalCount || totalRFQs > lastTotalCount) {
              await rfqRepository.setLastTotalCount(buyer_token, totalRFQs);
            }
          }
          const shouldSync =
            !cacheComplete &&
            !cacheCountComplete &&
            (cachedCount < totalRFQs ||
              cachedPages < pageCount ||
              (lastTotalCount && totalRFQs > lastTotalCount));

          if (shouldSync) {
            rfqRepository
              .syncRemainingPagesInBackground(
                auth_token,
                buyer_token,
                pageCount,
                pageToFetch,
                filters.search,
                filters.start,
                filters.end,
                filters.sortCol,
                filters.sortOrder,
                {
                  force: cachedCount < totalRFQs || cachedPages < pageCount,
                  expectedTotal: totalRFQs,
                },
              )
              .catch((e) => console.warn("Background sync error:", e));
          } else {
            if (cacheNowComplete && !cacheComplete) {
              await rfqRepository.setCacheComplete(buyer_token, true);
            }
            if (!lastTotalCount || totalRFQs > lastTotalCount) {
              await rfqRepository.setLastTotalCount(buyer_token, totalRFQs);
            }
          }
        }
      }
      rfqFetchInFlightRef.current = false;
    } catch (error) {
      console.error("Error fetching RFQ page:", error);
      const isNetworkError =
        error?.code === "ERR_NETWORK" ||
        error?.message?.includes?.("Network Error");
      if (isNetworkError) {
        console.warn(
          "📴 Network error - falling back to IndexedDB + client-side pagination",
        );
        setForceClientPaging(true);
        const cachedRFQs = await rfqRepository.getRFQsFromIndexedDB(
          buyer_token,
          null,
          filters.search,
          filters.start,
          filters.end,
          filters.sortCol,
          filters.sortOrder,
        );
        const sorted =
          (cachedRFQs || []).length > 0
            ? [...cachedRFQs].sort((a, b) => {
                if (a._pendingSync && !b._pendingSync) return -1;
                if (!a._pendingSync && b._pendingSync) return 1;
                return getRFQCreatedMs(b) - getRFQCreatedMs(a);
              })
            : [];
        dispatch(setBuyerRFQData(sorted));
        setTableProps({ isLoading: false, errorMessage: "" });
      } else {
        setTableProps((p) => ({
          ...p,
          isLoading: false,
          errorMessage: error?.message || "Failed to load RFQs",
        }));
      }
      rfqFetchInFlightRef.current = false;
    }
  };

  const fetchServerPage = async (page1Based) => {
    if (!shouldMakeAPICall(auth_token, buyer_token)) return;
    setTableProps((p) => ({ ...p, isLoading: true, errorMessage: "" }));
    try {
      const { rfqs, totalRFQs, pageCount, pageSize } =
        await rfqRepository.fetchPageFromAPI(
          auth_token,
          buyer_token,
          page1Based,
          filters.search,
          filters.start,
          filters.end,
          filters.sortCol,
          filters.sortOrder,
        );
      const sorted =
        (rfqs || []).length > 0
          ? [...rfqs].sort((a, b) => getRFQCreatedMs(b) - getRFQCreatedMs(a))
          : [];
      dispatch(setBuyerRFQData(sorted));
      setServerPagination({ totalRFQs, pageCount, pageSize });
      setTableProps({ isLoading: false, errorMessage: "" });
    } catch (e) {
      console.error("Error fetching RFQ page:", e);
      setTableProps((p) => ({
        ...p,
        isLoading: false,
        errorMessage: e?.message || "Failed to load page",
      }));
    }
  };

  // userMessage Section state and fn's

  // user state ends

  let delay = 300;

  const buildBidIdParams = (rfqTokenValue, iteration) => {
    const params = [
      {
        key: "rfq_token",
        value: rfqTokenValue || "",
      },
    ];

    if (rfqTokenValue && iteration) {
      if (iteration === "default") {
        params.push({
          key: "default",
          value: iteration,
        });
      } else {
        params.push({
          key: "quote_no",
          value: iteration,
        });
      }
    }

    return params;
  };

  useEffect(() => {
    if (viewRFQ) {
      // Only call bid APIs if we don't already have bids data and not loaded from rfq_bids
      // This prevents overwriting data from rfq_bids
      if (
        (!bulkBidsData || bulkBidsData.length === 0) &&
        !bidsLoadedFromRfqBids
      ) {
        getEveryBidsData(rfqToken);
      }
      if ((!bidsData || bidsData.length === 0) && !bidsLoadedFromRfqBids) {
        GetAllBidsData(pageNumber, rfqToken);
      }
    }
  }, [iterationNumber]);

  useEffect(() => {
    if (openForm.open) {
      getCountriesList();
    }
    if (editRFQForm) {
      setUploadItemDocument({
        inputs: true,
        uploadFile: false,
      });
    }
  }, [editRFQForm, openForm.open, newRFQForm]);

  // Load countries when RFQ page loads
  useEffect(() => {
    if (RFQMain) {
      console.log("Loading countries on RFQ page load");
      getCountriesList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RFQMain]);

  // Load countries when New RFQ form opens
  useEffect(() => {
    if (newRFQForm) {
      console.log("Loading countries for New RFQ form");
      getCountriesList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newRFQForm]);
  const GetAllBidsData = async (pageNumber, rfq_code) => {
    // Try cache first when offline
    if (!shouldMakeAPICall(auth_token, buyer_token)) {
      console.log("📴 Offline - loading bids from cache");
      try {
        const cachedBids = await rfqRepository.getBidsFromCache(rfq_code);
        if (cachedBids && cachedBids.length > 0) {
          console.log(`📦 Loaded ${cachedBids.length} bids from cache`);
          // Apply mapping to cached bids
          const mappedCachedBids = cachedBids.map((bid) => mapBidForTable(bid));
          setBidsData(mappedCachedBids);
          // Set pagination data for cached bids
          setPaginationData({
            total_items: cachedBids.length,
            page_count: Math.ceil(cachedBids.length / 10),
            current_page: pageNumber,
            current_page_count: cachedBids.length,
          });
          setTableProps({
            ...tableProps,
            isLoading: false,
            errorMessage: "", // No error when using cache
          });
          return;
        } else {
          console.log("⚠️ No cached bids found");
          setBidsData([]);
          setPaginationData({});
          setTableProps({
            ...tableProps,
            isLoading: false,
            errorMessage: "", // No error - just empty data
          });
          return;
        }
      } catch (error) {
        console.error("Error loading bids from cache:", error);
        setBidsData([]);
        setPaginationData({});
        setTableProps({
          ...tableProps,
          isLoading: false,
          errorMessage: "", // No error - just empty data
        });
        return;
      }
    }

    // Online: use fetchPagedData
    fetchPagedData({
      pageNumber: pageNumber,
      endpoint: `${API_ENDPOINT.get_org_bid_view}`,
      idParams: buildBidIdParams(rfq_code, iterationNumber),
      searchQuery: searchQuery2,
      auth_token: auth_token,
      ...(sortingColumnName && { sortingColumnName: sortingColumnName }),
      ...(sortingOrder && { sortingOrder: sortingOrder }),
      setData: async (data) => {
        // Apply mapping to ensure all required fields are present
        const mappedData = Array.isArray(data)
          ? data.map((bid) => mapBidForTable(bid))
          : [];

        setBidsData(mappedData);
        // Also save to cache
        if (mappedData.length > 0) {
          await rfqRepository.saveBidsToCache(rfq_code, mappedData);
        }
      },
      setPaginationData: setPaginationData,
      tableProps,
      setTableProps: (props) => {
        setTableProps({
          ...props,
          errorMessage: sanitizeErrorMessage(props?.errorMessage),
        });
      },
    });
  };

  const getEveryBidsData = async (rfq_code) => {
    // Try cache first when offline
    if (!shouldMakeAPICall(auth_token, buyer_token)) {
      console.log("📴 Offline - loading bids from IndexedDB");
      try {
        const cachedBids = await rfqRepository.getBidsFromIndexedDB(rfq_code);
        if (cachedBids && cachedBids.length > 0) {
          console.log(
            `📦 Loaded ${cachedBids.length} bids from IndexedDB for bulk data`,
          );
          // Apply mapping to cached bids
          const mappedCachedBids = cachedBids.map((bid) => mapBidForTable(bid));
          setBulkBidsData(mappedCachedBids);
          return mappedCachedBids;
        } else {
          console.log("⚠️ No cached bids found for bulk data");
          setBulkBidsData([]);
          return [];
        }
      } catch (error) {
        console.error("Error loading bids from cache:", error);
        setBulkBidsData([]);
        return [];
      }
    }

    // Online: use API
    const formData = new FormData();
    formData.append("rfq_token", rfq_code);
    return await axios({
      method: "POST",
      url: `${API_ENDPOINT.get_org_bid_view}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then(async (res) => {
        console.log("📥 getEveryBidsData response:", res.data);
        const bids = res?.data || [];

        // Apply mapping to ensure all required fields are present
        const mappedBids = Array.isArray(bids)
          ? bids.map((bid) => mapBidForTable(bid))
          : [];

        setBulkBidsData(mappedBids);
        // Also save to cache
        if (mappedBids.length > 0) {
          await rfqRepository.saveBidsToCache(rfq_code, mappedBids);
        }
        return mappedBids;
      })
      .catch((err) => {
        console.log("Error loading bids:", err);
        return rfqRepository.getBidsFromIndexedDB(rfq_code).then((cachedBids) => {
          if (cachedBids && cachedBids.length > 0) {
            console.log("📦 Using bids from IndexedDB due to API error");
            // Apply mapping to cached bids
            const mappedCachedBids = cachedBids.map((bid) =>
              mapBidForTable(bid),
            );
            setBulkBidsData(mappedCachedBids);
            return mappedCachedBids;
          } else {
            setBulkBidsData([]);
            return [];
          }
        });
      });
  };
  //get RFQ category list (online: API + cache; offline: IndexedDB only)
  const getCategoryList = async () => {
    const normalizeCategories = (list) => {
      if (!Array.isArray(list)) return [];
      return list
        .map((c) => ({
          ...c,
          category:
            c?.category ?? c?.name ?? c?.category_name ?? c?.title ?? "",
          id: c?.id ?? c?.token ?? "",
        }))
        .filter((c) => String(c.category || "").trim() !== "");
    };

    // Try cache/IndexedDB first (works offline)
    const cachedCategories =
      await masterDataRepository.getRFQCategoriesFromCache();
    if (cachedCategories && cachedCategories.length > 0) {
      setRFQCategory((prev) => ({
        ...prev,
        categoryList: normalizeCategories(cachedCategories),
      }));
    }

    // Sync from API if online
    if (shouldMakeAPICall(auth_token, org_token)) {
      axios({
        method: "GET",
        url: `${API_ENDPOINT.list_of_prompt_category}`,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then(async (response) => {
          let promptList = response.data.response || response.data || [];
          await masterDataRepository.saveRFQCategoriesToCache(promptList);
          setRFQCategory((prev) => ({
            ...prev,
            categoryList: normalizeCategories(promptList),
          }));
        })
        .catch((error) => {
          console.log("Error loading categories, using cache:", error);
          if (cachedCategories && cachedCategories.length > 0) {
            setRFQCategory((prev) => ({
              ...prev,
              categoryList: normalizeCategories(cachedCategories),
            }));
          }
        });
    }
  };

  const resolveRFQCategory = (rfqData, categoryList = []) => {
    if (!rfqData) return { id: "", value: "" };

    const rawId =
      rfqData?.category_compare ??
      rfqData?.pr_category ??
      rfqData?.rfq_category?.id ??
      rfqData?.quotation_category_id ??
      rfqData?.category_id ??
      "";
    const rawValue =
      rfqData?.category_compare_name ??
      rfqData?.quotation_category ??
      rfqData?.pr_category_name ??
      rfqData?.rfq_category?.name ??
      rfqData?.category_name ??
      rfqData?.category ??
      "";

    const normalizedId = rawId != null ? String(rawId) : "";
    const normalizedRawValue = String(rawValue || "")
      .trim()
      .toLowerCase();

    const matchedCategory = Array.isArray(categoryList)
      ? categoryList.find((item) => {
          const itemId = item?.id != null ? String(item.id) : "";
          const itemValue = String(item?.category || "")
            .trim()
            .toLowerCase();
          return (
            (normalizedId && itemId === normalizedId) ||
            (normalizedRawValue && itemValue === normalizedRawValue)
          );
        })
      : null;

    return {
      id: matchedCategory?.id ?? normalizedId ?? "",
      value: matchedCategory?.category ?? rawValue ?? "",
    };
  };

  const enrichRFQCategoryData = (rfqData, tokenHint = "") => {
    if (!rfqData) return rfqData;

    const hasCategoryData =
      !!rfqData?.rfq_category?.id ||
      !!rfqData?.rfq_category?.name ||
      !!rfqData?.category_compare ||
      !!rfqData?.category_compare_name ||
      !!rfqData?.quotation_category ||
      !!rfqData?.pr_category ||
      !!rfqData?.pr_category_name;

    if (hasCategoryData) return rfqData;

    const matchedFromList = Array.isArray(RFQData)
      ? RFQData.find(
          (rfq) =>
            String(rfq?.token || "") ===
              String(rfqData?.token || tokenHint || "") ||
            String(rfq?.rfq_code || "") === String(tokenHint || ""),
        )
      : null;

    if (!matchedFromList) return rfqData;

    return {
      ...rfqData,
      rfq_category:
        matchedFromList?.rfq_category ?? rfqData?.rfq_category ?? null,
      category_compare:
        rfqData?.category_compare ??
        matchedFromList?.category_compare ??
        matchedFromList?.rfq_category?.id ??
        null,
      category_compare_name:
        rfqData?.category_compare_name ??
        matchedFromList?.category_compare_name ??
        matchedFromList?.quotation_category ??
        matchedFromList?.rfq_category?.name ??
        null,
      quotation_category:
        rfqData?.quotation_category ??
        matchedFromList?.quotation_category ??
        matchedFromList?.category_compare_name ??
        matchedFromList?.rfq_category?.name ??
        null,
      pr_category: rfqData?.pr_category ?? matchedFromList?.pr_category ?? null,
      pr_category_name:
        rfqData?.pr_category_name ?? matchedFromList?.pr_category_name ?? null,
    };
  };

  // Normalize Purchase Request Number across API variants
  const normalizePurchaseRequestNumber = (rfqData) => {
    if (!rfqData) return rfqData;
    const prNumber =
      rfqData.purchase_request_number ??
      rfqData.purchase_request_no ??
      rfqData.purchase_request_num ??
      rfqData.pr_number ??
      rfqData.pr_no ??
      rfqData.request_number ??
      "";
    if (!prNumber) return rfqData;
    if (rfqData.purchase_request_number === prNumber) return rfqData;
    return { ...rfqData, purchase_request_number: prNumber };
  };

  const getManualPurchaseRequestNumber = (rfqData) => {
    const value = String(rfqData?.purchase_request_number || "").trim();
    const prCode = String(
      rfqData?.pr_code || rfqData?.PR_Code || rfqData?.["PR Code"] || "",
    ).trim();
    const rfqCode = String(
      rfqData?.rfq_code || rfqData?.RFQ_Code || rfqData?.["RFQ Code"] || "",
    ).trim();
    const isGeneratedPrCode = /^PR-\d+\//i.test(value);

    if (!value || isGeneratedPrCode || value === prCode || value === rfqCode)
      return "";
    return value;
  };

  const normalizeMobileNumber = (rawValue) => {
    if (!rawValue) return "";
    const trimmed = String(rawValue).trim();
    // Remove leading +<countrycode> if present, keep only digits
    const digits = trimmed.replace(/\D/g, "");
    // If starts with India country code (91) and length > 10, drop leading 91
    if (digits.startsWith("91") && digits.length > 10) {
      return digits.slice(2);
    }
    return digits;
  };

  useEffect(() => {
    setBtnPrimaryLabel(editRFQForm ? "Update" : "Create RFQ ");
  }, [editRFQForm]);

  useEffect(() => {
    if (!RFQCategory?.id || RFQCategory?.value) return;
    if (
      !Array.isArray(RFQCategory?.categoryList) ||
      RFQCategory.categoryList.length === 0
    )
      return;

    const matched = RFQCategory.categoryList.find(
      (item) => String(item?.id ?? "") === String(RFQCategory.id),
    );

    if (matched?.category) {
      setRFQCategory((prev) => ({
        ...prev,
        value: matched.category,
      }));
    }
  }, [RFQCategory?.id, RFQCategory?.value, RFQCategory?.categoryList]);

  useEffect(() => {
    if (!RFQMain) return;
    // Search is already debounced; page navigation needs no additional delay.
    GetAllData(rfqListOffline ? undefined : serverPage);
  }, [
    RFQMain,
    serverPage,
    debouncedSearchQuery,
    startDateSearchQuery.value,
    endDateSearchQuery.value,
    sortingColumnName,
    sortingOrder,
    rfqListOffline,
  ]);

  useEffect(() => {
    if (!viewRFQ) return;

    // Check if we already have bids from rfq_bids before calling separate APIs
    if (!bulkBidsData || bulkBidsData.length === 0) {
      getEveryBidsData(rfqToken);
    }

    const timeoutId = setTimeout(() => {
      if (pageNumber) {
        // Only call GetAllBidsData if we don't have bids data
        if (!bidsData || bidsData.length === 0) {
          GetAllBidsData(pageNumber, rfqToken);
        }
        GetAllMessageData();
      }
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [
    viewRFQ,
    pageNumber,
    messagePageNumber,
    messageSearchQuery,
    searchQuery2,
    rfqToken,
    iterationNumber,
  ]);

  //get shipping address
  const getshippingAddress = async () => {
    const buyerToken = data?.user?.user_token;
    // Try RFQ addresses from API response first (from buyer_rfq_full_view)
    const rfqAddresses =
      await rfqRepository.getRFQAddressesFromCache(buyerToken);
    if (rfqAddresses && rfqAddresses.length > 0) {
      console.log(`📦 Using ${rfqAddresses.length} RFQ addresses from cache`);
      setShippingAddress(rfqAddresses);
      // Still sync from API in background if online
    }

    // Bind shipping addresses from IndexedDB (db.shippingAddresses) when offline / fallback
    const cachedAddresses =
      await masterDataRepository.getShippingAddressesFromIndexedDB(buyerToken);
    if (
      cachedAddresses &&
      cachedAddresses.length > 0 &&
      (!rfqAddresses || rfqAddresses.length === 0)
    ) {
      setShippingAddress(cachedAddresses);
    }

    // Sync from API if online
    if (shouldMakeAPICall(auth_token, org_token)) {
      await axios({
        method: "POST",
        url: `${API_ENDPOINT.buyer_shipping_address}`,
        data: {
          buyer_token: buyerToken, //loged user token
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then(async (res) => {
          let shippingAddress = res.data.response || res.data || [];
          // Save to cache
          await masterDataRepository.saveShippingAddressesToCache(
            shippingAddress,
            data.user.user_token,
          );
          setShippingAddress(shippingAddress);
        })
        .catch((err) => {
          if (
            err.code === "ERR_NETWORK" ||
            err.code === "ERR_CONNECTION_REFUSED"
          ) {
            console.log(
              "📴 Network error - using shipping addresses from IndexedDB",
            );
          } else {
            console.log(
              "Error loading shipping addresses, using IndexedDB:",
              err,
            );
          }
          if (cachedAddresses && cachedAddresses.length > 0) {
            setShippingAddress(cachedAddresses);
          }
        });
    }
  };
  /**
   * Load RFQ for View or Edit.
   * Offline: bind all fields from IndexedDB only (db.rfqs, db.rfqBids, etc.) — no API calls.
   * Online: fetch current details so sealed bid settings and lock status stay up to date.
   */
  const getIndividualData = async (unique_id, query) => {
    console.log({ unique_id });

    setOpenForm({
      open: true,
      loading: true,
      errorMessage: "",
    });

    setLoadingState(true);

    const isOffline = !shouldMakeAPICall(auth_token, buyer_token);
    const preferCacheData = isOffline;

    // Resolve unique_id from IndexedDB: by token first, then by rfq_code if it looks like a code
    let cachedRFQ = null;
    try {
      cachedRFQ = await rfqRepository.getRFQByTokenFromIndexedDB(unique_id);
      if (!cachedRFQ && unique_id && String(unique_id).includes("/")) {
        cachedRFQ = await rfqRepository.getRFQByRfqCodeFromIndexedDB(
          buyer_token,
          unique_id,
        );
        if (cachedRFQ)
          console.log("📦 Resolved RFQ by rfq_code from IndexedDB:", unique_id);
      }
    } catch (e) {
      console.warn("Error resolving RFQ from IndexedDB:", e);
    }

    try {
      if (
        cachedRFQ &&
        rfqRepository.hasAllRequiredFieldsForEdit(cachedRFQ) &&
        preferCacheData
      ) {
        console.log(
          "✅ Using cached RFQ data for editing - no API call needed",
        );

        // Transform cached data to match API response format (include rfq_addresses)
        const transformedData =
          await rfqRepository.transformListDataToEditFormat(
            cachedRFQ,
            buyer_token,
          );

        if (transformedData) {
          let responseData = transformedData.response[0];
          responseData = mergeSealedBidMeta(responseData, transformedData, cachedRFQ);
          responseData = enrichRFQCategoryData(responseData, unique_id);
          responseData = normalizePurchaseRequestNumber(responseData);
          console.log(responseData, "response");
          let itemsData = transformedData.items;
          // Fallback to nested items from cachedRFQ if transformedData.items is empty or missing
          if (
            (!itemsData || itemsData.length === 0) &&
            cachedRFQ?.items?.length
          ) {
            itemsData = cachedRFQ.items;
            console.log(
              `📦 Using ${itemsData.length} items from nested items array (cache fallback)`,
            );
          }
          let rfqAddresses = transformedData.rfq_addresses || [];

          console.log("📦 Using cached items data:", itemsData);
          const itemsArray = normalizeRfqItems(
            Array.isArray(itemsData) ? itemsData : itemsData ? [itemsData] : [],
          );
          setItemsListDataViewRFQ(itemsArray);
          setUniqueData(responseData);

          // Multi-item RFQs: keep all item tokens so vendor-by-category filtering uses every line item.
          const itemTokens = [
            ...new Set(
              itemsArray
                .map((it) =>
                  String(
                    it?.item_token ?? it?.itemToken ?? it?.token ?? "",
                  ).trim(),
                )
                .filter(Boolean),
            ),
          ];
          setItemToken(itemTokens);
          if (!isOffline && itemTokens.length > 0) {
            void getVendorsByCategory(itemTokens);
          }

          // Set shipping addresses from rfq_addresses if available
          if (rfqAddresses && rfqAddresses.length > 0) {
            console.log(
              `📦 Using ${rfqAddresses.length} RFQ addresses from API response`,
            );
            setShippingAddress(rfqAddresses);
          } else {
            // Fallback to regular shipping addresses
            void getshippingAddress();
          }

          // Load bids and vendor list from cache when viewing RFQ (fallback to nested data from list API)
          const rfqToken = responseData?.token || unique_id;
          const [cachedBidsFromDb, cachedVendorListFromDb] = await Promise.all([
            rfqRepository.getBidsFromIndexedDB(rfqToken),
            rfqRepository.getRFQVendorListFromIndexedDB(rfqToken),
          ]);
          let cachedBids = cachedBidsFromDb;
          if (!cachedBids?.length && cachedRFQ?.rfq_bids?.length) {
            cachedBids = cachedRFQ.rfq_bids;
            console.log(
              `📦 Using ${cachedBids.length} bids from nested rfq_bids (IndexedDB fallback)`,
            );
          }
          const hasBidsInCache = cachedBids && cachedBids.length > 0;
          if (hasBidsInCache) {
            console.log(`📦 Loaded ${cachedBids.length} bids from IndexedDB`);
            const mappedBids = cachedBids
              .map((bid) => mapBidForTable(bid))
              .filter(Boolean);
            setBulkBidsData(mappedBids);
            setBidsData(mappedBids);
            setBidsLoadedFromRfqBids(true);
          } else {
            console.log("⚠️ No cached bids found");
            setBidsLoadedFromRfqBids(false);
            setBulkBidsData([]);
            setBidsData([]);
          }

          let cachedVendorList = cachedVendorListFromDb;
          if (!cachedVendorList?.length && cachedRFQ?.rfq_vendor_list?.length) {
            cachedVendorList = cachedRFQ.rfq_vendor_list;
            console.log(
              `📦 Using ${cachedVendorList.length} vendors from nested rfq_vendor_list (IndexedDB fallback)`,
            );
          }
          if (cachedVendorList && cachedVendorList.length > 0) {
            const vendorsWithChat = cachedVendorList.filter(
              (v) => Array.isArray(v?.chat) && v.chat.length > 0,
            ).length;
            console.log(
              `📦 Loaded ${cachedVendorList.length} RFQ vendors from IndexedDB${vendorsWithChat > 0 ? ` — vendor chat exists (${vendorsWithChat} vendor(s))` : " — no vendor chat in cache"}`,
            );
            setRfqVendorList(cachedVendorList);
          } else {
            console.log("⚠️ No cached vendor list found in IndexedDB");
            setRfqVendorList([]);
          }

          // Upgrade cached bids mapping once vendor list is available (buyer_rfq_full_view shape).
          if (
            hasBidsInCache &&
            cachedVendorList &&
            cachedVendorList.length > 0
          ) {
            const upgradedBids = cachedBids
              .map((bid) => mapBidForTable(bid, cachedVendorList))
              .filter(Boolean);
            setBulkBidsData(upgradedBids);
            setBidsData(upgradedBids);
          }

          let fileObj = responseData?.proposal_document?.split("/");
          let fileName = fileObj && fileObj[fileObj?.length - 1];
          setFileName(fileName);

          setRFQToken(responseData.token);
          void getCategoryList();

          setOpenForm({
            open: true,
            loading: false,
            errorMessage: "",
          });

          setRFQToken(responseData?.token);

          if (query === "update inputs") {
            void hydrateRfqBudget(responseData);
            hydrateAlternativeSuppliers(responseData?.alternative_supplier);
          }

          if (query === "update inputs") {
            const itemsForInput = Array.isArray(itemsData)
              ? itemsData
              : itemsData
                ? [itemsData]
                : [];
            let mappedItemsList = normalizeRfqItems(itemsForInput)?.map(
              (el, i) => {
                return {
                  itemToken: el.item_token,
                  itemTokenisValid: false,

                  itemMappedToken: resolveRfqItemMappedToken(el),

                  itemCode: el.item_code,
                  itemCodeisValid: false,

                  itemName: el.item_name,
                  itemNameisValid: false,

                  expenseType:
                    el.expense_type ??
                    el.expenseType ??
                    responseData?.expense_type ??
                    responseData?.expenseType ??
                    "",

                  itemQuantity: el.quantity,
                  itemQuantityisValid: false,

                  itemUnit: el.unit || el.uom || "",
                  itemUnitisValid: false,

                  itemDescription: el.description || el.item_description || "",
                  itemDescriptionisValid: false,

                  itemPartNumber: el.manufacturer_part_no || el.part_number || "",
                  itemCategory: el.category || "",
                  itemHsnCode: el.hsn_code || "",
                  itemUnspscCode: el.unspsc_code || "",
                  itemSubCategory: el.sub_category || "",
                  itemType: el.item_type || "",
                  itemBrand: el.brand || "",
                  itemTax: Array.isArray(el.GST_list)
                    ? [...new Set(el.GST_list
                        .map((tax) => `${tax?.country || ""}${tax?.country && tax?.gst ? " - " : ""}${tax?.gst || ""}${tax?.gst ? "%" : ""}`)
                        .filter(Boolean))]
                        .join(", ")
                    : "",
                  itemSpecifications: el.specifications || "",
                  itemAliases: el.aliases || "",

                  itemDuplicate: false,
                };
              },
            );

            setItemsInput(
              (mappedItemsList || []).map((it) => ({
                ...it,
                itemDuplicate: false,
              })),
            );

            setRequestNumber({
              value: getManualPurchaseRequestNumber(responseData),
              isValid: emptyCheck(getManualPurchaseRequestNumber(responseData)),
            });
            const selectedCategory = resolveRFQCategory(
              responseData,
              RFQCategory.categoryList,
            );
            setRFQCategory((prev) => ({
              ...prev,
              value: selectedCategory.value,
              id: selectedCategory.id,
              isValid: true,
            }));
            setBidType({
              value: normalizeBidTypeValue(responseData?.bidding_type),
              isValid: true,
            });
            setSealedBid(normalizeBooleanValue(responseData?.sealed_bid));
            setBidStatus({
              value: responseData?.bid_status,
              isValid: true,
            });

            // changing format to 8 August 2023 to 2023-08-08 12:32:09.021329
            let startDate = dayjs(
              responseData?.bid_from_date,
              "DD MMMM YYYY",
            ).format("YYYY-MM-DD HH:mm:ss.SSSSSS");
            let endDate = dayjs(
              responseData?.bid_to_date,
              "DD MMMM YYYY",
            ).format("YYYY-MM-DD HH:mm:ss.SSSSSS");

            const bidTimeRaw = responseData?.bid_time;
            const endTime =
              bidTimeRaw && String(bidTimeRaw).trim()
                ? dayjs
                    .utc(bidTimeRaw)
                    .local()
                    .format("YYYY-MM-DD HH:mm:ss.SSSSSS")
                : "";

            setFromDate({
              value: startDate,
              isValid: true,
            });
            setToDate({
              value: endDate,
              isValid: true,
            });
            setTime({
              value: endTime,
              isChanged: false,
              isValid: true,
            });

            const vendorStr = responseData?.select_vendor ?? "";
            let finalVendorArray = Array.isArray(vendorStr)
              ? vendorStr.map((s) => String(s).trim()).filter(Boolean)
              : vendorStr
                ? String(vendorStr)
                    .split(",")
                    .map((s) => s.trim())
                    .filter(Boolean)
                : [];

            setVendor({
              value: finalVendorArray,
              isValid: true,
            });

            setExistingVendorList(finalVendorArray);
            setVendorID(finalVendorArray);

            setAddress1({
              value: responseData?.shipping_address1,
              isValid: true,
            });
            setAddress2({
              value: responseData?.shipping_address2,
              isValid: true,
            });
            setCountry((prev) => ({
              ...prev,
              value: responseData?.country,
              countryList: [],
              isValid: true,
            }));
            setStateName((prev) => ({
              ...prev,
              value: responseData?.state,
              stateList: [],
              isValid: true,
            }));
            setCity((prev) => ({
              ...prev,
              value: responseData?.city,
              cityList: [],
              isValid: true,
            }));

            setMobileNumber({
              value: normalizeMobileNumber(responseData?.mobile_number),
              isValid: true,
            });

            setUploadDocument({
              uploadDescripton: responseData?.proposal_description
                ? true
                : false,
              uploadFile: responseData?.proposal_document ? true : false,
            });

            setProposalDescription({
              value: responseData?.proposal_description,
              isValid: true,
            });

            setProposalDocument({
              value: responseData?.proposal_document,
              isValid: true,
              hasFile: true,
            });

            setPincode({
              value: responseData?.pincode,
              isValid: true,
            });
          }

          setLoadingState(false);
          return {
            source: "cache",
            rfqToken: responseData?.token,
            bidsLoadedFromRfqBids: Boolean(hasBidsInCache),
          }; // Exit early - no API call needed
        }
      } else {
        console.log("⚠️ Cached RFQ data incomplete or missing, calling API...");
        if (cachedRFQ) {
          console.log("Missing fields:", {
            hasItems: !!cachedRFQ.items,
            itemsLength: cachedRFQ.items?.length,
            hasToken: !!cachedRFQ.token,
            hasBiddingType: !!cachedRFQ.bidding_type,
          });
        }
      }
    } catch (error) {
      console.warn("Error checking cache, falling back to API:", error);
    }

    // Offline: never call API. Use cache only or show clear error.
    if (isOffline) {
      setLoadingState(false);
      setOpenForm({
        open: false,
        loading: false,
        errorMessage: cachedRFQ
          ? "Cached RFQ is incomplete for editing. Open this RFQ while online first, then try again offline."
          : "Cannot load RFQ for edit while offline. Open the RFQ list while online first, then try Edit again.",
      });
      return {
        source: "offline_incomplete",
        rfqToken: cachedRFQ?.token || null,
        bidsLoadedFromRfqBids: false,
      };
    }

    // Fallback to API call if cache doesn't have complete data (online only)
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.get_individual_RFQ}${unique_id}`,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then(async (res) => {
        setLoadingState(false);

        let responseData = res?.data?.response?.[0];
        responseData = mergeSealedBidMeta(responseData, res?.data, cachedRFQ);
        // Fallback to cached data if API response is missing key fields
        let cachedFallback = null;
        if (cachedRFQ) {
          try {
            const transformed =
              await rfqRepository.transformListDataToEditFormat(
                cachedRFQ,
                buyer_token,
              );
            cachedFallback = transformed?.response?.[0] || cachedRFQ;
          } catch (e) {
            cachedFallback = cachedRFQ;
          }
        }
        const fillIfEmpty = (val, fallbackVal) =>
          val === undefined || val === null || String(val).trim() === ""
            ? fallbackVal
            : val;
        responseData = enrichRFQCategoryData(responseData, unique_id);
        responseData = normalizePurchaseRequestNumber(responseData);
        if (cachedFallback) {
          responseData = {
            ...responseData,
            bid_time: fillIfEmpty(
              responseData?.bid_time,
              cachedFallback?.bid_time,
            ),
            select_vendor: fillIfEmpty(
              responseData?.select_vendor,
              cachedFallback?.select_vendor,
            ),
          };
        }
        let itemsData = res?.data?.items ?? responseData?.items;
        let rfqAddresses = res?.data?.rfq_addresses || [];
        let rfqBids = res?.data?.rfq_bids ?? responseData?.rfq_bids;
        let rfqVendorList =
          res?.data?.rfq_vendor_list ?? responseData?.rfq_vendor_list;
        if (!Array.isArray(rfqBids)) rfqBids = [];
        if (!Array.isArray(rfqVendorList) || rfqVendorList.length === 0) {
          // Some orgs return rfq_vendor_list only in list API (buyer_rfq_full_view) / cache.
          // Prefer cached nested vendor list over showing an empty "Message Vendor" list.
          const tokenForVendorCache = responseData?.token || unique_id;
          const cachedNested = cachedRFQ?.rfq_vendor_list;
          if (Array.isArray(cachedNested) && cachedNested.length > 0) {
            rfqVendorList = cachedNested;
          } else {
            try {
              const cachedList =
                await rfqRepository.getRFQVendorListFromCache(
                  tokenForVendorCache,
                );
              if (Array.isArray(cachedList) && cachedList.length > 0) {
                rfqVendorList = cachedList;
              }
            } catch {
              // ignore cache read failures
            }
          }
        }
        if (!Array.isArray(rfqVendorList)) rfqVendorList = [];

        console.log("📥 API Response structure:", {
          hasResponse: !!res?.data?.response,
          hasItems: !!itemsData,
          hasRfqAddresses: !!res?.data?.rfq_addresses,
          hasRfqBids: !!rfqBids?.length,
          hasRfqVendorList: !!rfqVendorList?.length,
          nestedFallback: {
            items: !!responseData?.items && !res?.data?.items,
            bids: !!responseData?.rfq_bids && !res?.data?.rfq_bids,
            vendors:
              !!responseData?.rfq_vendor_list && !res?.data?.rfq_vendor_list,
          },
        });

        // Save rfq_addresses to cache if available (from buyer_rfq_full_view API)
        if (rfqAddresses && rfqAddresses.length > 0) {
          await rfqRepository.saveRFQAddressesToCache(
            buyer_token,
            rfqAddresses,
          );
          console.log(
            `✅ Cached ${rfqAddresses.length} RFQ addresses from API`,
          );
          setShippingAddress(rfqAddresses);
        } else {
          // Fallback to regular shipping addresses
          getshippingAddress();
        }

        // Save rfq_bids to cache if available and set state
        if (rfqBids && rfqBids.length > 0) {
          const rfqToken = responseData?.token || unique_id;

          // Ensure all required fields are present for table display
          console.log("📥 Raw rfq_bids data:", rfqBids);
          const mappedBids = rfqBids
            .map((bid, index) => {
              const mapped = mapBidForTable(bid, rfqVendorList);
              console.log(`🔍 Mapping bid ${index + 1} from rfq_bids:`, {
                original: {
                  vendor: bid.vendor,
                  vendor_code: bid.vendor_code,
                  company_vendor_code: bid.company_vendor_code,
                  company_name: bid.company_name,
                },
                mapped: {
                  vendor: mapped?.vendor,
                  vendor_code: mapped?.vendor_code,
                  hasVendor: !!mapped?.vendor,
                  hasVendorCode: !!mapped?.vendor_code,
                },
              });
              return mapped;
            })
            .filter((bid) => bid !== null); // Filter out any null mappings
          console.log("✅ Mapped bids (first 2):", mappedBids.slice(0, 2));

          await rfqRepository.saveBidsToCache(rfqToken, mappedBids);
          console.log(
            `✅ Cached ${mappedBids.length} RFQ bids from API response`,
          );
          // Set both bulk and paginated bids data
          setBulkBidsData(mappedBids);
          setBidsData(mappedBids);
          setBidsLoadedFromRfqBids(true); // Mark that bids were loaded from rfq_bids
          console.log(
            `✅ Set ${mappedBids.length} bids to state from rfq_bids:`,
            mappedBids.slice(0, 2),
          );
        } else {
          console.log(
            "⚠️ No rfq_bids in API response, will load from separate API if needed",
          );
          setBidsLoadedFromRfqBids(false);
          // Clear any previous RFQ's bids to avoid stale UI (e.g. "Unselect Vendors" showing incorrectly)
          setBulkBidsData([]);
          setBidsData([]);
          setPaginationData({});
        }

        // Save rfq_vendor_list to cache if available and set state
        if (rfqVendorList && rfqVendorList.length > 0) {
          const rfqToken = responseData?.token || unique_id;
          await rfqRepository.saveRFQVendorListToCache(rfqToken, rfqVendorList);
          console.log(
            `✅ Cached ${rfqVendorList.length} RFQ vendors from API response`,
          );
          setRfqVendorList(rfqVendorList);
          console.log(
            `✅ Set ${rfqVendorList.length} vendors to state from rfq_vendor_list`,
          );
        } else {
          console.log("⚠️ No rfq_vendor_list in API response");
          setRfqVendorList([]);
        }

        console.log(itemsData);
        const itemsArray = normalizeRfqItems(
          Array.isArray(itemsData) ? itemsData : itemsData ? [itemsData] : [],
        );
        void getCategoryList();
        const itemTokens = [
          ...new Set(
            itemsArray
              .map((it) =>
                String(
                  it?.item_token ?? it?.itemToken ?? it?.token ?? "",
                ).trim(),
              )
              .filter(Boolean),
          ),
        ];
        console.log(itemTokens, "token");
        void getVendorsByCategory(itemTokens);
        setItemsListDataViewRFQ(itemsArray);
        setUniqueData(responseData);
        setItemToken(itemTokens);

        let fileObj = responseData?.proposal_document?.split("/");
        let fileName = fileObj && fileObj[fileObj?.length - 1];
        setFileName(fileName);

        setRFQToken(responseData?.token);

        setOpenForm({
          open: true,
          loading: false,
          errorMessage: "",
        });

        if (query === "update inputs") {
          void hydrateRfqBudget(responseData);
          hydrateAlternativeSuppliers(responseData?.alternative_supplier ?? res?.data?.alternative_supplier);
        }

        if (query === "update inputs") {
          const itemsForInput = Array.isArray(itemsData)
            ? itemsData
            : itemsData
              ? [itemsData]
              : [];
          let mappedItemsList = normalizeRfqItems(itemsForInput)?.map(
            (el, i) => {
              return {
                itemToken: el.item_token,
                itemTokenisValid: false,

                itemMappedToken: resolveRfqItemMappedToken(el),

                itemCode: el.item_code,
                itemCodeisValid: false,

                itemName: el.item_name,
                itemNameisValid: false,

                expenseType:
                  el.expense_type ??
                  el.expenseType ??
                  responseData?.expense_type ??
                  responseData?.expenseType ??
                  "",

                itemQuantity: el.quantity,
                itemQuantityisValid: false,

                itemUnit: el.unit || el.uom || "",
                itemUnitisValid: false,

                itemDescription: el.description || el.item_description || "",
                itemDescriptionisValid: false,

                itemPartNumber: el.manufacturer_part_no || el.part_number || "",
                itemCategory: el.category || "",
                itemHsnCode: el.hsn_code || "",
                itemUnspscCode: el.unspsc_code || "",
                itemSubCategory: el.sub_category || "",
                itemType: el.item_type || "",
                itemBrand: el.brand || "",
                itemTax: Array.isArray(el.GST_list)
                  ? [...new Set(el.GST_list
                      .map((tax) => `${tax?.country || ""}${tax?.country && tax?.gst ? " - " : ""}${tax?.gst || ""}${tax?.gst ? "%" : ""}`)
                      .filter(Boolean))]
                      .join(", ")
                  : "",
                itemSpecifications: el.specifications || "",
                itemAliases: el.aliases || "",

                itemDuplicate: false,
              };
            },
          );

          setItemsInput(
            (mappedItemsList || []).map((it) => ({
              ...it,
              itemDuplicate: false,
            })),
          );

          setRequestNumber({
            value: getManualPurchaseRequestNumber(responseData),
            isValid: emptyCheck(getManualPurchaseRequestNumber(responseData)),
          });
          const selectedCategory = resolveRFQCategory(
            responseData,
            RFQCategory.categoryList,
          );
          setRFQCategory((prev) => ({
            ...prev,
            value: selectedCategory.value,
            id: selectedCategory.id,
            isValid: true,
          }));
          setBidType({
            value: normalizeBidTypeValue(responseData?.bidding_type),
            isValid: true,
          });
          setSealedBid(normalizeBooleanValue(responseData?.sealed_bid));
          setBidStatus({
            value: responseData?.bid_status,
            isValid: true,
          });

          // changing format to 8 August 2023 to 2023-08-08 12:32:09.021329
          let startDate = dayjs(
            responseData?.bid_from_date,
            "DD MMMM YYYY",
          ).format("YYYY-MM-DD HH:mm:ss.SSSSSS");
          let endDate = dayjs(responseData?.bid_to_date, "DD MMMM YYYY").format(
            "YYYY-MM-DD HH:mm:ss.SSSSSS",
          );

          const bidTimeVal = responseData?.bid_time;
          const endTime =
            bidTimeVal && String(bidTimeVal).trim()
              ? dayjs
                  .utc(bidTimeVal)
                  .local()
                  .format("YYYY-MM-DD HH:mm:ss.SSSSSS")
              : "";

          setFromDate({
            value: startDate,
            isValid: true,
          });
          setToDate({
            value: endDate,
            isValid: true,
          });
          setTime({
            value: endTime,
            isChanged: false,
            isValid: true,
          });

          const vendorStrApi = responseData?.select_vendor ?? "";
          let finalVendorArray = Array.isArray(vendorStrApi)
            ? vendorStrApi.map((s) => String(s).trim()).filter(Boolean)
            : vendorStrApi
              ? String(vendorStrApi)
                  .split(",")
                  .map((s) => s.trim())
                  .filter(Boolean)
              : [];

          void getVendorsByCategory(itemTokens);

          setVendor({
            value: finalVendorArray,
            isValid: true,
          });

          setExistingVendorList(finalVendorArray);
          setVendorID(finalVendorArray);
          // setExistingVendorList(itemsData?.item_token);

          setAddress1({
            value: responseData?.shipping_address1,
            isValid: true,
          });
          setAddress2({
            value: responseData?.shipping_address2,
            isValid: true,
          });
          setCountry((prev) => ({
            ...prev,
            value: responseData?.country,
            countryList: [],
            isValid: true,
          }));
          setStateName((prev) => ({
            ...prev,
            value: responseData?.state,
            stateList: [],
            isValid: true,
          }));
          setCity((prev) => ({
            ...prev,
            value: responseData?.city,
            cityList: [],
            isValid: true,
          }));

          setMobileNumber({
            value: normalizeMobileNumber(responseData?.mobile_number),
            isValid: true,
          });

          setUploadDocument({
            uploadDescripton: responseData?.proposal_description ? true : false,
            uploadFile: responseData?.proposal_document ? true : false,
          });

          setProposalDescription({
            value: responseData?.proposal_description,
            isValid: true,
          });

          setProposalDocument({
            value: responseData?.proposal_document,
            isValid: true,
            hasFile: true,
          });

          setPincode({
            value: responseData?.pincode,
            isValid: true,
          });
        }
        return {
          source: "api",
          rfqToken: responseData?.token,
          bidsLoadedFromRfqBids: Array.isArray(rfqBids) && rfqBids.length > 0,
        };
      })
      .catch((err) => {
        setLoadingState(false);
        console.log(err);
        setOpenForm({
          open: false,
          loading: false,
          errorMessage:
            err?.response?.status !== 500
              ? err?.response?.data && typeof err?.response?.data === "object"
                ? Object.values(err?.response?.data)[0]
                : err?.message || "An error occurred"
              : "Something went wrong, please try again later.",
        });
        return {
          source: "error",
          rfqToken: null,
          bidsLoadedFromRfqBids: false,
        };
      });
  };

  const viewAllItem = async (org_token, options = {}) => {
    const { silent = false, showLoader } = options;
    const hideLoader = showLoader === false || silent;

    if (masterFetchRef.current.itemsPromise) {
      await masterFetchRef.current.itemsPromise;
      await getAllVendorsData({ showLoader: !hideLoader });
      return;
    }

    const loadItemsPromise = (async () => {
      if (!hideLoader) {
        setOpenForm({
          open: false,
          loading: true,
          errorMessage: "",
        });
      }

      // Try cache first
      const cachedItems = await masterDataRepository.getItemsFromCache();
      if (cachedItems && cachedItems.length > 0) {
        setItemList({
          values: {
            tokens: cachedItems.map((e) => e?.token),
            visibleOption: cachedItems.map((e) => e?.item_code),
          },
        });
        setItemNameList({
          values: {
            tokens: cachedItems.map((e) => e?.token),
            visibleOption: cachedItems.map((e) => e?.item_name),
          },
        });
        if (!hideLoader) {
          setOpenForm({
            open: true,
            loading: false,
            errorMessage: "",
          });
        }
      }

      // Sync from API if online
      if (shouldMakeAPICall(auth_token, org_token)) {
        await axios({
          method: "POST",
          url: `${API_ENDPOINT.view_all_item}`,
          data: {
            org_token: org_token,
          },
          headers: {
            Authorization: `Bearer ${auth_token} `,
          },
        })
          .then(async (res) => {
            const items = res?.data?.response || [];
            // Save to cache
            await masterDataRepository.saveItemsToCache(items);

            if (!hideLoader) {
              setOpenForm({
                open: true,
                loading: false,
                errorMessage: "",
              });
            }
            setItemList({
              values: {
                tokens: items.map((e) => e?.token),
                visibleOption: items.map((e) => e?.item_code),
              },
            });
            setItemNameList({
              values: {
                tokens: items.map((e) => e?.token),
                visibleOption: items.map((e) => e?.item_name),
              },
            });
          })
          .catch((err) => {
            console.log("Error loading items, using IndexedDB:", err);
            if (!hideLoader) {
              setOpenForm({
                open: false,
                loading: false,
                errorMessage: Object.values(
                  err?.response?.data || { error: "Failed to load items" },
                ),
              });
            }
          });
      } else if (!hideLoader && (!cachedItems || cachedItems.length === 0)) {
        setOpenForm({
          open: false,
          loading: false,
          errorMessage:
            "No items available offline. Please connect to the internet.",
        });
      }
    })();

    masterFetchRef.current.itemsPromise = loadItemsPromise;
    try {
      await loadItemsPromise;
    } finally {
      masterFetchRef.current.itemsPromise = null;
    }

    await getAllVendorsData({ showLoader: !hideLoader });
  };

  console.log(itemList);
  //get all data
  const getAllVendorsData = async (options = {}) => {
    const { silent = false, showLoader } = options;
    const hideLoader = showLoader === false || silent;

    if (masterFetchRef.current.vendorsPromise) {
      await masterFetchRef.current.vendorsPromise;
      return;
    }

    const loadVendorsPromise = (async () => {
      if (!hideLoader) {
        setOpenForm((prev) => ({
          ...prev,
          loading: true,
          errorMessage: "",
        }));
      }

      const cachedVendors = await masterDataRepository.getVendorsFromCache();
      if (cachedVendors && cachedVendors.length > 0) {
        const nextAll = {
          values: {
            tokens: cachedVendors.map((e) => e?.token),
            visibleOption: cachedVendors.map(
              (e) => e?.company_name + " (" + e?.company_official_email + ")",
            ),
          },
        };
        setAllVendorsList(nextAll);
        if (!vendorFilterActiveRef.current) {
          setVendorsList(nextAll);
        }
        if (!hideLoader) {
          setOpenForm((prev) => ({
            ...prev,
            open: true,
            loading: false,
            errorMessage: "",
          }));
        }
      } else {
        const empty = { values: { tokens: [], visibleOption: [] } };
        setAllVendorsList(empty);
        if (!vendorFilterActiveRef.current) {
          setVendorsList(empty);
        }
      }

      if (shouldMakeAPICall(auth_token, buyer_token)) {
        await axios({
          method: "POST",
          url: `${API_ENDPOINT.get_all_vendor}`,
          data: {
            org_token: buyer_token,
          },
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        })
          .then(async (res) => {
            const vendors = res?.data?.users || [];
            await masterDataRepository.saveVendorsToCache(vendors);
            const nextAll = {
              values: {
                tokens: vendors.map((e) => e?.token),
                visibleOption: vendors.map(
                  (e) =>
                    e?.company_name + " (" + e?.company_official_email + ")",
                ),
              },
            };
            setAllVendorsList(nextAll);
            if (!vendorFilterActiveRef.current) {
              setVendorsList(nextAll);
            }
            if (!hideLoader) {
              setOpenForm((prev) => ({
                ...prev,
                open: true,
                loading: false,
                errorMessage: "",
              }));
            }
          })
          .catch((err) => {
            if (
              !hideLoader &&
              err.code !== "ERR_NETWORK" &&
              err.code !== "ERR_CONNECTION_REFUSED"
            ) {
              setOpenForm((prev) => ({
                ...prev,
                open: true,
                loading: false,
                errorMessage:
                  cachedVendors && cachedVendors.length > 0
                    ? "Using cached vendors. Some vendors may be outdated."
                    : "Failed to load vendors. Form will open with empty vendor list.",
              }));
            } else if (!hideLoader) {
              setOpenForm((prev) => ({
                ...prev,
                open: true,
                loading: false,
                errorMessage: "",
              }));
            }
          });
      } else if (!hideLoader) {
        setOpenForm((prev) => ({
          ...prev,
          open: true,
          loading: false,
          errorMessage: "",
        }));
      }
    })();

    masterFetchRef.current.vendorsPromise = loadVendorsPromise;
    try {
      await loadVendorsPromise;
    } finally {
      masterFetchRef.current.vendorsPromise = null;
    }
  };

  const applyItemMasterDetails = (item, index) => {
    handleItemInputChanges(item.uom || item.unit || "", "itemUnit", index);
    handleItemInputChanges(
      item.manufacturer_part_no || item.part_number || "",
      "itemPartNumber",
      index,
    );
    handleItemInputChanges(
      item.item_description || item.description || "",
      "itemDescription",
      index,
    );
    handleItemInputChanges(item.category || "", "itemCategory", index);
    handleItemInputChanges(item.sub_category || "", "itemSubCategory", index);
    handleItemInputChanges(item.item_type || "", "itemType", index);
    handleItemInputChanges(item.hsn_code || "", "itemHsnCode", index);
    handleItemInputChanges(item.unspsc_code || "", "itemUnspscCode", index);
    handleItemInputChanges(item.brand || "", "itemBrand", index);
    handleItemInputChanges(
      Array.isArray(item.GST_list) ? item.GST_list : [],
      "itemGSTList",
      index,
    );
    handleItemInputChanges(
      Array.isArray(item.GST_list)
        ? [...new Set(item.GST_list
            .map((tax) => `${tax?.country || ""}${tax?.country && tax?.gst ? " - " : ""}${tax?.gst || ""}${tax?.gst ? "%" : ""}`)
            .filter(Boolean))]
            .join(", ")
        : "",
      "itemTax",
      index,
    );
    handleItemInputChanges(item.specifications || "", "itemSpecifications", index);
    handleItemInputChanges(item.aliases || "", "itemAliases", index);
  };

  const getItemDetailsByItemCode = async (item_token, index) => {
    console.log(item_token, "itemToken");
    const isOffline = !shouldMakeAPICall(auth_token, buyer_token);
    if (isOffline) {
      const cachedItems = await masterDataRepository.getItemsFromCache();
      console.log(cachedItems, "cachedItemss");
      const item = cachedItems.find((i) => {
        console.log("Checking item:", i);

        return (
          i.token === item_token ||
          i.item_token === item_token ||
          i.item_code === item_token ||
          i.item_name === item_token
        );
      });

      console.log(item, "items");
      if (item) {
        handleItemInputChanges(item.item_name || "", "itemName", index);
        handleItemInputChanges(item.expense_type || "", "expenseType", index);
        applyItemMasterDetails(item, index);

        const tokenToUse = item.token || item.item_token;
        getVendorsByCategory(collectSelectedItemTokens(index, tokenToUse));
      }
      return;
    }
    await axios({
      method: "GET",
      url: `${API_ENDPOINT.get_individual_item_by_item_code}${item_token}`,
      headers: {
        Authorization: `Bearer ${auth_token} `,
      },
    })
      .then((res) => {
        let item = res?.data?.Item[0];
        console.log(item);
        handleItemInputChanges(item.item_name, "itemName", index);
        handleItemInputChanges(item.expense_type || "", "expenseType", index);
        applyItemMasterDetails(item, index);
        getVendorsByCategory(collectSelectedItemTokens(index, item.token));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getItemDetailsByNameCode = async (item_token, index) => {
    console.log(item_token, "itemToken");
    const isOffline = !shouldMakeAPICall(auth_token, buyer_token);
    if (isOffline) {
      const cachedItems = await masterDataRepository.getItemsFromCache();
      console.log(cachedItems, "cachedItemss");
      const item = cachedItems.find((i) => {
        console.log("Checking item:", i);

        return (
          i.token === item_token ||
          i.item_token === item_token ||
          i.item_code === item_token ||
          i.item_name === item_token
        );
      });

      console.log(item, "items");
      if (item) {
        handleItemInputChanges(item.item_code || "", "itemCode", index);
        handleItemInputChanges(item.expense_type || "", "expenseType", index);
        applyItemMasterDetails(item, index);

        const tokenToUse = item.token || item.item_token;
        getVendorsByCategory(collectSelectedItemTokens(index, tokenToUse));
      }

      return;
    }
    await axios({
      method: "GET",
      url: `${API_ENDPOINT.get_individual_item_by_item_code}${item_token}`,
      headers: {
        Authorization: `Bearer ${auth_token} `,
      },
    })
      .then((res) => {
        let item = res?.data?.Item[0];
        console.log(item);
        handleItemInputChanges(item.item_code, "itemCode", index);
        handleItemInputChanges(item.expense_type || "", "expenseType", index);
        applyItemMasterDetails(item, index);
        getVendorsByCategory(collectSelectedItemTokens(index, item.token));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const openUpdateRFQModal = (rfq_token) => {
    const tokenInlocal = localStorage.getItem("selected_rfq_code");
    const selectedRfqFromList = Array.isArray(RFQData)
      ? RFQData.find(
          (rfq) =>
            String(rfq?.token || rfq?.rfq_token || "") ===
            String(rfq_token || ""),
        )
      : null;
    openEditRFQ();
    if (selectedRfqFromList?.department) {
      void hydrateRfqBudget({
        department:
          selectedRfqFromList.department?.name ||
          selectedRfqFromList.department,
        department_id:
          selectedRfqFromList.department_id ||
          selectedRfqFromList.department?.id,
      });
    }
    getIndividualData(tokenInlocal ? tokenInlocal : rfq_token, "update inputs");
    setEditRFQForm(true);
    setRFQToken(rfq_token);
    if (!itemList?.values?.tokens?.length) {
      viewAllItem(org_token, { showLoader: false });
    } else if (!vendorsList?.values?.tokens?.length) {
      getAllVendorsData({ showLoader: false });
    }
  };
  const getRFQCreatedMs = (rfq) => {
    const raw =
      rfq?.created_date ??
      rfq?.created_on ??
      rfq?.created ??
      rfq?.bid_from_date ??
      rfq?._lastUpdated ??
      0;

    if (typeof raw === "number") return raw;
    const ms = Date.parse(raw);
    return Number.isNaN(ms) ? 0 : ms;
  };

  const rfqCellValueOrDash = (value) => {
    if (value === undefined || value === null) return "-";
    const stringValue = String(value);
    return stringValue.trim() === "" ? "-" : value;
  };

  const getRfqItemsFromRow = (row) => {
    if (!row) return [];
    if (Array.isArray(row.items)) return row.items;
    if (typeof row.items === "string") {
      try {
        const parsed = JSON.parse(row.items);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  const mapRfqItemsForPreview = (row) => {
    const items = getRfqItemsFromRow(row);
    return items.map((item, index) => ({
      sl_no: index + 1,
      item_name: rfqCellValueOrDash(item?.item_name ?? item?.itemName),
      item_code: rfqCellValueOrDash(item?.item_code ?? item?.itemCode),
      expense_type: rfqCellValueOrDash(item?.expense_type ?? item?.expenseType),
      quantity: rfqCellValueOrDash(item?.quantity ?? item?.itemQuantity),
      unit: rfqCellValueOrDash(item?.unit ?? item?.itemUnit),
      description: rfqCellValueOrDash(item?.description),
    }));
  };

  const buildRfqItemsTooltipTitle = (items = []) => {
    const rows = Array.isArray(items) ? items.slice(0, 5) : [];
    if (!rows.length) return "No items found.";

    return (
      <TableContainer
        component={Paper}
        sx={{ maxWidth: 560, maxHeight: 260, overflow: "auto" }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontSize: "14px",
                  fontFamily: "GilroyBold",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                Item Name
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "14px",
                  fontFamily: "GilroyBold",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                Item Code
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "14px",
                  fontFamily: "GilroyBold",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
                align="right"
              >
                Quantity
              </TableCell>
              <TableCell
                sx={{
                  fontSize: "14px",
                  fontFamily: "GilroyBold",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                Unit
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((item, index) => (
              <TableRow
                key={String(
                  item?.item_token ??
                    item?.itemToken ??
                    item?.item_code ??
                    item?.itemCode ??
                    index,
                )}
              >
                <TableCell
                  sx={{
                    fontSize: "14px",
                    fontFamily: "gilroyMedium",
                    maxWidth: 220,
                  }}
                >
                  {rfqCellValueOrDash(item?.item_name ?? item?.itemName)}
                </TableCell>
                <TableCell
                  sx={{
                    fontSize: "14px",
                    fontFamily: "gilroyMedium",
                    maxWidth: 160,
                  }}
                >
                  {rfqCellValueOrDash(item?.item_code ?? item?.itemCode)}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}
                  align="right"
                >
                  {rfqCellValueOrDash(item?.quantity ?? item?.itemQuantity)}
                </TableCell>
                <TableCell
                  sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}
                >
                  {rfqCellValueOrDash(item?.unit ?? item?.itemUnit)}
                </TableCell>
              </TableRow>
            ))}
            {items.length > rows.length && (
              <TableRow>
                <TableCell
                  colSpan={4}
                  sx={{
                    fontSize: "14px",
                    fontFamily: "gilroyMedium",
                    fontStyle: "italic",
                  }}
                >
                  +{items.length - rows.length} more
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const openRfqItemsPreviewDialog = (row) => {
    setRfqItemsPreviewDialog({
      open: true,
      rfqCode: row?.rfq_code || "",
      items: mapRfqItemsForPreview(row),
    });
  };

  const closeRfqItemsPreviewDialog = () => {
    setRfqItemsPreviewDialog((prev) => ({ ...prev, open: false }));
  };

  const renderRfqMultipleItemsCell = (row, field) => {
    const items = getRfqItemsFromRow(row);
    const hasMultiple = items.length > 1;

    const value = hasMultiple
      ? "Multiple Items"
      : rfqCellValueOrDash(row?.[field]);
    if (!hasMultiple) return <span>{value}</span>;

    const tooltipTitle = buildRfqItemsTooltipTitle(items);

    return (
      <Tooltip
        arrow
        placement="right-start"
        title={tooltipTitle}
        componentsProps={{
          tooltip: { sx: { bgcolor: "transparent", p: 0, maxWidth: "none" } },
        }}
      >
        <span
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "14px",
            fontFamily: "gilroyMedium",
          }}
          onClick={(event) => {
            event.stopPropagation();
            openRfqItemsPreviewDialog(row);
          }}
        >
          {value}
        </span>
      </Tooltip>
    );
  };

  const renderRfqCodeCell = (row) => {
    const value = rfqCellValueOrDash(row?.rfq_code);

    return (
      // <Tooltip title={value === "-" ? "" : value} placement="top" arrow>

      // </Tooltip>

      <span className={classes.rfqCodeCell}>{value}</span>
    );
  };

  const renderRfqStatusPill = (row) => {
    const statusText = rfqCellValueOrDash(row?.rfq_status);
    const normalizedStatus = String(statusText || "").trim().toLowerCase();
    const isInactiveStatus = [
      "closed",
      "cancelled",
      "canceled",
      "failed",
      "rejected",
    ].includes(normalizedStatus);

    return (
      <span
        className={
          isInactiveStatus ? classes.rfqStatusInactive : classes.rfqStatusActive
        }
      >
        {statusText}
      </span>
    );
  };

  // data for the datatable
  const headings = [
    {
      label: "RFQ ID",
      field: "rfq_code",
      col_width: "26rem",
      minWidth: "26rem",
      renderCell: (row) => renderRfqCodeCell(row),
    },
    {
      label: "Item Name",
      field: "item_name",
      col_width: "16rem",
      minWidth: "16rem",
      renderCell: (row) => renderRfqMultipleItemsCell(row, "item_name"),
    },

    {
      label: "Item Code",
      field: "item_code",
      col_width: "13rem",
      minWidth: "13rem",
      renderCell: (row) => renderRfqMultipleItemsCell(row, "item_code"),
    },
    {
      label: "Quantity",
      field: "quantity",
      col_width: "10rem",
      minWidth: "10rem",
      renderCell: (row) => renderRfqMultipleItemsCell(row, "quantity"),
    },
    {
      label: "Bid Created Date",
      field: "created_date",
      col_width: "14rem",
      minWidth: "14rem",
    },
    {
      label: "Bid Start Date",
      field: "bid_from_date",
      col_width: "13rem",
      minWidth: "13rem",
    },
    {
      label: "Bid End Date",
      field: "bid_to_date",
      col_width: "13rem",
      minWidth: "13rem",
    },

    {
      label: "Status",
      field: "bid_status",
      col_width: "12rem",
      minWidth: "12rem",
    },
    {
      label: "Order Status",
      field: "rfq_status",
      col_width: "13rem",
      minWidth: "12rem",
      renderCell: (row) => renderRfqStatusPill(row),
    },
  ];
  const formattedRows = (Array.isArray(displayRFQs) ? displayRFQs : []).map(
    (row) => ({
      ...row,
      expense_type: row?.expense_type || row?.expenseType || "-",
      rfq_status: row?.rfq_status || row?.po_status || "-",
      po_status: row?.po_status || "-",
    }),
  );

  //send bid types
  const getBidType = (_, optionValue) => {
    const matches = optionValue?.match(/\d+/);
    const number = matches ? parseInt(matches[0]) : null;

    if (optionValue === "All") {
      setIterationNumber();
    } else if (optionValue === "Initial") {
      setIterationNumber("0");
    } else if (optionValue === "Default") {
      setIterationNumber("default");
    } else {
      setIterationNumber(number);
    }
  };
  const getBidTypeSendMessg = (_, optionValue) => {
    const matches = optionValue?.match(/\d+/);
    const number = matches ? parseInt(matches[0]) : null;

    if (optionValue === "All") {
      setIterationNumber();
    } else if (optionValue === "Initial") {
      setIterationNumber("0");
    } else if (optionValue === "Default") {
      setIterationNumber("default");
    } else {
      setIterationNumber(number);
    }
  };

  let uniqueVersions = bulkBidsData?.map((e) => e.bid_version);

  let quoteIterationOptions = ["All", "Default", ...new Set(uniqueVersions)];

  // data for the view datatable
  const headingsForViewRFQ = [
    // { label: "Vendor", field: "vendor",hasCheckbox: true }, // added ?
    {
      label: "Supplier Company Name",
      field: "vendor",
      hasCheckbox: true,
      noWrap: true,
    }, // added ?
    //    {
    //   label: "Supplier Name",
    //   field: "supplier_name",
    // },
    {
      label: "Supplier Email",
      field: "supplier_email",
      noWrap: true,
    },
    { label: "Supplier ID", field: "vendor_code" },
    { label: "Quantity", field: "quantity" },
    { label: "Unit Price", field: "unit_price", noWrap: true },
    { label: "Total Price in Global Currency", field: "total_price" },
    { label: "Total Price in Local Currency", field: "converted_currency" },
    {
      label: "Quote Iteration",
      field: "bid_version",
      selectable_header: true,
      DropdownOptions: quoteIterationOptions,
      onClick: getBidType,
    },
    {
      label: "Created Date",
      field: "created_date",
      noWrap: true,
    },
  ];
  // data for the sent message view datatable
  const headingsForSentMessage = [
    //{ label: "Vendor", field: "company_name",hasCheckbox: true  },
    // { label: "Vendor", field: "company_name",hasCheckbox: false}, // added ?
    {
      label: "Supplier Company Name",
      field: "vendor_name",
      hasCheckbox: false,
    },
    { label: "Supplier Name", field: "first_name", hasCheckbox: false },
    { label: "Supplier ID", field: "vendor_code" },
    { label: "Company Email", field: "company_official_email" },
    { label: "Company Phone Number", field: "company_phone_number" },
  ];

  const emptyToDash = (v) => (v == null || v === "" ? "-" : v);
  const RFQitemsListMapped = itemsListDataViewRFQ?.map((e, i) => {
    const hsn = e?.hsn_code
      ? typeof e.hsn_code === "string"
        ? e.hsn_code.split("-")[0]
        : e.hsn_code
      : "";
    const unspsc = e?.unspsc_code
      ? typeof e.unspsc_code === "string"
        ? e.unspsc_code.split("-")[0]
        : e.unspsc_code
      : "";
    const expenseTypeRaw =
      e?.expense_type ??
      e?.expenseType ??
      e?.expense_type_name ??
      e?.expenseTypeName ??
      e?.expense_type_label ??
      e?.expenseTypeLabel;
    const expenseType =
      typeof expenseTypeRaw === "object"
        ? (expenseTypeRaw?.name ?? expenseTypeRaw?.label ?? "")
        : expenseTypeRaw;
    const fallbackExpenseType =
      uniqueData?.expense_type ??
      uniqueData?.expenseType ??
      uniqueData?.expense_type_name ??
      uniqueData?.expenseTypeName ??
      "";
    const resolvedExpenseType =
      String(expenseType || "").trim() !== ""
        ? expenseType
        : fallbackExpenseType;
    return {
      itemMappedToken: resolveRfqItemMappedToken(e),
      item_mapped_token: resolveRfqItemMappedToken(e),
      item_rfq_map_token: resolveRfqItemMappedToken(e),
      itemToken: e?.itemToken ?? e?.item_token ?? resolveRfqItemMappedToken(e),
      item_token: e?.item_token ?? e?.itemToken ?? resolveRfqItemMappedToken(e),
      item_name: emptyToDash(e?.item_name),
      expense_type: emptyToDash(resolvedExpenseType),
      item_code: emptyToDash(e?.item_code),
      category: emptyToDash(e?.category),
      hsn_code: emptyToDash(hsn),
      unspsc_code: emptyToDash(unspsc),
      sub_category: emptyToDash(e?.sub_category),
      item_type: emptyToDash(e?.item_type),
      unit: emptyToDash(e?.unit),
      quantity: emptyToDash(e?.quantity),
      normalized_value: emptyToDash(e?.normalized_value),
      part_number: emptyToDash(
        e?.manufacturer_part_no ?? e?.part_number,
      ),
      brand: emptyToDash(e?.brand),
      gst_list: Array.isArray(e?.GST_list)
        ? [
            ...new Set(
              e.GST_list
                .map((tax) =>
                  tax?.country && tax?.gst
                    ? `${tax.country} - ${tax.gst}%`
                    : "",
                )
                .filter(Boolean),
            ),
          ].join(", ")
        : "-",
      specifications: emptyToDash(e?.specifications),
      aliases: emptyToDash(e?.aliases),
      description: emptyToDash(e?.description),
    };
  });

  // data for the view datatable
  const headingsForViewItemsRFQ = [
    {
      label: "Item Name",
      field: "item_name",
      col_width: "150px",
      noWrap: true,
    },
    { label: "Expense Type", field: "expense_type", col_width: "150px" },
    { label: "Item Code", field: "item_code", col_width: "150px" },
    { label: "Quantity", field: "quantity", col_width: "100px" },
    { label: "Unit", field: "unit", col_width: "100px" },
    {
      label: "Normalized UOM",
      field: "normalized_value",
      col_width: "160px",
      wrapHeader: false,
      noWrap: true,
    },
    { label: "Category", field: "category", col_width: "150px" },
    { label: "HSN Code", field: "hsn_code", col_width: "150px" },
    { label: "UNSPSC Code", field: "unspsc_code", col_width: "150px" },
    { label: "Sub-Category", field: "sub_category", col_width: "150px" },
    { label: "Item Type", field: "item_type", col_width: "120px" },
    { label: "Manufacturer Part No.", field: "part_number", col_width: "170px" },
    { label: "Brand", field: "brand", col_width: "130px" },
    { label: "Tax", field: "gst_list", col_width: "130px" },
    {
      label: "Specifications",
      field: "specifications",
      cellType: "readMore",
      maxLength: 55,
      col_width: "220px",
    },
    { label: "Aliases", field: "aliases", col_width: "180px" },
    {
      label: "Description",
      field: "description",
      cellType: "view",
      highlightView: true,
      col_width: "150px",
      noWrap: true,
    },
  ];

  const headingMessage = [
    { label: "Supplier Name", field: "company_name" },
    // {
    //   label: "Quote Iteration",
    //   field: "bid_version",
    //   selectable_header: true,
    //   DropdownOptions: quoteIterationOptions,
    //   onClick: getBidTypeSendMessg,
    // },
  ];

  const regexForAlphabets = /[^a-zA-Z\s]/g;
  const regexForAlphaNumeric = /[^a-zA-Z0-9\s]+/g;
  const regexForNumber = /[^\d\s]/g;
  const numberOnlyRegex = /^\d+$/;
  const rfqPrAndPartNumberInvalidCharsRegex = /[^a-zA-Z0-9/_-]+/g;
  const RFQ_PR_AND_PART_NUMBER_MAX_LEN = 10;
  const RFQ_PR_NUMBER_MAX_LEN = 20;

  const sanitizeRfqPrAndPartNumber = (
    value = "",
    maxLength = RFQ_PR_AND_PART_NUMBER_MAX_LEN,
  ) => {
    return String(value || "")
      .replace(rfqPrAndPartNumberInvalidCharsRegex, "")
      .slice(0, maxLength);
  };

  const normalizeRfqItemKey = (item = {}) => {
    const key = item?.itemToken ?? item?.itemCode ?? "";
    const normalized = String(key ?? "")
      .trim()
      .toLowerCase();
    return normalized;
  };

  const hasRfqItemKeyConflict = (list = [], index) => {
    const current = list?.[index];
    if (!current) return false;
    const key = normalizeRfqItemKey(current);
    if (!key) return false;
    return (list || []).some((other, idx) => {
      if (idx === index) return false;
      return normalizeRfqItemKey(other) === key;
    });
  };

  const clearResolvedDuplicateFlags = (list = []) => {
    const next = (list || []).map((item) => ({ ...item }));
    next.forEach((item, idx) => {
      if (!item.itemDuplicate) return;
      const stillConflicts = hasRfqItemKeyConflict(next, idx);
      if (!stillConflicts) item.itemDuplicate = false;
    });
    return next;
  };

  const markDuplicateForIndexOnly = (list = [], index) => {
    const next = clearResolvedDuplicateFlags(list);
    if (!next[index]) return next;
    const key = normalizeRfqItemKey(next[index]);
    const isDup = hasRfqItemKeyConflict(next, index);
    if (isDup && key) {
      next.forEach((item, idx) => {
        if (idx === index) return;
        if (item.itemDuplicate && normalizeRfqItemKey(item) === key) {
          item.itemDuplicate = false;
        }
      });
    }
    next[index].itemDuplicate = isDup;
    return next;
  };

  const markLatestDuplicatesForSubmit = (list = []) => {
    const next = clearResolvedDuplicateFlags(list);
    const indicesByKey = new Map();
    next.forEach((item, idx) => {
      const key = normalizeRfqItemKey(item);
      if (!key) return;
      const existing = indicesByKey.get(key);
      if (existing) existing.push(idx);
      else indicesByKey.set(key, [idx]);
    });
    indicesByKey.forEach((indices) => {
      if (indices.length <= 1) return;
      const latestIdx = Math.max(...indices);
      indices.forEach((i) => {
        if (next[i]) next[i].itemDuplicate = false;
      });
      if (next[latestIdx]) next[latestIdx].itemDuplicate = true;
    });
    return next;
  };

  const hasAnyRfqItemDuplicates = (list = []) => {
    const seen = new Set();
    for (const item of list || []) {
      const key = normalizeRfqItemKey(item);
      if (!key) continue;
      if (seen.has(key)) return true;
      seen.add(key);
    }
    return false;
  };

  const addItemsInputs = () => {
    setItemsInput([
      ...itemsInput,
      {
        itemToken: "",
        itemTokenisValid: false,

        itemMappedToken: "",

        itemCode: "",
        itemCodeisValid: false,

        itemName: "",
        itemNameisValid: false,

        expenseType: "",

        itemQuantity: "",
        itemQuantityisValid: false,

        itemUnit: "",
        itemUnitisValid: false,

        itemDescription: "",
        itemDescriptionisValid: false,

        itemPartNumber: "",

        itemDuplicate: false,
      },
    ]);
  };

  const removeItemsInput = (index) => {
    setItemsInput((prev) => {
      const next = [...prev];
      next.splice(index, 1);
      const nextWithDup = clearResolvedDuplicateFlags(next);
      if (
        !nextWithDup.some((i) => i.itemDuplicate) &&
        btnErrorState?.errorMsg?.includes("Item already added")
      ) {
        setBtnErrorState({ error: false, errorMsg: "" });
      }
      const remainingTokens = [
        ...new Set(
          (nextWithDup || []).map((i) => i?.itemToken).filter(Boolean),
        ),
      ];
      if (remainingTokens.length > 0) {
        void getVendorsByCategory(remainingTokens);
      } else {
        vendorFilterActiveRef.current = false;
        if (allVendorsList?.values?.visibleOption?.length) {
          setVendorsList(allVendorsList);
        }
        // No item filter → show full vendor list again.
        void getAllVendorsData({ showLoader: false, silent: true });
      }
      return nextWithDup;
    });
  };

  const handleItemInputChanges = (e, elementName, index) => {
    if (itemVendorErrors?.[index]) {
      setItemVendorErrors((prev) => {
        const next = { ...(prev || {}) };
        delete next[index];
        return next;
      });
    }
    setItemsInput((prev) => {
      const next = prev.map((item) => ({ ...item }));
      if (!next[index]) return prev;
      next[index][elementName] = e;
      const keyFields = new Set(["itemToken", "itemCode", "itemName"]);
      const nextWithDup = keyFields.has(elementName)
        ? markDuplicateForIndexOnly(next, index)
        : next;
      if (elementName === "itemToken") {
        const tokens = collectSelectedItemTokens(index, e);
        if (tokens.length > 0) {
          void getVendorsByCategory(tokens);
        } else {
          vendorFilterActiveRef.current = false;
          if (allVendorsList?.values?.visibleOption?.length) {
            setVendorsList(allVendorsList);
          }
          void getAllVendorsData({ showLoader: false, silent: true });
        }
      }
      if (
        !nextWithDup.some((i) => i.itemDuplicate) &&
        btnErrorState?.errorMsg?.includes("Item already added")
      ) {
        setBtnErrorState({ error: false, errorMsg: "" });
      }
      return nextWithDup;
    });
  };

  const validateSelectedVendorsCoverItems = (selectedVendorTokens) => {
    const tokens = Array.isArray(selectedVendorTokens)
      ? selectedVendorTokens.filter(Boolean)
      : [];
    const isVendorList = tokens.length > 0;

    const itemTokensToValidate = uploadItemDocument.inputs
      ? collectSelectedItemTokens()
      : Array.isArray(uploadedItemTokensForVendorFilter)
        ? uploadedItemTokensForVendorFilter
        : [];

    const hasCoverageForAllTokens =
      itemTokensToValidate.length > 0 &&
      itemTokensToValidate.every((t) => {
        const key = String(t || "").trim();
        return (
          Array.isArray(allowedVendorTokensByItemToken?.[key]) &&
          allowedVendorTokensByItemToken[key].length > 0
        );
      });

    // If we don't have per-item coverage info yet (offline/slow), don't block.
    if (
      !isVendorList ||
      itemTokensToValidate.length === 0 ||
      !hasCoverageForAllTokens
    ) {
      return { enforced: false, isValid: true, itemErrors: {} };
    }

    const itemErrors = {};

    if (uploadItemDocument.inputs) {
      (Array.isArray(itemsInput) ? itemsInput : []).forEach((item, idx) => {
        const token = String(item?.itemToken || "").trim();
        if (!token) return;
        const allowed = allowedVendorTokensByItemToken?.[token] || [];
        const covered = tokens.some((t) => allowed.includes(String(t).trim()));
        if (!covered) itemErrors[idx] = "Select vendor for this item";
      });
    } else {
      const anyUncovered = itemTokensToValidate.some((token) => {
        const allowed =
          allowedVendorTokensByItemToken?.[String(token).trim()] || [];
        return !tokens.some((t) => allowed.includes(String(t).trim()));
      });
      if (anyUncovered)
        itemErrors._upload = "Please select vendor(s) for all items.";
    }

    return {
      enforced: true,
      isValid: Object.keys(itemErrors).length === 0,
      itemErrors,
    };
  };

  const validateForm = () => {
    let isItemListIsValid = true;
    const nextItemsInput = itemsInput.map((item) => ({ ...item }));

    nextItemsInput.forEach((el, index) => {
      const itemCodeOk = emptyCheck(el.itemCode);
      const itemNameOk = emptyCheck(el.itemName);
      const itemQuantityOk = emptyCheck(el.itemQuantity);
      const itemUnitOk = emptyCheck(el.itemUnit);
      const itemDescriptionOk =
        !!el?.itemDescription &&
        String(el.itemDescription).trim() !== "" &&
        String(el.itemDescription).length <= 2550;

      nextItemsInput[index].itemCodeisValid = !itemCodeOk;
      nextItemsInput[index].itemNameisValid = !itemNameOk;
      nextItemsInput[index].itemQuantityisValid = !itemQuantityOk;
      nextItemsInput[index].itemUnitisValid = !itemUnitOk;
      nextItemsInput[index].itemDescriptionisValid = !itemDescriptionOk;

      if (
        !(
          itemCodeOk &&
          itemNameOk &&
          itemQuantityOk &&
          itemUnitOk &&
          itemDescriptionOk
        )
      ) {
        isItemListIsValid = false;
      }
    });

    const shouldCheckDuplicates = !!uploadItemDocument.inputs;
    const nextWithDuplicates = shouldCheckDuplicates
      ? markLatestDuplicatesForSubmit(nextItemsInput)
      : nextItemsInput.map((item) => ({ ...item, itemDuplicate: false }));

    if (
      shouldCheckDuplicates &&
      nextWithDuplicates.some((i) => i.itemDuplicate)
    ) {
      isItemListIsValid = false;
    }

    setItemsInput(nextWithDuplicates);

    const isItemCSVIsValid = itemCSV.value !== null && itemCSV.value !== "";
    const isRequestNumber = emptyCheck(requestNumber.value);
    const rfqCategoryId = String(RFQCategory?.id ?? "").trim();
    const rfqCategoryValue = String(RFQCategory?.value ?? "").trim();
    const isRFQCategory =
      emptyCheck(rfqCategoryId, true) && emptyCheck(rfqCategoryValue, true);
    const isBidType = bidType.value !== "";
    const isDescription =
      proposalDescription.value && proposalDescription.value?.trim() !== "";
    const isProposalDocument = validateFile(
      proposalDocument.value,
      true,
      ["pdf", "docx", "xlsx", "xls", "ppt", "pptx"],
      5,
    ).isValid;
    const isfromDate = fromDate.value !== null && fromDate.value !== "";
    const istoDate = toDate.value !== null && toDate.value !== "";
    const istime = time.value !== "" && time?.value !== null;
    const selectedVendorTokens = getSelectedVendorTokens();
    const isVendorList = selectedVendorTokens.length > 0;
    const coverageCheck =
      validateSelectedVendorsCoverItems(selectedVendorTokens);
    const isVendorCoverageValid = coverageCheck.isValid;
    if (coverageCheck.enforced) {
      if (uploadItemDocument.inputs) {
        setItemVendorErrors(coverageCheck.itemErrors || {});
      }
      if (!coverageCheck.isValid) {
        setBtnErrorState({
          error: true,
          errorMsg:
            coverageCheck.itemErrors?._upload ||
            "Please select vendor(s) for all items.",
        });
      }
    }
    const isAddress1 = emptyCheck(address1.value);
    const isCountry = emptyCheck(country.value);
    const isState = emptyCheck(stateName.value);
    const isCity = emptyCheck(city.value);
    const isMobileNumber =
      emptyCheck(mobileNumber.value) && mobileNumber.isValid;
    const isPincode = emptyCheck(pincode.value);

    setItemCSV((prev) => ({ ...prev, isValid: isItemCSVIsValid }));
    setRequestNumber((prev) => ({ ...prev, isValid: isRequestNumber }));
    setRFQCategory((prev) => ({ ...prev, isValid: isRFQCategory }));
    setBidType((prev) => ({ ...prev, isValid: isBidType }));
    setFromDate((prev) => ({ ...prev, isValid: isfromDate }));
    setToDate((prev) => ({ ...prev, isValid: istoDate }));
    setTime((prev) => ({ ...prev, isValid: istime, isChanged: false }));
    setVendor((prev) => ({ ...prev, isValid: isVendorList }));
    setAddress1((prev) => ({ ...prev, isValid: isAddress1 }));
    setCountry((prev) => ({ ...prev, isValid: isCountry }));
    setStateName((prev) => ({ ...prev, isValid: isState }));
    setCity((prev) => ({ ...prev, isValid: isCity }));
    setMobileNumber((prev) => ({ ...prev, isValid: isMobileNumber }));
    setProposalDocument((prev) => ({ ...prev, isValid: isProposalDocument }));
    setPincode((prev) => ({ ...prev, isValid: isPincode }));

    let itemType = uploadItemDocument.uploadFile
      ? isItemCSVIsValid
      : uploadItemDocument.inputs && isItemListIsValid;

    let proposalDoc;

    if (itemCSV.value || itemsInput.length > 1) {
      proposalDoc = true;
      // uploadDocument.uploadFile
      //   ? isProposalDocument
      //   : uploadDocument.uploadDescripton && true;
      setProposalDescription((prev) => ({ ...prev, isValid: true }));
    } else {
      proposalDoc = true;
      // uploadDocument.uploadFile
      //   ? isProposalDocument
      //   : uploadDocument.uploadDescripton && isDescription;
      setProposalDescription((prev) => ({
        ...prev,
        isValid: isDescription,
      }));
    }

    return (
      itemType &&
      isRequestNumber &&
      isRFQCategory &&
      isBidType &&
      isfromDate &&
      istoDate &&
      istime &&
      isVendorList &&
      isVendorCoverageValid &&
      isAddress1 &&
      isCountry &&
      isState &&
      isCity &&
      isMobileNumber &&
      proposalDoc &&
      isPincode
    );
  };

  const handleOpen = () => setOpen(true);
  const handleOpen2 = () => setOpen2(true);
  const handleOpen1 = () => setOpen1(true);
  const handleClose = () => {
    setOpen(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleClose1 = () => {
    setOpen1(false);
    setVendorRegisteredEmail({
      value: "",
      errorMsg: "",
      isValid: true,
    });
    setCompanyName({
      value: "",
      errorMsg: "",
      isValid: true,
    });
  };

  // formdata
  const formData = new FormData();

  !editRFQForm && formData.append("buyer_token", buyer_token);

  if (typeof proposalDocument?.value === "object") {
    formData.append(
      "proposal_document",
      proposalDocument.value ? proposalDocument.value : "",
    );
  }

  const prNumberValue = sanitizeRfqPrAndPartNumber(requestNumber.value);
  formData.append("purchase_request_number", prNumberValue);
  if (selectedDepartment?.id) {
    formData.append("department_id", selectedDepartment.id);
  }
  if (selectedDepartment?.name) {
    formData.append("dept_name", selectedDepartment.name);
    formData.append("department_name", selectedDepartment.name);
  }
  formData.append(
    "budget_details",
    JSON.stringify(budgetConfigs),
  );
  formData.append(
    "budgetDetails",
    JSON.stringify(budgetConfigs.map((budget) => budget?.id).filter(Boolean)),
  );
  // if (!editRFQForm) {
  //Submit the parameter as a new RFQ requst.
  const rfqCategoryId = String(RFQCategory?.id ?? "").trim();
  if (rfqCategoryId) {
    formData.append("category_compare", rfqCategoryId);
  }
  // }
  formData.append("bidding_type", normalizeBidTypeValue(bidType.value));
  formData.append("sealed_bid", sealedBid);

  editRFQForm &&
    bidStatus.value !== "open" &&
    bidStatus.value !== "closed" &&
    bidStatus.isChanged &&
    formData.append("bid_status", bidStatus.value);

  !editRFQForm && formData.append("bid_from_date", fromDate.value);
  formData.append("bid_to_date", toDate.value);

  if (time.value) {
    formData.append("bid_time", time.value);
  }

  // API expects vendor contact tokens for mapping in some org setups; fall back to vendor tokens if contacts not available.
  const selectedVendorTokensForPayload =
    getSelectedVendorContactTokensForPayload().filter((token) => !String(token).startsWith("alt:"));
  const selectedIdsList =
    selectedVendorTokensForPayload.length === 1
      ? [selectedVendorTokensForPayload[0]]
      : selectedVendorTokensForPayload;
  formData.append("select_vendor", selectedIdsList);
  [...new Set(alternativeSupplierOptions.map((option) => option.email).filter(Boolean))]
    .forEach((email) => formData.append("alternative_supplier", email));

  formData.append("shipping_address1", address1.value);
  formData.append("shipping_address2", address2.value);
  formData.append("country", country.value);
  formData.append("city", city.value);
  formData.append("pincode", pincode.value);
  formData.append("state", stateName.value);
  formData.append("mobile_number", mobileNumber.value);

  let itemsListFormatted =
    itemsInput.length >= 1 &&
    itemsInput?.map((e, i) => {
      return {
        item_token: e.itemToken,
        item_code: e.itemCode || "",
        item_name: e.itemName || "",
        category: e.itemCategory || "",
        expense_type: e.expenseType || "",
        sub_category: e.itemSubCategory || "",
        item_type: e.itemType || "",
        hsn_code: e.itemHsnCode || "",
        unspsc_code: e.itemUnspscCode || "",
        quantity: e.itemQuantity,
        unit: e.itemUnit,
        part_number: sanitizeRfqPrAndPartNumber(e.itemPartNumber),
        description: e?.itemDescription,
        brand: e.itemBrand || "",
        GST_list: e.itemGSTList || [],
        specifications: e.itemSpecifications || "",
        aliases: e.itemAliases || "",
      };
    });

  if (!editRFQForm) {
    uploadItemDocument.inputs
      ? formData.append("item_code", JSON.stringify(itemsListFormatted))
      : formData.append("item_code_xlsx", itemCSV.value);
  }
  let itemsListFormattedForUpdate =
    itemsInput.length >= 1 &&
    itemsInput?.map((e, i) => {
      return {
        item_token: e.itemToken,
        expense_type: e.expenseType || "",
        quantity: e.itemQuantity,
        item_mapped_token: e.itemMappedToken,
        unit: e.itemUnit,
        description: e.itemDescription,
        part_number: sanitizeRfqPrAndPartNumber(e.itemPartNumber),
      };
    });
  if (editRFQForm) {
    formData.append(
      "items_data_list",
      JSON.stringify(itemsListFormattedForUpdate),
    );
    deletedItemsToken.length >= 1 &&
      formData.append("delete_item", deletedItemsToken);
  }

  //check array has duplicates
  function hasDuplicates(array) {
    const valueSet = new Set();

    for (const item of array) {
      if (valueSet.has(item)) {
        return true; // Duplicate found
      }

      valueSet.add(item);
    }

    return false; // No duplicates found
  }

  //RFQ submit click
  const handleSubmit = async () => {
    // Clear any previous error state
    setBtnErrorState({
      error: false,
      errorMsg: "",
    });

    const focusQuotationCategory = () => {
      const node = quotationCategoryRef.current;
      if (!node) return;
      try {
        node.scrollIntoView({ behavior: "smooth", block: "center" });
      } catch {
        // ignore scroll errors
      }
      const input = node.querySelector("input");
      if (input && typeof input.focus === "function") input.focus();
    };

    const focusFirstValidationError = () => {
      window.setTimeout(() => {
        const message = document.querySelector(
          `.${classes.newRfqCreateScreen} [class*="error_message"], .${classes.newRfqCreateScreen} [class*="error_msg"]`,
        );
        if (!message) return;

        const field =
          message.closest('[class*="d_input_container"], [class*="select_container"]') ||
          message;
        field.scrollIntoView({ behavior: "smooth", block: "center" });
        field.querySelector("input:not([disabled]), textarea:not([disabled])")?.focus();
      }, 0);
    };

    const isOnline = shouldMakeAPICall(auth_token, buyer_token);

    try {
      const selectedVendorTokens = getSelectedVendorTokens();
      let biddingDetails =
        bidType.value !== "" &&
        fromDate.value &&
        toDate.value &&
        time.value &&
        selectedVendorTokens.length > 0;

      let shippingDetails =
        address1.value &&
        country.value &&
        stateName.value &&
        city.value &&
        mobileNumber.value &&
        pincode.value;

      const validation = validateForm();
      const rfqCategoryId = String(RFQCategory?.id ?? "").trim();
      const rfqCategoryValue = String(RFQCategory?.value ?? "").trim();
      const isRFQCategorySelected = !!(rfqCategoryId && rfqCategoryValue);

      if (!selectedDepartment?.id) {
        setDepartmentError("Department is required.");
        setBtnErrorState({ error: true, errorMsg: "Please choose a department." });
        return;
      }

      if (!validation && !isRFQCategorySelected) {
        setRFQCategory((prev) => ({ ...prev, isValid: false }));
        setBtnErrorState({
          error: true,
          errorMsg: "Quotation Category is required.",
        });
        focusQuotationCategory();
        return;
      }
      if (!validation) {
        focusFirstValidationError();
      }
      // If per-item vendor coverage failed, validateForm already set inline errors + message.
      if (
        !validation &&
        btnErrorState?.error &&
        String(btnErrorState?.errorMsg || "")
          .toLowerCase()
          .includes("select vendor")
      ) {
        return;
      }
      const hasDuplicateItems =
        !!uploadItemDocument.inputs &&
        hasAnyRfqItemDuplicates(itemsInput || []);
      const newVendorEmails = vendorId.filter((item) => item === undefined);
      if (!validation && hasDuplicateItems) {
        setBtnErrorState({
          error: true,
          errorMsg:
            "Item already added. Remove the duplicate item to continue.",
        });
        return;
      }

      if (validation) {
        setLoadingState(true);
        if (newVendorEmails.length !== 0) {
          try {
            let res = await submitNewVendors();
            if (res && Boolean(res?.length)) {
              formData.delete("select_vendor");
              const baseTokens = getSelectedVendorContactTokensForPayload();
              const nextTokens = [
                ...new Set([
                  ...(baseTokens || []),
                  ...(res || []).filter(Boolean),
                ]),
              ];
              formData.append("select_vendor", nextTokens);
            }
          } catch (vendorError) {
            // Silently handle vendor creation errors when offline
            if (!isOnline) {
              console.log(
                "📴 Offline mode - vendor creation skipped, will be created when RFQ syncs",
              );
              // Continue with RFQ creation - vendors will be created when syncing
            } else {
              console.error("Error creating vendors:", vendorError);
              // Only show error if online and it's a real error (not network)
              if (
                vendorError.code !== "ERR_NETWORK" &&
                vendorError.code !== "ERR_CONNECTION_REFUSED"
              ) {
                setBtnErrorState({
                  error: true,
                  errorMsg: "Failed to create vendors. Please try again.",
                });
                setLoadingState(false);
                return;
              }
            }
          }
        }
        if (editRFQForm) {
          await submitUpdateRFQ(rfqToken, formData, buyer_token);
        } else {
          setLoadingState(true);
          await submitNewRFQ(formData);
        }
      } else if (biddingDetails && !shippingDetails) {
        tab2Click();
      } else if (!biddingDetails && shippingDetails) {
        tab1Click();
      } else {
        setBtnErrorState({
          error: true,
          errorMsg: "Please fill out all fields.",
        });
      }
    } catch (error) {
      // Catch any unexpected errors
      console.error("Error in handleSubmit:", error);
      // When offline, don't show error messages - just clear loading
      if (!isOnline) {
        console.log("📴 Offline mode - error caught, clearing loading state");
        setLoadingState(false);
        setBtnErrorState({
          error: false,
          errorMsg: "",
        });
      } else {
        // Only show error if online
        setBtnErrorState({
          error: true,
          errorMsg: error?.message || "An error occurred. Please try again.",
        });
        setLoadingState(false);
      }
    }

    // else if (hasDuplicates(item_codes)){
    //   setBtnErrorState({
    //     error: true,
    //     errorMsg: "",
    //   });
    // }
  };

  const handleSubmit1 = async (e) => {
    e.stopPropagation();

    const isEmailValid = validateEmail(VendorRegisteredEmail.value);
    const isCompanyValid = emptyCheck(CompanyName.value);

    setCompanyName((prev) => ({ ...prev, isValid: isCompanyValid }));
    setVendorRegisteredEmail((prev) => ({ ...prev, isValid: isEmailValid }));

    if (isEmailValid && isCompanyValid) {
      setLoading(true);
      try {
        await axios.post(
          API_ENDPOINT.add_vendor,
          {
            company_name: CompanyName.value.trim(),
            person_name: CompanyName.value.trim(),
            company_official_email: [VendorRegisteredEmail.value.trim()],
            buyer_token,
          },
          { headers: { Authorization: `Bearer ${auth_token}` } },
        );
        setVendor((prev) => ({
          ...prev,
          isValid: true,
          value: [...prev.value, `${CompanyName.value} (${VendorRegisteredEmail.value})`],
        }));
        handleClose1();
        setSupplierAddedPopupOpen(true);
      } catch (error) {
        const response = error?.response?.data?.response;
        setVendorRegisteredEmail((prev) => ({
          ...prev,
          message: response?.company_official_email?.[0] || (typeof response === "string" ? response : null) || "Unable to add supplier. Please try again.",
          isValid: false,
        }));
      } finally {
        setLoading(false);
      }
    }
  };

  const sendNewRFQToken = async (token) => {
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.rfq_newversion_chatgpt}`,
      data: {
        rfq_token: token,
        org_token: organization_token || org_token || buyer_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const registerAlternativeSuppliers = async (onlyNew = false) => {
    const suppliers = alternativeSupplierOptions.filter((option) =>
      !onlyNew || !initialAlternativeEmailsRef.current.includes(option.email.toLowerCase()),
    );
    if (!suppliers.length) return true;
    try {
      await axios.post(
        API_ENDPOINT.add_vendor,
        {
          company_name: suppliers.map((option) => option.vendor_name || alternativeSuppliers.find((supplier) => supplier.email.toLowerCase() === option.email.toLowerCase())?.vendor_name || option.email),
          person_name: suppliers.map((option) => option.vendor_name || alternativeSuppliers.find((supplier) => supplier.email.toLowerCase() === option.email.toLowerCase())?.vendor_name || option.email),
          company_official_email: suppliers.map((option) => option.email),
          buyer_token: org_token,
        },
        { headers: { Authorization: `Bearer ${auth_token}` } },
      );
      initialAlternativeEmailsRef.current = [...new Set([...initialAlternativeEmailsRef.current, ...suppliers.map((option) => option.email.toLowerCase())])];
      return true;
    } catch (error) {
      const message = error?.response?.data?.message || "Could not add alternative suppliers to Supplier Master. Please try again.";
      setAlternativeSupplierError(message);
      setBtnErrorState({ error: true, errorMsg: message });
      setLoadingState(false);
      return false;
    }
  };

  const submitNewRFQ = async (formData) => {
    const isOnline = shouldMakeAPICall(auth_token, buyer_token);

    if (!isOnline) {
      // OFFLINE MODE: Queue the action (following PR module pattern)
      console.log("📴 Offline mode - queuing RFQ creation...");

      try {
        // Use new_RFQ endpoint (which maps to add_rfq_multiple_item)
        await offlineQueue.enqueue("create", API_ENDPOINT.new_RFQ, formData);
        console.log("✅ RFQ queued successfully");

        // Optimistic update: Update local cache
        try {
          // Create complete optimistic RFQ object with all form data
          const tempToken = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
          const now = new Date().toISOString();
          const purchaseRequestNumber =
            formData.get("purchase_request_number") || "";

          // Generate RFQ code format: RFQ_XXXX/OrgName/Year/Month/PRNumber
          const currentYear = new Date().getFullYear();
          const nextYear = currentYear + 1;
          const financialYear = `${currentYear}-${nextYear}`;
          const currentMonth = new Date()
            .toLocaleString("en-US", { month: "short" })
            .toUpperCase();
          // Get org name from user data or use default
          const orgName =
            data?.user?.org_name || data?.user?.company_name || "Organization";
          const rfqCode = purchaseRequestNumber
            ? `RFQ_${Date.now()}/${orgName}/${financialYear}/${currentMonth}/PR${purchaseRequestNumber}`
            : `RFQ_${Date.now()}/${orgName}/${financialYear}/${currentMonth}`;

          // Get item name(s) from form data
          let itemName = "Multiple Items";
          let itemCode = "Multiple Items";
          let quantity = "Multiple Items";
          let unit = "Multiple Items";

          if (
            uploadItemDocument.inputs &&
            itemsInput &&
            itemsInput.length > 0
          ) {
            // Type details mode - get first item name
            const firstItem = itemsInput[0];
            if (firstItem.itemName) {
              itemName =
                itemsInput.length === 1 ? firstItem.itemName : "Multiple Items";
              itemCode =
                itemsInput.length === 1
                  ? firstItem.itemCode || "Multiple Items"
                  : "Multiple Items";
              quantity =
                itemsInput.length === 1
                  ? firstItem.itemQuantity
                  : "Multiple Items";
              unit =
                itemsInput.length === 1 ? firstItem.itemUnit : "Multiple Items";
            }
          } else {
            // Attach document mode - will be processed when synced
            itemName = "Multiple Items (from document)";
          }

          const optimisticRFQ = {
            sl_no: 0, // Will be updated after sync
            token: tempToken,
            rfq_token: tempToken,
            rfq_code: rfqCode,
            item_name: itemName,
            item_code: itemCode,
            hsn_code: "",
            unspsc_code: null,
            quantity: quantity,
            part_number: "nan",
            proposal_description: null,
            proposal_document: formData.get("proposal_document")
              ? "Pending upload"
              : "",
            file_type: null,
            unit: unit,
            purchase_request_number: purchaseRequestNumber,
            bidding_type: formData.get("bidding_type") === "true",
            sealed_bid: formData.get("sealed_bid") === "true",
            bid_status: "open",
            bid_from_date: formData.get("bid_from_date") || now,
            bid_to_date: formData.get("bid_to_date") || now,
            bid_time: formData.get("bid_time") || now,
            shipping_address1: formData.get("shipping_address1") || "",
            shipping_address2: formData.get("shipping_address2") || "",
            city: formData.get("city") || "",
            country: formData.get("country") || "",
            pincode: formData.get("pincode") || "",
            state: formData.get("state") || "",
            mobile_number: formData.get("mobile_number") || "",
            select_vendor: formData.get("select_vendor") || "",
            org_approval: "False",
            buyer_details: {
              id: data?.user?.id || 0,
              name: data?.user?.name || data?.user?.first_name || "Buyer",
              role: data?.user?.role || "Buyer",
            },
            items:
              uploadItemDocument.inputs && itemsInput && itemsInput.length > 0
                ? itemsInput.map((e) => ({
                    item_token: e.itemToken || "",
                    item_name: e.itemName || "",
                    item_code: e.itemCode || "",
                    category: e.itemCategory || "",
                    hsn_code: e.itemHsnCode || "",
                    unspsc_code: null,
                    quantity: e.itemQuantity || "",
                    unit: e.itemUnit || "",
                    normalized_value:
                      e.itemQuantity && e.itemUnit
                        ? `${e.itemQuantity} ${e.itemUnit}`
                        : "",
                    part_number: e.itemPartNumber || "",
                    item_mapped_token: e.itemMappedToken || "",
                    description: e.itemDescription || "",
                  }))
                : [],
            // Offline sync markers
            _pendingSync: true,
            _lastUpdated: Date.now(),
            _queueId: null, // Will be set after enqueue if needed
          };

          // Get existing RFQs and add new one at the TOP (beginning of array)
          console.log("📦 Saving optimistic RFQ to cache...");
          const existingRFQs = await rfqRepository.getRFQsFromIndexedDB(
            buyer_token,
            null,
            "",
            "",
            "",
            "",
            "",
          );
          console.log(
            `📦 Found ${existingRFQs.length} existing RFQs in IndexedDB`,
          );
          // Add optimistic RFQ at the beginning (top of list)
          const updatedRFQs = [optimisticRFQ, ...existingRFQs];
          await rfqRepository.saveToCache(updatedRFQs, buyer_token);
          console.log(
            "✅ Optimistic RFQ saved to cache, total RFQs:",
            updatedRFQs.length,
          );

          // Update Redux state directly with optimistic data (like PR module)
          dispatch(setBuyerRFQData(updatedRFQs));
          console.log("✅ State updated with optimistic RFQ");
        } catch (cacheError) {
          console.error("Error updating cache optimistically:", cacheError);
          // Continue anyway - queue is still saved
        }
      } catch (queueError) {
        console.error("Error queuing action:", queueError);
        // Still show popup even if queue fails (optimistic)
      }

      // Show success message (optimistic) - ALWAYS show, even if queue/cache fails
      // Match online path exactly for consistency
      handleOpen();
      setPopupHeroText("RFQ Created!");
      setPopupMessage(
        "Your RFQ has been created successfully. When the system is online, it will sync with your database.",
      );
      setLoadingState(false);

      // Clear error state
      setBtnErrorState({
        error: false,
        errorMsg: "",
      });

      // Close form and reset all states (same as online mode)
      setNewRFQForm(false);
      setOpenForm({
        open: false,
        loading: false,
        errorMessage: "",
      });

      console.log("✅ Offline popup shown - form closed");

      return; // Exit early - action is queued
    }

    if (!(await registerAlternativeSuppliers())) return;

    // ONLINE MODE: Make API call
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.new_RFQ} `,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token} `,
      },
    })
      .then(async (res) => {
        handleOpen();
        setPopupHeroText("RFQ Created!");
        setPopupMessage(res?.data?.response);
        setLoadingState(false);

        // Sync updated data from API to cache
        if (shouldMakeAPICall(auth_token, buyer_token)) {
          console.log("🔄 Syncing RFQ list after creation...");
          try {
            // Sync ALL RFQs (null = get all) to ensure new RFQ appears at top
            await rfqRepository.syncFromAPI(
              auth_token,
              buyer_token,
              null, // null = get all RFQs (API returns all in one call)
              "", // No search filter
              "", // No date filters
              "", // No date filters
              "", // No sorting
              "", // No sorting
            );
            console.log("✅ RFQ cache synced after creation");
          } catch (syncError) {
            console.warn("⚠️ Failed to sync cache after creation:", syncError);
            // Continue anyway - GetAllData will refresh from API
          }
        }

        // Refresh the UI with latest data
        GetAllData();
        setBtnErrorState({
          error: false,
          errorMsg: "",
        });
        //chatgpt call
        if (res?.data?.item_status) {
          sendNewRFQToken(res?.data?.rfq_token);
        }
      })
      .catch(async (err) => {
        // Check if we're actually offline (network error)
        const isActuallyOffline =
          err?.code === "ERR_NETWORK" || err?.code === "ERR_CONNECTION_REFUSED";

        if (isActuallyOffline) {
          // If we got a network error, we're actually offline - fall back to offline behavior
          console.log(
            "📴 Network error detected in online path - falling back to offline mode",
          );

          try {
            // Queue the action for later sync
            await offlineQueue.enqueue(
              "create",
              API_ENDPOINT.new_RFQ,
              formData,
            );
            console.log("✅ RFQ queued for offline sync");

            // Create optimistic RFQ and save to cache
            try {
              const tempToken = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
              const now = new Date().toISOString();
              const purchaseRequestNumber =
                formData.get("purchase_request_number") || "";

              const currentYear = new Date().getFullYear();
              const nextYear = currentYear + 1;
              const financialYear = `${currentYear}-${nextYear}`;
              const currentMonth = new Date()
                .toLocaleString("en-US", { month: "short" })
                .toUpperCase();
              const orgName =
                data?.user?.org_name ||
                data?.user?.company_name ||
                "Organization";
              const rfqCode = purchaseRequestNumber
                ? `RFQ_${Date.now()}/${orgName}/${financialYear}/${currentMonth}/PR${purchaseRequestNumber}`
                : `RFQ_${Date.now()}/${orgName}/${financialYear}/${currentMonth}`;

              let itemName = "Multiple Items";
              let itemCode = "Multiple Items";
              let quantity = "Multiple Items";
              let unit = "Multiple Items";

              if (
                uploadItemDocument.inputs &&
                itemsInput &&
                itemsInput.length > 0
              ) {
                const firstItem = itemsInput[0];
                if (firstItem.itemName) {
                  itemName =
                    itemsInput.length === 1
                      ? firstItem.itemName
                      : "Multiple Items";
                  itemCode =
                    itemsInput.length === 1
                      ? firstItem.itemCode || "Multiple Items"
                      : "Multiple Items";
                  quantity =
                    itemsInput.length === 1
                      ? firstItem.itemQuantity
                      : "Multiple Items";
                  unit =
                    itemsInput.length === 1
                      ? firstItem.itemUnit
                      : "Multiple Items";
                }
              } else {
                itemName = "Multiple Items (from document)";
              }

              const optimisticRFQ = {
                sl_no: 0,
                token: tempToken,
                rfq_token: tempToken,
                rfq_code: rfqCode,
                item_name: itemName,
                item_code: itemCode,
                hsn_code: "",
                unspsc_code: null,
                quantity: quantity,
                part_number: "nan",
                proposal_description: null,
                proposal_document: formData.get("proposal_document")
                  ? "Pending upload"
                  : "",
                file_type: null,
                unit: unit,
                purchase_request_number: purchaseRequestNumber,
                bidding_type: formData.get("bidding_type") === "true",
                bid_status: "open",
                bid_from_date: formData.get("bid_from_date") || now,
                bid_to_date: formData.get("bid_to_date") || now,
                bid_time: formData.get("bid_time") || now,
                shipping_address1: formData.get("shipping_address1") || "",
                shipping_address2: formData.get("shipping_address2") || "",
                city: formData.get("city") || "",
                country: formData.get("country") || "",
                pincode: formData.get("pincode") || "",
                state: formData.get("state") || "",
                mobile_number: formData.get("mobile_number") || "",
                select_vendor: formData.get("select_vendor") || "",
                org_approval: "False",
                buyer_details: {
                  id: data?.user?.id || 0,
                  name: data?.user?.name || data?.user?.first_name || "Buyer",
                  role: data?.user?.role || "Buyer",
                },
                items:
                  uploadItemDocument.inputs &&
                  itemsInput &&
                  itemsInput.length > 0
                    ? itemsInput.map((e) => ({
                        item_token: e.itemToken || "",
                        item_name: e.itemName || "",
                        item_code: e.itemCode || "",
                        category: e.itemCategory || "",
                        hsn_code: e.itemHsnCode || "",
                        unspsc_code: null,
                        quantity: e.itemQuantity || "",
                        unit: e.itemUnit || "",
                        normalized_value:
                          e.itemQuantity && e.itemUnit
                            ? `${e.itemQuantity} ${e.itemUnit}`
                            : "",
                        part_number: e.itemPartNumber || "",
                        item_mapped_token: e.itemMappedToken || "",
                        description: e.itemDescription || "",
                      }))
                    : [],
                _pendingSync: true,
                _lastUpdated: Date.now(),
                _queueId: null,
              };

              const existingRFQs = await rfqRepository.getRFQsFromIndexedDB(
                buyer_token,
                null,
                "",
                "",
                "",
                "",
                "",
              );
              const updatedRFQs = [optimisticRFQ, ...existingRFQs];
              await rfqRepository.saveToCache(updatedRFQs, buyer_token);
              dispatch(setBuyerRFQData(updatedRFQs));
              console.log("✅ Optimistic RFQ saved to cache");
            } catch (cacheError) {
              console.error("Error updating cache optimistically:", cacheError);
            }
          } catch (queueError) {
            console.error("Error queuing action:", queueError);
          }

          // Show success popup (same as offline mode)
          handleOpen();
          setPopupHeroText("RFQ Created!");
          setPopupMessage(
            "Your RFQ has been created successfully. When the system is online, it will sync with your database.",
          );
          setLoadingState(false);
          setBtnErrorState({
            error: false,
            errorMsg: "",
          });
          setNewRFQForm(false);
          setOpenForm({
            open: false,
            loading: false,
            errorMessage: "",
          });
        } else {
          // Real API error (not network) - show error
          handleClose();
          setBtnErrorState({
            error: true,
            errorMsg:
              (err?.response?.data && typeof err?.response?.data === "object"
                ? Object.values(err?.response?.data)[0]
                : null) ||
              err?.message ||
              "Please fill out all fields",
          });
          setLoadingState(false);
        }
      });
  };

  const submitUpdateRFQ = async (rfq_token, formData, token) => {
    formData.append("buyer_token", token);
    const alternativeEmails = formData.getAll("alternative_supplier");
    formData.delete("alternative_supplier");
    formData.append("alternative_supplier", JSON.stringify(alternativeEmails));
    const isOnline = shouldMakeAPICall(auth_token, buyer_token);

    if (!isOnline) {
      // OFFLINE MODE: Queue the action
      try {
        await offlineQueue.enqueue(
          "update",
          `${API_ENDPOINT.edit_RFQ}${rfq_token}`,
          formData,
        );

        // Optimistic update: Update in cache
        const existingRFQs = await rfqRepository.getRFQsFromIndexedDB(
          buyer_token,
          null,
          "",
          "",
          "",
          "",
          "",
        );
        const updatedRFQs = existingRFQs.map((rfq) => {
          if (rfq.token === rfq_token || rfq.rfq_token === rfq_token) {
            return {
              ...rfq,
              sealed_bid: formData.get("sealed_bid") === "true",
              _pendingSync: true,
              _lastUpdated: Date.now(),
            };
          }
          return rfq;
        });
        await rfqRepository.saveToCache(updatedRFQs, buyer_token);

        handleOpen();
        setPopupHeroText("RFQ Updated (Offline)!");
        setPopupMessage("RFQ will be synced when you're back online.");
        setLoadingState(false);
        GetAllData();
        setBtnErrorState({
          error: false,
          errorMsg: "",
        });
      } catch (err) {
        handleClose();
        setBtnErrorState({
          error: true,
          errorMsg: "Failed to queue RFQ update. Please try again.",
        });
        setLoadingState(false);
      }
      return;
    }

    if (!(await registerAlternativeSuppliers(true))) return;

    // ONLINE MODE: Make API call
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.edit_RFQ}${rfq_token}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then(async (res) => {
        handleOpen();
        setPopupHeroText("RFQ Updated!");
        setPopupMessage(res?.data?.response);
        setLoadingState(false);

        // Sync updated data from API to cache
        if (shouldMakeAPICall(auth_token, buyer_token)) {
          console.log("🔄 Syncing RFQ list after update...");
          try {
            // Sync all RFQs to get updated data (API returns all in one call)
            await rfqRepository.syncFromAPI(
              auth_token,
              buyer_token,
              null, // null = get all RFQs (API returns all in one call)
              "", // No search filter
              "", // No date filters
              "", // No date filters
              "", // No sorting
              "", // No sorting
            );

            // Clear optimistic update flags for this RFQ
            const existingRFQs = await rfqRepository.getRFQsFromIndexedDB(
              buyer_token,
              null,
              "",
              "",
              "",
              "",
              "",
            );
            const updatedRFQs = existingRFQs.map((rfq) => {
              if (
                (rfq.token === rfq_token || rfq.rfq_token === rfq_token) &&
                rfq._pendingSync
              ) {
                return {
                  ...rfq,
                  _pendingSync: false,
                  _lastUpdated: null,
                };
              }
              return rfq;
            });
            await rfqRepository.saveToCache(updatedRFQs, buyer_token);

            console.log("✅ RFQ cache synced after update");
          } catch (syncError) {
            console.warn("⚠️ Failed to sync cache after update:", syncError);
            // Continue anyway - GetAllData will refresh from API
          }
        }

        // Refresh the UI with latest data
        GetAllData();
        setBtnErrorState({
          error: false,
          errorMsg: "",
        });
      })
      .catch((err) => {
        handleClose();
        setBtnErrorState({
          error: true,
          errorMsg:
            (err?.response?.data && typeof err?.response?.data === "object"
              ? Object.values(err?.response?.data)[0]
              : null) ||
            err?.message ||
            "Please fill out all fields",
        });
        setLoadingState(false);
      });
  };

  const submitNewVendors = async () => {
    const isOnline = shouldMakeAPICall(auth_token, buyer_token);

    // If offline, skip vendor creation - new vendors will be created when RFQ syncs
    if (!isOnline) {
      console.log(
        "📴 Offline mode - skipping vendor creation. Vendors will be created when RFQ syncs.",
      );
      return []; // Return empty array so RFQ creation can proceed
    }

    let vendor_details = [];
    vendorId.forEach((itm, i) => {
      if (itm === undefined) {
        let detailStr = vendor.value[i]?.split("(");

        if (detailStr.length > 1) {
          // Check if splitting resulted in two parts
          vendor_details.push(
            `${detailStr[0]?.trim()}|${detailStr[1].replace(")", "")}`,
          );
        } else {
          console.error("Invalid vendor string format:", vendor.value[i]);
        }
      }
    });

    console.log({ vendor_details });

    return axios({
      method: "POST",
      url: API_ENDPOINT.rfq_add_new_vendor,
      data: {
        vendor_details,
        buyer_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((response) => {
        // setVendorID((prev) => ({
        //   ...prev,
        //   value: [
        //     ...prev?.value?.filter(Boolean),
        //     ...response?.data?.response?.map((item) => item.token),
        //   ],
        // }));
        return response?.data?.response?.map((item) => item.token);
      })
      .catch((e) => {
        // Handle errors gracefully - don't show network errors when offline
        if (e.code === "ERR_NETWORK" || e.code === "ERR_CONNECTION_REFUSED") {
          console.log(
            "📴 Network error creating vendors - will be created when RFQ syncs",
          );
          return []; // Return empty array so RFQ creation can proceed
        }
        console.error("Error creating vendors:", e);
        return []; // Return empty array on other errors too
      });
  };
  const resetForm = () => {
    setAlternativeSupplierOptions([]);
    setAlternativeSupplierError("");
    initialAlternativeEmailsRef.current = [];
    setSelectedDepartment(null);
    setBudgetConfigs([]);
    setDepartmentError("");
    setItemCSV({
      value: "",
      hasFile: false,
      isValid: true,
    });
    setUploadItemDocument({
      uploadFile: true,
      inputs: false,
    });
    setDeletedItemsToken([]);
    setItemsInput([
      {
        itemToken: "",
        itemTokenisValid: false,

        itemMappedToken: "",

        itemCode: "",
        itemCodeisValid: false,

        itemName: "",
        itemNameisValid: false,

        expenseType: "",

        itemQuantity: "",
        itemQuantityisValid: false,

        itemUnit: "",
        itemUnitisValid: false,

        itemDescription: "",
        itemDescriptionisValid: false,

        itemPartNumber: "",

        itemDuplicate: false,
      },
    ]);
    setRequestNumber({ value: "", isChanged: false, isValid: true });
    setRFQCategory({
      value: "",
      id: "",
      categoryList: [],
      isValid: true,
    });
    setBidType({ value: true, isValid: true });
    setSealedBid(false);
    setFromDate({ value: "", isValid: true });
    setToDate({ value: "", isValid: true });
    setTime({ value: "", isValid: true, isChanged: false });
    setVendor({ value: [], isValid: true });
    setAddress1({ value: "", isValid: true });
    setAddress2({ value: "", isValid: true });
    setCountry((prev) => ({ ...prev, value: "", isValid: true }));
    setStateName({ value: "", isValid: true });
    setCity({ value: "", isValid: true });
    setUploadDocument({ uploadFile: true, uploadDescripton: false });
    setMobileNumber({ value: "", format: "", isValid: true });
    setProposalDescription({ value: "", isValid: true });
    setProposalDocument({ value: "", isValid: true });
    setPincode({ value: "", isValid: true });
    setBidStatus((prev) => ({ ...prev, isChanged: false, isValid: true }));
  };

  //units select options
  const unitsOptions = [
    "Assemblies",
    "Dozen",
    "Each",
    "Feet",
    "Gallons",
    "Kilo",
    "Liters",
    "Metric Tons",
    "Meters",
    "Pieces",
    "Pounds",
    "Sets",
    "Tons",
    "Yards  ",
  ];

  /*
   * View / Edit field-by-field audit (offline → IndexedDB):
   * VIEW: org_details (rfq_code, bidding_type, proposal_document, purchase_request_number) ← uniqueData;
   *       proposal_description, shippingDetails, bidding_details ← uniqueData (shipping built from parts; bid_time "-" if empty);
   *       Items table ← itemsListDataViewRFQ; Bids table ← bidsData/bulkBidsData; Messages ← rfqVendorList.
   * EDIT: itemsInput, requestNumber, bidType, bidStatus, fromDate, toDate, time, vendor, address1/2, country, state, city,
   *       mobileNumber, pincode, proposalDescription, proposalDocument ← responseData (transformListDataToEditFormat);
   *       shippingAddress ← rfq_addresses or getshippingAddress. All set in getIndividualData (cache or API path).
   */
  //view RFQ data
  const org_details = [
    {
      label: "RFQ ID",
      value: uniqueData?.rfq_code,
      size: "20rem",
    },
    {
      label: "Bid Type",
      value: !uniqueData?.bidding_type ? "Closed" : "Auction",
      size: "10rem",
    },
    {
      label: "Proposal Document",
      value: uniqueData?.proposal_document ? "Yes" : "No",
      size: "14rem",
    },
    {
      label: "Purchase Request Number",
      value:
        uniqueData?.purchase_request_number ??
        uniqueData?.purchase_request_no ??
        uniqueData?.pr_number ??
        uniqueData?.pr_no ??
        uniqueData?.request_number ??
        "-",
      size: "20rem",
    },
    {
      label: "Quotation Category",
      value:
        resolveRFQCategory(uniqueData, RFQCategory.categoryList)?.value ||
        uniqueData?.rfq_category?.name ||
        uniqueData?.category_compare ||
        uniqueData?.pr_category ||
        "-",
      size: "20rem",
    },
  ];

  const proposal_description = [
    {
      label: `Document`,
      value: uniqueData?.proposal_document ? (
        <DownloadFileButton
          file={uniqueData?.proposal_document}
          fileName={fileName}
        />
      ) : (
        "-"
      ),
    },
  ];

  // Build shipping string from non-empty parts; "-" when all missing (e.g. offline list-only data)
  const shippingParts = [
    uniqueData?.shipping_address1,
    uniqueData?.shipping_address2,
    uniqueData?.city,
    uniqueData?.state,
    uniqueData?.pincode,
    uniqueData?.country,
  ].filter((p) => p != null && String(p).trim() !== "");
  const shippingDetails = [
    {
      label: "Shipping Details",
      value: shippingParts.length > 0 ? shippingParts.join(", ") : "-",
    },
  ];

  dayjs.extend(utc);
  dayjs.extend(localizedFormat);

  const localTime =
    uniqueData?.bid_time && String(uniqueData.bid_time).trim()
      ? dayjs.utc(uniqueData.bid_time).local().format("h:mm A")
      : "-";

  // Helper function to format dates consistently
  const formatBidDate = (dateValue) => {
    if (!dateValue) return "-";

    // Check if already in "DD MMMM YYYY" format (from API)
    if (
      typeof dateValue === "string" &&
      /^\d{1,2}\s+\w+\s+\d{4}$/.test(dateValue.trim())
    ) {
      return dateValue;
    }

    // Try parsing with dayjs (handles various formats)
    try {
      // Try parsing as "DD MMMM YYYY" first (API format)
      let parsed = dayjs(dateValue, "DD MMMM YYYY");
      if (parsed.isValid()) {
        return parsed.format("DD MMMM YYYY");
      }

      // Try parsing as ISO date or other formats
      parsed = dayjs(dateValue);
      if (parsed.isValid()) {
        return parsed.format("DD MMMM YYYY");
      }
    } catch (e) {
      console.warn("Error formatting date:", e, dateValue);
    }

    // If all parsing fails, return original value
    return dateValue;
  };

  const bidding_details = [
    {
      label: "Bid Start Date",
      value: formatBidDate(uniqueData?.bid_from_date),
    },
    {
      label: "Bid End Date",
      value: formatBidDate(uniqueData?.bid_to_date),
    },
    {
      label: "Bid End Time",
      value: localTime,
    },
  ];

  //delete data
  const handleOpenDlt = () => setOpenDlt(true);
  const handleCloseDlt = () => {
    setOpenDlt(false);
  };

  const handleOpenDltConfirmation = (deletion_id) => {
    let rowData = getUniqueData(RFQData, "token", deletion_id);

    let rfqCode = rowData?.rfq_code?.split("/")[0];

    setPopupHeroText(`Are you sure want to delete "${rfqCode}"?`);

    setRFQToken(deletion_id);
    setOpenDltConfirmation(true);
    setPopupMessage("Heads up! this action can't be undone.");
  };
  const handleCloseDltConfirmation = () => {
    setOpenDltConfirmation(false);
  };
  const handleDeleteRFQ = () => {
    deleteRFQ();
    handleOpenDlt();
    handleCloseDltConfirmation();
  };

  // delete function
  const deleteRFQ = async () => {
    setLoadingState(true);
    const isOnline = shouldMakeAPICall(auth_token, buyer_token);

    if (!isOnline) {
      // OFFLINE MODE: Queue the action
      try {
        const formData = new FormData();
        await offlineQueue.enqueue(
          "delete",
          `${API_ENDPOINT.delete_RFQ}${rfqToken}`,
          formData,
        );

        // Optimistic update: Remove from IndexedDB-backed list
        const existingRFQs = await rfqRepository.getRFQsFromIndexedDB(
          buyer_token,
          null,
          "",
          "",
          "",
          "",
          "",
        );
        const filteredRFQs = existingRFQs.filter(
          (rfq) => rfq.token !== rfqToken && rfq.rfq_token !== rfqToken,
        );
        await rfqRepository.saveToCache(filteredRFQs, buyer_token);

        setLoadingState(false);
        GetAllData();
        setPopupHeroText("RFQ Deleted (Offline)!");
        setPopupMessage("RFQ will be deleted when you're back online.");
        handleOpenDlt();
        handleCloseDltConfirmation();
      } catch (err) {
        setLoadingState(false);
        console.error("Failed to queue delete:", err);
      }
      return;
    }

    // ONLINE MODE: Make API call
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.delete_RFQ}${rfqToken}`,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then(async (res) => {
        setLoadingState(false);

        // Sync updated data from API to cache
        if (shouldMakeAPICall(auth_token, buyer_token)) {
          console.log("🔄 Syncing RFQ list after deletion...");
          try {
            const pageToSync = rfqListOffline ? pageNumber : serverPage;
            await rfqRepository.syncFromAPI(
              auth_token,
              buyer_token,
              pageToSync,
              searchQuery,
              startDateSearchQuery.value,
              endDateSearchQuery.value,
              sortingColumnName,
              sortingOrder,
            );
            console.log("✅ RFQ cache synced after deletion");
          } catch (syncError) {
            console.warn("⚠️ Failed to sync cache after deletion:", syncError);
          }
        }

        if (rfqListOffline) GetAllData();
        else GetAllData(serverPage);
        setPopupHeroText("RFQ Deleted!");
        setPopupMessage(res?.data?.response);
        handleOpenDlt();
        handleCloseDltConfirmation();
      })
      .catch((err) => {
        setLoadingState(false);
      });
  };
  async function createPurchaseOrder(bid_token) {
    const normalizeText = (value) => String(value ?? "").trim();
    const extractBidToken = (value) => {
      if (typeof value === "string") return normalizeText(value);
      return normalizeText(
        value?.select_bid_token ??
          value?.bid_token ??
          value?.bidToken ??
          value?.vendor_bid_token ??
          value?.vendorBidToken ??
          value?.vendor_bid_id ??
          value?.vendorBidId ??
          value?.token,
      );
    };

    const selectedBidTokens = [
      ...(Array.isArray(bid_token) ? bid_token : bid_token ? [bid_token] : []),
      ...(Array.isArray(quantity) ? quantity : []),
    ]
      .map(extractBidToken)
      .filter(Boolean);
    const uniqueSelectedBidTokens = [...new Set(selectedBidTokens)];

    const fetchRfqItems = async () => {
      const res = await axios({
        method: "POST",
        url: `${API_ENDPOINT.get_individual_RFQ}${rfqToken}`,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });
      return Array.isArray(res?.data?.items) ? res.data.items : [];
    };

    const fetchOrgBidView = async () => {
      const formData = new FormData();
      formData.append("rfq_token", rfqToken);
      const res = await axios({
        method: "POST",
        url: `${API_ENDPOINT.get_org_bid_view}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });
      // org_bid_view returns array directly in res.data (existing code uses `res?.data || []`).
      if (Array.isArray(res?.data)) return res.data;
      if (Array.isArray(res?.data?.response)) return res.data.response;
      if (Array.isArray(res?.data?.data)) return res.data.data;
      if (Array.isArray(res?.data?.results)) return res.data.results;
      if (Array.isArray(res?.data?.items)) return res.data.items;
      return [];
    };

    let rfqItemsFromApi = [];
    let orgBidRowsFromApi = [];
    try {
      [rfqItemsFromApi, orgBidRowsFromApi] = await Promise.all([
        fetchRfqItems(),
        fetchOrgBidView(),
      ]);
    } catch (e) {
      console.warn(
        "create_selected_PO: failed to fetch RFQ items / org_bid_view",
        e,
      );
    }

    const extractVendorBidItemToken = (item) =>
      normalizeText(
        item?.vendorBidItemToken ??
          item?.vendor_bid_item_token ??
          item?.vendor_bid_items_token ??
          item?.vendor_bid_item?.token ??
          item?.vendorBidItem?.token ??
          item?.vendorBidItemsToken ??
          item?.vendor_bid_items?.token ??
          item?.token,
      );

    const extractItemCode = (item) =>
      normalizeText(item?.itemCode ?? item?.item_code);
    const extractItemName = (item) =>
      normalizeText(item?.itemName ?? item?.item_name);
    const extractItemMappedToken = (item) =>
      normalizeText(
        item?.itemMappedToken ??
          item?.item_mapped_token ??
          item?.item_rfq_map_token ??
          item?.itemRfqMapToken ??
          item?.item_rfq_map?.token ??
          item?.itemRfqMap?.token ??
          item?.item_token ??
          item?.itemToken,
      );

    const getItemListFromBidRow = (row) => {
      if (Array.isArray(row?.item_list) && row.item_list.length > 0)
        return row.item_list;
      if (Array.isArray(row?.items) && row.items.length > 0) return row.items;
      if (
        Array.isArray(row?.vendor_bid_items) &&
        row.vendor_bid_items.length > 0
      )
        return row.vendor_bid_items;
      if (Array.isArray(row?.vendorBidItems) && row.vendorBidItems.length > 0)
        return row.vendorBidItems;
      if (Array.isArray(row?.quote_items) && row.quote_items.length > 0)
        return row.quote_items;
      if (Array.isArray(row?.quoteItems) && row.quoteItems.length > 0)
        return row.quoteItems;

      // Some org_bid_view responses are already item-level (no nested item list).
      const looksLikeItemLevelRow =
        row &&
        (row?.item_code != null ||
          row?.itemCode != null ||
          row?.item_name != null ||
          row?.itemName != null ||
          row?.item_mapped_token != null ||
          row?.itemMappedToken != null);
      if (looksLikeItemLevelRow) return [row];

      return [];
    };

    const selectedBidRowsFromApi = (() => {
      if (!Array.isArray(orgBidRowsFromApi) || orgBidRowsFromApi.length === 0)
        return [];
      if (uniqueSelectedBidTokens.length === 0) return [];
      const set = new Set(uniqueSelectedBidTokens);

      const byBidToken = orgBidRowsFromApi.filter((row) => {
        const rowToken = extractBidToken(row);
        return rowToken && set.has(rowToken);
      });
      if (byBidToken.length > 0) return byBidToken;

      // Fallback: some flows may pass vendor_token(s) instead of bid token(s)
      return orgBidRowsFromApi.filter((row) => {
        const vendorToken = normalizeText(
          row?.vendor_token ??
            row?.vendorToken ??
            row?.vendor_id ??
            row?.vendorId,
        );
        return vendorToken && set.has(vendorToken);
      });
    })();

    // Build vendorBidItemToken index from org_bid_view quote item list.
    const buildVendorBidItemTokenIndex = () => {
      const byMappedToken = new Map();
      const byCode = new Map();
      const byName = new Map();

      selectedBidRowsFromApi.forEach((bidRow) => {
        getItemListFromBidRow(bidRow).forEach((item) => {
          const vendorBidItemToken = extractVendorBidItemToken(item);
          if (!vendorBidItemToken) return;

          const mappedToken = extractItemMappedToken(item);
          const itemCode = extractItemCode(item);
          const itemName = extractItemName(item);

          if (mappedToken && !byMappedToken.has(mappedToken))
            byMappedToken.set(mappedToken, vendorBidItemToken);
          if (itemCode && !byCode.has(itemCode))
            byCode.set(itemCode, vendorBidItemToken);
          if (itemName && !byName.has(itemName))
            byName.set(itemName, vendorBidItemToken);
        });
      });

      return { byMappedToken, byCode, byName };
    };

    const {
      byMappedToken: vendorBidItemTokenByMappedToken,
      byCode: vendorBidItemTokenByCode,
      byName: vendorBidItemTokenByName,
    } = buildVendorBidItemTokenIndex();

    const rfqItemsForPayload = normalizeRfqItems(
      Array.isArray(rfqItemsFromApi) && rfqItemsFromApi.length > 0
        ? rfqItemsFromApi
        : Array.isArray(itemsListDataViewRFQ)
          ? itemsListDataViewRFQ
          : [],
    );

    const itemsPayloadFromRfqItems = rfqItemsForPayload
      .map((rfqItem) => {
        const itemMappedToken = normalizeText(
          rfqItem?.itemMappedToken ??
            rfqItem?.item_mapped_token ??
            rfqItem?.item_mappedToken,
        );
        const itemCode = normalizeText(rfqItem?.itemCode ?? rfqItem?.item_code);
        const itemName = normalizeText(rfqItem?.itemName ?? rfqItem?.item_name);

        const vendorBidItemToken =
          (itemMappedToken &&
            vendorBidItemTokenByMappedToken.get(itemMappedToken)) ||
          (itemCode && vendorBidItemTokenByCode.get(itemCode)) ||
          (itemName && vendorBidItemTokenByName.get(itemName)) ||
          "";

        return vendorBidItemToken
          ? {
              vendorBidItemToken,
              itemMappedToken,
              itemCode,
              itemName,
            }
          : null;
      })
      .filter(Boolean);

    const itemsPayload = (() => {
      if (itemsPayloadFromRfqItems.length > 0) return itemsPayloadFromRfqItems;

      // Fallback: build directly from vendor quote item list (org_bid_view), and enrich with rfq_individual_items_view mapping when possible.
      const mappedTokenByCode = new Map();
      const mappedTokenByName = new Map();
      rfqItemsForPayload.forEach((rfqItem) => {
        const code = normalizeText(rfqItem?.itemCode ?? rfqItem?.item_code);
        const name = normalizeText(rfqItem?.itemName ?? rfqItem?.item_name);
        const mapped = normalizeText(
          rfqItem?.itemMappedToken ??
            rfqItem?.item_mapped_token ??
            rfqItem?.item_mappedToken,
        );
        if (code && mapped && !mappedTokenByCode.has(code))
          mappedTokenByCode.set(code, mapped);
        if (name && mapped && !mappedTokenByName.has(name))
          mappedTokenByName.set(name, mapped);
      });

      const items = [];
      selectedBidRowsFromApi.forEach((bidRow) => {
        getItemListFromBidRow(bidRow).forEach((item) => {
          const vendorBidItemToken = extractVendorBidItemToken(item);
          if (!vendorBidItemToken) return;

          const itemCode = extractItemCode(item);
          const itemName = extractItemName(item);
          const itemMappedToken =
            extractItemMappedToken(item) ||
            (itemCode && mappedTokenByCode.get(itemCode)) ||
            (itemName && mappedTokenByName.get(itemName)) ||
            "";

          items.push({
            vendorBidItemToken,
            itemMappedToken,
            itemCode,
            itemName,
          });
        });
      });

      const seen = new Set();
      return items.filter((it) => {
        if (!it.vendorBidItemToken) return false;
        if (seen.has(it.vendorBidItemToken)) return false;
        seen.add(it.vendorBidItemToken);
        return true;
      });
    })();

    if (itemsPayload.length === 0) {
      console.warn("create_selected_PO: items payload is empty", {
        rfqToken,
        selectedBidTokens: uniqueSelectedBidTokens,
        rfqItemsCount: rfqItemsForPayload.length,
        selectedBidRowsCount: selectedBidRowsFromApi.length,
        orgBidRowsCount: orgBidRowsFromApi.length,
      });
    }

    await axios({
      url: `${API_ENDPOINT.create_selected_PO}`,
      method: "POST",
      data: {
        rfq_token: rfqToken,
        buyer_token: buyer_token,
        items: itemsPayload,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        // console.log(res); PO-created successfuly
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const selectBid = async (bid_token) => {
    setLoadingState(true);
    await axios({
      url: `${API_ENDPOINT.select_bid}`,
      method: "POST",
      data: {
        bid_token: bid_token,
        bid_status: "selected",
        buyer_token: buyer_token,
        quantity: quantity, // added ?
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);
        setOpenBidConfirmation({
          selectBid: false,
          unSelectBid: false,
        });
        setBidSelection({
          select: true,
          unselect: false,
        });
        GetAllBidsData(pageNumber, rfqToken);
        createPurchaseOrder(bid_token);
      })
      .catch((err) => {
        setLoadingState(false);
        setOpenBidConfirmation({
          selectBid: false,
          unSelectBid: false,
        });
        GetAllBidsData(pageNumber, rfqToken);
      });
  };

  const unSelectBid = async (bid_token) => {
    setLoadingState(true);
    await axios({
      url: `${API_ENDPOINT.select_bid}`,
      method: "POST",
      data: {
        bid_token: bid_token,
        bid_status: "unselected",
        buyer_token: buyer_token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);
        GetAllBidsData(pageNumber, rfqToken);
        localStorage.setItem("hasSelectedBid", false);
        setOpenBidConfirmation({
          selectBid: false,
          unSelectBid: false,
        });
        setBidSelection({
          select: false,
          unselect: true,
        });
      })
      .catch((err) => {
        setLoadingState(false);
        GetAllBidsData(pageNumber, rfqToken);
        setOpenBidConfirmation({
          selectBid: false,
          unSelectBid: false,
        });
      });
  };

  const navigate = useNavigate();

  const availableAlternativeSuppliers = alternativeSuppliers
    .map((supplier) => ({ ...supplier, label: `${supplier.email} (${supplier.vendor_name})` }));

  const toggleAlternativeSupplier = (supplier, checked) => {
    const email = supplier.email.trim().toLowerCase();
    setAlternativeSupplierOptions((current) => checked
      ? current.some((option) => option.email.toLowerCase() === email)
        ? current
        : [...current, { label: supplier.label, email: supplier.email, vendor_name: supplier.vendor_name, token: `alt:${email}` }]
      : current.filter((option) => option.email.toLowerCase() !== email));
    setVendor((current) => ({ ...current, isValid: checked || current.value.length > 0 || alternativeSupplierOptions.length > 1 }));
    setAlternativeSupplierError("");
  };

  useEffect(() => {
    if (!alternativeSupplierOptions.length || !alternativeSuppliers.length) return;
    setAllowedVendorTokensByItemToken((current) => {
      const next = { ...current };
      alternativeSuppliers.forEach((supplier) => {
        const option = alternativeSupplierOptions.find((selected) => selected.email.toLowerCase() === supplier.email.toLowerCase());
        if (!option) return;
        supplier.itemTokens.forEach((itemToken) => {
          next[itemToken] = [...new Set([...(next[itemToken] || []), option.token])];
        });
      });
      return next;
    });
  }, [alternativeSupplierOptions, alternativeSuppliers]);

  const alternativeSupplierPicker = (
    <div className={classes.alternativeSupplierPicker}>
        <div className={classes.alternativeSupplierContent}>
          <div className={classes.alternativeSupplierHeading}>
            <div><strong>Suppliers for selected items</strong><span>Choose one or more contacts to invite to this RFQ.</span></div>
            <div className={classes.alternativeSupplierHeadingActions}>
              <span className={classes.alternativeSupplierCount}>{alternativeSupplierOptions.length} selected</span>
              <button type="button" onClick={() => {
                setAlternativeSupplierOptions([]);
                setVendor((current) => ({ ...current, isValid: current.value.length > 0 }));
                setAlternativeSupplierError("");
              }} disabled={!alternativeSupplierOptions.length}>Clear</button>
            </div>
          </div>
          {alternativeSupplierOptions.length > 0 && <div className={classes.alternativeSupplierChips}>
            {alternativeSupplierOptions.map((option) => <span key={option.token} className={classes.alternativeSupplierChip}>
              {option.label}
              <button type="button" aria-label={`Remove ${option.label}`} onClick={() => {
                const remaining = alternativeSupplierOptions.filter((entry) => entry.token !== option.token);
                setAlternativeSupplierOptions(remaining);
                setVendor((current) => ({ ...current, isValid: current.value.length > 0 || remaining.length > 0 }));
              }}>×</button>
            </span>)}
          </div>}
          {alternativeSupplierLoading ? <p>Loading suppliers...</p> : availableAlternativeSuppliers.length > 0 ? (
            <div className={classes.alternativeSupplierList}>
              <label className={classes.alternativeSupplierSelectAll}>
                <input type="checkbox" checked={availableAlternativeSuppliers.every((supplier) => alternativeSupplierOptions.some((option) => option.email.toLowerCase() === supplier.email.toLowerCase()))} onChange={(event) => availableAlternativeSuppliers.forEach((supplier) => toggleAlternativeSupplier(supplier, event.target.checked))} />
                <span>Select all suppliers</span>
              </label>
              {availableAlternativeSuppliers.map((supplier) => (
                <label className={`${classes.alternativeSupplierOption} ${alternativeSupplierOptions.some((option) => option.email.toLowerCase() === supplier.email.toLowerCase()) ? classes.alternativeSupplierOptionSelected : ""}`} key={`${supplier.email}-${supplier.vendor_name}`}>
                  <input type="checkbox" checked={alternativeSupplierOptions.some((option) => option.email.toLowerCase() === supplier.email.toLowerCase())} onChange={(event) => toggleAlternativeSupplier(supplier, event.target.checked)} />
                  <span>{supplier.label}</span>
                </label>
              ))}
            </div>
          ) : <p>No alternative suppliers with an email were found for the selected items.</p>}
          {alternativeSupplierError && <p role="alert" className={classes.alternativeSupplierError}>{alternativeSupplierError}</p>}
        </div>
    </div>
  );

  const supplierSourceTabs = (
    <div className={classes.supplierSourceTabs} role="tablist" aria-label="Supplier source">
      <button type="button" role="tab" aria-selected={!showAlternativeSuppliers} className={!showAlternativeSuppliers ? classes.supplierSourceActive : ""} onClick={() => setShowAlternativeSuppliers(false)}>Supplier Master</button>
      <button type="button" role="tab" aria-selected={showAlternativeSuppliers} className={showAlternativeSuppliers ? classes.supplierSourceActive : ""} onClick={() => setShowAlternativeSuppliers(true)}>Alternative Suppliers{alternativeSupplierOptions.length ? ` (${alternativeSupplierOptions.length})` : ""}</button>
    </div>
  );

  const showNoMappedVendorsNote =
    !!editRFQForm &&
    !!vendorFilterActiveRef.current &&
    collectSelectedItemTokens().length > 0 &&
    (vendorsList?.values?.visibleOption?.length || 0) === 0;

  const closeSelectBid = () => {
    getEveryBidsData(rfqToken);
    // GetAllBidsData(pageNumber, rfqToken);
    setBidToken("");
    setOpenBidConfirmation({
      selectBid: false,
      unSelectBid: false,
    });

    if (bidSelection.select) {
      navigate("/Buyer_dashboard/PO"); // <-- change to your desired path
    }
    setBidSelection({
      select: false,
      unselect: false,
    });
  };

  const handleCloseComparePopup = () => {
    setOpenComparisonPopup(false);
  };
  const handleOpenComparePopup = () => {
    setOpenComparisonPopup(true);
  };

  const submitRequote = async () => {
    const formData = new FormData();

    formData.append("rfq_token", uniqueData?.token);
    formData.append("vendor_list", selectedRows);
    setLoadingState(true);
    await axios({
      method: "POST",
      url: `${API_ENDPOINT.requote_bid}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        setLoadingState(false);

        handleOpen();
        setPopupHeroText("Resubmission Request Sent!");
        setPopupMessage(
          res?.data && typeof res?.data === "object"
            ? Object.values(res?.data)[0] || "Request sent successfully"
            : "Request sent successfully",
        );
        cancelRequestRequote();
      })
      .catch((err) => {
        setLoadingState(false);
        setBtnErrorState({
          error: true,
          errorMsg: Object.values(err?.response?.data),
        });
        handleClose();
      });
  };

  const normalizeNegotiationItemText = (value) =>
    String(value || "")
      .trim()
      .replace(/\s+/g, " ")
      .toLowerCase();

  const fetchNegotiationItemMaster = async () => {
    if (shouldMakeAPICall(auth_token, org_token)) {
      try {
        const response = await axios({
          method: "POST",
          url: `${API_ENDPOINT.view_all_item}`,
          data: {
            org_token,
          },
          headers: {
            Authorization: `Bearer ${auth_token} `,
          },
        });

        const items = Array.isArray(response?.data?.response)
          ? response.data.response
          : [];
        if (items.length > 0) {
          await masterDataRepository.saveItemsToCache(items);
          return items;
        }
      } catch (error) {
        console.warn("Negotiation bot item master API failed:", error);
      }
    }

    const cachedItems = await masterDataRepository.getItemsFromCache();
    return Array.isArray(cachedItems) ? cachedItems : [];
  };

  const resolveNegotiationMasterItem = (rfqItem, itemMaster = []) => {
    const rfqItemName = normalizeNegotiationItemText(
      rfqItem?.item_name || rfqItem?.itemName,
    );
    const rfqItemCode = normalizeNegotiationItemText(
      rfqItem?.item_code || rfqItem?.itemCode,
    );

    if (!rfqItemName) return null;

    const nameMatches = itemMaster.filter(
      (item) =>
        normalizeNegotiationItemText(item?.item_name || item?.itemName) ===
        rfqItemName,
    );

    if (nameMatches.length === 1) return nameMatches[0];

    if (nameMatches.length > 1 && rfqItemCode) {
      const codeMatch = nameMatches.find(
        (item) =>
          normalizeNegotiationItemText(item?.item_code || item?.itemCode) ===
          rfqItemCode,
      );
      if (codeMatch) return codeMatch;
    }

    return nameMatches[0] || null;
  };

  const getNegotiationBotItems = (itemMaster = []) => {
    const sourceItems = Array.isArray(itemsListDataViewRFQ)
      ? normalizeRfqItems(itemsListDataViewRFQ)
      : Array.isArray(RFQitemsListMapped)
        ? RFQitemsListMapped
        : [];

    return sourceItems
      .map((item, index) => {
        const masterItem = resolveNegotiationMasterItem(item, itemMaster);
        const masterItemToken = String(
          masterItem?.token || masterItem?.item_token || "",
        ).trim();
        return {
          ...item,
          item_rfq_map_token: masterItemToken,
          itemMappedToken: masterItemToken,
          master_item_token: masterItemToken,
          item_name: item?.item_name || item?.itemName || `Item ${index + 1}`,
          item_code: item?.item_code || item?.itemCode || "-",
          description: item?.description || "-",
          quantity: item?.quantity || "-",
          unit: item?.unit || "-",
          tokenResolvedFromItemMaster: Boolean(masterItemToken),
        };
      })
      .filter((item) => item.item_rfq_map_token);
  };

  const fetchComparisonPreviousPurchases = async () => {
    const rfqTokenForPayload = uniqueData?.token || rfqToken;
    if (!rfqTokenForPayload) return;

    setComparisonPreviousPurchases([]);
    try {
      const normalizePreviousPurchases = (value) => {
        if (Array.isArray(value)) {
          return value.flatMap(normalizePreviousPurchases);
        }
        if (!value || typeof value !== "object") return [];
        if (
          value.history_id ||
          value.purchase_order_token ||
          value.purchase_order_number ||
          value.unit_price
        ) {
          return [value];
        }
        return Object.values(value).flatMap(normalizePreviousPurchases);
      };
      const rawItems = Array.isArray(itemsListDataViewRFQ)
        ? itemsListDataViewRFQ
        : itemsListDataViewRFQ
          ? [itemsListDataViewRFQ]
          : [];
      const mappedItems = Array.isArray(RFQitemsListMapped)
        ? RFQitemsListMapped
        : [];
      const items = rawItems.map((item, index) => {
        const mappedItem = mappedItems[index] || {};
        return {
          item_token:
            item?.item_token ||
            item?.item_rfq_map_token ||
            item?.master_item_token ||
            item?.token ||
            item?.itemMappedToken ||
            mappedItem?.item_token ||
            mappedItem?.item_rfq_map_token ||
            mappedItem?.itemMappedToken ||
            "",
          item_name:
            item?.item_name || item?.itemName || mappedItem?.item_name || `Item ${index + 1}`,
          item_code: item?.item_code || item?.itemCode || mappedItem?.item_code || "-",
        };
      }).filter((item) => item.item_token);
      const responses = await Promise.all(
        items.map(async (item) => {
          try {
            const response = await axios.post(
              API_ENDPOINT.negotiation_bot_history,
              {
                rfq_token: rfqTokenForPayload,
                  item_token: item.item_token,
              },
              { headers: { Authorization: `Bearer ${auth_token}` } },
            );
            const data = response?.data?.response || response?.data || {};
            const purchases = normalizePreviousPurchases(
              data?.previous_purchases ||
                data?.previous_purchase ||
                data?.item?.previous_purchase,
            );
            return purchases.map((purchase) => ({
              ...purchase,
              comparison_item_token: item.item_token,
              item_name: purchase?.item_name || item.item_name,
              item_code: purchase?.item_code || item.item_code,
            }));
          } catch (error) {
            console.warn("Previous purchase history could not be loaded for item:", item.item_name, error);
            return [];
          }
        }),
      );
      setComparisonPreviousPurchases(responses.flat());
    } catch (error) {
      console.warn("Previous purchase history could not be loaded:", error);
    }
  };

  const resetNegotiationBot = () => {
    setNegotiationExpandedDescriptions({});
    setNegotiationBotState({
      open: false,
      loading: false,
      submitting: false,
      itemPicker: false,
      selectMode: false,
      data: null,
      botItems: [],
      selectedItem: null,
      selectedHistoryId: "",
      selectedVendorBidItemTokens: [],
      result: null,
      error: "",
    });
  };

  const fetchNegotiationBotHistory = async (selectedItem) => {
    const rfqTokenForPayload = uniqueData?.token || rfqToken;
    const itemRfqMapToken = selectedItem?.item_rfq_map_token;
    setNegotiationExpandedDescriptions({});

    if (!rfqTokenForPayload || !itemRfqMapToken) {
      setNegotiationBotState((prev) => ({
        ...prev,
        open: true,
        loading: false,
        itemPicker: false,
        error: "Missing RFQ token or item RFQ map token for negotiation bot.",
      }));
      return;
    }

    setNegotiationBotState((prev) => ({
      ...prev,
      open: true,
      loading: true,
      itemPicker: false,
      selectMode: false,
      data: null,
      selectedItem,
      selectedHistoryId: "",
      selectedVendorBidItemTokens: [],
      result: null,
      error: "",
    }));

    try {
      const response = await axios.post(
        API_ENDPOINT.negotiation_bot_history,
        {
          rfq_token: rfqTokenForPayload,
          item_token: itemRfqMapToken,
        },
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        },
      );

      const responseData = response?.data?.response || response?.data || {};
      const previousPurchases = getNegotiationPreviousPurchases(responseData);
      const firstHistoryId = previousPurchases[0]?.history_id || "";

      setNegotiationBotState((prev) => ({
        ...prev,
        loading: false,
        data: responseData,
        selectedHistoryId: firstHistoryId,
      }));
    } catch (error) {
      setNegotiationBotState((prev) => ({
        ...prev,
        loading: false,
        error:
          (error?.response?.data && typeof error.response.data === "object"
            ? Object.values(error.response.data)[0]
            : null) ||
          error?.message ||
          "Unable to load negotiation bot history.",
      }));
    }
  };

  const openNegotiationBot = () => {
    setNegotiationExpandedDescriptions({});
    setNegotiationBotState((prev) => ({ ...prev, loading: false, open: false }));
    const rawNegotiationItems = Array.isArray(itemsListDataViewRFQ)
      ? itemsListDataViewRFQ
      : itemsListDataViewRFQ
        ? [itemsListDataViewRFQ]
        : [];
    const mappedNegotiationItems = Array.isArray(RFQitemsListMapped)
      ? RFQitemsListMapped
      : [];
    const negotiationItems = rawNegotiationItems.map((item, index) => {
      const mappedItem = mappedNegotiationItems[index] || {};
      return {
      item_token:
        item?.item_token ||
        item?.item_rfq_map_token ||
        item?.master_item_token ||
        item?.token ||
        item?.itemMappedToken ||
        mappedItem?.item_token ||
        mappedItem?.item_rfq_map_token ||
        mappedItem?.itemMappedToken ||
        "",
      item_name:
        item?.item_name || item?.itemName || mappedItem?.item_name || `Item ${index + 1}`,
      item_code: item?.item_code || item?.itemCode || mappedItem?.item_code || "-",
      quantity: item?.quantity || mappedItem?.quantity || "-",
      unit: item?.unit || item?.unit_measure || item?.uom || mappedItem?.unit || "",
    };
    });

    openNegotiationBotInChat({
      mode: "buyer",
      rfqCode: uniqueData?.rfq_code || uniqueData?.rfq_no || rfqToken,
      rfqToken: uniqueData?.token || rfqToken,
      itemToken: negotiationItems[0]?.item_token || "",
      items: negotiationItems,
      itemName:
        negotiationItems[0]?.item_name ||
        uniqueData?.item_name ||
        uniqueData?.proposal_title,
    });
  };

  const enableNegotiationSelection = () => {
    if (!getNegotiationPreviousPurchases(negotiationBotState?.data).length) {
      setNegotiationBotState((prev) => ({
        ...prev,
        error: "No previous purchase history is available for negotiation.",
      }));
      return;
    }

    if (!negotiationBotState?.data?.current_quotations?.length) {
      setNegotiationBotState((prev) => ({
        ...prev,
        error: "No current vendor quotations are available for negotiation.",
      }));
      return;
    }

    setNegotiationBotState((prev) => ({
      ...prev,
      selectMode: true,
      error: "",
    }));
  };

  const toggleNegotiationVendorToken = (token) => {
    const normalizedToken = String(token || "").trim();
    if (!normalizedToken) return;

    setNegotiationBotState((prev) => {
      const selected = new Set(prev.selectedVendorBidItemTokens || []);
      if (selected.has(normalizedToken)) {
        selected.delete(normalizedToken);
      } else {
        selected.add(normalizedToken);
      }

      return {
        ...prev,
        selectedVendorBidItemTokens: Array.from(selected),
        error: "",
      };
    });
  };

  const getNegotiationQuotationTokens = () =>
    (negotiationBotState.data?.current_quotations || [])
      .map((quote) => String(quote?.vendor_bid_item_token || "").trim())
      .filter(Boolean);

  const toggleAllNegotiationVendorTokens = () => {
    const allTokens = getNegotiationQuotationTokens();
    if (!allTokens.length) return;

    setNegotiationBotState((prev) => {
      const selectedTokens = prev.selectedVendorBidItemTokens || [];
      const allSelected = allTokens.every((token) =>
        selectedTokens.includes(token),
      );

      return {
        ...prev,
        selectedVendorBidItemTokens: allSelected ? [] : allTokens,
        error: "",
      };
    });
  };

  const submitNegotiationRevisionRequest = async () => {
    const rfqTokenForPayload = uniqueData?.token || rfqToken;
    const itemTokenForPayload =
      negotiationBotState.selectedItem?.item_rfq_map_token ||
      negotiationBotState.selectedItem?.item_token ||
      negotiationBotState.data?.item?.item_token ||
      negotiationBotState.data?.item?.token ||
      "";
    const selectedTokens =
      negotiationBotState.selectedVendorBidItemTokens || [];

    if (!itemTokenForPayload) {
      setNegotiationBotState((prev) => ({
        ...prev,
        error: "Unable to find item token for negotiation request.",
      }));
      return;
    }

    if (!negotiationBotState.selectedHistoryId) {
      setNegotiationBotState((prev) => ({
        ...prev,
        error: "Select a previous purchase reference before submitting.",
      }));
      return;
    }

    if (!selectedTokens.length) {
      setNegotiationBotState((prev) => ({
        ...prev,
        error: "Select at least one vendor quotation to request revision.",
      }));
      return;
    }

    setNegotiationBotState((prev) => ({
      ...prev,
      submitting: true,
      error: "",
      result: null,
    }));

    try {
      const response = await axios.post(
        API_ENDPOINT.negotiation_bot_request_revision,
        {
          rfq_token: rfqTokenForPayload,
          item_token: itemTokenForPayload,
          history_id: negotiationBotState.selectedHistoryId,
          vendor_bid_item_tokens: selectedTokens,
        },
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        },
      );

      setNegotiationBotState((prev) => ({
        ...prev,
        submitting: false,
        result: response?.data?.response || response?.data || {},
        selectMode: false,
        selectedVendorBidItemTokens: [],
      }));
    } catch (error) {
      setNegotiationBotState((prev) => ({
        ...prev,
        submitting: false,
        error:
          (error?.response?.data && typeof error.response.data === "object"
            ? Object.values(error.response.data)[0]
            : null) ||
          error?.message ||
          "Unable to send negotiation revision request.",
      }));
    }
  };

  const formatNegotiationPrice = (currency, value) => {
    const amount = String(value ?? "").trim();
    if (!amount) return "-";
    return `${currency || ""} ${amount}`.trim();
  };

  const getNegotiationDisplayPrice = (record = {}) =>
    formatNegotiationPrice(
      record?.currency,
      record?.unit_price_display || record?.unit_price,
    );

  const getNegotiationDeltaClass = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue) || numericValue === 0) {
      return classes.negotiationDeltaNeutral;
    }
    return numericValue < 0
      ? classes.negotiationDeltaBetter
      : classes.negotiationDeltaHigher;
  };

  const getNegotiationQuoteDelta = (quote = {}) => {
    const amount = String(
      quote?.difference_amount_display || quote?.difference_amount || "",
    ).trim();
    const percentage = String(quote?.difference_percentage || "").trim();

    if (!amount && !percentage) return "-";

    const currency = quote?.currency || "";
    const amountLabel = amount
      ? `${currency} ${amount}`.trim()
      : "";
    const percentageLabel = percentage ? `${percentage}%` : "";

    return [amountLabel, percentageLabel].filter(Boolean).join(" / ");
  };

  const toggleNegotiationDescription = (key) => {
    setNegotiationExpandedDescriptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderNegotiationDescription = (
    value,
    key,
    className = classes.negotiationDescriptionText,
  ) => {
    const text = String(value || "-");
    const limit = 120;
    const canExpand = text.length > limit;
    const expanded = Boolean(negotiationExpandedDescriptions[key]);
    const displayText =
      canExpand && !expanded ? `${text.slice(0, limit).trim()}...` : text;

    return (
      <p className={className}>
        {displayText}
        {canExpand && (
          <>
            {" "}
            <button
              type="button"
              className={classes.negotiationReadMore}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                toggleNegotiationDescription(key);
              }}
            >
              {expanded ? "Show less" : "Read more"}
            </button>
          </>
        )}
      </p>
    );
  };

  const formatNegotiationDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getNegotiationPreviousPurchases = (data = {}) => {
    if (Array.isArray(data?.previous_purchases)) {
      return data.previous_purchases;
    }
    if (data?.previous_purchase && typeof data.previous_purchase === "object") {
      return [data.previous_purchase];
    }
    return [];
  };

  const getBestNegotiationQuote = () => {
    const quotes = Array.isArray(negotiationBotState.data?.current_quotations)
      ? negotiationBotState.data.current_quotations
      : [];
    return quotes.reduce((best, quote) => {
      const quotePrice = Number(quote?.unit_price);
      if (!Number.isFinite(quotePrice)) return best;
      if (!best) return quote;
      const bestPrice = Number(best?.unit_price);
      return quotePrice < bestPrice ? quote : best;
    }, null);
  };

  const getNegotiationPreviousPrice = () =>
    getNegotiationDisplayPrice(getSelectedNegotiationHistory() || {});

  const getSelectedNegotiationHistory = () => {
    const histories = getNegotiationPreviousPurchases(negotiationBotState.data);
    return (
      histories.find(
        (history) =>
          String(history?.history_id || "") ===
          String(negotiationBotState.selectedHistoryId || ""),
      ) ||
      histories[0] ||
      null
    );
  };

  const somethingWentWrong = () => {
    setLoadingState(false);
    handleOpenComparePopup();
    setPopupTexts({
      popupHeroText: "Something went wrong!",
      popupDescription: "Please check your files and try again later.",
      warningImg: somthingWrongImg,
    });
  };

  const getItemTokensForHistory = () => {
    if (Array.isArray(itemsListDataViewRFQ)) {
      return itemsListDataViewRFQ
        .map((item) => item?.item_token)
        .filter((token) => token);
    }
    if (itemsListDataViewRFQ?.item_token) {
      return [itemsListDataViewRFQ.item_token];
    }
    if (Array.isArray(itemToken)) {
      return itemToken.filter(Boolean);
    }
    if (itemToken) {
      return [itemToken];
    }
    return [];
  };

  const extractHistoryFields = (historyPayload) => {
    const src = historyPayload?.response ?? historyPayload ?? {};
    const fields = {};
    [
      "price_history_summary",
      "price_variation_analysis",
      "price_trend",
      "recommendation_notes",
      "intelligence_outputs",
    ].forEach((key) => {
      if (src?.[key] !== undefined) {
        fields[key] = src[key];
      }
    });
    return fields;
  };

  const mergeHistoryIntoOutputDataLocal = (historyItems, historyFields) => {
    if (!Array.isArray(historyItems)) return historyItems;
    if (!historyFields || Object.keys(historyFields).length === 0)
      return historyItems;
    return historyItems.map((item) => {
      if (!item || typeof item !== "object") return item;
      const outputData = item.Output_data;
      if (outputData === null || outputData === undefined) return item;

      let parsed = outputData;
      let wasString = false;
      if (typeof outputData === "string") {
        try {
          parsed = JSON.parse(outputData);
          wasString = true;
        } catch (err) {
          return item;
        }
      }

      const merged = Array.isArray(parsed)
        ? parsed.map((p) => ({ ...p, ...historyFields }))
        : { ...parsed, ...historyFields };

      return {
        ...item,
        Output_data: wasString ? JSON.stringify(merged, null, 2) : merged,
      };
    });
  };

  const fetchPriceHistoryForItems = async (tokens) => {
    if (!tokens?.length) return null;
    try {
      const res = await axios({
        method: "POST",
        url: `${API_ENDPOINT.comparison_item_po_price_history}`,
        data: {
          buyer_token: buyer_token,
          org_token: organization_token || org_token || buyer_token,
          item_tokens: tokens,
        },
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });
      return res?.data ?? null;
    } catch (err) {
      console.warn("Price history API failed:", err);
      return null;
    }
  };

  const normalizeDocumentUrlForCompare = (url) => {
    if (!url) return "";
    const raw = String(url);
    const cloudfront = process.env.REACT_APP_CLOUDFRONT_URL;
    if (!cloudfront) return raw;
    return raw.replace("https://teckost.s3.amazonaws.com", cloudfront);
  };

  const getComparableDocumentUrl = (source) => {
    if (!source) return "";
    if (typeof source === "string") return normalizeDocumentUrlForCompare(source);
    if (Array.isArray(source)) {
      return source.map(getComparableDocumentUrl).find(Boolean) || "";
    }

    return normalizeDocumentUrlForCompare(
      source?.url ||
        source?.file_url ||
        source?.document_url ||
        source?.document ||
        source?.path ||
        source?.location ||
        "",
    );
  };

  const getFileNameFromUrl = (url, fallbackName) => {
    try {
      const parts = String(url || "").split("/");
      const last = parts[parts.length - 1];
      const cleaned = (last || "").split("?")[0].trim();
      return cleaned || fallbackName;
    } catch {
      return fallbackName;
    }
  };

  const fetchBlobFromUrl = async (url) => {
    const res = await fetch(url);
    if (!res.ok) {
      throw new Error(`Failed to fetch file (${res.status})`);
    }
    return await res.blob();
  };

  const buildNewVersionChatGPTPayloadFromRFQ = async (bidSource) => {
    const prn =
      uniqueData?.purchase_request_number ??
      uniqueData?.purchase_request_no ??
      uniqueData?.pr_number ??
      uniqueData?.pr_no ??
      uniqueData?.request_number ??
      "";
    const categoryResolved = resolveRFQCategory(
      uniqueData,
      RFQCategory?.categoryList,
    );

    const buyerDocUrl = getComparableDocumentUrl(
      uniqueData?.item_description_doc ||
        uniqueData?.proposal_document ||
        uniqueData?.document ||
        uniqueData?.document_url,
    );
    const buyerDescription =
      uniqueData?.proposal_description ||
      uniqueData?.proposalDescription ||
      uniqueData?.proposal_desc ||
      "";

    const vendorSource =
      Array.isArray(bidSource) && bidSource.length > 0
        ? bidSource
        : Array.isArray(bulkBidsData) && bulkBidsData.length > 0
        ? bulkBidsData
        : Array.isArray(bidsData)
          ? bidsData
          : [];
    const vendorDocs = vendorSource
      .map((b) => ({
        url: getComparableDocumentUrl(
          b?.document ||
            b?.document_url ||
            b?.quotation_document ||
            b?.quotation_document_url ||
            b?.vendor_quotation ||
            b?.files,
        ),
        vendor: b?.vendor || b?.vendor_name || b?.vendor_company || "vendor",
      }))
      .filter((d) => d.url && String(d.url).trim() !== "");

    const uniqueVendorDocUrls = [
      ...new Map(vendorDocs.map((d) => [String(d.url), d])).values(),
    ];

    if (!buyerDocUrl && !String(buyerDescription || "").trim()) {
      throw new Error(
        "Buyer requirement (document/description) is missing for this RFQ.",
      );
    }
    if (uniqueVendorDocUrls.length === 0) {
      throw new Error("No vendor quotation documents found to run comparison.");
    }
    if (!String(categoryResolved?.id || "").trim()) {
      throw new Error("Quotation category is missing for this RFQ.");
    }
    if (!String(prn || "").trim()) {
      throw new Error("Purchase Request Number is missing for this RFQ.");
    }

    const formData = new FormData();
    if (buyerDocUrl) {
      const blob = await fetchBlobFromUrl(buyerDocUrl);
      const buyerFileName = getFileNameFromUrl(
        buyerDocUrl,
        "buyer_requirement.pdf",
      );
      formData.append("file1", blob, buyerFileName);
    } else {
      formData.append("data1", String(buyerDescription || ""));
    }

    // Vendor files start from file2
    for (let i = 0; i < uniqueVendorDocUrls.length; i++) {
      const item = uniqueVendorDocUrls[i];
      const blob = await fetchBlobFromUrl(item.url);
      const vendorSafeName = String(item.vendor || "vendor")
        .replace(/[^\w.-]+/g, "_")
        .slice(0, 60);
      const fileName =
        getFileNameFromUrl(
          item.url,
          `${vendorSafeName || "vendor"}_quote.pdf`,
        ) || `${vendorSafeName || "vendor"}_quote.pdf`;
      formData.append(`file${i + 2}`, blob, fileName);
    }

    formData.append("purchase_req_number", String(prn || "").trim());
    formData.append("category_compare", String(categoryResolved.id));
    formData.append("buyer_token", buyer_token);
    formData.append("org_token", organization_token || org_token || buyer_token);
    formData.append("file_number", uniqueVendorDocUrls.length + 1);

    return formData;
  };

  const fetchComparisonHistoryRecordByToken = async (token) => {
    const formData = new FormData();
    formData.append("buyer_token", buyer_token);
    formData.append("compare_history", token);
    // Backend expects pagination even when fetching by token
    formData.append("page", 1);
    const res = await axios({
      method: "POST",
      url: `${API_ENDPOINT.comparison_history}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    });
    const payload = res?.data?.response;
    if (!payload) return null;
    if (Array.isArray(payload)) return payload[0] || null;
    return payload;
  };

  const callCompare = async ({ trigger = false, bidSource } = {}) => {
    setLoadingState(true);
    try {
      let token = compareHistoryToken;

      if (trigger) {
        setIsComparePending(true);
        const comparePayload = await buildNewVersionChatGPTPayloadFromRFQ(bidSource);
        const res = await axios({
          method: "POST",
          url: `${API_ENDPOINT.newversion_chatgpt}`,
          data: comparePayload,
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        });
        token = res?.data?.response || "";
        if (res?.data?.queued === false && token) {
          await axios({
            method: "POST",
            url: `${API_ENDPOINT.comparison_resume}`,
            data: { comparison_token: token },
            headers: {
              Authorization: `Bearer ${auth_token}`,
            },
          });
        }
        setCompareHistoryToken(token);
      }

      if (!token) {
        setLoadingState(false);
        return;
      }

      const record = await fetchComparisonHistoryRecordByToken(token);
      const quoteDetails = record?.json_data;
      const jsonHistory = record?.datas;

      const hasQuoteDetails = Array.isArray(quoteDetails)
        ? quoteDetails.length > 0
        : !!quoteDetails;

      if (hasQuoteDetails) {
        const flattenedData = Array.isArray(quoteDetails) &&
          quoteDetails.some((item) => Array.isArray(item) || item?.rfq_data)
          ? quoteDetails
          : flattenNestedObjects(
              Array.isArray(quoteDetails) ? quoteDetails : [quoteDetails],
            );
        const headerdata = {
          prn_number: record?.prn_number,
          created_date: record?.created_date || record?.created_on,
        };
        setCompairedData(flattenedData);
        setFileJsonHistory(jsonHistory);
        setComparedNameDate(headerdata);
        setIsComparePending(false);

        setLoadingState(false);
      } else {
        // Job is still running / record not ready yet
        setCompairedData([]);
        setFileJsonHistory([]);
        setComparedNameDate({
          prn_number: record?.prn_number,
          created_date: record?.created_date || record?.created_on,
        });
        setIsComparePending(true);
        setLoadingState(false);
      }
    } catch (err) {
      setLoadingState(false);
      setIsComparePending(true);
      console.warn("Comparison result is not ready yet:", err);
    }
  };

  const handleViewComparedResultClick = async () => {
    openViewIndividualRFQ();
    void fetchComparisonPreviousPurchases();
    const currentBids = await getEveryBidsData(rfqToken);
    await callCompare({ trigger: true, bidSource: currentBids });
  };

  const openRequote = () => {
    setRequestQuote(true);
    setPageNumber(1);
    GetAllBidsData(1, rfqToken);
  };

  const openViewQuote = () => {
    setEnableSelect(true);
    setSelectedRows([]);
    setPageNumber(1);
    GetAllBidsData(1, rfqToken);
  };

  const openExploreMore = () => {
    setExploreError("");
    setExploreMatches([]);
    setExploreSearch("");
    setExploreExpandedDescriptions({});

    const options = Array.isArray(RFQitemsListMapped) ? RFQitemsListMapped : [];
    // Default to selecting all RFQ items; user can deselect as needed.
    setExploreSelectedItems(options);
    setOpenExploreUnregisteredQuotes(true);
  };

  const formatExploreMoney = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    const n = Number(value);
    if (!Number.isFinite(n)) return String(value);
    return n.toLocaleString("en-IN");
  };

  const formatExploreRupees = (value) => {
    const s = formatExploreMoney(value);
    if (!s || s === "-") return "-";
    return `₹${s}`;
  };

  const toggleExploreDescription = (key) => {
    setExploreExpandedDescriptions((prev) => ({
      ...(prev || {}),
      [key]: !(prev || {})[key],
    }));
  };

  const generateExplorePdf = async (match) => {
    try {
      const vendorEmail = String(match?.vendor_details?.vendor_email || "-");
      const vendorStatus = String(match?.vendor_details?.status || "-");
      const itemName = String(match?.item_name || "-");
      const description = String(match?.description || "-");
      const fingerprint = String(match?.specification_fingerprint || "-");
      const unit = formatExploreRupees(match?.unit_price);
      const tax = match?.tax ?? "-";

      const warrantyRaw =
        match?.warranty?.warranty_raw_text ??
        match?.warranty?.warrantyRawText ??
        null;
      const warrantyPeriod =
        match?.warranty?.warranty_period ??
        match?.warranty?.warrantyPeriod ??
        null;
      const warrantyType =
        match?.warranty?.warranty_type ?? match?.warranty?.warrantyType ?? null;
      const warrantyNumber =
        match?.warranty?.warranty_number ??
        match?.warranty?.warrantyNumber ??
        null;
      const warrantyDisplay =
        String(warrantyRaw || "").trim() ||
        [
          warrantyPeriod ? warrantyPeriod : "",
          warrantyType ? warrantyType : "",
          warrantyNumber !== null &&
          warrantyNumber !== undefined &&
          warrantyNumber !== ""
            ? String(warrantyNumber)
            : "",
        ]
          .filter(Boolean)
          .join(" | ") ||
        "-";

      const wrapper = document.createElement("div");
      wrapper.style.fontFamily = "gilroyMedium, Arial, sans-serif";
      wrapper.style.fontSize = "12px";
      wrapper.style.padding = "16px";
      wrapper.innerHTML = `
        <div style="display:flex;justify-content:space-between;align-items:flex-start;gap:12px;">
          <div>
            <div style="font-family:gilroyBold, Arial, sans-serif;font-size:16px;margin-bottom:4px;">Unregistered Quotation (Explore)</div>
            <div style="color:#475569;">Generated on: ${new Date().toLocaleString()}</div>
          </div>
          <div style="text-align:right;color:#475569;">RFQ: ${String(rfqToken || "-")}</div>
        </div>
        <hr style="border:none;border-top:1px solid #e2e8f0;margin:12px 0;" />
        <table style="width:100%;border-collapse:collapse;">
          <tbody>
            <tr><td style="padding:6px 0;color:#64748b;width:180px;">Supplier Email</td><td style="padding:6px 0;">${vendorEmail}</td></tr>
            <tr><td style="padding:6px 0;color:#64748b;">Supplier Status</td><td style="padding:6px 0;">${vendorStatus}</td></tr>
            <tr><td style="padding:6px 0;color:#64748b;">Item Name</td><td style="padding:6px 0;">${itemName}</td></tr>
            <tr><td style="padding:6px 0;color:#64748b;">Description</td><td style="padding:6px 0;">${description}</td></tr>
            <tr><td style="padding:6px 0;color:#64748b;">Specification</td><td style="padding:6px 0;">${fingerprint}</td></tr>
            <tr><td style="padding:6px 0;color:#64748b;">Unit Price</td><td style="padding:6px 0;">${unit}</td></tr>
            <tr><td style="padding:6px 0;color:#64748b;">Tax (%)</td><td style="padding:6px 0;">${tax}</td></tr>
            <tr><td style="padding:6px 0;color:#64748b;">Warranty</td><td style="padding:6px 0;">${warrantyDisplay}</td></tr>
          </tbody>
        </table>
      `;

      // eslint-disable-next-line no-undef
      await html2pdf()
        .set({
          margin: 8,
          filename: `${itemName !== "-" ? itemName : "Quotation"} - ${vendorEmail !== "-" ? vendorEmail : "vendor"}.pdf`,
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        })
        .from(wrapper)
        .save();
    } catch (err) {
      console.warn("Failed to generate explore PDF:", err);
    }
  };

  const fetchExploreUnregisteredQuotes = async () => {
    if (!rfqToken) {
      setExploreError("RFQ token missing.");
      return;
    }
    if (!shouldMakeAPICall(auth_token, buyer_token)) {
      setExploreError(
        "You appear to be offline. Explore requires an internet connection.",
      );
      return;
    }
    if (
      !Array.isArray(exploreSelectedItems) ||
      exploreSelectedItems.length === 0
    ) {
      setExploreError("Select at least one RFQ item to explore.");
      return;
    }

    setExploreError("");
    setExploreLoading(true);
    try {
      const requests = exploreSelectedItems.map((it) => {
        const itemName = String(it?.item_name || "").trim();
        const description = String(it?.description || "").trim();
        return axios({
          method: "POST",
          url: API_ENDPOINT.explore_unregistered_quotation_history,
          data: {
            rfq_token: rfqToken,
            item_name: itemName === "-" ? "" : itemName,
            description: description === "-" ? "" : description,
          },
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        });
      });

      const responses = await Promise.allSettled(requests);
      const merged = [];
      responses.forEach((r) => {
        if (r.status !== "fulfilled") return;
        const data = r.value?.data || {};
        const matches = Array.isArray(data.matches) ? data.matches : [];
        merged.push(...matches);
      });

      // De-dupe by match token if present, else by quotation_token+item_name+vendor_email.
      const unique = [];
      const seen = new Set();
      merged.forEach((m) => {
        const vendorEmail = m?.vendor_details?.vendor_email || "";
        const key =
          String(m?.token || "").trim() ||
          `${m?.quotation_token || ""}::${m?.item_name || ""}::${vendorEmail}`;
        if (seen.has(key)) return;
        seen.add(key);
        unique.push(m);
      });

      setExploreMatches(unique);
      if (unique.length === 0) {
        setExploreError("No matching unregistered vendor quotations found.");
      }
    } catch (err) {
      setExploreError(
        err?.response?.data?.message ||
          err?.response?.data?.response ||
          "Unable to explore unregistered quotations. Please try again.",
      );
    } finally {
      setExploreLoading(false);
    }
  };

  const filteredExploreMatches = useMemo(() => {
    const q = String(exploreSearch || "")
      .trim()
      .toLowerCase();
    const base = Array.isArray(exploreMatches) ? exploreMatches : [];
    if (!q) return base;

    return base.filter((m) => {
      const vendorEmail = String(
        m?.vendor_details?.vendor_email || "",
      ).toLowerCase();
      const vendorStatus = String(
        m?.vendor_details?.status || "",
      ).toLowerCase();
      const fileName = String(m?.file_name || "").toLowerCase();
      const itemName = String(m?.item_name || "").toLowerCase();
      const desc = String(m?.description || "").toLowerCase();
      const fingerprint = String(
        m?.specification_fingerprint || "",
      ).toLowerCase();
      return (
        vendorEmail.includes(q) ||
        vendorStatus.includes(q) ||
        fileName.includes(q) ||
        itemName.includes(q) ||
        desc.includes(q) ||
        fingerprint.includes(q)
      );
    });
  }, [exploreMatches, exploreSearch]);

  const exploreItemOptions = useMemo(() => {
    const items = Array.isArray(RFQitemsListMapped) ? RFQitemsListMapped : [];
    return [{ __all: true, item_name: "All items" }, ...items];
  }, [RFQitemsListMapped]);

  const cancelRequestRequote = () => {
    setRequestQuote(false);
    setSelectedRows([]);
    setPageNumber(1);
    GetAllBidsData(1, rfqToken);
  };

  const getCountriesList = async () => {
    // Try cache first
    const cachedCountries = await masterDataRepository.getCountriesFromCache();
    if (cachedCountries && cachedCountries.length > 0) {
      setCountry((prev) => ({
        ...prev,
        countryList: cachedCountries,
      }));
    }

    // Sync from API if online
    if (shouldMakeAPICall(auth_token, buyer_token)) {
      axios({
        method: "POST",
        url: API_ENDPOINT.view_countries,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then(async (res) => {
          const countries = res?.data?.response || res?.data || [];
          // Save to cache
          await masterDataRepository.saveCountriesToCache(countries);
          setCountry((prev) => ({
            ...prev,
            countryList: countries,
          }));
        })
        .catch((err) => {
          // Network errors are expected when offline - silently use cache
          if (
            err.code === "ERR_NETWORK" ||
            err.code === "ERR_CONNECTION_REFUSED"
          ) {
            console.log("📴 Network error - using cached countries");
          } else {
            console.log("Error loading countries, using cache:", err);
          }
          // Use cached data if API fails
          if (cachedCountries && cachedCountries.length > 0) {
            setCountry((prev) => ({
              ...prev,
              countryList: cachedCountries,
            }));
          }
        });
    }
  };

  const getStatesList = async (country_id, country_token = null) => {
    console.log(
      `🔍 Loading states for country_id: ${country_id || "all (initial load)"}, country_token: ${country_token || "N/A"}`,
    );

    // Try cache first - get all states if country_id provided, then filter client-side
    let cachedStates = [];
    // Check if country_id is provided (not null, not undefined) - use !== null to allow 0 as valid ID
    if (country_id !== null && country_id !== undefined) {
      // When country is selected: ONLY filter from cache, NO API call
      // States use country_id (number) to match country's id, not token
      // First try to get filtered states by country_id from database index
      cachedStates = await masterDataRepository.getStatesFromCache(country_id);
      console.log(
        `📦 Found ${cachedStates.length} states from cache (filtered by country_id)`,
      );

      // If no filtered states found, try getting all states and filter client-side
      if (!cachedStates || cachedStates.length === 0) {
        console.log(
          `📦 No filtered states found, trying all states and filtering client-side`,
        );
        const allCachedStates =
          await masterDataRepository.getStatesFromCache(null);
        console.log(`📦 Found ${allCachedStates.length} total states in cache`);

        if (allCachedStates && allCachedStates.length > 0) {
          // Filter by country_id (number) - this matches country.id
          // getStatesFromCache returns s.data || s, so s is already the state object
          cachedStates = allCachedStates.filter((s) => {
            // s is the state object from API (already unwrapped by getStatesFromCache)
            // Check country_id directly from the state object
            // Also check if it's a number comparison (strict equality)
            const stateCountryId = s?.country_id;
            const matches =
              stateCountryId === country_id ||
              Number(stateCountryId) === Number(country_id);
            if (!matches && allCachedStates.length > 0) {
              console.log(
                `🔍 Filtering: state.country_id=${stateCountryId} (type: ${typeof stateCountryId}), looking for country_id=${country_id} (type: ${typeof country_id})`,
              );
            }
            return matches;
          });
          console.log(
            `📦 Filtered to ${cachedStates.length} states for country_id ${country_id}`,
          );
          if (cachedStates.length === 0) {
            console.warn(
              `⚠️ No states found for country_id ${country_id}. Sample state data:`,
              allCachedStates[0],
            );
            console.warn(
              `⚠️ Sample state country_id: ${allCachedStates[0]?.country_id || allCachedStates[0]?.data?.country_id}`,
            );
          }
        } else {
          console.warn(
            `⚠️ No states in cache at all. States need to be loaded first.`,
          );
          console.warn(`⚠️ Triggering initial load of states...`);
          // If cache is completely empty, trigger initial load (but don't wait for it)
          // The user will see states populate once the API call completes
          getStatesList(null).catch((err) =>
            console.error("Error loading states:", err),
          );
        }
      }

      // Always set the state list (even if empty)
      console.log(
        `✅ Setting state list with ${cachedStates.length} states (filtered from cache)`,
      );
      setStateName((prev) => ({
        ...prev,
        stateList: cachedStates || [],
      }));

      // For edit form, try to match existing state value
      if (
        editRFQForm &&
        cachedStates &&
        cachedStates.length > 0 &&
        stateName.value
      ) {
        let filterStates = cachedStates.filter(
          (el) => el.name === stateName.value,
        );
        let state_token = filterStates && filterStates[0]?.token;
        let state_id = filterStates && filterStates[0]?.id;
        filterStates && setstateToken(filterStates[0]?.token);
        if (state_token && state_token !== null && state_token !== "") {
          getCityList(state_id, state_token);
        }
      }

      // NO API CALL when filtering by country - just use cache
      return;
    } else {
      // Initial load (country_token is null): Load from cache, then sync from API if online
      cachedStates = await masterDataRepository.getStatesFromCache(null);
      console.log(
        `📦 Loaded ${cachedStates.length} states from cache (initial load)`,
      );

      // Set cached data immediately
      setStateName((prev) => ({
        ...prev,
        stateList: cachedStates || [],
      }));
    }

    // Sync from API only on initial load (when country_token is null)
    if (shouldMakeAPICall(auth_token, buyer_token)) {
      axios({
        method: "GET",
        url: API_ENDPOINT.all_view_states,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then(async (res) => {
          const allStates = res?.data?.response || res?.data || [];

          // Save all states to cache (for future filtering)
          await masterDataRepository.saveStatesToCache(allStates, null);

          console.log(
            `✅ API returned ${allStates.length} states, cached and updated state list`,
          );
          setStateName((prev) => ({
            ...prev,
            stateList: allStates,
          }));
        })
        .catch((err) => {
          // Network errors are expected when offline - silently use cache
          if (
            err.code === "ERR_NETWORK" ||
            err.code === "ERR_CONNECTION_REFUSED"
          ) {
            console.log("📴 Network error - using cached states");
          } else {
            console.log("Error loading states, using cache:", err);
          }
          // Use cached data if API fails
          if (cachedStates && cachedStates.length > 0) {
            setStateName((prev) => ({
              ...prev,
              stateList: cachedStates,
            }));
          }
        });
    }
  };

  const getStatesListAutoFillCall = async (country_token) => {
    try {
      const response = await axios({
        method: "GET",
        url: API_ENDPOINT.all_view_states,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      });

      const allStates = response?.data?.response || response?.data || [];
      // Filter by country if country_token provided
      const states = country_token
        ? allStates.filter(
            (s) =>
              s.country_token === country_token ||
              s.country_id === country_token,
          )
        : allStates;

      // Save all states to cache
      await masterDataRepository.saveStatesToCache(allStates, null);

      setStateName((prev) => ({
        ...prev,
        stateList: states,
      }));

      if (editRFQForm) {
        let filterStates = states.filter((el) => el.name === stateName.value);

        let state_token = filterStates && filterStates[0]?.token;
        let state_id = filterStates && filterStates[0]?.id;
        filterStates && setstateToken(filterStates[0]?.token);

        if (state_id && state_id !== null && state_id !== "") {
          // Pass state_id (number) for proper filtering by state_id
          getCityList(state_id, state_token);
        }
      }

      return { response: states }; // Return the filtered states
    } catch (error) {
      console.error(error);
      throw error; // Re-throw the error to handle it outside this function if needed
    }
  };

  const getCityList = async (state_id, state_token = null) => {
    console.log(
      `🔍 Loading cities for state_id: ${state_id !== null && state_id !== undefined ? state_id : "all (initial load)"}, state_token: ${state_token || "N/A"}`,
    );
    console.log(
      `🔍 getCityList called with state_id type: ${typeof state_id}, value: ${state_id}`,
    );

    // Try cache first - get all cities if state_id provided, then filter client-side
    let cachedCities = [];
    // Check if state_id is provided (not null, not undefined) - use !== null to allow 0 as valid ID
    if (state_id !== null && state_id !== undefined) {
      console.log(
        `✅ Filtering mode: state_id=${state_id}, will NOT make API call`,
      );
      // When state is selected: ONLY filter from cache, NO API call
      // Cities use state_id (number) to match state's id, not token
      // First try to get filtered cities by state_id from database index
      cachedCities = await masterDataRepository.getCitiesFromCache(state_id);
      console.log(
        `📦 Found ${cachedCities.length} cities from cache (filtered by state_id)`,
      );

      // If no filtered cities found, try getting all cities and filter client-side
      if (!cachedCities || cachedCities.length === 0) {
        console.log(
          `📦 No filtered cities found, trying all cities and filtering client-side`,
        );
        const allCachedCities =
          await masterDataRepository.getCitiesFromCache(null);
        console.log(`📦 Found ${allCachedCities.length} total cities in cache`);

        if (allCachedCities && allCachedCities.length > 0) {
          // Filter by state_id (number) - this matches state.id
          // getCitiesFromCache returns c.data, so c is already the city object
          cachedCities = allCachedCities.filter((c) => {
            // c is the city object from API (already unwrapped by getCitiesFromCache)
            // Check state_id directly from the city object
            // Also handle number/string type mismatches
            const cityStateId = c?.state_id;
            const matches =
              cityStateId === state_id ||
              Number(cityStateId) === Number(state_id);
            if (
              !matches &&
              allCachedCities.length > 0 &&
              allCachedCities.indexOf(c) === 0
            ) {
              // Only log for first city to avoid spam
              console.log(
                `🔍 Filtering: city.state_id=${cityStateId} (type: ${typeof cityStateId}), looking for state_id=${state_id} (type: ${typeof state_id})`,
              );
              console.log(`🔍 Full city object:`, c);
            }
            return matches;
          });
          console.log(
            `📦 Filtered to ${cachedCities.length} cities for state_id ${state_id}`,
          );
          if (cachedCities.length === 0) {
            console.warn(
              `⚠️ No cities found for state_id ${state_id}. Sample city data:`,
              allCachedCities[0],
            );
            console.warn(
              `⚠️ Sample city state_id: ${allCachedCities[0]?.state_id || allCachedCities[0]?.data?.state_id}`,
            );
          }
        } else {
          console.warn(
            `⚠️ No cities in cache at all. Cities need to be loaded first.`,
          );
          console.warn(
            `⚠️ Cache is empty - cities will be loaded when online or on next initial load`,
          );
          // Don't trigger API call here when filtering - it would cause network error
          // Cities will be loaded on initial page/form load
          cachedCities = []; // Set empty array
        }
      }

      // Remove duplicate cities by name to avoid React key warnings
      const uniqueCities = cachedCities.filter(
        (city, index, self) =>
          index ===
          self.findIndex((c) => c.name === city.name && c.token === city.token),
      );

      // Always set the city list (even if empty)
      console.log(
        `✅ Setting city list with ${uniqueCities.length} cities (filtered from cache, ${cachedCities.length - uniqueCities.length} duplicates removed)`,
      );
      setCity((prev) => ({
        ...prev,
        cityList: uniqueCities || [],
      }));

      // NO API CALL when filtering by state - just use cache
      console.log(
        `✅ Returning early - NO API call for filtering by state_id=${state_id}`,
      );
      return; // CRITICAL: This return prevents API call when filtering
    } else {
      // Initial load (state_id is null/undefined): Load from cache, then sync from API if online
      console.log(`📦 Initial load mode: loading all cities from cache`);
      cachedCities = await masterDataRepository.getCitiesFromCache(null);
      console.log(
        `📦 Loaded ${cachedCities.length} cities from cache (initial load)`,
      );

      // Set cached data immediately
      setCity((prev) => ({
        ...prev,
        cityList: cachedCities || [],
      }));
    }

    // Sync from API only on initial load (when state_id is null/undefined)
    // This code should NOT execute when filtering by state_id (due to return above)
    console.log(
      `📦 About to check API call - state_id=${state_id}, shouldMakeAPICall=${shouldMakeAPICall(auth_token, buyer_token)}`,
    );
    if (shouldMakeAPICall(auth_token, buyer_token)) {
      console.log(`🌐 Making API call for cities (initial load only)`);
      axios({
        method: "GET",
        url: API_ENDPOINT.all_view_cities,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
      })
        .then(async (res) => {
          const allCities = res?.data?.response || res?.data || [];

          // Save all cities to cache (for future filtering)
          await masterDataRepository.saveCitiesToCache(allCities, null);

          console.log(
            `✅ API returned ${allCities.length} cities, cached and updated city list`,
          );
          setCity((prev) => ({
            ...prev,
            cityList: allCities,
          }));
        })
        .catch((err) => {
          // Network errors are expected when offline - silently use cache
          if (
            err.code === "ERR_NETWORK" ||
            err.code === "ERR_CONNECTION_REFUSED"
          ) {
            console.log("📴 Network error - using cached cities");
          } else {
            console.log("Error loading cities, using cache:", err);
          }
          // Use cached data if API fails
          if (cachedCities && cachedCities.length > 0) {
            setCity((prev) => ({
              ...prev,
              cityList: cachedCities,
            }));
          }
        });
    }
  };

  const getCompanyList = async (searchValue) => {
    let abortController = new AbortController();
    try {
      abortController.abort();

      const newAbortController = new AbortController();
      abortController = newAbortController;

      const formData = new FormData();
      formData.append("buyer_token", org_token);
      formData.append("search", searchValue);

      const response = await axios({
        method: "POST",
        url: `${API_ENDPOINT.getCompanyList}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${auth_token}`,
        },
        signal: abortController.signal,
      });

      let responseData = response?.data?.response;
      setCompanyList(responseData?.map((e) => e?.company_name));
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Request aborted:", error.message);
      } else {
        console.log(error);
      }
    }
  };

  const vendorsTabInputs = [
    <DFreeSoloInput
      label="Company Name"
      value={CompanyName.value}
      options={companyList}
      inputRegex={/[^a-zA-Z0-9\s]+/g}
      onChange={(value) => {
        if (open1) {
          setCompanyName({
            value: value,
            isValid: emptyCheck(value),
          });
        }
        if (value?.length > 2) {
          getCompanyList(value);
        } else {
          setCompanyList([]);
        }
      }}
      error={!CompanyName.isValid}
      errorMsg={"Company name is required"}
      size={"100%"}
    />,
    <DTextInput
      label={"Email"}
      value={VendorRegisteredEmail.value}
      onChange={(e) => {
        let val = e.target.value;
        const arr = [];
        vendorId.forEach((item, i) => {
          if (item === undefined) {
            //extracting mail id from vendor
            arr.push(vendor.value[i]?.split("(")[1]?.replace(")", ""));
          }
        });
        //checking if the vendor mail exists
        if (arr.some((item) => item === val)) {
          setVendorRegisteredEmail({
            value: val,
            isValid: false,
            message: "vendor already selected",
          });
        } else {
          setVendorRegisteredEmail({
            value: val,
            isValid: validateEmail(val),
          });
        }
      }}
      error={!VendorRegisteredEmail.isValid}
      errorMsg={
        !emptyCheck(VendorRegisteredEmail.value)
          ? "Email is required"
          : VendorRegisteredEmail?.message
            ? VendorRegisteredEmail?.message
            : !VendorRegisteredEmail.isValid
              ? "Invalid email format"
              : "" || ""
      }
      customClassName={vendorClasses.addVendorPopupInput}
      size={"100%"}
    />,
  ];
  const vendorsTabHeading = (
    <HeaderTitle
      titleText={"Add Supplier"}
      customclass={vendorClasses.popupHeading}
    />
  );
  const popupActions = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleClose1}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      buyerBtn={true}
    />,
    <DButton
      label={"Add"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      buyerBtn={true}
      error={primaryBtnError.error}
      errorMsg={primaryBtnError.errorMsg}
      loadingState={loading}
      onClick={handleSubmit1}
    />,
  ];

  // poppup
  const handleCloseViewItemPopup = () => {
    setSendMessage(false);
    setTextAreaSendMessage(false);
    setSendErrorMsg(false);
    setSelectedRows([]);
  };
  const handleCloseSendMessage = () => {
    setSendMessage(true);
    setTextAreaSendMessage(false);
    setErrorMessages(false);
    setTextAreaVlaue({ ...textAreaVlaue, send_message: "" });
    setCharsLeft(0);
    setSelectedRows([]);
    setSendErrorMsg(false);
    setMsg_file([]);
    Setsendmsg(false);
  };

  const sendMessages = () => {
    setSendMessage(true);
  };

  const handleContinue = () => {
    if (selectedRows.length > 0) {
      setTextAreaSendMessage(true);
    } else {
      setSendErrorMsg(true);
    }
  };

  // const handleSendMessage = async () => {
  //   if (textAreaVlaue.send_message.length <= 0) {
  //     setErrorMessages(true);
  //   } else {
  //     await axios({
  //       method: "POST",
  //       url: `${API_ENDPOINT.rfq_chat}`,
  //       data: {
  //         sender_token: AdminData?.user_token,
  //         sender_role: AdminData?.role,
  //         receiver_token: selectedRows.join(", "),
  //         receiver_role: `${
  //           AdminData?.role == "Buyer" ? "vendor contact" : "buyer"
  //         }`,
  //         rfq_token: rfqToken,
  //         message: textAreaVlaue.send_message,
  //       },
  //       headers: {
  //         Authorization: `Bearer ${auth_token}`,
  //       },
  //     })
  //       .then((res) => {
  //         handleOpen2();
  //         setPopupHeroText("Message sent successfully ");
  //         setPopupMessage(res?.data?.response);
  //         setLoadingState(false);
  //         setBtnErrorState({
  //           error: false,
  //           errorMsg: "",
  //         });
  //         setSendMessage(false);
  //         setErrorMessages(false);
  //         setTextAreaVlaue({ ...textAreaVlaue, send_message: "" });
  //         setCharsLeft(0);
  //       })
  //       .catch((err) => {
  //         handleClose2();
  //         setBtnErrorState({
  //           error: true,
  //           errorMsg:
  //             Object.values(err?.response?.data)[0] ||
  //             "Please fill out all fields",
  //         });
  //         setLoadingState(false);
  //       });
  //   }
  // };
  const [sendmsg, Setsendmsg] = useState(false);

  const handleSendMessage = async () => {
    Setsendmsg(true);
    if (textAreaVlaue.send_message.length <= 0) {
      setErrorMessages(true);
      return; // Exit if there's an error
    } else {
      const formData = new FormData();
      formData.append("sender_token", AdminData?.user_token);
      formData.append("sender_role", AdminData?.role);
      formData.append("receiver_token", selectedRows.join(", "));
      formData.append(
        "receiver_role",
        AdminData?.role === "Buyer" ? "vendor contact" : "buyer",
      );
      formData.append("rfq_token", rfqToken);
      formData.append("message", textAreaVlaue.send_message);

      if (msg_file) {
        msg_file.forEach((file) => {
          formData.append("rfqcon_files", file);
        });
      }
      try {
        const res = await axios.post(API_ENDPOINT.rfq_chat, formData, {
          headers: {
            Authorization: `Bearer ${auth_token}`,
            "Content-Type": "multipart/form-data",
          },
        });

        if (res?.data?.response == "Message sent.") {
          Setsendmsg(false);
        }
        handleOpen2();
        setPopupHeroText("Message sent successfully ");
        setPopupMessage(res?.data?.response);
        setLoadingState(false);
        setBtnErrorState({ error: false, errorMsg: "" });
        setSendMessage(false);
        setErrorMessages(false);
        setTextAreaVlaue({ ...textAreaVlaue, send_message: "" });
        setCharsLeft(0);
        setMsg_file([]);
      } catch (err) {
        // Handle error
        handleClose2();
        setBtnErrorState({
          error: true,
          errorMsg:
            (err?.response?.data && typeof err?.response?.data === "object"
              ? Object.values(err?.response?.data)[0]
              : null) ||
            err?.message ||
            "Please fill out all fields",
        });
        setLoadingState(false);
      }
    }
  };

  const openViewTimeLineModal = async (unique_id, rowData) => {
    console.log(rowData);

    console.log({
      buyer_token: AdminData?.user_token,
      vendor_token: rowData?.token,
      rfq_token: rfqToken,
    });

    setTimeLineVendorData(() => rowData);
    const buyerTokenForCache = buyer_token || AdminData?.user_token;

    const isOffline = !shouldMakeAPICall(auth_token, buyer_token);
    if (isOffline) {
      const parseDate = (dateStr) => {
        if (!dateStr || typeof dateStr !== "string") return new Date(0);
        try {
          if (String(dateStr).includes(" - ")) {
            const [datePart, timePart] = String(dateStr).split(" - ");
            return new Date(
              `${(datePart || "").trim()} ${(timePart || "").trim()}`,
            );
          }
          return new Date(String(dateStr).trim());
        } catch (e) {
          return new Date(0);
        }
      };
      const buildTimelineFromVendorChat = (vendorChat) => {
        if (!Array.isArray(vendorChat) || vendorChat.length === 0) return [];
        return vendorChat.map((msg) => ({
          id: msg.token || msg.id,
          rfq: msg.rfq,
          message: msg.message,
          sender_role: msg.sender_role,
          receiver_role: msg.receiver_role,
          sender_token: msg.sender,
          receiver_token: msg.receiver,
          created: parseDate(msg.created_date || msg.created),
          created_raw: msg.created_date || msg.created || "",
          status: msg.message_type === "system generated",
          document: msg.document || [],
        }));
      };

      // Vendor chat is already mapped in rfq_vendor_list (API key) → rfqVendorListMappedForMessages has chat: v.chat → rowData.chat
      let timelineData = [];
      const vendorChat = rowData?.chat;
      let source = null;
      if (Array.isArray(vendorChat) && vendorChat.length > 0) {
        timelineData = buildTimelineFromVendorChat(vendorChat);
        source = "rfq_vendor_list (rowData.chat)";
      }
      if (timelineData.length === 0) {
        try {
          const cached = await rfqRepository.getChatTimelineFromCache(
            rfqToken,
            rowData?.token,
            buyerTokenForCache,
          );
          if (Array.isArray(cached) && cached.length > 0) {
            timelineData = cached;
            source = "IndexedDB cache";
          }
        } catch (e) {
          console.warn("Timeline cache load failed:", e);
          if (Array.isArray(vendorChat) && vendorChat.length > 0) {
            timelineData = buildTimelineFromVendorChat(vendorChat);
            source = "rfq_vendor_list (rowData.chat)";
          }
        }
      }
      if (timelineData.length > 0 && source) {
        console.log(
          `✅ Timeline has vendor chat (${timelineData.length} messages) from ${source}`,
        );
      } else if (timelineData.length === 0) {
        console.log(
          "⚠️ No vendor chat found offline (rowData.chat and cache both empty)",
        );
      }

      setViewTimeLineData(timelineData);
      setOpenForm({
        open: true,
        loading: false,
        errorMessage: timelineData.length === 0 ? "" : "",
      });
      setViewRFQ(false);
      setRFQMain(false);
      setPageNumber(1);
      setNewRFQForm(false);
      setEditRFQForm(false);
      setViewTimeLine(true);
      setViewUserTimeLine(false);
      setChatConfirmationDialog({ open: false, isClosedChat: true });
      return;
    }

    try {
      const rfqChatResponse = await axios.post(
        `${API_ENDPOINT.view_rfq_chat}`,
        {
          buyer_token: AdminData?.user_token,
          vendor_token: rowData?.token,
          rfq_token: rfqToken,
        },
        {
          headers: { Authorization: `Bearer ${auth_token}` },
        },
      );

      let viewTimeLineData = rfqChatResponse?.data?.response || [];

      console.log(rfqChatResponse);

      const rfqExists = viewTimeLineData.some((chat) => chat.rfq);
      let finalTimeline = viewTimeLineData;

      if (data.access_type == "Buyer") {
        if (rfqExists) {
          const rfqId = viewTimeLineData.find((chat) => chat.rfq)?.rfq;

          const additionalRfqResponse = await axios.post(
            `${API_ENDPOINT.rfq_timeline_messages}`,
            {
              buyer: AdminData?.user_token,
              rfq_id: rfqId,
            },
            {
              headers: { Authorization: `Bearer ${auth_token}` },
            },
          );

          console.log(additionalRfqResponse.data);

          const parseDate = (dateStr) => {
            if (!dateStr || typeof dateStr !== "string") return new Date(0);

            try {
              if (dateStr.includes(" - ")) {
                const [datePart, timePart] = dateStr.split(" - ");
                return new Date(`${datePart.trim()} ${timePart.trim()}`);
              } else {
                return new Date(dateStr.trim());
              }
            } catch (error) {
              console.error("Date parsing error for:", dateStr, error);
              return new Date(0);
            }
          };

          const combineAndSortMessages = (msg1, msg2) => {
            const formattedMsg1 = msg1.map((msg) => ({
              id: msg.token || null,
              rfq: msg.rfq,
              message: msg.message,
              sender_role: msg.sender_role,
              receiver_role: msg.receiver_role,
              sender_token: msg.sender,
              receiver_token: msg.receiver,
              created: parseDate(msg.created_date),
              created_raw: msg.created_date || "MISSING",
              status: msg.message_type === "system generated",
              document: msg.document || [],
            }));

            console.log(msg2);
            const formattedMsg2 = msg2.map((msg) => ({
              id: msg.id,
              rfq: msg.rfq,
              message: msg.message,
              name: msg.name,
              designation: msg.designation ?? msg.desingation,
              role: msg.role,
              sender_token: msg.sender_token,
              receiver_token: msg.receiver_token,
              created: parseDate(msg.created),
              created_raw: msg.created || "MISSING",
              status: msg.status,
              document: msg.document || [],
              company_name: msg.company_name,
            }));

            const combinedMessages = [...formattedMsg1, ...formattedMsg2];

            combinedMessages.sort((a, b) => a.created - b.created);

            return combinedMessages;
          };

          let mergedData = combineAndSortMessages(
            viewTimeLineData,
            additionalRfqResponse.data,
          );

          console.log({ mergedData });

          finalTimeline = mergedData;
          setViewTimeLineData(mergedData);
        } else {
          setViewTimeLineData(viewTimeLineData);
        }

        //   // Extract RFQ ID from first matched entry

        //   // Second API call: Fetch additional RFQ details

        //   // Merge additional RFQ details into existing timeline data
        //   viewTimeLineData = [...viewTimeLineData, ...additionalRfqResponse?.data?.response || []];
      } else {
        setViewTimeLineData(viewTimeLineData);
      }

      // Persist timeline to IndexedDB keyed by buyer_token, rfq_token, vendor_token for offline
      if (
        Array.isArray(finalTimeline) &&
        finalTimeline.length > 0 &&
        rfqToken &&
        rowData?.token &&
        buyerTokenForCache
      ) {
        rfqRepository
          .saveChatTimelineToCache(
            rfqToken,
            finalTimeline,
            rowData.token,
            buyerTokenForCache,
          )
          .catch((err) => {
            console.warn("Failed to cache chat timeline for offline:", err);
          });
      }

      // Update the UI with fetched data
      // setViewTimeLineData(viewTimeLineData);

      setOpenForm({
        open: true,
        loading: false,
        errorMessage: "",
      });

      // Second API call: Check Vendor Chat Status
      const vendorChatStatusResponse = await axios.post(
        `${API_ENDPOINT.vendor_msg_box}`,
        {
          vendor_token: rowData?.token,
          rfq_token: rfqToken,
        },
        {
          headers: { Authorization: `Bearer ${auth_token}` },
        },
      );

      setChatConfirmationDialog((prevStatus) => ({
        open: false,
        isClosedChat: vendorChatStatusResponse?.data?.response, // true -> chat closed, false -> chat open
      }));
    } catch (error) {
      console.error("Error fetching timeline data:", error);
      const isNetworkError =
        error?.code === "ERR_NETWORK" ||
        error?.message?.includes?.("Network Error");
      const friendlyMessage = isNetworkError
        ? "Chat is available when you're online."
        : error?.response?.data && typeof error?.response?.data === "object"
          ? Object.values(error?.response?.data)[0]
          : "Something went wrong!";

      setOpenForm({
        open: true,
        loading: false,
        errorMessage: friendlyMessage,
      });
    }

    // Reset RFQ views (only when we didn't return early)
    setViewRFQ(false);
    setRFQMain(false);
    setPageNumber(1);
    setNewRFQForm(false);
    setEditRFQForm(false);
    setViewTimeLine(true);
  };

  const handleWordCount = (event) => {
    const inputValue = event.target.value;
    const charCount = inputValue.length;
    const maxChar = 2000;
    const truncatedValue = inputValue.slice(0, maxChar);
    setTextAreaVlaue({ ...textAreaVlaue, send_message: truncatedValue });
    const charLength = Math.min(maxChar, charCount); // Ensures the count doesn't exceed 200
    setCharsLeft(charLength);
  };

  // viewItemsActionButtons
  const viewItemsActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewItemPopup}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={"Continue"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleContinue}
    />,
  ];

  const viewTextActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseSendMessage}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={sendmsg && !errorMessages ? "Sending" : "Send Message"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleSendMessage}
      disabled={sendmsg && !errorMessages}
    />,
  ];
  console.log(uniqueData?.item_description_doc, "unique");

  // added start ?
  const handlePopup = (
    selectedRows,
    vendorname,
    vendor_slno,
    ventoken,
    select_bid_token,
  ) => {
    if (selectedRows > 0) {
      // setOpenModalsubmit(true);
      // setMessage('Please select vendor');
    } else {
      // setupdateUserFlag(true);
      setOpenvendor(true);
    }
  };
  const unselectcheckbox = (bidTokens) => {
    setOpenBidConfirmation({
      selectBid: false,
      unSelectBid: true,
    });

    const bid_token = bidTokens.map((tokenObj) => ({
      token: tokenObj.token,
      email: tokenObj.vendor_email,
    })); // Extract tokens into an array
    setBidToken(bid_token);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setMsg_file((prefiles) => [...prefiles, file]);
    }
  };

  const handleRemoveFile = (index) => {
    setMsg_file((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const viewUserChildren = [
    <>
      <p className={classes.heading_sub_text}>
        You can send messages to multiple vendors
      </p>

      <DataTable
        headings={headingMessage}
        tableData={rfqVendorListForMessageSelection}
        bulkData={bulkBidsData}
        tableSize={"100%"}
        errorMessage={tableProps.errorMessage}
        isLoading={tableProps.isLoading}
        selection={true}
        customClass={classes.fixedHeader}
        hasBidIteration={true}
        selectedRowsList={handleSeletedRowsListMessage}
        setSortingColumnName={setSortingColumnName}
        sortingColumnName={sortingColumnName}
        setSortingOrder={setSortingOrder}
        sortingOrder={sortingOrder}
        actionButtons={viewTextActionButtons}
        checkboxSelection={true}
        sendMessage={sendMessage}
      />
      {sendErrorMsg && (
        <p className={classes.error_msg}>Please select the vendors</p>
      )}
    </>,
  ];

  const viewTextChildren = [
    <div>
      <p className={classes.heading_sub_text}>Please enter your message</p>
      <TextArea
        maxLength="2000"
        style={{ width: "100 %" }}
        title="send_message"
        name="send_message"
        rows={7}
        value={textAreaVlaue.send_message}
        placeholder="Type your message here..."
        onChange={handleWordCount}
      />
      {charsLeft === 2000 && (
        <p className={classes.error_msg}>
          Message should be less than 2000 characters only
        </p>
      )}
      {errorMessages ? (
        <p className={classes.error_msg}>Please fill above message field</p>
      ) : (
        ""
      )}
      <Attachment
        msg_file={msg_file}
        handleFileChange={handleFileChange}
        handleRemoveFile={handleRemoveFile}
      />
    </div>,
  ];

  const viewUserHeading = (
    <HeaderTitle
      titleText={"Send Message" || <MoreHoriz sx={{ fontSize: "30px" }} />}
      customclass={classes.heading_pop_pup}
    />
  );

  let downloadPdf = (rfq_code) => {
    setLoadingStateDwnload(true);
    setOrganizationDetailspdfUI(true);
    const element = document.getElementById("organization_details");
    let options = {
      margin: [10, 10],
      html2canvas: {
        scale: 2,
        useCORS: false,
        backgroundColor: "#ffffff",
      },
      jsPDF: {
        format: "a3",
        orientation: "portrait",
        margins: {
          top: 10,
          bottom: 10,
          left: 10,
          right: 10,
        },
      },
      // Callback function to modify the jsPDF object before rendering the PDF
      onBeforeSendPDF: function (pdf, renderer, options) {
        // Set the top and bottom margins to 20mm for the second page and beyond
        pdf.setPage(options.pageNumber - 1);
        if (options.pageNumber > 1) {
          pdf.setPageMargins(10, 50, 10);
        }
      },
      filename: rfq_code,
    };
    setTimeout(() => {
      html2pdf().set(options).from(element).save();
      setLoadingStateDwnload(false);
      setOrganizationDetailspdfUI(false);
    }, 2000);
  };

  const handleSelectedAddress = async (addressData) => {
    let { city, pincode, shipping_address1, shipping_address2, state } =
      addressData;
    setAddress1((prev) => ({
      ...prev,
      value: shipping_address1 ? shipping_address1 : "",
      isValid: validateSelect("Select", shipping_address1),
    }));
    setAddress2({
      value: shipping_address2 ? shipping_address2 : "",
    });
    setCountry((prev) => ({
      ...prev,
      value: addressData.country ? addressData.country : "",
      isValid: validateSelect("Select", addressData.country),
    }));
    setStateName((prev) => ({
      ...prev,
      value: state ? state : "",
      isValid: validateSelect("Select", state),
    }));
    setCity((prev) => ({
      ...prev,
      value: city ? city : "",
      isValid: validateSelect("Select", city),
    }));
    setPincode({
      value: pincode ? pincode : "",
      isValid: emptyCheck(pincode),
    });
    // setMobileNumber({
    //   value: splitCodeMobileNumber(e?.address?.mobile_number).mobile,
    //   format: splitCodeMobileNumber(e?.address?.mobile_number).code,
    //   isValid:
    //     emptyCheck(splitCodeMobileNumber(e?.address?.mobile_number).code),
    // });

    let filterObj = country?.countryList?.filter(
      (el) => el?.name === addressData.country,
    );
    if (filterObj && filterObj[0]) {
      filterObj && setCountryToken(filterObj[0]?.token);
      getStatesList(filterObj[0]?.id, filterObj[0]?.token);
    }

    try {
      const countryId = filterObj && filterObj[0]?.id;
      const countryToken = filterObj && filterObj[0]?.token;
      if (countryId) {
        // Load states for this country
        await getStatesList(countryId, countryToken);
        // Get cached states and find matching state
        const allCachedStates =
          await masterDataRepository.getStatesFromCache(null);
        const filteredStates = allCachedStates.filter((s) => {
          const stateData = s.data || s;
          return (
            stateData?.country_id === countryId || s.country_id === countryId
          );
        });
        let filterObj1 = filteredStates.filter((el) => {
          const stateData = el.data || el;
          return (stateData?.name || el.name) === state;
        });
        if (filterObj1 && filterObj1?.length > 0) {
          const stateData = filterObj1[0].data || filterObj1[0];
          const stateId = stateData?.id || filterObj1[0]?.id;
          const stateToken = stateData?.token || filterObj1[0]?.token;
          filterObj1 && setstateToken(stateToken);
          if (stateId) {
            getCityList(stateId, stateToken);
          }
        }
      }
    } catch (error) {
      // Handle errors here
      console.error(error);
    }
  };
  const handleChatStatusConfirmation = (chatState) => {
    setChatConfirmationDialog((pre) => ({
      ...pre,
      open: true,
    }));
  };
  const closeChatModule = () => {
    getEveryBidsData(rfqToken);
    setChatConfirmationDialog((pre) => ({
      ...pre,
      open: false,
    }));
  };

  const chatStateChage = async (chatState, token) => {
    setLoadingState(true);
    await axios({
      url: `${API_ENDPOINT.rfq_chat_box}`,
      method: "POST",
      data: {
        disable: !chatState,
        rfq_token: token,
        vendor_token: timeLineVendorData?.token,
      },
      headers: {
        Authorization: `Bearer ${auth_token}`,
      },
    })
      .then((res) => {
        openViewTimeLineModal("", timeLineVendorData);
        setLoadingState(false);
        //reset state
        setChatConfirmationDialog((prevStatus) => ({
          isClosedChat: false,
          open: false,
        }));
      })
      .catch((err) => {
        console.log(err);
        setLoadingState(false);
        //maintain btn state close modal
        setChatConfirmationDialog((prevStatus) => ({
          ...prevStatus,
          open: false,
        }));
      });
  };

  const handleOpenVendorPopup = () => {
    setSelectedbids(false);
    setOpenVendorPopup(true);
    setPageNumber(1);
    GetAllBidsData(1, rfqToken);
  };

  const handleCloseVendorPopup = () => {
    setOpenVendorPopup(false);
    setSelectedbids(true);
  };

  // user message section

  const [getuserlist, setUserList] = useState();
  const [userPageNumber, setUserPageNumber] = useState(1);
  const [userPaginationData, setUserPaginationData] = useState();
  const userItemsPerPage = 10;

  const [userSearchQuery, setUserSearchQuery] = useState("");

  const filteredUserList = useMemo(() => {
    if (!Array.isArray(getuserlist)) {
      return [];
    }
    if (!userSearchQuery.trim()) {
      return getuserlist;
    }
    const q = userSearchQuery.trim().toLowerCase();
    return getuserlist.filter((u) => {
      const name = `${u?.first_name || ""} ${u?.last_name || ""}`
        .trim()
        .toLowerCase();
      return (
        name.includes(q) ||
        (u?.email || "").toLowerCase().includes(q) ||
        (u?.department || "").toString().toLowerCase().includes(q) ||
        (u?.role || "").toString().toLowerCase().includes(q)
      );
    });
  }, [getuserlist, userSearchQuery]);

  const userTotalPages =
    filteredUserList.length > 0
      ? Math.ceil(filteredUserList.length / userItemsPerPage)
      : userPaginationData?.page_count || 0;

  const userTotalItems =
    filteredUserList.length > 0
      ? filteredUserList.length
      : userPaginationData?.total_items ||
        userPaginationData?.total_count ||
        (userPaginationData?.page_count
          ? userPaginationData.page_count * userItemsPerPage
          : 0);

  const displayedUserList = filteredUserList.slice(
    (userPageNumber - 1) * userItemsPerPage,
    userPageNumber * userItemsPerPage,
  );

  const [getusermessagemodal, setUserMessageModal] = useState(false);

  const [getuserlistpopup, setUserListPopup] = useState(false);

  const [getusererrormsg, setUserErrorMsg] = useState(false);

  const [getuserinput, setUserInput] = useState({
    message: "",
  });

  const [getmessagebtnstatus, setMessageBtnStatus] = useState(false);
  const [getsuccesspopup, setSuccessPopup] = useState(false);

  const [getuserpopupherotext, setUserPopupHeroText] = useState("");

  const [getuserdescpopup, setUserDescPopup] = useState("");

  const [viewUserTimeLine, setViewUserTimeLine] = useState(false);
  const [viewUserTimeLineData, setViewUserTimeLineData] = useState([]);
  const [timeLineUserData, setTimeLineUserData] = useState(null);

  const [getuserfileupload, setUserFileUpload] = useState([]);

  const getAllUserList = async () => {
    // Try cache first when offline
    if (!shouldMakeAPICall(auth_token, buyer_token)) {
      console.log("📴 Offline - loading user list from cache");
      try {
        const cachedUsers = await masterDataRepository.getUsersFromCache();
        if (cachedUsers && cachedUsers.length > 0) {
          console.log(`📦 Loaded ${cachedUsers.length} users from cache`);
          // Filter users for this RFQ context if needed
          const filteredUsers = cachedUsers.filter(
            (user) => user.role === "User" && user.token !== buyer_token,
          );
          setUserList(filteredUsers);
          // Set pagination data for cached users
          setUserPaginationData({
            total_items: filteredUsers.length,
            page_count: Math.ceil(filteredUsers.length / 10),
            current_page: userPageNumber,
            current_page_count: filteredUsers.length,
          });
          setUserTableProps({
            ...userTableProps,
            isLoading: false,
            errorMessage: "", // No error when using cache
          });
          return;
        } else {
          console.log("⚠️ No cached users found");
          setUserList([]);
          setUserPaginationData({});
          setUserTableProps({
            ...userTableProps,
            isLoading: false,
            errorMessage: "", // No error - just empty data
          });
          return;
        }
      } catch (error) {
        console.error("Error loading users from cache:", error);
        setUserList([]);
        setUserPaginationData({});
        setUserTableProps({
          ...userTableProps,
          isLoading: false,
          errorMessage: "", // No error - just empty data
        });
        return;
      }
    }

    // Online: use fetchPagedData
    const body = new FormData();
    body.append("page", userPageNumber);
    body.append("buyer_token", buyer_token);
    body.append("page_size", 10);

    fetchPagedData({
      pageNumber: userPageNumber,
      endpoint: `${API_ENDPOINT.all_user_list}`,
      auth_token: auth_token,
      setData: setUserList,
      setPaginationData: setUserPaginationData,
      tableProps: userTableProps,
      setTableProps: (props) => {
        // Don't show network errors when offline - use cache silently
        if (
          props.errorMessage &&
          props.errorMessage.includes("Network error")
        ) {
          // Fallback: bind from IndexedDB (db.users) on network error
          masterDataRepository.getUsersFromIndexedDB().then((cachedUsers) => {
            if (cachedUsers && cachedUsers.length > 0) {
              console.log("📦 Using users from IndexedDB due to network error");
              const filteredUsers = cachedUsers.filter(
                (user) => user.role === "User" && user.token !== buyer_token,
              );
              setUserList(filteredUsers);
              setUserPaginationData({
                total_items: filteredUsers.length,
                page_count: Math.ceil(filteredUsers.length / 10),
                current_page: userPageNumber,
                current_page_count: filteredUsers.length,
              });
              setUserTableProps({
                ...userTableProps,
                isLoading: false,
                errorMessage: "", // Clear error - using cache
              });
            } else {
              setUserTableProps({
                ...props,
                errorMessage: "", // Clear error even if no cache
              });
            }
          });
        } else {
          setUserTableProps({
            ...props,
            errorMessage: sanitizeErrorMessage(props?.errorMessage),
          });
        }
      },
      allData: true,
      bodyData: body,
    });
  };

  const userHeadings = [
    { label: "Name", field: "first_name" },
    { label: "Email", field: "email" },
    { label: "Department", field: "department" },
    { label: "Role", field: "role" },
  ];

  useEffect(() => {
    getAllUserList();
  }, [userPageNumber]);

  // useEffect(() => {
  //   const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
  //   if (!chatActionRaw) return;

  //   const { action, pr_code } = JSON.parse(chatActionRaw);

  //   sessionStorage.removeItem("CHAT_ACTION");

  //   if (
  //     (action === "create_rfq_from_pr" || action === "send_rfq_to_vendors") &&
  //     pr_code
  //   ) {
  //     openEditRFQ();

  //     setRequestNumber({
  //       value: pr_code,
  //       isChanged: true,
  //       isValid: true,
  //     });

  //     return;
  //   }
  // }, []);

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, rfq_code } = JSON.parse(chatActionRaw);

    if (!RFQData || RFQData.length === 0) return;

    if (
      action !== "create_rfq_from_pr" &&
      action !== "send_rfq_to_vendors" &&
      action !== "track_rfq_responses" &&
      action !== "open_specific_rfq" &&
      action !== "search_rfq" &&
      action !== "export_rfq"
    ) {
      return;
    }

    // download

    if (action === "export_rfq") {
      downloadFile({
        key: "org_token",
        value: buyer_token,
        fileNameProp: "RFQ Data",
        outputFormat: "CSV",
        API_ENDPOINT: API_ENDPOINT.buyer_rfq_csv,
        authToken: auth_token,
        setLoadingState: setLoadingStateDwnload,
        rfqData: true,
      });
    }

    const safePrCode = rfq_code?.toString().trim();
    if (!safePrCode) {
      console.warn("Missing pr_code in CHAT_ACTION");
      sessionStorage.removeItem("CHAT_ACTION");
      return;
    }

    const rfq = RFQData.find((r) => {
      if (!r?.rfq_code) return false;

      const parts = r.rfq_code.split("/").map((p) => p.trim());

      return (
        parts[0]?.toLowerCase() === safePrCode.toLowerCase() || // PR-259
        parts[parts.length - 1] === safePrCode // 62553
      );
    });

    if (!rfq?.token) {
      console.warn("RFQ not found for:", safePrCode);
      return;
    }
    if (action === "create_rfq_from_pr") {
      openUpdateRFQModal(rfq.token);
    }

    if (action === "track_rfq_responses") {
      openViewRFQ(rfq.token);
    }

    if (action === "open_specific_rfq") {
      openViewRFQ(rfq.token);
    }

    if (action === "search_rfq") {
      console.log(rfq_code);
      setSearchQuery(rfq_code);
    }

    sessionStorage.removeItem("CHAT_ACTION");
  }, [RFQData]);

  const openuserMessageModal = () => {
    setUserMessageModal(true);
    setOpenForm({
      open: true,
      loading: false,
      errorMessage: "",
    });
  };

  const viewUserMessageHeading = (
    <HeaderTitle
      titleText={"Send Message" || <MoreHoriz sx={{ fontSize: "30px" }} />}
      customclass={classes.heading_pop_pup}
    />
  );

  const viewListUsers = [
    <>
      <p className={classes.heading_sub_text}>
        You can send messages to multiple Users
      </p>

      <DTextInput
        label={"Search Users"}
        size={"100%"}
        name={"user_search"}
        placeholder={"Search by name, email, department, role"}
        value={userSearchQuery}
        onChange={(e) => setUserSearchQuery(e.target.value)}
      />

      {userSearchQuery && (
        <p style={{ marginTop: "6px", fontSize: "12px", color: "#6b7280" }}>
          Showing results for "{userSearchQuery}"
        </p>
      )}

      <DataTable
        headings={userHeadings}
        tableData={displayedUserList}
        tableSize={"100%"}
        errorMessage={tableProps.errorMessage}
        isLoading={tableProps.isLoading}
        selection={true}
        customClass={classes.fixedHeader}
        hasBidIteration={true}
        selectedRowsList={handleSeletedRowsListMessage}
        setSortingColumnName={setSortingColumnName}
        sortingColumnName={sortingColumnName}
        setSortingOrder={setSortingOrder}
        sortingOrder={sortingOrder}
        actionButtons={viewTextActionButtons}
        checkboxSelection={true}
        sendMessage={getusermessagemodal}
      />
      {getusererrormsg && (
        <p className={classes.error_msg}>Please select the vendors</p>
      )}
    </>,
  ];

  const closeMainModelBtn = () => {
    setUserMessageModal(false);
    setSelectedRows([]);
  };

  const continueBtn = () => {
    if (selectedRows.length > 0) {
      setUserListPopup(true);
      setUserErrorMsg(false);
    } else {
      setUserErrorMsg(true);
    }
  };

  const closeMainMessageModal = () => {
    setUserListPopup(false);
    setUserErrorMsg(false);
  };

  const handleUserTextArea = (evt) => {
    const inputVal = evt.target.value;
    setUserInput({ ...getuserinput, message: inputVal });
  };

  const userMessageActionBnt = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={closeMainModelBtn}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={"Continue"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={continueBtn}
    />,
  ];

  const handleUserSendMessage = async () => {
    setMessageBtnStatus(true);

    const formData = new FormData();

    formData.append("sender_token", AdminData?.user_token);
    formData.append("sender_role", AdminData?.role);
    formData.append("receiver_token", selectedRows);
    formData.append("rfq_token", rfqToken);
    formData.append("message", getuserinput.message);

    // const requestData = {
    //   sender_token: AdminData?.user_token,
    //   sender_role: AdminData?.role,
    //   receiver_token: selectedRows,
    //   rfq_token: rfqToken,
    //   message: getuserinput.message,
    //   attachments: []
    // };

    if (getuserfileupload) {
      getuserfileupload.forEach((file) => {
        formData.append("rfq_doc", file);
      });
    }

    try {
      const res = await axios.post(API_ENDPOINT.user_chat_message, formData, {
        headers: {
          Authorization: `Bearer ${auth_token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res?.data?.message == "Message Sent") {
        setMessageBtnStatus(false);
        setSuccessPopup(true);
        setUserInput({ ...getuserinput, message: "" });
        setUserPopupHeroText("Message Sent Successfully!!");
        setSelectedRows([]);
        setUserDescPopup(res?.data?.message);
      }
    } catch (error) {
      console.error("Error:", error.response?.data || error.message);
    }
  };

  const sentUserMessage = () => {
    setUserListPopup(false);
    setSuccessPopup(false);
  };

  const userMainModelActionBtn = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={closeMainMessageModal}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <DButton
      label={getmessagebtnstatus ? "Sending" : "Send Message"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleUserSendMessage}
    />,
  ];

  const handleuserFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUserFileUpload((prefiles) => [...prefiles, file]);
    }
  };

  const handleUserRemoveFile = (index) => {
    setUserFileUpload((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const userMessageTextArea = [
    <div>
      <p className={classes.heading_sub_text}>Please enter your message</p>
      <TextArea
        maxLength="2000"
        style={{ width: "100 %" }}
        title="send_message"
        name="send_message"
        value={getuserinput.message}
        rows={7}
        placeholder="Type your message here..."
        onChange={handleUserTextArea}
      />
      <Attachment
        msg_file={getuserfileupload}
        handleFileChange={handleuserFileChange}
        handleRemoveFile={handleUserRemoveFile}
      />
    </div>,
  ];

  const openUserMessageTimeline = async (unique_id, rowData) => {
    setTimeLineUserData(rowData);

    const rfqId = uniqueData?.id;
    if (rfqId == null || rfqId === "") {
      console.warn(
        "RFQ complement: uniqueData.id missing; user timeline filter may show no messages. Ensure get_individual_RFQ / buyer_rfq_full_view returns id.",
      );
    }

    const formData = new FormData();
    formData.append("sender_token", buyer_token);
    formData.append("receiver_token", rowData.token);

    try {
      const res = await axios.post(API_ENDPOINT.get_chat_messages, formData, {
        headers: {
          Authorization: `Bearer ${auth_token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setOpenForm({ open: true, loading: false, errorMessage: "" });
      const raw = Array.isArray(res.data) ? res.data : [];
      let filteredresults = raw.filter(
        (items) =>
          items.rfq_id != null &&
          rfqId != null &&
          String(items.rfq_id) === String(rfqId),
      );
      setViewUserTimeLineData(filteredresults);
    } catch (err) {
      console.error("Error:", err?.response?.data || err);
      setOpenForm({
        open: false,
        loading: false,
        errorMessage:
          (err?.response?.data && typeof err?.response?.data === "object"
            ? Object.values(err?.response?.data)[0]
            : null) ||
          err?.message ||
          "Failed to load chat messages",
      });
    }

    setViewRFQ(false);
    setViewUserTimeLine(true);
  };

  // Quick RFQ

  const [quickRFQ, SetQuickRFQ] = useState(false);
  const [quickRfqCodeForHeader, setQuickRfqCodeForHeader] = useState("");

  const openQuickRFQ = () => {
    SetQuickRFQ((prev) => !prev);
    setRFQMain(false);
  };

  const closeQuickRFQ = () => {
    SetQuickRFQ((prev) => !prev);
    setQuickRfqCodeForHeader("");
    setRFQMain(true);
  };

  const getTimelineBadgeClass = (item = {}) => {
    const senderRole = item.sender_role?.toLowerCase();
    const receiverRole = item.receiver_role?.toLowerCase();
    const baseRole = item.role?.toLowerCase();

    if (
      senderRole === "vendor admin" ||
      receiverRole === "vendor admin" ||
      baseRole === "buyer"
    ) {
      return classes.vendorAdmin;
    }

    if (
      baseRole === "user" ||
      senderRole === "user" ||
      receiverRole === "user"
    ) {
      return classes.user;
    }

    if (receiverRole === "buyer" || senderRole === "buyer") {
      return classes.buyer;
    }

    return classes.defaultcolor;
  };

  const getTimelineDisplayName = (item = {}) => {
    if (item.sender_role) {
      return item.sender_role.toLowerCase() === "vendor admin"
        ? "Vendor"
        : item.sender_role;
    }

    if (item.name) {
      return item.name;
    }

    if (item.company_name) {
      return item.company_name;
    }

    if (item.sender_name) {
      return item.sender_name;
    }

    return "Unknown Sender";
  };

  const getTimelineTimestamp = (item = {}) => {
    const timestamp =
      item.created_raw || item.created || item.created_at || item.createdOn;

    if (!timestamp || typeof timestamp !== "string") {
      return "";
    }

    return timestamp.includes("T") ? timestamp.split("T")[0] : timestamp;
  };

  const getTimelineCreatedMs = (item = {}) => {
    const raw =
      item.created instanceof Date
        ? item.created
        : item.created_raw || item.created || item.created_at || item.createdOn;
    if (raw instanceof Date) return raw.getTime();
    const parsed = Date.parse(String(raw || ""));
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const getTimelineSearchHaystack = (item = {}) => {
    const docNames = Array.isArray(item.document)
      ? item.document.map((d) => d?.name || d?.url).filter(Boolean)
      : [];

    const parts = [
      item.message,
      item.sender_role,
      item.role,
      item.receiver_role,
      item.name,
      item.sender_name,
      item.company_name,
      item.designation,
      item.created_raw,
      ...docNames,
    ]
      .filter(Boolean)
      .map((v) => String(v).toLowerCase());

    return parts.join(" ");
  };

  const filterAndSortTimeline = (timelineData = [], query = "") => {
    if (!Array.isArray(timelineData) || timelineData.length === 0) return [];
    const q = String(query || "")
      .trim()
      .toLowerCase();

    const filtered =
      q === ""
        ? [...timelineData]
        : timelineData.filter((item) =>
            getTimelineSearchHaystack(item).includes(q),
          );

    filtered.sort((a, b) => getTimelineCreatedMs(a) - getTimelineCreatedMs(b));
    return filtered;
  };

  const filteredVendorTimelineData = useMemo(
    () => filterAndSortTimeline(viewTimeLineData, searchQuery3),
    [viewTimeLineData, searchQuery3],
  );

  const filteredUserTimelineData = useMemo(
    () => filterAndSortTimeline(viewUserTimeLineData, searchQuery3),
    [viewUserTimeLineData, searchQuery3],
  );

  const renderMaskedAttachmentList = (
    item,
    keyPrefix = "masked-doc",
    tooltipTitle = "Documents can be viewed once the bidding period has ended",
  ) => {
    if (!Array.isArray(item?.document) || item.document.length === 0) {
      return null;
    }

    return (
      <div className={classes.box_loyout_right}>
        <div className={classes.padding_box}>
          {item.document.map((doc, docIndex) => (
            <p
              key={`${keyPrefix}-${docIndex}`}
              className={classes.right_progrop}
            >
              <Tooltip
                title={tooltipTitle}
                placement="top"
                slotProps={{ tooltip: { sx: { fontSize: "13px" } } }}
              >
                <span
                  style={{
                    color: "#9ca3af",
                    cursor: "not-allowed",
                    pointerEvents: "auto",
                    textDecoration: "none",
                  }}
                >
                  {doc?.name || "Attachment"}
                </span>
              </Tooltip>
            </p>
          ))}
        </div>
      </div>
    );
  };

  const currentVendorBidDocuments = useMemo(() => {
    const activeVendorTokens = [
      timeLineVendorData?.token,
      timeLineVendorData?.vendor_token,
      timeLineVendorData?.vendorToken,
    ]
      .map((token) => String(token || "").trim())
      .filter(Boolean);
    const activeVendorEmail = String(
      timeLineVendorData?.vendor_email ||
        timeLineVendorData?.company_official_email ||
        "",
    )
      .trim()
      .toLowerCase();
    const bidSource = [
      ...(Array.isArray(bulkBidsData) ? bulkBidsData : []),
      ...(Array.isArray(bidsData) ? bidsData : []),
    ];

    if (
      (activeVendorTokens.length === 0 && !activeVendorEmail) ||
      bidSource.length === 0
    ) {
      return [];
    }

    return bidSource
      .filter((bid) => {
        const bidVendorToken = String(
          bid?.vendor_token || bid?.token || bid?.vendorToken || "",
        ).trim();
        const bidVendorEmail = String(
          bid?.vendor_email || bid?.company_official_email || "",
        )
          .trim()
          .toLowerCase();

        return (
          Boolean(bid?.document) &&
          (activeVendorTokens.includes(bidVendorToken) ||
            (activeVendorEmail && bidVendorEmail === activeVendorEmail))
        );
      })
      .filter(
        (bid, index, matchingBids) =>
          matchingBids.findIndex(
            (matchingBid) => matchingBid?.document === bid?.document,
          ) === index,
      )
      .map((bid, bidIndex) => ({
        key: `bid-${bidIndex}`,
        item: {
          document: [
            {
              url: bid.document,
              name: bid.document.split("/").pop(),
            },
          ],
        },
      }));
  }, [bidsData, bulkBidsData, timeLineVendorData]);

  const renderTimelineCards = (timelineData = [], disableAttachments = false) => {
    if (!Array.isArray(timelineData) || timelineData.length === 0) {
      return null;
    }

    return timelineData.map((item, index) => (
      <div
        className={classes.rfq_time_line_contant}
        key={`${item?.id || index}-${
          item?.created_raw || item?.created || index
        }`}
      >
        <div className={classes.time_line_box}>
          <div className={classes.time_line_box_loyout}>
            <div
              className={`${classes.box_loyout_left} ${getTimelineBadgeClass(
                item,
              )}`}
            >
              <div className={classes.padding_box}>
                <p className={classes.left_titel}>
                  {getTimelineDisplayName(item)}
                </p>
                {item?.designation && (
                  <p style={{ fontSize: "12px" }}>{item.designation}</p>
                )}
              </div>
            </div>
            <div className={classes.box_loyout_right}>
              <div className={classes.padding_box}>
                <p className={classes.left_titel}>Message</p>
                <p className={classes.right_progrop}>{item.message}</p>
                <p className={classes.right_progrop_date_time}>
                  {getTimelineTimestamp(item)}
                </p>
              </div>
              {disableAttachments ? (
                renderMaskedAttachmentList(
                  item,
                  `timeline-${item?.id || index}`,
                )
              ) : (
                <AttachmentList item={item} />
              )}
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const rfqCodeForHeaderRaw =
    editRFQForm && uniqueData ? uniqueData?.rfq_code : null;
  const rfqCodeForHeader =
    rfqCodeForHeaderRaw != null && String(rfqCodeForHeaderRaw).trim() !== ""
      ? String(rfqCodeForHeaderRaw)
      : "";

  // Empty-state text (easy to change)
  const EMPTY_STATE_TEXT = {
    noVendorsSelected: "No vendor selected for the RFQ.",
    bidNotSubmitted: "Bid not submitted.",
  };

  const hasSelectedVendorsForRfq = (() => {
    const sv = uniqueData?.select_vendor;
    if (Array.isArray(sv))
      return sv.filter((v) => String(v || "").trim() !== "").length > 0;
    return String(sv || "").trim() !== "";
  })();

  // "Bid submitted" is based on the bids table (bidsData). bulkBidsData can be used for
  // selection/status logic and may exist even when there are no submitted bids.
  const hasSubmittedBids = Array.isArray(bidsData) && bidsData.length > 0;
  const isSealedBidRFQ = normalizeBooleanValue(
    uniqueData?.sealed_bid ?? uniqueData?.sealedBid,
  );
  const lockedBidCountRaw =
    uniqueData?.locked_bid_count ?? uniqueData?.lockedBidCount;
  const lockedBidCountValue = Number(lockedBidCountRaw);
  const hasLockedBidCount =
    lockedBidCountRaw !== undefined &&
    lockedBidCountRaw !== null &&
    String(lockedBidCountRaw).trim() !== "" &&
    Number.isFinite(lockedBidCountValue);
  const shouldShowSealedBidNotice =
    isSealedBidRFQ && (!hasLockedBidCount || lockedBidCountValue > 0);
  const sealedBidNotice = shouldShowSealedBidNotice
    ? "Sealed Bid: Quotations cannot be viewed or opened until the bid closes."
    : "";
  const sealedBidCloseLabel =
    uniqueData?.next_unlock_at && dayjs(uniqueData.next_unlock_at).isValid()
      ? dayjs(uniqueData.next_unlock_at).format("DD MMM YYYY, hh:mm A")
      : `${formatBidDate(uniqueData?.bid_to_date)}${
          localTime && localTime !== "-" ? `, ${localTime}` : ""
        }`;
  const sealedBidRemainingLabel =
    uniqueData?.next_unlock_at && dayjs(uniqueData.next_unlock_at).isValid()
      ? (() => {
          const minutes = dayjs(uniqueData.next_unlock_at).diff(dayjs(), "minute");
          if (minutes <= 0) return "";
          const days = Math.floor(minutes / 1440);
          const hours = Math.floor((minutes % 1440) / 60);
          const mins = minutes % 60;
          return `${days ? `${days}d ` : ""}${hours}h ${mins}m`;
        })()
      : "";
  const sealedActionLockIcon = shouldShowSealedBidNotice ? (
    <LockOutlined sx={{ fontSize: "1.6rem" }} />
  ) : null;
  const sealedLockedActionClass = shouldShowSealedBidNotice
    ? `${classes.rfqActionBtn} ${classes.sealedLockedActionBtn}`
    : classes.rfqActionBtn;
  const sealedBidNoticePanel = shouldShowSealedBidNotice ? (
    <div className={classes.sealedBidPanel}>
      <div className={classes.sealedBidVisual}>
        <div className={classes.sealedBidShield}>
          <span className={classes.sealedBidOrbit} />
          <span className={classes.sealedBidOrbitSmall} />
          <span className={classes.sealedBidShieldFace}>
            <span className={classes.sealedBidShieldFacet} />
            <LockOutlined className={classes.sealedBidLockIcon} />
          </span>
        </div>
      </div>

      <div className={classes.sealedBidPanelMain}>
        <div className={classes.sealedBidTitleRow}>
          <h3>Sealed Bid Active</h3>
          <span>
            <LockOutlined />
            Sealed
          </span>
        </div>
        <p>{sealedBidNotice}</p>
        <div className={classes.sealedBidCloseRow}>
          <EventOutlined />
          <span>Bid closes on</span>
          <strong>{sealedBidCloseLabel}</strong>
        </div>
      </div>

      <div className={classes.sealedBidPanelInfo}>
        <h4>What this means?</h4>
        <p>
          <LockOutlined />
          Supplier quotes are encrypted and hidden
        </p>
        <p>
          <AccessTimeOutlined />
          Quotations become available after bid close
        </p>
        <p>
          <VerifiedUserOutlined />
          This keeps the RFQ process fair and transparent
        </p>
        {sealedBidRemainingLabel && (
          <div className={classes.sealedBidRemaining}>
            Time remaining: <strong>{sealedBidRemainingLabel}</strong>
          </div>
        )}
      </div>
    </div>
  ) : null;
  const noBidsMessage = hasSelectedVendorsForRfq
    ? EMPTY_STATE_TEXT.bidNotSubmitted
    : EMPTY_STATE_TEXT.noVendorsSelected;

  const sendUnregisteredVendorInterestMail = async (m) => {
    const vendorEmail = String(
      m?.vendor_details?.vendor_email || m?.vendor_email || m?.email || "",
    ).trim();
    const itemName = String(m?.item_name || m?.name || "").trim();
    const rfqTokenValue = String(rfqToken || "").trim();

    if (!vendorEmail || !itemName || !rfqTokenValue) {
      setPopupHeroText("Error");
      setPopupMessage(
        "Unable to send vendor interest email. Missing RFQ, vendor, or item details.",
      );
      setOpen(true);
      return;
    }

    const requestKey = `${vendorEmail}::${itemName}`;
    setMailSendingToken(requestKey);

    try {
      const response = await axios.post(
        API_ENDPOINT.send_unregistered_vendor_interest_mail,
        {
          buyer_token,
          rfq_token: rfqTokenValue,
          vendor_email: vendorEmail,
          item_name: itemName,
          message: "We are interested in your product.",
        },
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        },
      );

      setPopupHeroText("Success");
      setPopupMessage(
        response?.data?.response || "Vendor interest email sent successfully.",
      );

      setOpen(true);
    } catch (error) {
      console.log(error);

      setPopupHeroText("Error");
      setPopupMessage(
        error?.response?.data?.response ||
          "Failed to send vendor interest email.",
      );

      setOpen(true);
    } finally {
      setMailSendingToken("");
    }
  };

  return (
    <div className={classes.users_tab_wrapper}>
      <div className={classes.users_topHeader}>
        <div className={`${classes.lhs}`} style={{ marginLeft: "1.5rem" }}>
          {quickRFQ ? (
            <div className={classes.quickrfq_header}>
              <HeaderTitle
                titleText={
                  quickRfqCodeForHeader
                    ? `Xpress RFQ - RFQ ID: ${quickRfqCodeForHeader}`
                    : "Xpress RFQ"
                }
                customclass={classes.dashHead}
              />
              <DButton
                label={"BACK"}
                btnHeight="4rem"
                btnWidth={"12rem"}
                buyerBtn={true}
                onClick={closeQuickRFQ}
              />
            </div>
          ) : (
            <HeaderTitle
              titleText="RFQ Events"
              customclass={classes.dashHead}
            />
          )}

          {/* quickRFQ ?

              (<div>
                <button>Back</button>
                <HeaderTitle titleText="Quick RFQ" customclass={classes.dashHead} /> :
              </div>)


              (< HeaderTitle titleText="RFQ" customclass={classes.dashHead} />) */}
        </div>

        {viewRFQComparedTable && (
          <div className={classes.comparedResultHeaderBack}>
            <DButton
              label={"BACK"}
              btnHeight="4rem"
              btnWidth={"12rem"}
              buyerBtn={true}
              onClick={() => {
                backViewIndividualRFQ();
              }}
            />
          </div>
        )}

        {/* <div className={`${classes.notificationBar}`}>
          <DateBar />
          <NotificationBell />
          <ProfileCard
            buyerBtn={true}
            buyerBtnOutline={true}
            profilePath={"/Buyer_dashboard/My_profile"}
          />
        </div> */}
      </div>

      <div
        className={`${classes.search_add_wrapper} ${
          viewRFQ || newRFQForm || editRFQForm ? classes.formActionBar : ""
        } ${viewTimeLine || viewUserTimeLine ? classes.edgeActionBar : ""}`}
        style={{ marginLeft: "1.5rem" }}
      >
        {viewRFQ || RFQMain || viewTimeLine || viewUserTimeLine ? (
          <div
            className={`${classes.flex} ${classes.flex_align_end}  ${classes.search_add_wrapper_content_left}`}
          >
            {RFQMain && (
              <SearchBar
                value={searchQuery}
                onChange={(query) => {
                  setSearchQuery(query);
                  setPageNumber(1);
                }}
                placeholder="Search RFQ ID, item name, item code..."
              />
            )}
            {/* {viewRFQ && (
              <SearchBar
                value={searchQuery2}
                onChange={(query) => {
                  setSearchQuery2(query);
                  setPageNumber(1);
                }}
              />
            )} */}
            {(viewTimeLine || viewUserTimeLine) && (
              <SearchBar
                value={searchQuery3}
                onChange={(query) => {
                  setSearchQuery3(query);
                  setPageNumber(1);
                }}
                placeholder="Search messages..."
              />
            )}

            {RFQMain && (
              <div className={`${classes.flex}`}>
                <DDateInput
                  customClass={classes.dateFilters}
                  type={"date"}
                  label={"Start Date"}
                  disableFuture={true}
                  onChange={(e) => {
                    setPageNumber(1);
                    // If end date is already selected and becomes invalid (before start date), reset it.
                    if (e && endDateSearchQuery?.value) {
                      const start = new Date(e);
                      const end = new Date(endDateSearchQuery.value);
                      if (
                        !Number.isNaN(start.getTime()) &&
                        !Number.isNaN(end.getTime()) &&
                        end < start
                      ) {
                        setEndDateSearchQuery({ isValid: true, value: "" });
                      }
                    }
                    setStartDateSearchQuery({
                      isValid: e ? emptyCheck(e) : true,
                      value: e,
                    });
                  }}
                  value={startDateSearchQuery}
                  error={!startDateSearchQuery?.isValid}
                  errorMsg={"From date is required"}
                />
                <DDateInput
                  customClass={classes.dateFilters}
                  type={"date"}
                  label={"End Date"}
                  disableFuture={true}
                  fromDate={startDateSearchQuery.value}
                  onChange={(e) => {
                    setPageNumber(1);
                    setEndDateSearchQuery({
                      isValid: e ? emptyCheck(e) : true,
                      value: e,
                    });
                  }}
                  value={endDateSearchQuery}
                  error={!endDateSearchQuery?.isValid}
                  errorMsg={"To date is required"}
                />
              </div>
            )}
          </div>
        ) : (
          <>
            {viewTimeLine || quickRFQ || viewRFQComparedTable ? (
              ""
            ) : (
              newRFQForm || editRFQForm ? (
                <div className={classes.newRfqHeader}>
                  <span className={classes.newRfqHeaderIcon}>
                    <AttachmentOutlined />
                  </span>
                  <div>
                    <h1>{editRFQForm ? "Edit RFQ" : "New RFQ"}</h1>
                    <p>
                      {editRFQForm
                        ? `${rfqCodeForHeader ? `RFQ ID: ${rfqCodeForHeader}` : "Update Request for Quotation"}`
                        : "Create a new Request for Quotation"}
                    </p>
                  </div>
                </div>
              ) : (
                <HeaderTitle
                  titleText={
                    editRFQForm
                      ? `Edit RFQ${rfqCodeForHeader ? ` - RFQ ID: ${rfqCodeForHeader}` : ""}`
                      : "New RFQ"
                  }
                  customclass={classes.dashHead}
                />
              )
            )}
          </>
        )}

        {(viewRFQ || newRFQForm || editRFQForm) && (
          <div className={classes.formBackAction}>
            <DButton
              label={"BACK"}
              btnHeight="4rem"
              btnWidth={"12rem"}
              buyerBtn={true}
              display={"flex"}
              onClick={() => {
                openRFQMain();
              }}
              customWrapperClass={viewTimeLine ? classes.flex_end : ""}
            />
          </div>
        )}

        {(viewTimeLine || viewUserTimeLine) && (
          <div className={classes.rightAlignedAction}>
            <DButton
              label={"BACK"}
              btnHeight="4rem"
              btnWidth={"12rem"}
              buyerBtn={true}
              onClick={() => {
                openRFQMainTimeLine();
              }}
            />
          </div>
        )}

        {RFQMain && (
          <div className={classes.rhsButtons}>
            <FilterBar
              filterValue={statusFilter}
              onFilterChange={(value) => {
                setStatusFilter(value);
                setPage(0);
                setServerPage(1);
              }}
              options={[
                { value: "", label: "All" },
                { value: "open", label: "Open" },
                { value: "closed", label: "Closed" },
              ]}
            />
            <DropdownBtnOutlined
              label="DOWNLOAD AS"
              btnHeight="4rem"
              btnWidth="18rem"
              loadingState={loadingStateDwnload}
              disabled={RFQData?.length === 0}
              onClick={(fileFormat) => {
                downloadFile({
                  key: "org_token",
                  value: buyer_token,
                  fileNameProp: "RFQ Data",
                  outputFormat: fileFormat,
                  API_ENDPOINT: API_ENDPOINT.buyer_rfq_csv,
                  authToken: auth_token,
                  setLoadingState: setLoadingStateDwnload,
                  rfqData: true,
                });
              }}
              options={["CSV", "PDF"]}
            />

            <DButton
              labelImg={plusIcon}
              iconWidth="1rem"
              iconHeight="1rem"
              label={"NEW RFQ"}
              btnHeight="4rem"
              buyerBtn={true}
              onClick={openNewRFQ}
            />

            <DButton
              labelImg={plusIcon}
              iconWidth="1rem"
              iconHeight="1rem"
              label={"XPRESS RFQ"}
              btnHeight="4rem"
              buyerBtn={true}
              onClick={openQuickRFQ}
            />
          </div>
        )}
      </div>

      {RFQMain && (
        <>
          <div className={`${classes.d_dataTable} `}>
            <DataTable
              headings={headings}
              tableData={formattedRows}
              tableSize={"100%"}
              actionColumnWidth="10rem"
              stickyFirstColumn={true}
              fixedLayout={true}
              actions={true}
              errorMessage={tableProps.errorMessage}
              isLoading={tableProps.isLoading}
              viewBtn={true}
              editBtn={true}
              deleteBtn={true}
              viewTooltip="View"
              editTooltip="Edit"
              sorting={true}
              viewClick={openViewRFQ}
              editClick={openUpdateRFQModal}
              deleteClick={handleOpenDltConfirmation}
              setSortingColumnName={setSortingColumnName}
              sortingColumnName={sortingColumnName}
              setSortingOrder={setSortingOrder}
              sortingOrder={sortingOrder}
            />

            {/* Offline: client-side pagination. Online: server-side pagination. */}
            {!tableProps.isLoading && (
              <PaginantionComponent
                pageNumber={useClientSidePaging ? page + 1 : serverPage}
                setPageNumber={(value) => {
                  if (value === "") return;
                  const parsed = parseInt(value, 10);
                  if (Number.isNaN(parsed)) return;
                  if (useClientSidePaging) {
                    setPage(parsed - 1);
                  } else {
                    setServerPage(parsed);
                  }
                }}
                currentPage={useClientSidePaging ? page + 1 : serverPage}
                itemsPerPage={paginationCount}
                totalItems={
                  paginationCount > 0
                    ? Math.ceil(paginationCount / paginationRowsPerPage)
                    : 0
                }
                rowsPerPage={paginationRowsPerPage}
                rowsPerPageOptions={
                  useClientSidePaging
                    ? [5, 10, 25, 50]
                    : [paginationRowsPerPage]
                }
                onRowsPerPageChange={handleChangeRowsPerPage}
                previouPageClick={() => {
                  if (useClientSidePaging) {
                    if (page > 0) setPage((prev) => Math.max(0, prev - 1));
                  } else if (serverPage > 1) {
                    setServerPage((prev) => Math.max(1, prev - 1));
                  }
                }}
                nextPageClick={() => {
                  const totalPagesCount =
                    paginationCount > 0
                      ? Math.ceil(paginationCount / paginationRowsPerPage)
                      : 0;
                  if (useClientSidePaging) {
                    if (page + 1 < totalPagesCount) {
                      setPage((prev) =>
                        Math.min(totalPagesCount - 1, prev + 1),
                      );
                    }
                  } else if (serverPage < totalPagesCount) {
                    setServerPage((prev) =>
                      Math.min(totalPagesCount, prev + 1),
                    );
                  }
                }}
                disablePrevious={
                  useClientSidePaging ? page <= 0 : serverPage <= 1
                }
                disableNext={
                  useClientSidePaging
                    ? page + 1 >=
                      (paginationCount > 0
                        ? Math.ceil(paginationCount / paginationRowsPerPage)
                        : 0)
                    : serverPage >=
                      (paginationCount > 0
                        ? Math.ceil(paginationCount / paginationRowsPerPage)
                        : 0)
                }
              />
            )}
          </div>
        </>
      )}

      {quickRFQ && (
        <div className={classes.quickrfqcontainer}>
          <hr></hr>

          {/* <HeaderTitle
            customclass={classes.tabHeading}
            titleText={"RFQ Details"}
          /> */}

          {/* <p onClick={()=>smple()}>Arron</p> */}

          <QuickRFQ
            closeQuickRFQ={closeQuickRFQ}
            onRfqCodeChange={setQuickRfqCodeForHeader}
          />
        </div>
      )}

      {viewRFQ && (
        <>
          <div className={classes.tabsScreens}>
            <div className={classes.infoSection}>
              <HeaderTitle
                customclass={classes.tabHeading}
                titleText={"RFQ Details"}
              />

              <div className={classes.info}>
                {org_details.map((e, i) => (
                  <InfoLabel
                    key={i}
                    isLoading={loadingState}
                    label={e.label}
                    value={e.value}
                    size={e.size}
                  />
                ))}
              </div>
            </div>

            {(selectedDepartment || budgetConfigLoading || budgetConfigs.length > 0) && (
              <section className={classes.rfqBudgetViewSection}>
                <HeaderTitle customclass={classes.tabHeading} titleText="Budget Overview" />
                <div className={classes.rfqBudgetViewDepartment}>
                  <span>Department</span>
                  <strong>{selectedDepartment?.name || uniqueData?.department || "-"}</strong>
                </div>
                {budgetConfigLoading && (
                  <Typography className={classes.rfqBudgetLoading}>
                    Loading department budgets...
                  </Typography>
                )}
                {budgetConfigs.length > 0 && (
                  <div className={classes.rfqExpenseBudgetGrid}>
                    {[...budgetConfigs]
                      .sort((a, b) => {
                        const order = { CAPEX: 0, OPEX: 1 };
                        return (order[String(a?.expense_type || "").toUpperCase()] ?? 9) -
                          (order[String(b?.expense_type || "").toUpperCase()] ?? 9);
                      })
                      .map((budget) => {
                        const allocated = getBudgetNumber(budget?.allocated_amount);
                        const balance = getBudgetNumber(budget?.balance_amount);
                        const spent = Math.max(allocated - balance, 0);
                        return (
                          <article key={budget?.id || budget?.expense_type} className={classes.rfqExpenseBudgetCard}>
                            <div className={classes.rfqExpenseBudgetHeader}>
                              <div>
                                <strong>{budget?.expense_type || "Budget"}</strong>
                                <span>{budget?.purchase_type || "Purchase budget"}</span>
                              </div>
                              <span>{budget?.currency || ""}</span>
                            </div>
                            <div className={classes.rfqExpenseBudgetTotals}>
                              {[
                                ["Total Budget", allocated],
                                ["Budget Consumed", spent],
                                ["Budget Balance", balance],
                              ].map(([label, amount]) => (
                                <div key={label}>
                                  <span>{label}</span>
                                  <strong>{formatBudgetAmount(amount, budget?.currency)}</strong>
                                </div>
                              ))}
                            </div>
                            <div className={classes.rfqBudgetStages}>
                              {[
                                ["PR Available", "pr_available"],
                                ["PO Available", "po_available"],
                                ["GRN Available", "grn_available"],
                              ].map(([label, field]) => (
                                <div key={label}>
                                  <span>{label}</span>
                                  <strong>{formatBudgetAmount(budget?.[field], budget?.currency)}</strong>
                                </div>
                              ))}
                            </div>
                          </article>
                        );
                      })}
                  </div>
                )}
              </section>
            )}

            <div className={`${classes.d_dataTable_items}`}>
              <DataTable
                headings={headingsForViewItemsRFQ}
                stickyHead={true}
                tableFixedHeight={"400px"}
                tableData={RFQitemsListMapped}
                tableSize={"100%"}
                customClass={classes.dTable}
                setSortingColumnName={setSortingColumnName}
                sortingColumnName={sortingColumnName}
                setSortingOrder={setSortingOrder}
                sortingOrder={sortingOrder}
                requestRequote={requestRequote}
                viewQuotes={enableSelect}
                selectVendors={selectedbids}
              />
            </div>

            {shippingDetails.map((e, i) => (
              <InfoLabel
                key={i}
                isLoading={loadingState}
                // customClass={classes.desc}
                label={e.label}
                value={e.value}
                size={"98%"}
                maxLength={"350"}
              />
            ))}

            <div className={classes.infoSection}>
              {proposal_description.map((e, i) => (
                <InfoLabel
                  key={i}
                  isLoading={loadingState}
                  // customClass={classes.desc}
                  label={e.label}
                  value={e.value}
                  size={"98%"}
                  maxLength={"350"}
                />
              ))}
            </div>

            <div className={`${classes.infoSection}`}>
              <HeaderTitle
                customclass={classes.tabHeading}
                titleText={"Bidding Details"}
              />

              {sealedBidNoticePanel}

              <div className={classes.collaborationNoticeCard}>
                <div className={classes.collaborationNoticeContent}>
                  <div className={classes.collaborationNoticeIcon}>
                    <ForumOutlined />
                  </div>
                  <div className={classes.collaborationNoticeText}>
                    <h3>Important: RFQ Communication</h3>
                    <p>
                      All technical and commercial queries related to this RFQ
                      should be raised only through the Collaboration Tool.
                    </p>
                    <strong>
                      Please do not use email for RFQ-related communication.
                    </strong>
                  </div>
                </div>
                <button
                  type="button"
                  className={classes.collaborationNoticeButton}
                  onClick={sendMessages}
                >
                  <ForumOutlined />
                  <span>Open Collaboration Tool</span>
                  <ArrowForwardIosOutlined />
                </button>
              </div>

              <div className={`${classes.compareSection} ${classes.info}`}>
                <div className={`${classes.flex}`}>
                  {bidding_details.map((e, i) => {
                    return (
                      <InfoLabel
                        key={i}
                        isLoading={loadingState}
                        label={e.label}
                        value={e.value}
                        size={"20rem"}
                      />
                    );
                  })}
                </div>

                <div className={classes.rfqActionButtons}>
                  {requestRequote === false &&
                    enableSelect === false &&
                    selectedbids === false && (
                      <>
                        <DButton
                          iconWidth="1rem"
                          iconHeight="1rem"
                          label={"Message Supplier"}
                          disabled={false}
                          btnHeight="4rem"
                          btnWidth="max-content"
                          buyerBtn={true}
                          customClass={classes.rfqActionBtn}
                          onClick={sendMessages}
                        />

                        <DButton
                          iconWidth="1rem"
                          iconHeight="1rem"
                          label={"Message User"}
                          disabled={false}
                          btnHeight="4rem"
                          btnWidth="max-content"
                          buyerBtn={true}
                          customClass={classes.rfqActionBtn}
                          onClick={openuserMessageModal}
                        />
                      </>
                    )}
                  {requestRequote === false &&
                  enableSelect === false &&
                  selectedbids === false ? (
                    <>
                      {
                        <DButton
                          iconWidth="1rem"
                          iconHeight="1rem"
                          label={"Request Revised Quote"}
                          disabled={
                            shouldShowSealedBidNotice ||
                            !bidsData ||
                            bidsData?.length === 0 ||
                            hasSelectedBid === true ||
                            uniqueData?.bid_status?.toLowerCase() ===
                              "closed" ||
                            uniqueData?.bid_status?.toLowerCase() ===
                              "cancelled" ||
                            uniqueData?.bid_status?.toLowerCase() === "failed"
                          }
                          labelImg={sealedActionLockIcon}
                          btnHeight="4rem"
                          btnWidth="max-content"
                          buyerBtn={true}
                          customClass={sealedLockedActionClass}
                          onClick={openRequote}
                        />
                      }

                     

                      <DButton
                        iconWidth="1rem"
                        iconHeight="1rem"
                        disabled={
                          shouldShowSealedBidNotice ||
                          !bidsData ||
                          bidsData?.length === 0
                        }
                        // disabled={false}
                        label={"Quote Viewer"}
                        labelImg={sealedActionLockIcon}
                        btnHeight="4rem"
                        btnWidth="max-content"
                        buyerBtn={true}
                        customClass={sealedLockedActionClass}
                        // onClick={() => {
                        //   setEnableSelect(true);
                        // }}
                        onClick={openViewQuote}
                      />

                      {uniqueData?.item_status !== "False" && (
                        <DButton
                          iconWidth="1rem"
                          iconHeight="1rem"
                          disabled={
                            shouldShowSealedBidNotice ||
                            !bidsData ||
                            bidsData?.length === 0
                          }
                          label={"View Compared Result"}
                          labelImg={sealedActionLockIcon}
                          btnHeight="4rem"
                          btnWidth="max-content"
                          buyerBtn={true}
                          loadingState={loadingState}
                          customClass={sealedLockedActionClass}
                          onClick={() => {
                            handleViewComparedResultClick();
                          }}
                        />
                      )}
                    </>
                  ) : enableSelect ? (
                    <>
                      <DButtonOutlined
                        iconWidth="1rem"
                        iconHeight="1rem"
                        label={"Cancel"}
                        btnHeight="4rem"
                        btnWidth="max-content"
                        buyerBtn={true}
                        customClass={classes.rfqActionBtn}
                        onClick={() => {
                          setEnableSelect(false);
                          setSelectedRowForComparison([]);
                          setSelectedRows([]);
                        }}
                      />
                      <DButton
                        iconWidth="1rem"
                        iconHeight="1rem"
                        label={"View"}
                        disabled={
                          !selectedRows ||
                          selectedRows?.length === 0 ||
                          // selectedRowForComparison?.length < 0
                          // ||
                          selectedRowForComparison?.filter(
                            (el, i) =>
                              el?.document === "" || el?.document === null,
                          ).length > 0
                        }
                        btnHeight="4rem"
                        btnWidth="max-content"
                        loadingState={loadingState}
                        buyerBtn={true}
                        customClass={classes.rfqActionBtn}
                        customWrapperClass={classes.viewQuotesBtnWrap}
                        error={
                          // selectedRowForComparison?.length > 3 ||
                          selectedRowForComparison?.filter(
                            (el, i) =>
                              el?.document === "" || el?.document === null,
                          ).length > 0
                        }
                        errorMsg={
                          selectedRowForComparison?.filter(
                            (el, i) =>
                              el?.document === "" || el?.document === null,
                          ).length > 0
                            ? "Only files quotes can be viewed."
                            : selectedRowForComparison?.length > 3
                              ? "Only 3 files can be viewed at a time."
                              : ""
                        }
                        onClick={() => {
                          setEnableSelect(false);
                          let hasDoc = selectedRowForComparison?.filter(
                            (el, i) =>
                              el?.document === "" || el?.document === null,
                          );
                          setOpenViewQuotesPopup(true);
                        }}
                      />
                    </>
                  ) : (
                    <>
                      {!selectedbids && (
                        <DButtonOutlined
                          iconWidth="1rem"
                          iconHeight="1rem"
                          label={"Cancel"}
                          btnHeight="4rem"
                          btnWidth="max-content"
                          buyerBtn={true}
                          customClass={classes.rfqActionBtn}
                          onClick={cancelRequestRequote}
                        />
                      )}

                      {!selectedbids && (
                        <DButton
                          iconWidth="1rem"
                          iconHeight="1rem"
                          label={"Submit Requote"}
                          disabled={!selectedRows || selectedRows?.length === 0}
                          btnHeight="4rem"
                          btnWidth="max-content"
                          loadingState={loadingState}
                          buyerBtn={true}
                          customClass={classes.rfqActionBtn}
                          onClick={submitRequote}
                        />
                      )}
                    </>
                  )}
                  {selectedbids && (
                    <DButton
                      iconWidth="1rem"
                      iconHeight="1rem"
                      label={"Cancel"}
                      btnHeight="4rem"
                      btnWidth="max-content"
                      buyerBtn={true}
                      customClass={classes.rfqActionBtn}
                      onClick={() => {
                        setSelectedbids(false);
                        setSelectedRows([]);
                        setisempty(true);
                        // setSelectedRows([]);
                        // clearTotalData();
                        // settotaldata([]); // Clear the totaldata state
                      }}
                    />
                  )}
                  {!enableSelect &&
                    !requestRequote &&
                    selectedVendors.length === 0 &&
                    !selectedbids && (
                      <DButton
                        iconWidth="1rem"
                        iconHeight="1rem"
                        disabled={
                          shouldShowSealedBidNotice ||
                          selectedbids ||
                          !hasSubmittedBids
                        }
                        label={"Purchase Order Automation"}
                        labelImg={sealedActionLockIcon}
                        btnHeight="4rem"
                        btnWidth="max-content"
                        buyerBtn={true}
                        customClass={sealedLockedActionClass}
                        onClick={handleOpenVendorPopup}
                        // onClick={() => {
                        //   // setSelectedbids(true);
                        //   // setisempty(false);
                        // }}
                      />
                    )}

                  {selectedbids &&
                  Array.isArray(vendor_data) &&
                  vendor_data.length > 0 &&
                  !hasSelectedStatus ? (
                    <DButton
                      label={"Submit"}
                      btnWidth={"max-content"}
                      btnHeight={"4rem"}
                      buyerBtn={true}
                      disabled={
                        (selectedbids && !selectedRows) ||
                        selectedRows?.length === 0
                      }
                      customClass={classes.rfqActionBtn}
                      onClick={() => handlePopup(selectedRows)}
                    />
                  ) : (
                    !selectedbids &&
                    hasSubmittedBids &&
                    selectedVendors.length > 0 && (
                      <DButton
                        key={"unselect-button"}
                        label={"Unselect Vendors"}
                        btnWidth={"max-content"}
                        btnHeight={"4rem"}
                        buyerBtn={true}
                        disabled={
                          (isAnyApproved && !isAnyAppStatusOne) || sendapproval
                        }
                        customClass={classes.rfqActionBtn}
                        onClick={() => {
                          const bidTokens = selectedVendors.map((item) => ({
                            token: item.token,
                            email: item.vendor_email,
                          }));
                          unselectcheckbox(bidTokens);
                        }}
                      />
                    )
                  )}

                  {!selectedbids && !requestRequote && !enableSelect && (
                    <DButton
                      iconWidth="1rem"
                      iconHeight="1rem"
                      label={"Negotiation Bot"}
                      disabled={
                        shouldShowSealedBidNotice ||
                        !bidsData ||
                        bidsData?.length === 0 ||
                        hasSelectedBid === true ||
                        uniqueData?.bid_status?.toLowerCase() === "closed" ||
                        uniqueData?.bid_status?.toLowerCase() ===
                          "cancelled" ||
                        uniqueData?.bid_status?.toLowerCase() === "failed"
                      }
                      btnHeight="4rem"
                      btnWidth="max-content"
                      buyerBtn={true}
                      labelImg={sealedActionLockIcon}
                      customClass={sealedLockedActionClass}
                      loadingState={negotiationBotState.loading}
                      onClick={openNegotiationBot}
                    />
                  )}
                  {!selectedbids && !requestRequote && !enableSelect && (
                    <DButton
                      iconWidth="1rem"
                      iconHeight="1rem"
                      disabled={
                        !Array.isArray(itemsListDataViewRFQ) ||
                        itemsListDataViewRFQ.length === 0
                      }
                      label={"Explore Alternatives"}
                      btnHeight="4rem"
                      btnWidth="max-content"
                      buyerBtn={true}
                      customClass={`${classes.rfqActionBtn} ${classes.exploreAlternativesBtn}`}
                      onClick={openExploreMore}
                    />
                  )}
                </div>
              </div>
            </div>

            <DataTable
              headings={headingsForViewRFQ}
              tableData={bidsData}
              bulkData={bulkBidsData}
              getTokenType={"vendor token"}
              tableSize={"100%"}
              errorMessage={tableProps.errorMessage}
              hideDefaultEmptyMessage={!hasSubmittedBids}
              isLoading={tableProps.isLoading}
              selection={requestRequote || enableSelect || selectedbids}
              maxBidIterationCount={maxBidIterationCount}
              customClass={classes.dTable}
              file={true}
              buyer={true}
              // timeline={true}
              hasBidIteration={true}
              // disableSelectAll={enableSelect}
              // viewTimeLineClick={openViewTimeLineModal}
              selectedRowsList={handleSeletedRowsList}
              selectBidBtn={
                uniqueData?.bid_status?.toLowerCase() !== "cancelled" &&
                uniqueData?.bid_status?.toLowerCase() !== "failed"
              }
              clearAllSelectedRows={
                !selectedRows ||
                selectedRows?.length === 0 ||
                !selectedRowForComparison ||
                selectedRowForComparison?.length === 0
              }
              onSelectBid={(bid_token, quan) => {
                // added ?
                setQuantity(quan);
                setOpenBidConfirmation({
                  selectBid: true,
                  unSelectBid: false,
                });
                setBidToken(bid_token);
              }}
              onUnSelectBid={(bid_token) => {
                setOpenBidConfirmation({
                  selectBid: false,
                  unSelectBid: true,
                });
                setBidToken(bid_token);
              }}
              setSortingColumnName={setSortingColumnName}
              sortingColumnName={sortingColumnName}
              setSortingOrder={setSortingOrder}
              sortingOrder={sortingOrder}
              actionButtons={viewTextActionButtons}
              checkboxSelection={true}
              selectedvendorbids={selectedbids}
              openvendor={openvendor}
              setOpenvendor={setOpenvendor}
              // settotaldata={settotaldata}
              isempty={isempty}
              setisempty={setisempty}
              RFQitemsListMapped={RFQitemsListMapped}
              requestRequote={requestRequote}
              viewQuotes={enableSelect}
              selectVendors={selectedbids}
            />

            {!tableProps.isLoading &&
              !!uniqueData &&
              !hasSubmittedBids &&
              !sealedBidNotice && (
              <div className={classes.emptyAbovePagination}>
                {noBidsMessage}
              </div>
            )}

            <div
              className={classes.viewRfqPagination}
              style={{ alignSelf: "stretch", display: "flex", justifyContent: "flex-end", width: "100%" }}
            >
              <PaginantionComponent
                pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              currentPage={currentPage || pageNumber || 1}
              itemsPerPage={totalItems || 0}
              totalItems={totalPages || 0}
              previouPageClick={() => {
                if (pageNumber > 1) {
                  previouPageClick(pageNumber, setPageNumber);
                }
              }}
              nextPageClick={() => {
                nextPageClick(pageNumber, setPageNumber, paginationData);
              }}
              disablePrevious={pageNumber === 1}
              disableNext={
                pageNumber >= totalPages ||
                totalPages === 0 ||
                (!paginationData && (!bidsData || bidsData.length === 0))
                }
              />
            </div>

            <HeaderTitle
              customclass={classes.tabHeading}
              titleText={"Supplier Messages"}
            />

            <DataTable
              headings={headingsForSentMessage}
              tableData={messagesTableData}
              bulkData={bulkBidsData}
              tableSize={"100%"}
              errorMessage={messageTableProps.errorMessage}
              isLoading={messageTableProps.isLoading}
              selection={false}
              maxBidIterationCount={maxBidIterationCount}
              customClass={classes.dTable}
              hasBidIteration={true}
              setSortingColumnName={setSortingColumnName}
              sortingColumnName={sortingColumnName}
              setSortingOrder={setSortingOrder}
              sortingOrder={sortingOrder}
              timeline={true}
              viewTimeLineClick={openViewTimeLineModal}
            />

            {!messageTableProps.isLoading &&
              (!hasSelectedVendorsForRfq ||
                !messagesTableData ||
                messagesTableData.length === 0) &&
              !messageTableProps.errorMessage && (
                <div className={classes.emptyAbovePagination}>
                  {!hasSelectedVendorsForRfq
                    ? EMPTY_STATE_TEXT.noVendorsSelected
                    : "No RFQ vendors found."}
                </div>
              )}

            <div
              className={classes.viewRfqPagination}
              style={{ alignSelf: "stretch", display: "flex", justifyContent: "flex-end", width: "100%" }}
            >
              <PaginantionComponent
                pageNumber={messagePageNumber}
              setPageNumber={setMessagePageNumber}
              currentPage={messageCurrentPage || messagePageNumber || 1}
              itemsPerPage={messageTotalItems || 0}
              totalItems={messageTotalPages || 0}
              previouPageClick={() => {
                if (messagePageNumber > 1) {
                  previouPageClick(messagePageNumber, setMessagePageNumber);
                }
              }}
              nextPageClick={() => {
                nextPageClick(
                  messagePageNumber,
                  setMessagePageNumber,
                  messagePaginationData,
                );
              }}
              disablePrevious={messagePageNumber === 1}
              disableNext={
                messagePageNumber >= messageTotalPages ||
                messageTotalPages === 0 ||
                (!messagePaginationData &&
                  (!messagesTableData || messagesTableData.length === 0))
                }
              />
            </div>

            {/* user message timeline */}

            <HeaderTitle
              customclass={classes.tabHeading}
              titleText={"User Messages"}
            />

            <DataTable
              headings={userHeadings}
              tableData={displayedUserList}
              bulkData={bulkBidsData}
              tableSize={"100%"}
              errorMessage={userTableProps.errorMessage}
              isLoading={userTableProps.isLoading}
              selection={false}
              maxBidIterationCount={maxBidIterationCount}
              customClass={classes.dTable}
              hasBidIteration={false}
              setSortingColumnName={setSortingColumnName}
              sortingColumnName={sortingColumnName}
              setSortingOrder={setSortingOrder}
              sortingOrder={sortingOrder}
              timeline={true}
              viewTimeLineClick={openUserMessageTimeline}
            />

            <div
              className={classes.viewRfqPagination}
              style={{ alignSelf: "stretch", display: "flex", justifyContent: "flex-end", width: "100%" }}
            >
              <PaginantionComponent
                pageNumber={userPageNumber}
              setPageNumber={setUserPageNumber}
              currentPage={
                userPaginationData?.current_page || userPageNumber || 1
              }
              itemsPerPage={userTotalItems ?? 0}
              totalItems={userTotalPages || 0}
              previouPageClick={() => {
                if (userPageNumber > 1) {
                  previouPageClick(userPageNumber, setUserPageNumber);
                }
              }}
              nextPageClick={() => {
                // For client-side pagination, check against calculated total pages
                if (
                  filteredUserList.length > 0 &&
                  userPageNumber < userTotalPages
                ) {
                  setUserPageNumber(parseInt(userPageNumber) + 1);
                } else if (userPaginationData) {
                  // Fallback to server-side pagination if available
                  nextPageClick(
                    userPageNumber,
                    setUserPageNumber,
                    userPaginationData,
                  );
                }
              }}
              disablePrevious={userPageNumber === 1}
              disableNext={
                filteredUserList.length > 0
                  ? userPageNumber >= userTotalPages
                  : userPaginationData
                    ? userPageNumber >= (userPaginationData?.page_count || 1)
                    : !getuserlist || getuserlist.length === 0
                }
              />
            </div>
          </div>
        </>
      )}

      {viewUserTimeLine && (
        <div className={classes.tabsScreens}>
          <div className={classes.width__100}>
            <h1 className={classes.view__time_line_titel}>
              User Message Timeline
            </h1>
            {sealedBidNoticePanel}
            <div className={classes.view__time_line}>
              {org_details.map((e, i) => (
                <InfoLabel
                  key={i}
                  isLoading={loadingState}
                  label={e.label}
                  value={e.value}
                  size={e.size}
                />
              ))}
              <div className={classes.chatActionBntWrapper}>
                <DropdownBtnOutlined
                  label="DOWNLOAD"
                  btnHeight="4rem"
                  btnWidth="17rem"
                  custom={classes.bgcolor}
                  loadingState={loadingStateDwnload}
                  disabled={RFQData?.length === 0}
                  onClick={(fileFormat) => {
                    const rfq_codes = org_details.map((e) =>
                      e.label === "RFQ ID" ? e.value : "",
                    );
                    downloadPdf(rfq_codes[0]);
                  }}
                  options={["PDF"]}
                />
                {/* Disable/Enable Chat applies to vendor timeline only; hidden in User Message Timeline */}
              </div>
            </div>
            <div className={classes.overflow_hadle}>
              <div>{renderTimelineCards(filteredUserTimelineData)}</div>

              <div className={classes.documentconatiner}>
                <div className={classes.documentheader}>
                  <h3>Uploaded Documents</h3>
                </div>
                <div className={classes.documentcontent}>
                  <ul>
                    {Array.isArray(filteredUserTimelineData) &&
                      filteredUserTimelineData
                        .filter(
                          (entry) =>
                            Array.isArray(entry.document) &&
                            entry.document.length > 0,
                        )
                        .map((entry, index) => (
                          <AttachmentList
                            key={`user-doc-${index}`}
                            item={entry}
                          />
                        ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {openForm.errorMessage ? (
        <div className={` ${classes.formErrorWrap} ${classes.flex}`}>
          <p className={classes.error_msg}> {openForm.errorMessage} </p>
        </div>
      ) : openForm.errorMessage && newRFQForm ? (
        <div className={` ${classes.formErrorWrap} ${classes.flex}`}>
          <p className={classes.error_msg}>
            {" "}
            {openForm.errorMessage} <br /> contact your organisation to add an
            item to create an RFQ.
          </p>
        </div>
      ) : newRFQForm || (editRFQForm && openForm.open) ? (
        <>
          <div
            className={`${classes.tabsScreens} ${
              newRFQForm || editRFQForm ? classes.newRfqCreateScreen : ""
            }`}
          >
            {/* <HeaderTitle
              titleText={`${editRFQForm ? "Edit RFQ" : "New RFQ"}`}
              customclass={classes.dashHead}
            /> */}

            <section className={classes.rfqBudgetOverview}>
              <HeaderTitle titleText="Budget Overview" />
              <div className={classes.rfqBudgetDepartment}>
                <Autocomplete
                  options={departmentList}
                  loading={departmentLoading}
                  value={selectedDepartment}
                  disabled={editRFQForm}
                  getOptionLabel={(option) => option?.name || ""}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  onChange={(_, department) => {
                    setSelectedDepartment(department);
                    setDepartmentError("");
                    setBudgetConfigs([]);
                    if (department?.name) void fetchBudgetConfig(department.name);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      label="Department"
                      placeholder="Select department"
                      error={Boolean(departmentError)}
                      helperText={departmentError}
                    />
                  )}
                />
              </div>
              {budgetConfigLoading && (
                <Typography className={classes.rfqBudgetLoading}>
                  Loading department budgets...
                </Typography>
              )}
              {budgetConfigs.length > 0 && (
                <div className={classes.rfqExpenseBudgetGrid}>
                  {[...budgetConfigs]
                    .sort((a, b) => {
                      const order = { CAPEX: 0, OPEX: 1 };
                      return (order[String(a?.expense_type || "").toUpperCase()] ?? 9) -
                        (order[String(b?.expense_type || "").toUpperCase()] ?? 9);
                    })
                    .map((budget) => {
                      const allocated = getBudgetNumber(budget?.allocated_amount);
                      const balance = getBudgetNumber(budget?.balance_amount);
                      const spent = Math.max(allocated - balance, 0);
                      return (
                        <article key={budget?.id || budget?.expense_type} className={classes.rfqExpenseBudgetCard}>
                          <div className={classes.rfqExpenseBudgetHeader}>
                            <div>
                              <strong>{budget?.expense_type || "Budget"}</strong>
                              <span>{budget?.purchase_type || "Purchase budget"}</span>
                            </div>
                            <span>{budget?.currency || ""}</span>
                          </div>
                          <div className={classes.rfqExpenseBudgetTotals}>
                            {[
                              ["Total Budget", allocated],
                              ["Budget Consumed", spent],
                              ["Budget Balance", balance],
                            ].map(([label, amount]) => (
                              <div key={label}>
                                <span>{label}</span>
                                <strong>{formatBudgetAmount(amount, budget?.currency)}</strong>
                              </div>
                            ))}
                          </div>
                          <div className={classes.rfqBudgetStages}>
                            {[
                              ["PR Available", "pr_available"],
                              ["PO Available", "po_available"],
                              ["GRN Available", "grn_available"],
                            ].map(([label, field]) => (
                              <div key={label}>
                                <span>{label}</span>
                                <strong>{formatBudgetAmount(budget?.[field], budget?.currency)}</strong>
                              </div>
                            ))}
                          </div>
                        </article>
                      );
                    })}
                </div>
              )}
            </section>

            <div
              className={`${classes.docField} ${
                editRFQForm || uploadItemDocument.inputs
                  ? classes.docFieldSingleCol
                  : ""
              }`}
            >
              {!editRFQForm && (
                <div className={classes.input_container}>
                  <DefaultLabel label={"Create an RFQ"} required={true} />

                  <div className={classes.util}>
                    <DRadioInput
                      label={"Attach RFQ document"}
                      id={"itemCSVFile"}
                      value={"itemCSVFile"}
                      checked={uploadItemDocument.uploadFile}
                      customClass={classes.radioTag}
                      onChange={() => {
                        setUploadedItemTokensForVendorFilter([]);
                        setItemVendorErrors({});
                        setUploadItemDocument({
                          uploadFile: true,
                          inputs: false,
                        });
                      }}
                      name={"itemDoc"}
                    />

                    <DRadioInput
                      label={"Type details of RFQ"}
                      id={"itemInputs"}
                      checked={uploadItemDocument.inputs}
                      customClass={classes.radioTag}
                      value={"itemInputs"}
                      onChange={() => {
                        setItemCSV((prev) => ({
                          ...prev,
                          value: "",
                        }));
                        setUploadedItemTokensForVendorFilter([]);
                        setItemVendorErrors({});
                        setUploadItemDocument({
                          uploadFile: false,
                          inputs: true,
                        });
                      }}
                      name={"itemDoc"}
                    />
                  </div>

                  {uploadItemDocument.inputs && (
                    <div
                      className={`${classes.multiForm} ${classes.multiFormNoScroll}`}
                    >
                      {itemsInput?.length >= 1 &&
                        itemsInput?.map((el, index) => {
                          return (
                            <div
                              className={`${classes.items_form_wrapper}`}
                              key={index}
                            >
                              <div className={`${classes.itemCount}`}>
                                <span>Item #{index + 1}</span>
                              </div>
                              <div
                                className={
                                  classes.input_fields_wrapper_multi_line1
                                }
                              >
                                <DSelectInput
                                  customClass={classes.fields}
                                  label="Item Code"
                                  required={true}
                                  value={el.itemCode}
                                  options={itemList.values.visibleOption}
                                  filterMatchFrom="start"
                                  onChange={(e) => {
                                    handleItemInputChanges(
                                      e,
                                      "itemCode",
                                      index,
                                    );

                                    let itemToken =
                                      itemList.values.tokens[
                                        itemList.values.visibleOption.indexOf(e)
                                      ];
                                    itemToken !== null &&
                                      itemToken !== undefined &&
                                      itemToken !== "" &&
                                      getItemDetailsByItemCode(
                                        itemToken,
                                        index,
                                      );
                                    handleItemInputChanges(
                                      itemToken,
                                      "itemToken",
                                      index,
                                    );

                                    let isValid = !emptyCheck(String(e || ""));
                                    handleItemInputChanges(
                                      isValid,
                                      "itemCodeisValid",
                                      index,
                                    );

                                    handleItemInputChanges(
                                      false,
                                      "itemNameisValid",
                                      index,
                                    );

                                    if (!e) {
                                      handleItemInputChanges(
                                        "",
                                        "itemName",
                                        index,
                                      );
                                      handleItemInputChanges(
                                        "",
                                        "expenseType",
                                        index,
                                      );
                                      handleItemInputChanges(
                                        true,
                                        "itemNameisValid",
                                        index,
                                      );
                                    }
                                  }}
                                  error={el.itemCodeisValid || el.itemDuplicate}
                                  errorMsg={
                                    el.itemDuplicate
                                      ? "Item already added"
                                      : "Item Code is required"
                                  }
                                  size={"100%"}
                                />
                                <DSelectInput
                                  customClass={classes.fields}
                                  label="Item Name"
                                  required={true}
                                  value={el.itemName}
                                  options={itemNameList.values.visibleOption}
                                  filterMatchFrom="start"
                                  onChange={(e) => {
                                    handleItemInputChanges(
                                      e,
                                      "itemName",
                                      index,
                                    );

                                    let itemToken =
                                      itemNameList.values.tokens[
                                        itemNameList.values.visibleOption.indexOf(
                                          e,
                                        )
                                      ];
                                    itemToken !== null &&
                                      itemToken !== undefined &&
                                      itemToken !== "" &&
                                      getItemDetailsByNameCode(
                                        itemToken,
                                        index,
                                      );
                                    handleItemInputChanges(
                                      itemToken,
                                      "itemToken",
                                      index,
                                    );

                                    let isValid = !emptyCheck(String(e || ""));
                                    handleItemInputChanges(
                                      isValid,
                                      "itemNameisValid",
                                      index,
                                    );

                                    handleItemInputChanges(
                                      false,
                                      "itemCodeisValid",
                                      index,
                                    );

                                    if (!e) {
                                      handleItemInputChanges(
                                        "",
                                        "itemCode",
                                        index,
                                      );
                                      handleItemInputChanges(
                                        "",
                                        "expenseType",
                                        index,
                                      );
                                      handleItemInputChanges(
                                        true,
                                        "itemCodeisValid",
                                        index,
                                      );
                                    }
                                  }}
                                  error={el.itemNameisValid || el.itemDuplicate}
                                  errorMsg={
                                    el.itemDuplicate
                                      ? "Item already added"
                                      : "Item Name is required"
                                  }
                                  size={"100%"}
                                />
                                <DTextInput
                                  customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`}
                                  label="Expense Type"
                                  value={el.expenseType || ""}
                                  disabled={true}
                                  size={"100%"}
                                />
                                {/* <DTextInput
                                  customClass={classes.fields}
                                  label="Item Name"
                                  value={el.itemName}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    handleItemInputChanges(
                                      val,
                                      "itemName",
                                      index
                                    );

                                    let isValid = !emptyCheck(el.itemName);
                                    handleItemInputChanges(
                                      isValid,
                                      "itemNameisValid",
                                      index
                                    );
                                  }}
                                  error={el.itemNameisValid}
                                  errorMsg={"Item Name is required"}
                                  size={"100%"}
                                /> */}
                              </div>
                              <div
                                className={`${classes.input_fields_wrapper_multi_line2}`}
                              >
                                <DTextInput
                                  customClassName={classes.fields}
                                  label="Quantity"
                                  required={true}
                                  maxLength={10}
                                  type="text"
                                  value={el.itemQuantity}
                                  onChange={(e) => {
                                    let val = String(e?.target?.value || "")
                                      .replace(/\D/g, "")
                                      .slice(0, 10);
                                    let isValid = !emptyCheck(e?.target?.value);
                                    handleItemInputChanges(
                                      isValid,
                                      "itemQuantityisValid",
                                      index,
                                    );
                                    handleItemInputChanges(
                                      val,
                                      "itemQuantity",
                                      index,
                                    );
                                  }}
                                  error={el.itemQuantityisValid}
                                  errorMsg={"Quantity is required"}
                                  size={"100%"}
                                  onKeyDown={(e) => {
                                    if (
                                      e.key === "." ||
                                      e.key === "-" ||
                                      e.key === "+" ||
                                      e.key === "e" ||
                                      e.key === "E"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />

                                <DSelectInput
                                  customClass={`${classes.fields} ${classes.rfqReadOnlyItemField}`}
                                  label="Unit"
                                  required={true}
                                  value={el.itemUnit}
                                  options={unitsOptions}
                                  disabled={true}
                                  onChange={(e) => {
                                    let val = e;
                                    let isValid = !emptyCheck(val);
                                    handleItemInputChanges(
                                      isValid,
                                      "itemUnitisValid",
                                      index,
                                    );
                                    handleItemInputChanges(
                                      val,
                                      "itemUnit",
                                      index,
                                    );
                                  }}
                                  error={el.itemUnitisValid}
                                  errorMsg={"Unit is required"}
                                  size={"100%"}
                                />

                                <DTextInput
                                  customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`}
                                  label="Manufacturer Part Number (Optional)"
                                  maxLength={RFQ_PR_AND_PART_NUMBER_MAX_LEN}
                                  value={el.itemPartNumber}
                                  disabled={true}
                                  onChange={(e) => {
                                    let val = sanitizeRfqPrAndPartNumber(
                                      e?.target?.value,
                                    );
                                    // setPartNumber({
                                    //   value: val,
                                    // });
                                    handleItemInputChanges(
                                      val,
                                      "itemPartNumber",
                                      index,
                                    );
                                  }}
                                  size={"100%"}
                                />
                              </div>

                              <div
                                className={`${classes.input_fields_wrapper_multi_line2}`}
                              >
                                {[
                                  ["Category", el.itemCategory],
                                  ["Sub-category", el.itemSubCategory],
                                  ["Item Type", el.itemType],
                                  ["HSN Code", el.itemHsnCode],
                                  ["UNSPSC Code", el.itemUnspscCode],
                                  ["Brand", el.itemBrand],
                                  ["Tax", el.itemTax],
                                  ["Specifications", el.itemSpecifications],
                                  ["Aliases", el.itemAliases],
                                ].map(([label, value]) => (
                                  <Tooltip
                                    key={label}
                                    title={value || "-"}
                                    placement="top"
                                    followCursor
                                    slotProps={{
                                      tooltip: {
                                        sx: {
                                          fontSize: "13px",
                                          fontFamily: "gilroyMedium",
                                        },
                                      },
                                    }}
                                  >
                                    <span className={classes.rfqItemTooltipTarget}>
                                      <DTextInput
                                        customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`}
                                        label={label}
                                        value={value || "-"}
                                        disabled={true}
                                        size="100%"
                                      />
                                    </span>
                                  </Tooltip>
                                ))}
                              </div>

                              <DTextArea
                                label="Item Description"
                                required={true}
                                type="text"
                                placeholder={"description"}
                                maxLength={2550}
                                value={el.itemDescription}
                                onChange={(e) => {
                                  let val = e?.target?.value;
                                  let isValid;
                                  if (val && val.length > 2550) {
                                    isValid = true;
                                  } else if (val?.trim() === "") {
                                    isValid = true;
                                  } else {
                                    isValid = false;
                                  }
                                  handleItemInputChanges(
                                    isValid,
                                    "itemDescriptionisValid",
                                    index,
                                  );
                                  handleItemInputChanges(
                                    val,
                                    "itemDescription",
                                    index,
                                  );
                                }}
                                containerClass={classes.itemDescription}
                                customClassName={
                                  classes.itemDescriptionTextArea
                                }
                                inputWrapperClass={classes.textAreaWrapper}
                                error={el.itemDescriptionisValid}
                                errorMsg={
                                  el?.itemDescription &&
                                  el?.itemDescription.length > 2550
                                    ? "Item Description should be less than 2550 characters"
                                    : el.itemDescriptionisValid
                                      ? "Item Description is required"
                                      : ""
                                }
                                size={"95.5%"}
                              />
                              {itemVendorErrors?.[index] && (
                                <p className={classes.error_msg}>
                                  {itemVendorErrors[index]}
                                </p>
                              )}
                              {index !== 0 && (
                                <button
                                  onClick={() => {
                                    removeItemsInput(index);
                                  }}
                                  className={`${classes.removeFormButton}`}
                                >
                                  Remove
                                </button>
                              )}
                            </div>
                          );
                        })}

                      <div className={`${classes.addNewForm}`}>
                        <button
                          onClick={addItemsInputs}
                          className={`${classes.addNewFormButton}`}
                        >
                          Add Item
                        </button>
                      </div>
                    </div>
                  )}

                  {uploadItemDocument.uploadFile && !editRFQForm && (
                    <>
                      <DFileUpload
                        fileTypes={".csv,.xlsx"}
                        fileName={editRFQForm && fileName}
                        customFileTypeText={"(Supported format CSV/Excel)"}
                        onFileUpload={(file) => {
                          let isValidFile = validateFile(
                            file,
                            false,
                            ["csv", "xlsx"],
                            5,
                          ).isValid;
                          setItemCSV({
                            value: file,
                            hasFile: false,
                            isValid: isValidFile,
                          });

                          // Option-1: Preview vendors by parsing the uploaded file for item codes/names
                          // and applying the same vendor-by-category filtering before Create.
                          if (isValidFile && file) {
                            (async () => {
                              // Ensure items master is available for mapping item_code/item_name → item_token.
                              if (
                                !(itemList?.values?.tokens?.length > 0) ||
                                !(itemNameList?.values?.tokens?.length > 0)
                              ) {
                                await viewAllItem(org_token, {
                                  showLoader: false,
                                  silent: true,
                                });
                              }

                              const tokens =
                                await extractItemTokensFromItemUploadFile(file);
                              if (tokens.length > 0) {
                                setUploadedItemTokensForVendorFilter(tokens);
                                void getVendorsByCategory(tokens);
                              } else {
                                setUploadedItemTokensForVendorFilter([]);
                                // If we can't resolve items from file, keep the existing behavior (show all vendors).
                                vendorFilterActiveRef.current = false;
                                setVendorContactsByVendorToken({});
                                if (
                                  allVendorsList?.values?.visibleOption?.length
                                ) {
                                  setVendorsList(allVendorsList);
                                }
                              }
                            })();
                          }
                        }}
                        error={!itemCSV.isValid}
                        errorMsg={
                          validateFile(
                            itemCSV.value,
                            false,
                            ["csv"],
                            5,
                            "Please attach a csv or excel document",
                          ).errorMessage
                        }
                        size={"100%"}
                      />
                      <p
                        className={classes.linkBtn}
                        onClick={() => {
                          saveAs(RFQSampleItemsFile, "Sample CSV.csv");
                        }}
                      >
                        Sample CSV
                      </p>
                    </>
                  )}
                </div>
              )}

              {editRFQForm && (
                <div className={classes.itemsListWrapper}>
                  {editRFQForm && (
                    <span className={classes.headingSm}>Items</span>
                  )}
                  <div className={`${classes.multiForm}`}>
                    {itemsInput?.length >= 1 &&
                      itemsInput?.map((el, index) => {
                        return (
                          <div
                            className={`${classes.items_form_wrapper}`}
                            key={index}
                          >
                            <div className={`${classes.itemCount}`}>
                              <span>Item #{index + 1}</span>
                            </div>
                            <div
                              className={
                                classes.input_fields_wrapper_multi_line1
                              }
                            >
                              <DSelectInput
                                customClass={classes.fields}
                                label="Item Code"
                                value={el.itemCode}
                                options={itemList.values.visibleOption}
                                filterMatchFrom="start"
                                onChange={(e) => {
                                  handleItemInputChanges(e, "itemCode", index);

                                  let itemToken =
                                    itemList.values.tokens[
                                      itemList.values.visibleOption.indexOf(e)
                                    ];

                                  itemToken !== null &&
                                    itemToken !== undefined &&
                                    itemToken !== "" &&
                                    getItemDetailsByItemCode(itemToken, index);
                                  handleItemInputChanges(
                                    itemToken,
                                    "itemToken",
                                    index,
                                  );

                                  let isValid = !emptyCheck(String(e || ""));
                                  handleItemInputChanges(
                                    isValid,
                                    "itemCodeisValid",
                                    index,
                                  );

                                  handleItemInputChanges(
                                    false,
                                    "itemNameisValid",
                                    index,
                                  );

                                  if (!e) {
                                    handleItemInputChanges(
                                      "",
                                      "itemName",
                                      index,
                                    );
                                    handleItemInputChanges(
                                      "",
                                      "expenseType",
                                      index,
                                    );
                                    handleItemInputChanges(
                                      true,
                                      "itemNameisValid",
                                      index,
                                    );
                                  }
                                }}
                                error={el.itemCodeisValid || el.itemDuplicate}
                                errorMsg={
                                  el.itemDuplicate
                                    ? "Item already added"
                                    : "Item Code is required"
                                }
                                size={"100%"}
                              />
                              <DSelectInput
                                customClass={classes.fields}
                                label="Item Name"
                                value={el.itemName}
                                options={itemNameList.values.visibleOption}
                                filterMatchFrom="start"
                                onChange={(e) => {
                                  handleItemInputChanges(e, "itemName", index);

                                  let itemToken =
                                    itemNameList.values.tokens[
                                      itemNameList.values.visibleOption.indexOf(
                                        e,
                                      )
                                    ];
                                  itemToken !== null &&
                                    itemToken !== undefined &&
                                    itemToken !== "" &&
                                    getItemDetailsByNameCode(itemToken, index);
                                  handleItemInputChanges(
                                    itemToken,
                                    "itemToken",
                                    index,
                                  );

                                  let isValid = !emptyCheck(String(e || ""));
                                  handleItemInputChanges(
                                    isValid,
                                    "itemNameisValid",
                                    index,
                                  );

                                  handleItemInputChanges(
                                    false,
                                    "itemCodeisValid",
                                    index,
                                  );

                                  if (!e) {
                                    handleItemInputChanges(
                                      "",
                                      "itemCode",
                                      index,
                                    );
                                    handleItemInputChanges(
                                      "",
                                      "expenseType",
                                      index,
                                    );
                                    handleItemInputChanges(
                                      true,
                                      "itemCodeisValid",
                                      index,
                                    );
                                  }
                                }}
                                error={el.itemNameisValid || el.itemDuplicate}
                                errorMsg={
                                  el.itemDuplicate
                                    ? "Item already added"
                                    : "Item Name is required"
                                }
                                size={"100%"}
                              />
                              <DTextInput
                                customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`}
                                label="Expense Type"
                                value={el.expenseType || ""}
                                disabled={true}
                                size={"100%"}
                              />
                              {/* <DTextInput
                                customClass={classes.fields}
                                label="Item Name"
                                value={el.itemName}
                                onChange={(e) => {
                                  let val = e.target.value;
                                  handleItemInputChanges(
                                    val,
                                    "itemName",
                                    index
                                  );

                                  let isValid = !emptyCheck(el.itemName);
                                  handleItemInputChanges(
                                    isValid,
                                    "itemNameisValid",
                                    index
                                  );
                                }}
                                error={el.itemNameisValid}
                                errorMsg={"Item Name is required"}
                                size={"100%"}
                              /> */}
                            </div>
                            <div
                              className={`${classes.input_fields_wrapper_multi_line2}`}
                            >
                              <DTextInput
                                customClassName={classes.fields}
                                label="Quantity"
                                maxLength={10}
                                type="text"
                                value={el.itemQuantity}
                                onChange={(e) => {
                                  let val = String(e?.target?.value || "")
                                    .replace(/\D/g, "")
                                    .slice(0, 10);
                                  let isValid = !emptyCheck(e?.target?.value);
                                  handleItemInputChanges(
                                    isValid,
                                    "itemQuantityisValid",
                                    index,
                                  );
                                  handleItemInputChanges(
                                    val,
                                    "itemQuantity",
                                    index,
                                  );
                                }}
                                error={el.itemQuantityisValid}
                                errorMsg={"Quantity is required"}
                                size={"100%"}
                                onKeyDown={(e) => {
                                  if (
                                    e.key === "." ||
                                    e.key === "-" ||
                                    e.key === "+" ||
                                    e.key === "e" ||
                                    e.key === "E"
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />

                              <DSelectInput
                                customClass={classes.fields}
                                label="Unit"
                                value={el.itemUnit}
                                options={unitsOptions}
                                onChange={(e) => {
                                  let val = e;
                                  let isValid = !emptyCheck(val);
                                  handleItemInputChanges(
                                    isValid,
                                    "itemUnitisValid",
                                    index,
                                  );
                                  handleItemInputChanges(
                                    val,
                                    "itemUnit",
                                    index,
                                  );
                                }}
                                error={el.itemUnitisValid}
                                errorMsg={"Unit is required"}
                                size={"100%"}
                              />

                              <Tooltip title={el.itemPartNumber || "-"} placement="top" followCursor slotProps={{ tooltip: { sx: { fontSize: "13px", fontFamily: "gilroyMedium" } } }}>
                                <span className={classes.rfqItemTooltipTarget}>
                                  <DTextInput
                                    customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`}
                                    label="Manufacturer Part Number"
                                    maxLength={RFQ_PR_AND_PART_NUMBER_MAX_LEN}
                                    value={el.itemPartNumber}
                                    disabled={true}
                                    onChange={(e) => {
                                      let val = sanitizeRfqPrAndPartNumber(
                                        e?.target?.value,
                                      );
                                      handleItemInputChanges(
                                        val,
                                        "itemPartNumber",
                                        index,
                                      );
                                    }}
                                    size={"100%"}
                                  />
                                </span>
                              </Tooltip>
                            </div>

                            <div className={`${classes.input_fields_wrapper_multi_line2}`}>
                              {[
                                ["Category", el.itemCategory],
                                ["Sub-category", el.itemSubCategory],
                                ["Item Type", el.itemType],
                                ["HSN Code", el.itemHsnCode],
                                ["UNSPSC Code", el.itemUnspscCode],
                                ["Brand", el.itemBrand],
                                ["Tax", el.itemTax],
                                ["Specifications", el.itemSpecifications],
                                ["Aliases", el.itemAliases],
                              ].map(([label, value]) => (
                                <Tooltip
                                  key={label}
                                  title={value || "-"}
                                  placement="top"
                                  followCursor
                                  slotProps={{ tooltip: { sx: { fontSize: "13px", fontFamily: "gilroyMedium" } } }}
                                >
                                  <span className={classes.rfqItemTooltipTarget}>
                                    <DTextInput
                                      customClassName={`${classes.fields} ${classes.rfqReadOnlyItemField}`}
                                      label={label}
                                      value={value || "-"}
                                      disabled={true}
                                      size="100%"
                                    />
                                  </span>
                                </Tooltip>
                              ))}
                            </div>

                            <DTextArea
                              label="Item Description"
                              type="text"
                              placeholder={"description"}
                              maxLength={2550}
                              value={el.itemDescription}
                              onChange={(e) => {
                                let val = e?.target?.value;
                                let isValid;
                                if (val && val.length > 2550) {
                                  isValid = true;
                                } else if (val?.trim() === "") {
                                  isValid = true;
                                } else {
                                  isValid = false;
                                }
                                handleItemInputChanges(
                                  isValid,
                                  "itemDescriptionisValid",
                                  index,
                                );
                                handleItemInputChanges(
                                  val,
                                  "itemDescription",
                                  index,
                                );
                              }}
                              containerClass={classes.itemDescription}
                              customClassName={classes.itemDescriptionTextArea}
                              inputWrapperClass={classes.textAreaWrapper}
                              error={el.itemDescriptionisValid}
                              errorMsg={
                                el?.itemDescription &&
                                el?.itemDescription.length > 2550
                                  ? "Item Description should be less than 2550 characters"
                                  : el.itemDescriptionisValid
                                    ? "Item Description is required"
                                    : ""
                              }
                              size={"95.5%"}
                            />
                            {itemVendorErrors?.[index] && (
                              <p className={classes.error_msg}>
                                {itemVendorErrors[index]}
                              </p>
                            )}

                            {index !== 0 && (
                              <button
                                onClick={() => {
                                  // let dlt= deletedItemsToken.push(el.itemToken);
                                  if (
                                    el.itemToken !== null &&
                                    el.itemToken !== "" &&
                                    el.itemToken &&
                                    el.itemMappedToken !== null &&
                                    el.itemMappedToken !== "" &&
                                    el.itemMappedToken
                                  ) {
                                    setDeletedItemsToken([
                                      ...deletedItemsToken,
                                      el.itemMappedToken,
                                    ]);
                                  }
                                  removeItemsInput(index);
                                }}
                                className={`${classes.removeFormButton}`}
                              >
                                Remove
                              </button>
                            )}
                          </div>
                        );
                      })}

                    <div className={`${classes.addNewForm}`}>
                      <button
                        onClick={addItemsInputs}
                        className={`${classes.addNewFormButton}`}
                      >
                        Add Item
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className={classes.docField}>
              <div className={classes.input_container}>
                <DefaultLabel label={"Other documents related to RFQ"} />
                {/* {uploadDocument.uploadFile && ( */}
                <DFileUpload
                  fileTypes={".pdf,.docx,.xlsx,.xls,.ppt,.pptx"}
                  fileName={editRFQForm && fileName}
                  customFileTypeText={
                    "(Supported Format docx, ppt, pdf, xls, xlsx, pptx)"
                  }
                  onFileUpload={(file) => {
                    let isValidFile = validateFile(
                      file,
                      true,
                      ["pdf", "docx", "xlsx", "xls", "ppt", "pptx"],
                      5,
                    ).isValid;
                    setProposalDocument({
                      value: file,
                      hasFile: true,
                      isValid: isValidFile,
                    });
                  }}
                  error={!proposalDocument.isValid}
                  errorMsg={
                    validateFile(
                      proposalDocument.value,
                      true,
                      ["pdf", "docx", "xlsx", "xls", "ppt", "pptx"],
                      5,
                      "Proposal document",
                    ).errorMessage
                  }
                  size={"100%"}
                />
                {/* )} */}
              </div>
              <div className={classes.unitsInputs}>
                <DTextInput
                  customClass={classes.uniqueSelect}
                  label="Purchase Request Number"
                  required={true}
                  maxLength={RFQ_PR_NUMBER_MAX_LEN}
                  value={requestNumber.value}
                  onChange={(e) => {
                    let val = sanitizeRfqPrAndPartNumber(
                      e?.target?.value,
                      RFQ_PR_NUMBER_MAX_LEN,
                    );
                    setRequestNumber({
                      value: val,
                      isChanged: editRFQForm,
                      isValid: emptyCheck(val),
                    });
                  }}
                  error={!requestNumber.isValid}
                  errorMsg={"Request Number is required"}
                  size={"100%"}
                />
                {!categoryonEdit && (
                  <ThemeProvider theme={theme}>
                    <div
                      className={`${styles.select_container} ${classes.quotationCategory}`}
                      ref={quotationCategoryRef}
                    >
                      <label>
                        Select Quotation Category{" "}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Autocomplete
                        value={
                          RFQCategory.categoryList.find(
                            (option) =>
                              String(option?.id ?? "") ===
                              String(RFQCategory.id ?? ""),
                          ) ||
                          RFQCategory.categoryList.find(
                            (option) =>
                              String(option?.category || "")
                                .trim()
                                .toLowerCase() ===
                              String(RFQCategory.value || "")
                                .trim()
                                .toLowerCase(),
                          ) ||
                          (RFQCategory.value
                            ? {
                                category: RFQCategory.value,
                                id: RFQCategory.id || "",
                              }
                            : null)
                        }
                        onChange={(event, newValue) => {
                          if (typeof newValue === "string") {
                            setRFQCategory((state) => ({
                              ...state,
                              value: newValue,
                              id: "",
                              // Quotation category must be selected from the list (must have an id)
                              isValid: false,
                            }));
                            return;
                          }
                          if (newValue?.inputValue) {
                            setRFQCategory((state) => ({
                              ...state,
                              value: newValue.inputValue,
                              id: "",
                              // Quotation category must be selected from the list (must have an id)
                              isValid: false,
                            }));
                            return;
                          }
                          setRFQCategory((state) => ({
                            ...state,
                            value: newValue?.category ? newValue?.category : "",
                            id: newValue?.id ? newValue?.id : "",
                            isValid: !!(newValue?.category && newValue?.id),
                          }));
                        }}
                        filterOptions={(options, params) => {
                          const filtered = filter(options, params);

                          const { inputValue } = params;
                          // Suggest the creation of a new value
                          const isExisting = options.some(
                            (option) => inputValue === option.category,
                          );
                          if (inputValue !== "" && !isExisting) {
                            filtered.push({
                              inputValue,
                              title: `Add "${inputValue}"`,
                            });
                          }
                          return filtered;
                        }}
                        options={RFQCategory.categoryList}
                        getOptionLabel={(option) => {
                          // Value selected with enter, right from the input
                          if (typeof option === "string") {
                            return option;
                          }
                          if (option?.inputValue) {
                            return option.inputValue;
                          }
                          // Add "xxx" option created dynamically
                          if (option.category) {
                            return option.category;
                          }
                          // Regular option
                          return option.category;
                        }}
                        isOptionEqualToValue={(option, value) => {
                          const optionId = String(option?.id ?? "");
                          const valueId = String(value?.id ?? "");
                          if (optionId && valueId) return optionId === valueId;
                          return (
                            String(option?.category || "")
                              .trim()
                              .toLowerCase() ===
                            String(value?.category || "")
                              .trim()
                              .toLowerCase()
                          );
                        }}
                        renderOption={(props, option) => (
                          <li {...props}>
                            {option.category || option.inputValue}
                          </li>
                        )}
                        freeSolo
                        forcePopupIcon
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label=""
                            placeholder="Select quotation category"
                          />
                        )}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        id="quotation_category"
                        size="small"
                        className={`${styles.select_wrapper_multiSelect} ${
                          !RFQCategory.isValid ? styles.error : ""
                        }`}
                        sx={{
                          minHeight: "4.2rem",
                          height: "auto",
                          fontSize: "1.4rem",
                          transition: "0",
                          ".Mui-expanded": {
                            transition: "none",
                          },
                          ".MuiOutlinedInput-notchedOutline": {
                            border: "0",
                          },
                          ".MuiAutocomplete-input": {
                            fontSize: "1.4rem",
                            fontFamily: "GilroyMedium",
                            height: "2.6rem",
                          },
                          ".MuiFormLabel-root": {
                            display: "none",
                          },
                          ".MuiChip-root": {
                            height: "30px",
                            padding: "5px",
                          },
                        }}
                        componentsProps={{
                          popper: {
                            sx: {
                              fontFamily: "gilroyMedium",
                            },
                            modifiers: [
                              {
                                name: "flip",
                                enabled: false,
                              },
                              {
                                name: "preventOverflow",
                                enabled: true,
                              },
                            ],
                          },
                        }}
                      />
                      {!RFQCategory.isValid && (
                        <p className={styles.error_message}>
                          Quotation Category is required
                        </p>
                      )}
                    </div>
                  </ThemeProvider>
                )}
              </div>
            </div>

            <div className={classes.ViewVendorHeaderSM}>
              <DetailsTab
                small={true}
                activeColor={"#3B86C7"}
                tabName={"Bidding Details"}
                currentTab={tab1}
                clickFn={tab1Click}
              />
              <DetailsTab
                small={true}
                activeColor={"#3B86C7"}
                tabName={"Shipping Address"}
                currentTab={tab2}
                clickFn={tab2Click}
              />
            </div>

            {tab1 && (
              <>
                {!editRFQForm && (
                  <div className={classes.bidType}>
                    <div className={classes.newRfqBidConfigTitle}>
                      <span>
                        <AttachmentOutlined />
                      </span>
                      <h3>Bid Configuration</h3>
                    </div>
                    <div className={classes.input_container}>
                      <DefaultLabel label={"Bid Type"} required={true} />

                      <div className={classes.util}>
                        <DRadioInput
                          label={
                            <span className={classes.newRfqRadioLabel}>
                              <GavelOutlined />
                              Auction
                            </span>
                          }
                          id={"open"}
                          value={"open"}
                          checked={
                            bidType.value === true || bidType.value === "open"
                          }
                          customClass={classes.radioTag}
                          onChange={() => {
                            setBidType({
                              value: true,
                            });
                          }}
                          name={"bidType"}
                        />

                        <DRadioInput
                          label={
                            <span className={classes.newRfqRadioLabel}>
                              <LockOutlined />
                              Closed
                            </span>
                          }
                          id={"close"}
                          checked={
                            bidType.value === false ||
                            bidType.value === "closed"
                          }
                          customClass={classes.radioTag}
                          value={"close"}
                          onChange={() => {
                            setBidType({
                              value: false,
                            });
                          }}
                          name={"bidType"}
                        />
                      </div>
                    </div>

                    <div className={classes.input_container}>
                      <div className={classes.labelWithInfo}>
                        <DefaultLabel label={"Sealed Bid"} />
                        <Tooltip
                          title="Sealed Bid: Quotations cannot be viewed or opened until the bid closes."
                          placement="top"
                          arrow
                          componentsProps={{
                            tooltip: {
                              sx: { fontSize: "13px" },
                            },
                          }}
                        >
                          <InfoOutlined className={classes.infoIcon} />
                        </Tooltip>
                      </div>

                      <div className={classes.util}>
                        <DRadioInput
                          label={"Yes"}
                          id={"sealedBidYes"}
                          value={"true"}
                          checked={sealedBid === true}
                          customClass={classes.radioTag}
                          onChange={() => setSealedBid(true)}
                          name={"sealedBid"}
                        />

                        <DRadioInput
                          label={"No"}
                          id={"sealedBidNo"}
                          value={"false"}
                          checked={sealedBid === false}
                          customClass={classes.radioTag}
                          onChange={() => setSealedBid(false)}
                          name={"sealedBid"}
                        />
                      </div>
                    </div>

                    <div className={classes.bidStatus}>
                      <DDateInput
                        customClassName={classes.bidInputs}
                        label={"Start Date"}
                        required={true}
                        value={fromDate}
                        onChange={(e) => {
                          setFromDate({
                            value: e,
                            isValid:
                              e !== null ||
                              e !== null ||
                              e !== "" ||
                              e !== undefined ||
                              fromDate.value !== "",
                          });
                          setToDate({
                            value: "",
                            isValid: true,
                          });
                        }}
                        disablePast={true}
                        error={!fromDate.isValid}
                        errorMsg={"Start Date is required"}
                        // disabled={!bidType.value || !bidType.value === ""}
                        size={"26rem"}
                      />

                      <DDateInput
                        customClassName={classes.bidInputs}
                        label={"End Date"}
                        required={true}
                        value={toDate}
                        disabledInput={!fromDate.value}
                        fromDate={fromDate.value}
                        onChange={(e) => {
                          setToDate({
                            value: e,
                            isValid:
                              e !== null ||
                              e !== "" ||
                              e !== undefined ||
                              fromDate.value !== "",
                          });
                          setTime({
                            value: null,
                            isValid: true,
                          });
                        }}
                        error={!toDate.isValid}
                        disablePast={true}
                        errorMsg={"End Date is required"}
                        size={"26rem"}
                      />

                      <DTextInput
                        customClassName={classes.bidInputs}
                        label={"End Time"}
                        required={true}
                        showDefaultTime={false}
                        value={time.value}
                        disabled={!toDate.value}
                        endDate={toDate.value}
                        onChange={(e) => {
                          setTime({
                            value: e,
                            // isChanged: true,
                            isValid: Boolean(e),
                          });
                        }}
                        error={!time.isValid}
                        errorMsg={"Time is required"}
                        type={"time"}
                        size={"26rem"}
                      />
                      {fromDate.value && toDate.value && time.value && (
                        <DaysReminder
                          startDate={fromDate.value}
                          endDate={toDate.value}
                          endTime={time.value}
                        />
                      )}
                    </div>

                    <div className={classes.supplierSelectPanel}>
                      <div className={classes.supplierSelectHeader}>
                        <div>
                          <p className={classes.supplierSelectEyebrow}>
                            Suppliers
                          </p>
                          <h4>Select Supplier</h4>
                        </div>
                        <span className={classes.supplierSelectMeta}>
                          {(vendor.value?.length || 0) + alternativeSupplierOptions.length} selected
                        </span>
                      </div>
                      {supplierSourceTabs}
                      {!showAlternativeSuppliers ? <DSelectInput
                        customClass={`${classes.fields} ${classes.compactField} ${classes.supplierSelectField}`}
                        multiselect={true}
                        label="Select Supplier"
                        required={true}
                        value={vendor.value}
                        options={vendorsList.values}
                        setIDValue={setVendorID}
                        onChange={(value) => {
                          setVendor({
                            value: value,
                            isValid: value?.length !== 0 || alternativeSupplierOptions.length > 0,
                          });
                          if (Object.keys(itemVendorErrors || {}).length > 0) {
                            setItemVendorErrors({});
                          }
                          if (
                            btnErrorState?.error &&
                            String(btnErrorState?.errorMsg || "")
                              .toLowerCase()
                              .includes("select vendor")
                          ) {
                            setBtnErrorState({ error: false, errorMsg: "" });
                          }
                        }}
                        error={!vendor.isValid}
                        errorMsg={"Supplier is required"}
                        size={"100%"}
                      /> : alternativeSupplierPicker}
                    </div>
                  </div>
                )}

                {editRFQForm && (
                  <>
                    <div className={classes.bidType}>
                      <div className={classes.newRfqBidConfigTitle}>
                        <span>
                          <AttachmentOutlined />
                        </span>
                        <h3>Bid Configuration</h3>
                      </div>
                      <div className={classes.statusSelect}>
                        <div className={classes.input_container}>
                          <DefaultLabel label={"Bid Type"} />

                          <div className={classes.util}>
                            <DRadioInput
                              label={
                                <span className={classes.newRfqRadioLabel}>
                                  <GavelOutlined />
                                  Auction
                                </span>
                              }
                              id={"open"}
                              value={"open"}
                              checked={bidType.value === true}
                              customClass={classes.radioTag}
                              onChange={() => {
                                setBidType({
                                  value: true,
                                });
                              }}
                              name={"bidType"}
                            />

                            <DRadioInput
                              label={
                                <span className={classes.newRfqRadioLabel}>
                                  <LockOutlined />
                                  Closed
                                </span>
                              }
                              id={"close"}
                              checked={bidType.value === false}
                              customClass={classes.radioTag}
                              value={"close"}
                              onChange={() => {
                                setBidType({
                                  value: false,
                                });
                              }}
                              name={"bidType"}
                            />
                          </div>
                        </div>
                        <div className={classes.input_container}>
                          <div className={classes.labelWithInfo}>
                            <DefaultLabel label={"Sealed Bid"} />
                            <Tooltip
                              title="Sealed Bid: Quotations cannot be viewed or opened until the bid closes."
                              placement="top"
                              arrow
                              componentsProps={{
                                tooltip: {
                                  sx: { fontSize: "13px" },
                                },
                              }}
                            >
                              <InfoOutlined className={classes.infoIcon} />
                            </Tooltip>
                          </div>

                          <div className={classes.util}>
                            <DRadioInput
                              label={"Yes"}
                              id={"editSealedBidYes"}
                              value={"true"}
                              checked={sealedBid === true}
                              customClass={classes.radioTag}
                              onChange={() => setSealedBid(true)}
                              name={"editSealedBid"}
                            />

                            <DRadioInput
                              label={"No"}
                              id={"editSealedBidNo"}
                              value={"false"}
                              checked={sealedBid === false}
                              customClass={classes.radioTag}
                              onChange={() => setSealedBid(false)}
                              name={"editSealedBid"}
                            />
                          </div>
                        </div>
                        <div className={classes.input_container}>
                          <DefaultLabel label={"Bid Status"} />

                          <div className={classes.util}>
                            <DRadioInput
                              label="Cancelled"
                              id="cancelled"
                              value="cancelled"
                              checked={bidStatus.value === "cancelled"}
                              customClass={classes.radioTag}
                              name="bidStatus"
                              allowUncheck={true}
                              onChange={(checked, value) => {
                                if (!checked) {
                                  // Uncheck: set to null
                                  setBidStatus({
                                    value: null,
                                    isChanged: true,
                                  });
                                } else {
                                  // Check: set to the value (using a fallback value, though 'value' should be 'cancelled')
                                  setBidStatus({
                                    value: value || "cancelled",
                                    isChanged: true,
                                  });
                                }
                              }}
                            />

                            <DRadioInput
                              allowUncheck={true}
                              label={"Failed"}
                              id={"failed"}
                              checked={bidStatus.value === "failed"}
                              customClass={classes.radioTag}
                              value={"failed"}
                              onChange={(checked, value) => {
                                if (!checked) {
                                  // Uncheck: set to null
                                  setBidStatus({
                                    value: null,
                                    isChanged: true,
                                  });
                                } else {
                                  setBidStatus({
                                    value: value || "failed", // fallback to 'failed' if value is null
                                    isChanged: true,
                                  });
                                }
                              }}
                              name={"bidStatus"}
                            />
                          </div>
                        </div>
                      </div>

                      <div className={classes.bidStatus}>
                        <DDateInput
                          customClassName={classes.bidInputs}
                          label={"Start Date"}
                          value={fromDate}
                          disabledInput={editRFQForm}
                          onChange={(e) => {
                            setFromDate({
                              value: e,
                              isValid:
                                e !== null ||
                                e !== null ||
                                e !== "" ||
                                e !== undefined ||
                                fromDate.value !== "",
                            });
                          }}
                          disablePast={true}
                          error={!fromDate.isValid}
                          errorMsg={"Start Date is required"}
                          size={"26rem"}
                        />

                        <DDateInput
                          customClassName={classes.bidInputs}
                          label={"End Date"}
                          value={toDate}
                          fromDate={
                            fromDate.value !== ""
                              ? uniqueData?.bid_from_date
                              : fromDate.value
                          }
                          onChange={(e) => {
                            setToDate({
                              value: e,
                              isValid:
                                e !== null ||
                                e !== "" ||
                                e !== undefined ||
                                fromDate.value !== "",
                            });
                            setTime({
                              value: null,
                              isValid: true,
                            });
                          }}
                          disablePast={true}
                          error={!toDate.isValid}
                          errorMsg={"End Date is required"}
                          size={"26rem"}
                        />

                        <DTextInput
                          customClassName={classes.bidInputs}
                          label={"End Time"}
                          showDefaultTime={false}
                          value={time.value}
                          endDate={toDate.value}
                          onChange={(e) => {
                            setTime({
                              value: e,
                              isChanged: true,
                              isValid: Boolean(e),
                            });
                          }}
                          error={!time.isValid}
                          errorMsg={"Time is required"}
                          type={"time"}
                          size={"26rem"}
                        />
                        {fromDate.value && toDate.value && time.value && (
                          <DaysReminder
                            startDate={fromDate.value}
                            endDate={toDate.value}
                            endTime={time.value}
                          />
                        )}
                      </div>

                      <div className={classes.supplierSelectPanel}>
                        <div className={classes.supplierSelectHeader}>
                          <div>
                            <p className={classes.supplierSelectEyebrow}>
                              Suppliers
                            </p>
                            <h4>Select Supplier</h4>
                          </div>
                          <span className={classes.supplierSelectMeta}>
                            {(vendor.value?.length || 0) + alternativeSupplierOptions.length} selected
                          </span>
                        </div>
                        {supplierSourceTabs}
                        {!showAlternativeSuppliers ? <DSelectInput
                          isEdit={false}
                          customClass={`${classes.fields} ${classes.compactField} ${classes.supplierSelectField}`}
                          multiselect={true}
                          label="Select Supplier"
                          value={vendor.value}
                          options={vendorsList.values}
                          setIDValue={setVendorID}
                          onChange={(value) => {
                            setVendor({
                              value: value,
                              isValid: value?.length !== 0 || alternativeSupplierOptions.length > 0,
                            });
                            if (Object.keys(itemVendorErrors || {}).length > 0) {
                              setItemVendorErrors({});
                            }
                            if (
                              btnErrorState?.error &&
                              String(btnErrorState?.errorMsg || "")
                                .toLowerCase()
                                .includes("select vendor")
                            ) {
                              setBtnErrorState({ error: false, errorMsg: "" });
                            }
                          }}
                          error={!vendor.isValid}
                          errorMsg={"Supplier is required"}
                          size={"100%"}
                        /> : alternativeSupplierPicker}
                        {showNoMappedVendorsNote && (
                        <div className={classes.vendorMappingNote}>
                          <p>
                            No vendors are available for the selected item(s).
                            If this looks wrong, map the vendor with the
                            respective item in Supplier Management → Item
                            Mapping, then come back to select the vendor here.
                          </p>
                          <button
                            type="button"
                            className={classes.vendorMappingLink}
                            onClick={() => navigate("/Buyer_dashboard/Vendors")}
                          >
                            Open Supplier Management
                          </button>
                        </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
                <DButton
                  labelImg={plusIcon}
                  iconHeight={"15px"}
                  iconwidth={"15px"}
                  label="ADD SUPPLIER"
                  btnHeight="4rem"
                  buyerBtn={true}
                  onClick={() => {
                    handleOpen1();
                  }}
                />
              </>
            )}

            {tab2 && (
              <>
                <div className={classes.newRfqShippingLayout}>
                {(newRFQForm || editRFQForm) && (
                  <div className={classes.newRfqShippingVisual}>
                    <div className={classes.newRfqShippingMap}>
                      <span className={classes.newRfqShippingPin}>
                        <LocationOnOutlined />
                      </span>
                      <span className={classes.newRfqShippingTruck}>
                        <LocalShippingOutlined />
                      </span>
                    </div>
                    <div className={classes.newRfqShippingCopy}>
                      <span>
                        <LocationOnOutlined />
                      </span>
                      <div>
                        <h3>Shipping Address</h3>
                        <p>Delivery details for supplier coordination.</p>
                      </div>
                    </div>
                    <div className={classes.newRfqShippingNote}>
                      Ensure delivery location is accurate for smooth and timely fulfillment.
                    </div>
                  </div>
                )}
                <div className={classes.input_fields_wrapper}>
                  {!shippingAddress ? (
                    <DTextInput
                      customClassName={classes.fields}
                      label="Address Line 1"
                      required={true}
                      type="text"
                      value={address1.value}
                      onChange={(e) => {
                        let val = e.target.value;
                        setAddress1({
                          value: val,
                          isValid: emptyCheck(val),
                        });
                      }}
                      error={!address1.isValid}
                      errorMsg={"Address Line 1 is required"}
                      size={"100%"}
                    />
                  ) : (
                    <DSearchInputDropdown
                      addresses={shippingAddress}
                      selectHandler={handleSelectedAddress}
                      hanlderSearch={(e) => {
                        let val = e;
                        setAddress1({
                          value: val,
                          isValid: emptyCheck(val),
                        });
                      }}
                      searchTerm={address1}
                    />
                  )}

                  <DTextInput
                    customClassName={classes.fields}
                    label="Address Line 2 (Optional)"
                    type="text"
                    value={address2.value}
                    onChange={(e) => {
                      let val = e.target.value;
                      setAddress2({
                        value: val,
                      });
                    }}
                    size={"100%"}
                  />

                  <DSelectInput
                    label="Country"
                    required={true}
                    defaultDropdown={true}
                    value={country.value}
                    noInit={true}
                    onChange={(e) => {
                      setCountry((prev) => ({
                        ...prev,
                        value: e,
                        isValid: validateSelect("Select", e),
                      }));
                      setStateName({
                        value: "",
                        stateList: [],
                        isValid: true,
                      });
                      setCity({
                        value: "",
                        cityList: [],
                        isValid: true,
                      });
                      setstateToken();
                      let filterObj =
                        e && country.countryList?.filter((el) => el.name === e);
                      if (filterObj && filterObj[0]) {
                        // Store both token and id for filtering
                        setCountryToken(filterObj[0]?.token);
                        // Pass country.id (number) to getStatesList for proper filtering
                        e &&
                          getStatesList(filterObj[0]?.id, filterObj[0]?.token);
                      }
                    }}
                    options={
                      country.countryList?.map((el) => el.name) || ["Select"]
                    }
                    error={!country.isValid}
                    errorMsg={country.isValid ? "" : "Country is required"}
                    customClassName={classes.field}
                  />

                  <DSelectInput
                    label="State/Province/Region"
                    required={true}
                    defaultDropdown={true}
                    value={stateName.value}
                    disabled={!countryToken && !editRFQForm}
                    noInit={true}
                    onChange={(e) => {
                      setStateName((prev) => ({
                        ...prev,
                        value: e,
                        isValid: validateSelect("Select", e),
                      }));
                      setCity({
                        value: "",
                        cityList: [],
                        isValid: true,
                      });
                      let filterObj =
                        e && stateName.stateList?.filter((el) => el.name === e);
                      if (filterObj && filterObj[0]) {
                        // Store both token and id for filtering
                        setstateToken(filterObj[0]?.token);
                        // Pass state.id (number) to getCityList for proper filtering by state_id
                        const stateId = filterObj[0]?.id;
                        const stateToken = filterObj[0]?.token;
                        console.log(
                          `🔍 State selected: ${e}, state_id=${stateId}, state_token=${stateToken}`,
                        );
                        if (stateId !== null && stateId !== undefined) {
                          getCityList(stateId, stateToken);
                        } else {
                          console.warn(
                            `⚠️ State object missing id field:`,
                            filterObj[0],
                          );
                        }
                      }
                    }}
                    options={
                      stateName.stateList?.length >= 1
                        ? stateName.stateList?.map((el) => el.name)
                        : ["No states available"]
                    }
                    error={!stateName.isValid}
                    errorMsg={
                      stateName.isValid
                        ? ""
                        : "State/Province/Region is required"
                    }
                    customClassName={classes.field}
                  />

                  <DSelectInput
                    label="City"
                    required={true}
                    noInit={true}
                    defaultDropdown={true}
                    value={city.value}
                    disabled={!stateToken && !editRFQForm}
                    onChange={(e) => {
                      setCity((prev) => ({
                        ...prev,
                        value: e,
                        isValid: validateSelect("Select", e),
                      }));
                    }}
                    options={
                      city.cityList?.length >= 1
                        ? [
                            ...new Map(
                              city.cityList.map((el) => [el.name, el.name]),
                            ).values(),
                          ] // Remove duplicates by name
                        : ["No cities available"]
                    }
                    error={!city.isValid}
                    errorMsg={city.isValid ? "" : "City is required"}
                    customClassName={classes.field}
                  />

                  <DTextInput
                    customClassName={classes.fields}
                    label="Postal/Zipcode"
                    required={true}
                    type="text"
                    maxLength={50}
                    value={pincode.value}
                    onChange={(e) => {
                      let val = e.target.value?.replace(regexForNumber, "");
                      setPincode({
                        value: val,
                        isValid: emptyCheck(e.target.value),
                      });
                    }}
                    error={!pincode.isValid}
                    errorMsg={"Postal/Zipcode is required"}
                    size={"100%"}
                  />

                  <DPhoneNumberInput
                    label="Mobile Number"
                    required={true}
                    maxDigits={10}
                    value={mobileNumber.value}
                    placeholder={"9123456789"}
                    onChange={(
                      value,
                      data,
                      isValidMobileNumber,
                      formattedValue,
                    ) => {
                      const rawValue = String(value || "");
                      const allowsDigitsAndSpaces = /^[\d\s]+$/.test(rawValue);
                      // checking the value only for numbers
                      if (
                        (editRFQForm &&
                          (value === "" ||
                            value?.includes("+") ||
                            numberOnlyRegex.test(value) ||
                            allowsDigitsAndSpaces)) ||
                        (newRFQForm &&
                          (value === "" ||
                            numberOnlyRegex.test(value) ||
                            allowsDigitsAndSpaces))
                      ) {
                        setMobileNumber({
                          value: value,
                          format: data?.dialCode,
                          isValid: emptyCheck(value) && isValidMobileNumber,
                        });
                      }
                    }}
                    error={!mobileNumber.isValid}
                    errorMsg={
                      !emptyCheck(mobileNumber.value)
                        ? "Mobile Number is required"
                        : !mobileNumber.isValid
                          ? "Invalid phone number"
                          : ""
                    }
                    size={"100%"}
                  />
                </div>
                </div>
              </>
            )}

            <div className={classes.actions}>
              <DButtonOutlined
                buyerBtn={true}
                label="Cancel"
                btnHeight="4rem"
                btnWidth={"14.4rem"}
                onClick={openRFQMainCancel}
              />
              <DButton
                buyerBtn={true}
                label={btnPrimaryLabel}
                loadingState={loadingState}
                error={btnErrorState.error}
                errorMsg={btnErrorState.errorMsg}
                btnHeight="4rem"
                btnWidth={"14.4rem"}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </>
      ) : (
        !openForm.open &&
        openForm.loading && (
          <div className={classes.tabsScreens}>
            <span className={classes.loader}>
              <CircularProgress
                thickness={6}
                variant="indeterminate"
                disableShrink
                sx={{
                  animationDuration: "350ms",
                  color: "#55555580",
                }}
                size={25}
              />
            </span>
          </div>
        )
      )}

      {viewTimeLine && (
        <div className={classes.tabsScreens}>
          <div className={classes.width__100}>
            <h1 className={classes.view__time_line_titel}>
              RFQ Transaction Details
            </h1>
            {sealedBidNoticePanel}
            <div className={classes.view__time_line}>
              {org_details.map((e, i) => (
                <InfoLabel
                  key={i}
                  isLoading={loadingState}
                  label={e.label}
                  value={e.value}
                  size={e.size}
                />
              ))}
              <div className={classes.chatActionBntWrapper}>
                <DropdownBtnOutlined
                  label="DOWNLOAD"
                  btnHeight="4rem"
                  btnWidth="17rem"
                  custom={classes.bgcolor}
                  loadingState={loadingStateDwnload}
                  disabled={RFQData?.length === 0}
                  onClick={(fileFormat) => {
                    const rfq_codes = org_details.map((e, i) => {
                      return e.label === "RFQ ID" ? e.value : "";
                    });
                    downloadPdf(rfq_codes[0]);
                  }}
                  options={["PDF"]}
                />
                <DButton
                  label={
                    chatConfirmationDialog.isClosedChat
                      ? "Enable chat"
                      : "Disable Chat"
                  }
                  btnHeight="4rem"
                  btnWidth={"15rem"}
                  buyerBtn={true}
                  onClick={() => handleChatStatusConfirmation()}
                  customWrapperClass={classes.chatBtn}
                />
              </div>
            </div>
            <div className={classes.overflow_hadle}>
              {" "}
              {/* id="organization_details"*/}
              <div>
                {renderTimelineCards(
                  filteredVendorTimelineData,
                  shouldShowSealedBidNotice,
                )}
              </div>
              <div className={classes.documentconatiner}>
                <div className={classes.documentheader}>
                  {/* doc header */}
                  <h3>Uploaded Documents</h3>
                </div>

                <div className={classes.documentcontent}>
                  {/* documents */}
                  <ul>
                    {filteredVendorTimelineData &&
                      filteredVendorTimelineData
                        .filter(
                          (entry) =>
                            Array.isArray(entry.document) &&
                            entry.document.length > 0,
                        )
                        .map((entry, index) =>
                          shouldShowSealedBidNotice ? (
                            <React.Fragment key={index}>
                              {renderMaskedAttachmentList(
                                entry,
                                `vendor-doc-${index}`,
                              )}
                            </React.Fragment>
                          ) : (
                            <AttachmentList key={index} item={entry} />
                          ),
                        )}

                    {currentVendorBidDocuments.map(({ key, item }) =>
                      shouldShowSealedBidNotice ? (
                        <React.Fragment key={key}>
                          {renderMaskedAttachmentList(item, key)}
                        </React.Fragment>
                      ) : (
                        <li key={key}>
                          <a
                            href={item.document[0].url}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              display: "block",
                              fontSize: "13px",
                              overflowWrap: "anywhere",
                              wordBreak: "break-word",
                            }}
                          >
                            {item.document[0].name}
                          </a>
                        </li>
                      ),
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {viewRFQComparedTable && (
        <>
          <ComparedTable
            data={compairedData}
            compareJsonFile={fileJsonHistory}
            compareTitle={comparedNameDate}
            previousPurchases={comparisonPreviousPurchases}
            backButtonStatus={true}
            showHeader={true}
            isRefetchData={true}
            handleRefetchData={callCompare}
            isLoading={loadingState}
            isPending={isComparePending}
            pendingText="Comparison is in progress. Please wait — results will appear here once generated."
            autoRefreshIntervalMs={15 * 1000}
            isAutoRefresh={isComparePending}
          />
        </>
      )}

      {/* Multiple items preview (RFQ list) */}
      <Modal
        open={rfqItemsPreviewDialog.open}
        onClose={closeRfqItemsPreviewDialog}
      >
        <Fade in={rfqItemsPreviewDialog.open}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "min(1100px, 94vw)",
              maxHeight: "85vh",
              bgcolor: "#ffffff",
              borderRadius: "14px",
              boxShadow: 24,
              p: 2.2,
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1.5,
              }}
            >
              <Typography
                sx={{
                  fontFamily: "GilroyBold",
                  fontSize: "16px",
                  color: "#0f172a",
                }}
              >
                RFQ Items
                {rfqItemsPreviewDialog.rfqCode
                  ? ` - ${rfqItemsPreviewDialog.rfqCode}`
                  : ""}
              </Typography>
              <IconButton
                onClick={closeRfqItemsPreviewDialog}
                size="small"
                aria-label="Close"
              >
                <Close />
              </IconButton>
            </Box>

            <TableContainer component={Paper} sx={{ maxHeight: "70vh" }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontFamily: "GilroyBold",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Item Name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontFamily: "GilroyBold",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Item Code
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontFamily: "GilroyBold",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Expense Type
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontFamily: "GilroyBold",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                      align="right"
                    >
                      Quantity
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontFamily: "GilroyBold",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Unit
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontFamily: "GilroyBold",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Description
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(rfqItemsPreviewDialog.items || []).map((item) => (
                    <TableRow key={item.sl_no}>
                      <TableCell
                        sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}
                      >
                        {rfqCellValueOrDash(item?.item_name)}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}
                      >
                        {rfqCellValueOrDash(item?.item_code)}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}
                      >
                        {rfqCellValueOrDash(item?.expense_type)}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}
                        align="right"
                      >
                        {rfqCellValueOrDash(item?.quantity)}
                      </TableCell>
                      <TableCell
                        sx={{ fontSize: "14px", fontFamily: "gilroyMedium" }}
                      >
                        {rfqCellValueOrDash(item?.unit)}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontSize: "14px",
                          fontFamily: "gilroyMedium",
                          maxWidth: 420,
                        }}
                      >
                        {rfqCellValueOrDash(item?.description)}
                      </TableCell>
                    </TableRow>
                  ))}
                  {(rfqItemsPreviewDialog.items || []).length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          fontSize: "14px",
                          fontFamily: "gilroyMedium",
                          fontStyle: "italic",
                        }}
                      >
                        No items found for this RFQ.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Fade>
      </Modal>

      {/* success modal popup */}
      <Modal open={open}>
        <Fade in={open}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={openRFQMainCancel}
            />
          </Box>
        </Fade>
      </Modal>

      <Modal open={open2}>
        <Fade in={open2}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={sendMessageReset}
            />
          </Box>
        </Fade>
      </Modal>

      {/* add vendor modal popup */}
      <Modal
        open={open1}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
        }}
      >
        <Fade in={open1}>
          <div
            className={classes.flex}
            style={{
              height: "100vh",
            }}
          >
            <PopupFrame
              customClass={vendorClasses.InviteVendorPopup}
              styleCenterDiv={classes.centerDiv}
              inputChildren={vendorsTabInputs}
              poupHeading={vendorsTabHeading}
              actionButtons={popupActions}
            />
          </div>
        </Fade>
      </Modal>

      <Modal open={supplierAddedPopupOpen} onClose={() => setSupplierAddedPopupOpen(false)}>
        <Fade in={supplierAddedPopupOpen}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText="Supplier Added Successfully!"
              popupDescription="The supplier has been added to Supplier Master."
              popBtn={true}
              vendorBtn={true}
              btnText="Okay"
              btnClick={() => setSupplierAddedPopupOpen(false)}
            />
          </Box>
        </Fade>
      </Modal>

      {/* delete error modal two states - confirmation and deletion */}
      {/* confirmation */}
      <Modal open={openDltConfirmation}>
        <Fade in={openDltConfirmation}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              btnText={"Delete"}
              loadingPrimaryBtn={loadingState}
              secondaryBtn={true}
              vendorBtn={true}
              vendorBtnOutlined={true}
              btnTextSecondary={"Cancel"}
              btnClick={handleDeleteRFQ}
              btnClickSecondary={handleCloseDltConfirmation}
            />
          </Box>
        </Fade>
      </Modal>

      {/* deletion */}
      <Modal open={openDlt}>
        <Fade in={openDlt}>
          <Box>
            <SuccessPopupDashboard
              popupImage={deletePopupImg}
              popupHeroText={popupHeroText}
              popupDescription={popupMessage}
              popBtn={true}
              vendorBtn={true}
              loadingPrimaryBtn={loadingState}
              vendorBtnOutlined={true}
              btnText={"Okay"}
              btnClick={handleCloseDlt}
            />
          </Box>
        </Fade>
      </Modal>

      {/* bid select or unselect confirmation popup */}
      <Modal
        open={openBidConfirmation.selectBid || openBidConfirmation.unSelectBid}
      >
        <Box>
          <SuccessPopupDashboard
            popupHeroText={
              openBidConfirmation.selectBid
                ? "Are you sure you want to select these vendor(s)?"
                : "Are you sure you want to unselect these vendor(s)?"
            }
            customClass={classes.confimationPopup}
            popBtn={true}
            buyerBtn={true}
            buyerBtnOutlined={true}
            btnText={"Yes"}
            loadingPrimaryBtn={loadingState}
            btnClick={() => {
              openBidConfirmation.selectBid
                ? selectBid(bidToken)
                : unSelectBid(bidToken);
            }}
            secondaryBtn={true}
            btnTextSecondary={"No"}
            btnClickSecondary={closeSelectBid}
          />
        </Box>
      </Modal>

      {/* bid Selection */}
      <Modal open={bidSelection.select || bidSelection.unselect}>
        <Box>
          <SuccessPopupDashboard
            popupImage={bidSelection.select ? bidSelectedImg : bidUnSelectedImg}
            popupHeroText={
              bidSelection.select
                ? "Vendor(s) selected for PO process!"
                : "Vendors Unselected!"
            }
            popupDescription={
              bidSelection.select
                ? "The vendor will be notified via email. And will be Re-directed to Po Automation"
                : "The vendor will be notified this outcome via email."
            }
            popBtn={true}
            vendorBtn={true}
            vendorBtnOutlined={true}
            btnText={"Okay"}
            btnClick={closeSelectBid}
          />
        </Box>
      </Modal>

      {/* comparison */}
      <Modal open={openComparisonPopup}>
        <Fade in={openComparisonPopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={somthingWrongImg}
              popupHeroText={popupText.popupHeroText}
              popupDescription={popupText.popupDescription}
              loadingPrimaryBtn={loadingState}
              popBtn={true}
              vendorBtn={true}
              vendorBtnOutlined={true}
              btnText={"Okay"}
              customClass={classes.compareModal}
              btnClick={handleCloseComparePopup}
            />
          </Box>
        </Fade>
      </Modal>

      <Modal open={negotiationBotState.open} onClose={resetNegotiationBot}>
        <Fade in={negotiationBotState.open}>
          <Box>
            <div className={classes.negotiationBotModal}>
              <button
                type="button"
                className={classes.negotiationBotClose}
                onClick={resetNegotiationBot}
                aria-label="Close negotiation bot"
              >
                <Close sx={{ fontSize: "22px" }} />
              </button>

              <div className={classes.negotiationBotHeader}>
                <div className={classes.negotiationBotHeaderIcon}>NB</div>
                <div className={classes.negotiationBotHeaderCopy}>
                  <div className={classes.negotiationBotTitleRow}>
                    <span className={classes.negotiationBotEyebrow}>
                      RFQ Negotiation
                    </span>
                  </div>
                  <h2>Negotiation Bot</h2>
                  <p>
                    Use the previous purchase as the price anchor, compare each
                    current vendor quotation, and request revision from selected
                    vendors.
                  </p>
                </div>
              </div>

              {negotiationBotState.loading ? (
                <div className={classes.negotiationBotLoading}>
                  <CircularProgress size={28} thickness={5} />
                  <span>Loading negotiation history...</span>
                </div>
              ) : negotiationBotState.itemPicker ? (
                <div className={classes.negotiationBotSection}>
                  <h3>Select item to analyze</h3>
                  <div className={classes.negotiationItemGrid}>
                    {(negotiationBotState.botItems || []).map((item, index) => (
                      <button
                        type="button"
                        key={`${item.item_rfq_map_token}-${index}`}
                        className={classes.negotiationItemCard}
                        onClick={() => fetchNegotiationBotHistory(item)}
                      >
                        <strong>{item.item_name}</strong>
                        <span>{item.item_code}</span>
                        <small>
                          {item.quantity} {item.unit}
                        </small>
                      </button>
                    ))}
                  </div>
                </div>
              ) : negotiationBotState.data ? (
                <>
                  <div className={classes.negotiationContextGrid}>
                    <div className={classes.negotiationSummaryCard}>
                      <span>RFQ</span>
                      <strong>
                        {negotiationBotState.data?.rfq?.rfq_code || "-"}
                      </strong>
                    </div>
                    <div className={classes.negotiationSummaryCard}>
                      <span>Item</span>
                      <strong>
                        {negotiationBotState.data?.item?.item_name || "-"}
                      </strong>
                      <small>
                        {negotiationBotState.data?.item?.item_code || "-"} |{" "}
                        {negotiationBotState.data?.item?.quantity || "-"}{" "}
                        {negotiationBotState.data?.item?.unit || ""}
                      </small>
                    </div>
                  </div>

                  <div className={classes.negotiationBaselinePanel}>
                    <div className={classes.negotiationBaselineMain}>
                      <span>Previous Purchase Price</span>
                      <strong>{getNegotiationPreviousPrice()}</strong>
                      <small>
                        PO{" "}
                        {getSelectedNegotiationHistory()
                          ?.purchase_order_number || "-"}{" "}
                        |{" "}
                        {formatNegotiationDate(
                          getSelectedNegotiationHistory()
                            ?.purchase_order_date ||
                            getSelectedNegotiationHistory()?.purchase_date,
                        )}
                      </small>
                    </div>
                    <div className={classes.negotiationBaselineDetail}>
                      <span>Previous Vendor</span>
                      <strong>
                        {getSelectedNegotiationHistory()
                          ?.previous_vendor_name ||
                          getSelectedNegotiationHistory()?.vendor_name ||
                          "-"}
                      </strong>
                      <small>
                        {getSelectedNegotiationHistory()?.quantity || "-"}{" "}
                        {getSelectedNegotiationHistory()?.unit || ""} |{" "}
                        {getSelectedNegotiationHistory()?.item_code || "-"}
                      </small>
                    </div>
                    <div className={classes.negotiationBaselineDetail}>
                      <span>Best Current Quote</span>
                      <strong>
                        {getNegotiationDisplayPrice(
                          getBestNegotiationQuote() || {},
                        )}
                      </strong>
                      <small>
                        {getBestNegotiationQuote()?.vendor_name ||
                          "No priced quote"}
                      </small>
                    </div>
                    <div className={classes.negotiationBaselineDetail}>
                      <span>Current Vendors</span>
                      <strong>
                        {negotiationBotState.data?.current_quotations?.length ||
                          0}
                      </strong>
                      <small>
                        {negotiationBotState.selectedVendorBidItemTokens.length}{" "}
                        selected for revision
                      </small>
                    </div>
                  </div>

                  <div className={classes.negotiationBotSection}>
                    <div className={classes.negotiationSectionHeading}>
                      <span>01</span>
                      <h3>Item Details</h3>
                    </div>
                    <div className={classes.negotiationItemDetailGrid}>
                      <div>
                        <b>Description</b>
                        <p>
                          {negotiationBotState.data?.item?.description || "-"}
                        </p>
                      </div>
                      <div>
                        <b>Item Code</b>
                        <p>{negotiationBotState.data?.item?.item_code || "-"}</p>
                      </div>
                      <div>
                        <b>Quantity</b>
                        <p>
                          {negotiationBotState.data?.item?.quantity || "-"}{" "}
                          {negotiationBotState.data?.item?.unit || ""}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className={classes.negotiationBotSection}>
                    <div className={classes.negotiationSectionHeading}>
                      <span>02</span>
                      <h3>Previous Purchase Reference</h3>
                    </div>
                    <div className={classes.negotiationHistoryList}>
                      {getNegotiationPreviousPurchases(negotiationBotState.data)
                        .length ? (
                        getNegotiationPreviousPurchases(
                          negotiationBotState.data,
                        ).map((history, index) => (
                          <label
                            className={classes.negotiationHistoryCard}
                            key={history.history_id || `history-${index}`}
                          >
                            <input
                              type="radio"
                              name="negotiation-history"
                              disabled={!negotiationBotState.selectMode}
                              checked={
                                String(
                                  negotiationBotState.selectedHistoryId || "",
                                ) === String(history.history_id || "")
                              }
                              onChange={() =>
                                setNegotiationBotState((prev) => ({
                                  ...prev,
                                  selectedHistoryId: history.history_id || "",
                                  error: "",
                                }))
                              }
                            />
                            <div className={classes.negotiationHistoryBody}>
                              <div className={classes.negotiationHistoryHeader}>
                                <div className={classes.negotiationHistoryVendor}>
                                  <b>Previous Vendor</b>
                                  <strong>
                                    {history.previous_vendor_name ||
                                      history.vendor_name ||
                                      "Supplier"}
                                  </strong>
                                </div>
                                <div className={classes.negotiationHistoryPrice}>
                                  <b>Unit Price</b>
                                  <strong>
                                    {getNegotiationDisplayPrice(history)}
                                  </strong>
                                  <em>{history.match_type || "Reference"}</em>
                                </div>
                              </div>
                              <div className={classes.negotiationHistoryMeta}>
                                <div>
                                  <b>PO Date</b>
                                  <strong>
                                    {formatNegotiationDate(
                                      history.purchase_order_date ||
                                        history.purchase_date,
                                    )}
                                  </strong>
                                </div>
                                <div>
                                  <b>PO Number</b>
                                  <strong>
                                    {history.purchase_order_number || "-"}
                                  </strong>
                                </div>
                                <div>
                                  <b>Quantity</b>
                                  <strong>
                                    {history.quantity || "-"}{" "}
                                    {history.unit || ""}
                                  </strong>
                                </div>
                                <div>
                                  <b>Item Code</b>
                                  <strong>{history.item_code || "-"}</strong>
                                </div>
                              </div>
                              <div className={classes.negotiationHistoryDescription}>
                                <b>Previous Description</b>
                                {renderNegotiationDescription(
                                  history.description ||
                                    "Previous purchase reference available for comparison.",
                                  `previous-${history.history_id || index}`,
                                )}
                              </div>
                            </div>
                          </label>
                        ))
                      ) : (
                        <div className={classes.negotiationHistoryEmpty}>
                          No reference purchase history available for this item.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={classes.negotiationBotSection}>
                    <div className={classes.negotiationSectionTitleRow}>
                      <div className={classes.negotiationSectionHeading}>
                        <span>03</span>
                        <h3>Vendor Quote Comparison</h3>
                      </div>
                      {negotiationBotState.selectMode && (
                        <span>
                          {
                            negotiationBotState.selectedVendorBidItemTokens
                              .length
                          }{" "}
                          of {getNegotiationQuotationTokens().length} selected
                        </span>
                      )}
                    </div>
                    <div className={classes.negotiationQuoteTableWrap}>
                      <table className={classes.negotiationQuoteTable}>
                        <colgroup>
                          {negotiationBotState.selectMode && (
                            <col className={classes.negotiationSelectCol} />
                          )}
                          <col className={classes.negotiationSupplierCol} />
                          <col className={classes.negotiationPriceCol} />
                          <col className={classes.negotiationPriceCol} />
                          <col className={classes.negotiationDeltaCol} />
                          <col className={classes.negotiationDescriptionCol} />
                        </colgroup>
                        <thead>
                          <tr>
                            {negotiationBotState.selectMode && (
                              <th>
                                <label
                                  className={classes.negotiationSelectAll}
                                >
                                  <input
                                    type="checkbox"
                                    checked={
                                      getNegotiationQuotationTokens().length >
                                        0 &&
                                      getNegotiationQuotationTokens().every(
                                        (token) =>
                                          negotiationBotState.selectedVendorBidItemTokens.includes(
                                            token,
                                          ),
                                      )
                                    }
                                    onChange={toggleAllNegotiationVendorTokens}
                                  />
                                  <span>All</span>
                                </label>
                              </th>
                            )}
                            <th>Vendor Details</th>
                            <th>Current Quote</th>
                            <th>Past Price</th>
                            <th>Difference</th>
                            <th>Item / Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(
                            negotiationBotState.data?.current_quotations || []
                          ).map((quote) => {
                            const token = String(
                              quote.vendor_bid_item_token || "",
                            );
                            const checked =
                              negotiationBotState.selectedVendorBidItemTokens.includes(
                                token,
                              );
                            return (
                              <tr key={token || quote.vendor_token}>
                                {negotiationBotState.selectMode && (
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={checked}
                                      onChange={() =>
                                        toggleNegotiationVendorToken(token)
                                      }
                                    />
                                  </td>
                                )}
                                <td>
                                  <div
                                    className={classes.negotiationSupplierCell}
                                  >
                                    <strong>{quote.vendor_name || "-"}</strong>
                                    <span>
                                      Qty {quote.quantity || "-"}{" "}
                                      {quote.unit || ""}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <strong>{getNegotiationDisplayPrice(quote)}</strong>
                                  <small>{quote.currency || ""}</small>
                                </td>
                                <td>
                                  <strong>{getNegotiationPreviousPrice()}</strong>
                                  <small>
                                    {getSelectedNegotiationHistory()
                                      ?.previous_vendor_name ||
                                      getSelectedNegotiationHistory()
                                        ?.vendor_name ||
                                      ""}
                                  </small>
                                </td>
                                <td>
                                  <strong
                                    className={getNegotiationDeltaClass(
                                      quote.difference_amount,
                                    )}
                                  >
                                    {getNegotiationQuoteDelta(quote)}
                                  </strong>
                                  <small>vs previous purchase</small>
                                </td>
                                <td>
                                  <strong>
                                    {quote.item_name || "-"}{" "}
                                    {quote.item_code ? `(${quote.item_code})` : ""}
                                  </strong>
                                  <small>
                                    Part No: {quote.part_number || "-"}
                                  </small>
                                  {renderNegotiationDescription(
                                    quote.description || "-",
                                    `current-${
                                      quote.vendor_bid_item_token ||
                                      quote.vendor_token ||
                                      quote.vendor_name
                                    }`,
                                    classes.negotiationQuoteDescription,
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {negotiationBotState.result && (
                    <div className={classes.negotiationResultBox}>
                      <strong>
                        {negotiationBotState.result?.message ||
                          "Negotiation request sent successfully."}
                      </strong>
                      <span>
                        Requested Count:{" "}
                        {negotiationBotState.result?.requested_count || 0}
                        {negotiationBotState.result?.email_sent_count !==
                          undefined
                          ? ` | Emails Sent: ${negotiationBotState.result.email_sent_count}`
                          : ""}
                      </span>
                      {Array.isArray(negotiationBotState.result?.results) &&
                        negotiationBotState.result.results.length > 0 && (
                          <div className={classes.negotiationResultTableWrap}>
                            <table className={classes.negotiationResultTable}>
                              <thead>
                                <tr>
                                  <th>Supplier</th>
                                  <th>Revision</th>
                                  <th>Notification</th>
                                  <th>Email</th>
                                </tr>
                              </thead>
                              <tbody>
                                {negotiationBotState.result.results.map(
                                  (result) => (
                                    <tr
                                      key={
                                        result.vendor_bid_item_token ||
                                        result.vendor_token
                                      }
                                    >
                                      <td>{result.vendor_name || "-"}</td>
                                      <td>
                                        {result.revision_requested
                                          ? "Requested"
                                          : "Not requested"}
                                      </td>
                                      <td>
                                        {result.notification_created
                                          ? "Created"
                                          : "Pending"}
                                      </td>
                                      <td>
                                        {result.email_sent ? "Sent" : "Pending"}
                                      </td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                    </div>
                  )}
                </>
              ) : null}

              {negotiationBotState.error && (
                <div className={classes.negotiationError}>
                  {String(negotiationBotState.error)}
                </div>
              )}

              <div className={classes.negotiationBotActions}>
                <DButtonOutlined
                  label={"Cancel"}
                  btnHeight="4rem"
                  btnWidth="max-content"
                  buyerBtn={true}
                  onClick={resetNegotiationBot}
                />
                {negotiationBotState.data &&
                  !negotiationBotState.result &&
                  (!negotiationBotState.selectMode ? (
                    <DButton
                      label={"Select Suppliers"}
                      btnHeight="4rem"
                      btnWidth="max-content"
                      buyerBtn={true}
                      onClick={enableNegotiationSelection}
                    />
                  ) : (
                    <DButton
                      label={"Submit Request"}
                      btnHeight="4rem"
                      btnWidth="max-content"
                      buyerBtn={true}
                      loadingState={negotiationBotState.submitting}
                      disabled={
                        !negotiationBotState.selectedVendorBidItemTokens.length
                      }
                      onClick={submitNegotiationRevisionRequest}
                    />
                  ))}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
      {/* selected quatation */}
      <Modal open={openViewQuotesPopup}>
        <Fade in={openViewQuotesPopup}>
          <Box>
            <div className={classes.quotationWrapper}>
              <Close
                onClick={() => {
                  setSelectedRowForComparison([]);
                  setSelectedRows([]);
                  setOpenViewQuotesPopup(false);
                }}
                sx={{
                  position: "absolute",
                  right: "30px",
                  top: "20px",
                  fontSize: "35px",
                  cursor: "pointer",
                  borderRadius: "50%",
                  padding: "5px",
                  border: "1px solid #eee",
                }}
              />
              <span>View Quotes</span>
              <div className={`${classes.pdfWrapper}`}>
                <div className={`${classes.buyerPDFView}`}>
                  {/* <span className={`${classes.buyerPDFHeading}`}>
                    Buyer RFQ Details
                  </span> */}
                  <div
                    style={{
                      background: "#fff",
                      border: "1px solid #dbe3ea",
                      borderRadius: "8px",
                      padding: "16px",
                    }}
                  >
                    {/* <table
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead style={{ background: "#eef3f7" }}>
                        <tr>
                          {[
                            "Item Name",
                            "Item Code",
                            "HSN",
                            "Quantity",
                            "Unit",
                            "Description",
                            "Expense Type",
                          ].map((heading) => (
                            <th
                              key={heading}
                              style={{
                                padding: "10px",
                                textAlign: "left",
                                fontSize: "13px",
                                borderBottom: "1px solid #dbe3ea",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {heading}
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {Array.isArray(RFQitemsListMapped) &&
                        RFQitemsListMapped.length > 0 ? (
                          RFQitemsListMapped.map((item, idx) => (
                            <tr key={`buyer-rfq-item-${idx}`}>
                              <td
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #edf2f7",
                                }}
                              >
                                {item?.item_name || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #edf2f7",
                                }}
                              >
                                {item?.item_code || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #edf2f7",
                                }}
                              >
                                {item?.hsn_code || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #edf2f7",
                                }}
                              >
                                {item?.quantity || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #edf2f7",
                                }}
                              >
                                {item?.unit || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #edf2f7",
                                  maxWidth: "260px",
                                  whiteSpace: "pre-wrap",
                                  wordBreak: "break-word",
                                }}
                              >
                                {item?.description || "-"}
                              </td>
                              <td
                                style={{
                                  padding: "10px",
                                  borderBottom: "1px solid #edf2f7",
                                }}
                              >
                                {item?.expense_type || "-"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={7}
                              style={{ padding: "14px", textAlign: "center" }}
                            >
                              No RFQ items found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table> */}

                    <div style={{ marginTop: "18px" }}>
                      <span
                        className={`${classes.buyerPDFHeading} ${classes.viewQuotesSubHeading}`}
                      >
                        Buyer requirement document
                      </span>
                      {uniqueData?.item_description_doc ||
                      uniqueData?.proposal_document ? (
                        <PDFViewAllFileType
                          fileSrc={normalizeDocumentUrlForCompare(
                            uniqueData?.item_description_doc ||
                              uniqueData?.proposal_document,
                          )}
                        />
                      ) : (
                        <div className={classes.viewQuotesEmptyDoc}>
                          Buyer requirement document is not available.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className={`${classes.vendorPDFView}`}>
                  <div className={`${classes.vendorDocumentsWrapper}`}>
                    {selectedRowForComparison
                      ?.map((item) => [
                        {
                          uri: item.document?.replace(
                            "https://teckost.s3.amazonaws.com",
                            process.env.REACT_APP_CLOUDFRONT_URL,
                          ),
                          fileName: item?.vendor,
                        },
                      ])
                      ?.map((item) => (
                        <div className={`${classes.pdfcodeviewr}`}>
                          <DocViewer documents={item} />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* explore unregistered vendor quotation history */}
      <Modal open={openExploreUnregisteredQuotes}>
        <Fade in={openExploreUnregisteredQuotes}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "min(96vw, 1200px)",
              maxHeight: "88vh",
              overflow: "auto",
              bgcolor: "#f5f5f5",
              borderRadius: "14px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 24px 70px rgba(15, 23, 42, 0.2)",
              p: 2.5,
              fontFamily: "gilroyMedium",
              fontSize: "14px",
            }}
          >
            <Close
              onClick={() => {
                setOpenExploreUnregisteredQuotes(false);
                setExploreError("");
                setExploreLoading(false);
                setExploreExpandedDescriptions({});
              }}
              sx={{
                position: "absolute",
                right: "18px",
                top: "14px",
                fontSize: "34px",
                cursor: "pointer",
                borderRadius: "50%",
                padding: "5px",
                border: "1px solid #eee",
                background: "#fff",
              }}
            />

            <Typography
              sx={{ fontFamily: "gilroyBold", fontSize: 18, mb: 1.25 }}
            >
              Explore Alternative Quotations
            </Typography>

            <Typography sx={{ color: "#64748b", fontSize: 14, mb: 2 }}>
              Select one or more RFQ items and search for matching alternative
              vendor quotations.
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns:
                  "minmax(420px, 1fr) minmax(280px, 360px) auto",
                gap: 2,
                alignItems: "center",
                mb: 2,
                "@media (max-width: 900px)": {
                  gridTemplateColumns: "1fr",
                  alignItems: "stretch",
                },
              }}
            >
              <Autocomplete
                multiple
                size="small"
                options={exploreItemOptions}
                value={exploreSelectedItems}
                onChange={(_, value) => {
                  const next = Array.isArray(value) ? value : [];
                  const pickedAll = next.some((v) => v && v.__all);
                  if (pickedAll) {
                    const items = Array.isArray(RFQitemsListMapped)
                      ? RFQitemsListMapped
                      : [];
                    setExploreSelectedItems(items);
                    return;
                  }
                  setExploreSelectedItems(next.filter((v) => v && !v.__all));
                }}
                filterSelectedOptions
                isOptionEqualToValue={(opt, val) =>
                  Boolean(opt?.__all) === Boolean(val?.__all) &&
                  `${opt?.item_name}|${opt?.item_code}|${opt?.description}` ===
                    `${val?.item_name}|${val?.item_code}|${val?.description}`
                }
                getOptionLabel={(opt) => {
                  if (opt?.__all) return "All items";
                  const name = String(opt?.item_name || "").trim();
                  const code = String(opt?.item_code || "").trim();
                  const desc = String(opt?.description || "").trim();
                  const left = [name, code && code !== "-" ? `(${code})` : ""]
                    .filter(Boolean)
                    .join(" ");
                  return (
                    [left, desc && desc !== "-" ? desc : ""]
                      .filter(Boolean)
                      .join(" — ") || "Item"
                  );
                }}
                renderOption={(props, opt) => {
                  const label = opt?.__all
                    ? "All items"
                    : (() => {
                        const name = String(opt?.item_name || "").trim();
                        const code = String(opt?.item_code || "").trim();
                        const desc = String(opt?.description || "").trim();
                        const left = [
                          name,
                          code && code !== "-" ? `(${code})` : "",
                        ]
                          .filter(Boolean)
                          .join(" ");
                        return (
                          [left, desc && desc !== "-" ? desc : ""]
                            .filter(Boolean)
                            .join(" — ") || "Item"
                        );
                      })();

                  return (
                    <li {...props}>
                      <Typography
                        sx={{ fontFamily: "gilroyMedium", fontSize: "14px" }}
                      >
                        {label}
                      </Typography>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="RFQ Items"
                    placeholder="Select items"
                    InputLabelProps={{
                      ...params.InputLabelProps,
                      style: { fontFamily: "gilroyMedium", fontSize: "14px" },
                    }}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontFamily: "gilroyMedium", fontSize: "14px" },
                    }}
                  />
                )}
                sx={{
                  minWidth: 0,
                  "& .MuiChip-label": {
                    fontFamily: "gilroyMedium",
                    fontSize: "14px",
                  },
                  "& .MuiChip-root": { height: 30 },
                  "& .MuiAutocomplete-inputRoot": {
                    minHeight: 44,
                    alignItems: "center",
                  },
                }}
              />

              <Box sx={{ minWidth: 0 }}>
                <Box
                  sx={{
                    "& input": { fontFamily: "gilroyMedium", fontSize: "14px" },
                    "& input::placeholder": {
                      fontFamily: "gilroyMedium",
                      fontSize: "14px",
                    },
                  }}
                >
                  <SearchBar
                    value={exploreSearch}
                    onChange={setExploreSearch}
                    customClass={classes.exploreSearchBar}
                    placeholder="Search results (email, file, item…)"
                  />
                </Box>
              </Box>

              <DButton
                label={exploreLoading ? "Searching..." : "Search"}
                btnHeight="4rem"
                btnWidth="max-content"
                buyerBtn={true}
                customClass={classes.rfqActionBtn}
                disabled={
                  exploreLoading ||
                  !exploreSelectedItems ||
                  exploreSelectedItems.length === 0
                }
                onClick={fetchExploreUnregisteredQuotes}
              />
            </Box>

            {exploreError ? (
              <Typography sx={{ color: "#b91c1c", fontSize: 14, mb: 1.5 }}>
                {exploreError}
              </Typography>
            ) : null}

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography sx={{ fontFamily: "gilroyMedium", fontSize: 14 }}>
                Matches: {filteredExploreMatches.length}
              </Typography>
              {exploreLoading ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <CircularProgress size={18} />
                  <Typography
                    sx={{
                      fontFamily: "gilroyMedium",
                      fontSize: 14,
                      color: "#475569",
                    }}
                  >
                    Fetching...
                  </Typography>
                </Stack>
              ) : null}
            </Box>

            <TableContainer
              component={Paper}
              sx={{ borderRadius: 2, border: "1px solid #e2e8f0" }}
            >
              <Table
                size="small"
                stickyHeader
                sx={{
                  "& .MuiTableCell-root": {
                    fontFamily: "gilroyMedium",
                    fontSize: "14px",
                    py: 1,
                  },
                  "& .MuiTableCell-head": {
                    fontFamily: "gilroyBold",
                    backgroundColor: "#f8fafc",
                  },
                }}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Supplier Email</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Item</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell align="right">Unit Price</TableCell>
                    <TableCell align="right">Tax (%)</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredExploreMatches.map((m, idx) => {
                    const vendorEmail = m?.vendor_details?.vendor_email || "-";
                    const vendorStatus = m?.vendor_details?.status || "-";
                    const itemName = m?.item_name || "-";
                    const description = m?.description || "-";
                    const unit = formatExploreRupees(m?.unit_price);
                    const tax = m?.tax ?? "-";

                    const emailStr = String(vendorEmail || "").trim();
                    const rowKey = String(
                      m?.token || m?.quotation_token || `${idx}`,
                    );
                    const descText = String(description || "");
                    const shouldTruncate = descText.length > 90;
                    const isExpanded = Boolean(
                      exploreExpandedDescriptions?.[rowKey],
                    );
                    const shownDesc =
                      !shouldTruncate || isExpanded
                        ? descText
                        : `${descText.slice(0, 90)}...`;

                    return (
                      <TableRow
                        key={m?.token || `${m?.quotation_token || "q"}-${idx}`}
                        hover
                      >
                        <TableCell sx={{ maxWidth: 260 }}>
                          <Tooltip title={emailStr || ""}>
                            <span
                              style={{
                                display: "inline-block",
                                maxWidth: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {vendorEmail}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell>{vendorStatus}</TableCell>
                        <TableCell sx={{ maxWidth: 320 }}>
                          <span
                            style={{
                              display: "inline-block",
                              maxWidth: "100%",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {itemName}
                          </span>
                        </TableCell>
                        <TableCell sx={{ maxWidth: 420 }}>
                          <span>
                            {shownDesc || "-"}
                            {shouldTruncate ? (
                              <button
                                type="button"
                                onClick={() => toggleExploreDescription(rowKey)}
                                style={{
                                  marginLeft: 8,
                                  border: "none",
                                  background: "transparent",
                                  color: "#2563eb",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontFamily: "gilroyMedium",
                                  fontSize: "14px",
                                  padding: 0,
                                }}
                              >
                                {isExpanded ? "Read less" : "Read more"}
                              </button>
                            ) : null}
                          </span>
                        </TableCell>
                        <TableCell align="right">{unit}</TableCell>
                        <TableCell align="right">{tax}</TableCell>
                        <TableCell align="center">
                          <Stack
                            direction="row"
                            spacing={1}
                            justifyContent="center"
                          >
                            <Tooltip
                              title={
                                <span
                                  style={{
                                    fontFamily: "gilroyMedium",
                                    fontSize: 14,
                                  }}
                                >
                                  Mail vendor
                                </span>
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  disabled={
                                    !String(
                                      m?.vendor_details?.vendor_email ||
                                        m?.vendor_email ||
                                        m?.email ||
                                        "",
                                    ).trim() ||
                                    !String(
                                      m?.item_name || m?.name || "",
                                    ).trim() ||
                                    mailSendingToken ===
                                      `${String(
                                        m?.vendor_details?.vendor_email ||
                                          m?.vendor_email ||
                                          m?.email ||
                                          "",
                                      ).trim()}::${String(
                                        m?.item_name || m?.name || "",
                                      ).trim()}`
                                  }
                                  onClick={() =>
                                    sendUnregisteredVendorInterestMail(m)
                                  }
                                  sx={{
                                    bgcolor: "#e0f2fe",
                                    color: "#0284c7",
                                    border: "1px solid #bae6fd",
                                    "&:hover": {
                                      bgcolor: "#bae6fd",
                                    },
                                  }}
                                >
                                  <MailOutline sx={{ fontSize: 22 }} />
                                </IconButton>
                              </span>
                            </Tooltip>

                            <Tooltip
                              title={
                                <span
                                  style={{
                                    fontFamily: "gilroyMedium",
                                    fontSize: 14,
                                  }}
                                >
                                  Download PDF
                                </span>
                              }
                            >
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() => generateExplorePdf(m)}
                                  sx={{
                                    bgcolor: "#dbeafe",
                                    color: "#2563eb",
                                    border: "1px solid #bfdbfe",
                                    "&:hover": {
                                      bgcolor: "#bfdbfe",
                                      // transform: "translateY(-1px)",
                                    },
                                    // transition: "all 0.2s ease",
                                  }}
                                >
                                  <PictureAsPdf sx={{ fontSize: 24 }} />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  {!exploreLoading && filteredExploreMatches.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        sx={{ color: "#64748b", py: 3, textAlign: "center" }}
                      >
                        No results to display.
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Fade>
      </Modal>

      <Modal
        open={sendMessage}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={sendMessage}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            {textAreaSendMessage ? (
              <PopupFrame
                poupHeading={viewUserHeading}
                inputChildren={viewTextChildren}
                actionButtons={viewTextActionButtons}
                closePopup={handleCloseViewItemPopup}
                width={"auto"}
                customClass={classes.addPopup}
                styleCenterDiv={classes.centerDiv}
              />
            ) : (
              <PopupFrame
                poupHeading={viewUserHeading}
                inputChildren={viewUserChildren}
                actionButtons={viewItemsActionButtons}
                closePopup={handleCloseViewItemPopup}
                width={"auto"}
                customClass={classes.addPopup}
                styleCenterDiv={classes.centerDiv}
              />
            )}
          </div>
        </Fade>
      </Modal>

      {/* user message modal */}

      <Modal
        open={getusermessagemodal}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={getusermessagemodal}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            {getuserlistpopup ? (
              <PopupFrame
                poupHeading={viewUserMessageHeading}
                inputChildren={userMessageTextArea}
                actionButtons={userMainModelActionBtn}
                width={"auto"}
                customClass={classes.addPopup}
                styleCenterDiv={classes.centerDiv}
              />
            ) : (
              <PopupFrame
                poupHeading={viewUserMessageHeading}
                inputChildren={viewListUsers}
                actionButtons={userMessageActionBnt}
                width={"auto"}
                customClass={classes.addPopup}
                styleCenterDiv={classes.centerDiv}
              />
            )}
          </div>
        </Fade>
      </Modal>

      <Modal open={getsuccesspopup}>
        <Fade in={getsuccesspopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={getuserpopupherotext}
              popupDescription={getuserdescpopup}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={sentUserMessage}
            />
          </Box>
        </Fade>
      </Modal>

      {/* Chat state change confirmation popup */}
      <Modal open={chatConfirmationDialog.open}>
        <Box>
          <SuccessPopupDashboard
            popupHeroText={
              chatConfirmationDialog.isClosedChat
                ? "Are you sure want to enable the chat ?"
                : "Are you sure want to disable the chat ?"
            }
            customClass={classes.confimationPopup}
            popBtn={true}
            buyerBtn={true}
            buyerBtnOutlined={true}
            btnText={"Yes"}
            loadingPrimaryBtn={loadingState}
            btnClick={() =>
              chatStateChage(chatConfirmationDialog.isClosedChat, rfqToken)
            }
            secondaryBtn={true}
            btnTextSecondary={"No"}
            btnClickSecondary={closeChatModule}
          />
        </Box>
      </Modal>

      <Modal open={openVendorPopup}>
        <Fade in={openVendorPopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={bidSelectedImg}
              popupHeroText={"Select Supplier(s)"}
              popupDescription={
                "Tick the checkbox to select the Supplier(s) for Purchase Order Automation."
              }
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={handleCloseVendorPopup}
            />
          </Box>
        </Fade>
      </Modal>

      {/* Download PDF UI for donload HTML to PDF */}
      <div className={organizationDetailspdfUI ? classes.mp100vh : ""}>
        <div
          className={`${classes.downloadreportViewMain} ${classes.width__100} ${
            organizationDetailspdfUI ? classes.show : ""
          }`}
          id="organization_details"
        >
          <div className={classes.pdfLogoWrapper}>
            <img
              src={brLogo}
              alt={"BrandLogo"}
              className={classes.pdfLogoImg}
              style={{
                height: "24px",
                width: "auto",
                objectFit: "contain",
                display: "block",
              }}
            />
          </div>
          <h1 className={classes.view__time_line_titel}>
            RFQ Transaction Details
          </h1>
          <div className={`${classes.view__time_line} ${classes.mb20}`}>
            {org_details.map((e, i) => (
              <InfoLabel
                key={i}
                isLoading={loadingState}
                label={e.label}
                value={e.value}
                size={e.size}
              />
            ))}
          </div>
          <div className={classes.pdf_handle}>
            <div>
              {viewTimeLineData.map((item, index) => (
                <div className={classes.rfq_time_line_contant} key={index}>
                  <div className={classes.time_line_box}>
                    <div className={classes.time_line_box_loyout}>
                      <div
                        className={`${classes.box_loyout_left} ${
                          item.sender_role?.toLowerCase() === "vendor admin"
                            ? classes.vendorAdmin
                            : item?.receiver_role?.toLowerCase() ===
                                "vendor admin"
                              ? classes.vendorAdmin
                              : item.role?.toLowerCase() === "buyer"
                                ? classes.vendorAdmin
                                : item.role?.toLowerCase() === "user"
                                  ? classes.user
                                  : item.receiver_role?.toLowerCase() ===
                                      "Buyer"
                                    ? classes.buyer
                                    : classes.defaultcolor
                        }`}
                      >
                        <div className={classes.padding_box}>
                          <p className={classes.left_titel}>
                            {item.sender_role
                              ? item.sender_role.toLowerCase() ===
                                "vendor admin"
                                ? "Vendor"
                                : item.sender_role
                              : item.name || "Unknown Sender"}
                          </p>
                          <p style={{ fontSize: "12px" }}>{item.designation}</p>
                        </div>
                      </div>
                      <div className={classes.box_loyout_right}>
                        <div className={classes.padding_box}>
                          <p className={classes.left_titel}>Message</p>
                          <p className={classes.right_progrop}>
                            {" "}
                            {item.message}
                          </p>
                          <p className={classes.right_progrop_date_time}>
                            {item.created_raw}
                          </p>
                          {shouldShowSealedBidNotice ? (
                            renderMaskedAttachmentList(
                              item,
                              `timeline-inline-${item?.id || index}`,
                            )
                          ) : (
                            <AttachmentList item={item} />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className={classes.documentconatiner}>
              <div className={classes.documentheader}>
                {/* doc header */}
                <h3>Uploaded Documents</h3>
              </div>

              <div className={classes.documentcontent}>
                {/* documents */}
                <ul style={{ fontSize: "10px" }}>
                  {viewTimeLineData &&
                    viewTimeLineData
                      .filter((entry) => entry.document.length > 0)
                      .map((entry, index) =>
                        shouldShowSealedBidNotice ? (
                          <React.Fragment key={index}>
                            {renderMaskedAttachmentList(
                              entry,
                              `vendor-timeline-doc-${index}`,
                            )}
                          </React.Fragment>
                        ) : (
                          <AttachmentList key={index} item={entry} />
                        ),
                      )}

                  {currentVendorBidDocuments.map(({ key, item }) =>
                    shouldShowSealedBidNotice ? (
                      <React.Fragment key={key}>
                        {renderMaskedAttachmentList(item, key)}
                      </React.Fragment>
                    ) : (
                      <li key={key}>
                        <a
                          href={item.document[0].url}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            display: "block",
                            fontSize: "13px",
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                          }}
                        >
                          {item.document[0].name}
                        </a>
                      </li>
                    ),
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyerRFQTab;
